import firebase from 'firebase/app';
import 'firebase/firebase-auth';
import 'firebase/firebase-firestore';
import 'firebase/firebase-storage';
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { ServerStyleSheet } from 'styled-components';
//import {JWT} from 'google-auth-library'
import firebaseConfig from './JSONS/firebaseConfig';
import { Label } from '@material-ui/icons';


var URLVer = ""



const firebaseApp =  firebase.initializeApp(firebaseConfig);
const Auth =firebaseApp.auth();
const db = firebaseApp.firestore();
const storage = firebaseApp.storage();

var URL_SITE = localStorage.getItem('Url');
var EMPRESA = localStorage.getItem('Empresa');
var status = localStorage.getItem('roma');
var URL_WHAT ="https://api.z-api.io/instances/3E963274C1A682BB6B86CAE6335FD653/token/B37022824E3B78281960FAC9/"
var TOKEN_WHAT = 'F00e091b33041467086a036ecabbf8d1eS'

export default {
  TAEnviarSiteAppAluno: async(NomeApp, Telefone, SiteApp, setLoading, setAlertTipo, setAlert)=> {
        
         var ver = Telefone.replace("(", "55");
            var par1 = ver.replace(")", "");
            var par3 = par1.replace("-", "");

            var data={
              "phone": par3,
              "message": "Link do Site do Aplicativo "+NomeApp+": \n"+SiteApp,
            }   
           const req = await fetch(`${URL_WHAT}send-text`, 
            {
                  method: 'POST',
                  headers:{
                    'Content-Type': 'application/json',
                    'client-token': TOKEN_WHAT
                  },
                  body: JSON.stringify(data),
                });
         
       setAlert("Enviado com Sucesso");
      setAlertTipo("success");
       setLoading(false)
  },

  TADadosPermissoesAcao: async(ListEsp, setVerSofredo)=> {
        
          await db.collection("Permissoes")
          .doc(ListEsp.IdSofredor)
          .onSnapshot((doc) => {      
          setVerSofredo(doc.data())   
           });
        
         
 
  },
   TADadosFuncionarioAcao: async(ListEsp, setVerSofredo)=> {
        
          await db.collection("Users")
          .doc(ListEsp.IdSofredor)
          .onSnapshot((doc) => {      
          setVerSofredo(doc.data())   
           });
        
         
 
  },
  TADadosMedidasAcao: async(ListEsp, setVerSofredo)=> {
        
          await db.collection("MedidasAlunos")
          .doc(ListEsp.IdSofredor)
          .onSnapshot((doc) => {      
          setVerSofredo(doc.data())   
           });
        
         
 
  },
  TADadosRecebimentosAcao: async(ListEsp, setVerSofredo)=> {
        
          await db.collection("AlunoTicket")
          .doc(ListEsp.IdSofredor)
          .onSnapshot((doc) => {      
          setVerSofredo(doc.data())   
           });
        
         
 
  },
  TADadosTreinosAcao: async(ListEsp, setVerSofredo)=> {
        
          await db.collection("MemoriaTreino")
          .doc(ListEsp.IdSofredor)
          .onSnapshot((doc) => {      
          setVerSofredo(doc.data())   
           });
        
         
 
  },
    TADadosAlunosAcao: async(ListEsp, setVerAluno)=> {
        
          await db.collection("Alunos")
          .doc(ListEsp.IdSofredor)
          .onSnapshot((doc) => {      
          setVerAluno(doc.data())   
           });
        
         
 
  },
    TADadosExercicioAcao: async(ListEsp, setVerSofredo)=> {
        
          await db.collection("Exercicios")
          .doc(ListEsp.IdSofredor)
          .onSnapshot((doc) => {      
          setVerSofredo(doc.data())   
           });
        
         
 
  },
  TAListAcoesFuncionario: async(Dados, IdContRes, DataFim, DataIni,  IdConta, setQuant, setUsuariosContServ, setListCliente, setListTel, setCarreg, setProgress,)=> {
    var variac = 0 
    var DateTemp = new Date(DataIni);
    var currentDate = "";
    var Dia = DateTemp.getDate(); 
    var Mes = (DateTemp.getMonth()+1);
    var Ano = DateTemp.getFullYear();
    Dia = Dia < 10 ? '0'+Dia : Dia;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+Dia;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    var variac1 = 0 
    var DateTemp1 = new Date(DataFim);
    var currentDate1 = "";
    var Dia1 = DateTemp1.getDate(); 
    var Mes1 = (DateTemp1.getMonth()+1);
    var Ano1 = DateTemp1.getFullYear();
    Dia1 = Dia1 < 10 ? '0'+Dia1 : Dia1;
    Mes1 = Mes1 < 10 ? '0'+Mes1 : Mes1;
    currentDate1 = Ano1+'-'+Mes1+'-'+Dia1;
    variac1 = new Date(currentDate1 +"T23:59:00.000").getTime();
   
     var Quantidade = 0;
     
          await db.collection("Acoes")
          .where("dataDaAcao", "<=", variac1)
          .where("dataDaAcao", ">=", variac)
          .where("IdConta", "==", IdContRes)
           .get()
          .then(async (querySnapshot)=>{
          Quantidade = querySnapshot.size;
            setQuant(querySnapshot.size);
            var res = [];
            var res2 = [];
            let listra2 = []; 
            let listra3 = []; 
            querySnapshot.forEach((doc) => {

                res.push({
                Id: doc.id,
                dataDaAcao:doc.data().dataDaAcao,
                IdConta:doc.data().IdConta,
                IdExecutor:doc.data().IdExecutor,
                IdSofredor:doc.data().IdSofredor,
                Sessão:doc.data().Sessão,
                Acao:doc.data().Acao,
                });
                 
            });
           
            var Part = 0; 
            for(let i in  res){
              Part = Part+1;
              await db.collection("Users")
              .doc(res[i].IdExecutor)
              .get()
              .then(async (doc1)=>{
               res2.push({
                Id: res[i].Id,
                Nome: doc1.data().Nome,  
                Telefone: doc1.data().Telefone, 
                dataDaAcao:res[i].dataDaAcao,
                IdConta:res[i].IdConta,
                IdExecutor:res[i].IdExecutor,
                IdSofredor:res[i].IdSofredor,
                Sessão:res[i].Sessão,
                Acao:res[i].Acao,
                });
           const novoItem = {
                  value: res[i].IdExecutor,
                  label: doc1.data().Nome
                };
                const existe = listra2.some(item => item.value=== novoItem.value || item.label === novoItem.label);

                if (!existe) {
                  listra2.push(novoItem);
                }

                const novoItem3 = {
                  value:res[i].IdExecutor,
                  label: doc1.data().Telefone
                };
                const existe3 = listra3.some(item => item.value === novoItem3.value || item.label === novoItem3.label);

                if (!existe3) {
                  listra3.push(novoItem3);
                }

               
              
              });
             var Porcentagem = Part/Quantidade
             setProgress(Porcentagem*100)
            }



         

            res2.sort((a,b)=>{
              if(a.dataDaAcao < b.dataDaAcao) {
                return 1;
              } else {
                return -1;
              }
            });
             listra2.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
             listra3.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
            setCarreg(false)
            setListTel(listra3)
            setListCliente(listra2)
            setUsuariosContServ(res2);
      });
      
 
  },
  TAListGrupoClientes: async(Dados, IdConta, setListGrupo)=> {
         
          await db.collection("Permissoes")
          .where("Ativo", "==", true)
          .where("IdConta", "==",IdConta)
           .get()
          .then(async (querySnapshot)=>{
           
          
            let listra2 = []; 
            
            querySnapshot.forEach((doc) => {
               
                listra2.push({
                  value: doc.id,
                  label: doc.data().Nome,      
                  }); 
               

            });
           
             listra2.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
            
          
            setListGrupo(listra2)
           
      });
 
  },
    TADesativandoPermisaoFun: async(Dados, Id, IdConta, IdUse, InfIdUse, setAlertTipo, setAlert)=> {
    
   
    await db.collection("Permissoes").doc(Id).update({
     "Ativo":false, 
    }).then(async ()=>{
        await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Desativar", 
              Sessão:"Permissões",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })
      setAlert("Desativado com Sucesso");
      setAlertTipo("success");
    });
  },
   TAAtivandoPermisaoFun: async(Dados, Id, IdConta, IdUse, InfIdUse, setAlertTipo, setAlert)=> {
 
    await db.collection("Permissoes").doc(Id).update({
     "Ativo":true, 
    }).then(async ()=>{
       await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Ativar", 
               Sessão:"Permissões",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })
      setAlert("Ativado com Sucesso");
      setAlertTipo("success");
    });
  },
  TAListGruposClientes: async(Dados, IdContRes,  setQuant, setUsuariosContServ, setProgress, setCarreg)=> {
   

     var Quantidade = 0;
     
          await db.collection("Permissoes")
          .where("IdConta", "==", IdContRes)
           .get()
          .then(async (querySnapshot)=>{
          Quantidade = querySnapshot.size;
            setQuant(querySnapshot.size);
            var res = [];
     
            var Part = 0; 
            querySnapshot.forEach((doc) => {
            Part = Part+1;
                res.push({
                Id: doc.id,
                Ativo:doc.data().Ativo,
                Nome: doc.data().Nome,
                dataDaCricao:doc.data().dataDaCricao,
                permissoes:doc.data().permissoes,
                });
              


             var Porcentagem = Part/Quantidade
             setProgress(Porcentagem*100) 
            });
           
            


         

            res.sort((a,b)=>{
              if(a.Nome < b.Nome) {
                return 1;
              } else {
                return -1;
              }
            });
            console.log()
            setCarreg(false)
            setUsuariosContServ(res);
      });
      
 
  },
  TAEditarGruposClientes: async(ListEsp, Id, Dados, Nome, permissoes, InfIdConta, InfIdUse, IdConta, IdUse, setAlertTipo, setAlert, UsuariosContServ, setUsuariosContServ, setLoading, setMsgErro)=> {

    if(ListEsp.Nome === Nome){

    
    await db.collection("Permissoes").doc(Id).update({ 
          "Nome":Nome, 
          "permissoes":permissoes,
          }).then(async (doc1) => {
            
           
               
              await db.collection("Acoes").add({
              dataDaAcao:new Date().getTime(),
              IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar",
               Sessão:"Permissões",
               IdSofredor:Id,
              }).then(async (doc2) => {
                })

            setAlert("Atualizado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
              Nome, 
              permissoes,
            } : item);
          setUsuariosContServ(novaLista);
              
           
                
             
          })
          .catch((error) => {
         
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

        } else  {
   await db.collection("Permissoes")
    .where("Nome", "==", Nome)
    .where("IdConta", "==",IdConta)
    .get()
    .then(async (querySnapshot)=>{ 

      if(querySnapshot.size === 0){
         await db.collection("Permissoes").doc(Id).update({ 
          "Nome":Nome, 
          "permissoes":permissoes,
          }).then(async (doc1) => {
            
           
               
              await db.collection("Acoes").add({
              dataDaAcao:new Date().getTime(),
              IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar",
               Sessão:"Permissões",
               IdSofredor:Id,
              }).then(async (doc2) => {
                })

            setAlert("Atualizado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
              Nome, 
              permissoes,
            } : item);
          setUsuariosContServ(novaLista);
              
           
                
             
          })
          .catch((error) => {
         
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });
        

        } else {
           setLoading(false)
           setMsgErro("Esse Nome de Grupo já Existe em Sua Conta!")
          }

        })  
       
        }  
         
        
     
    },
  TACriarGruposClientes: async(Dados, Nome, permissoes, InfIdConta, InfIdUse, IdConta, IdUse, setAlertTipo, setAlert,  setLoading, setMsgErro, setAddList)=> {

      await db.collection("Permissoes")
    .where("Nome", "==", Nome)
    .where("IdConta", "==",IdConta)
      .get()
    .then(async (querySnapshot)=>{ 
      if(querySnapshot.size === 0){  
    await db.collection("Permissoes").add({
          Ativo:true, 
          Nome, 
          IdConta,
          permissoes,
          dataDaCricao:new Date().getTime(),
          }).then(async (doc1) => {
            var IdPerm = doc1.id;
           
               
              await db.collection("Acoes").add({
              dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Criar", 
               Sessão:"Permissões",
               IdSofredor:IdPerm,
              }).then(async (doc2) => {
                })

            setAlert("Criado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

             setAddList({
                Id: IdPerm,
                Ativo:true, 
                Nome, 
                IdConta,
                permissoes,
                dataDaCricao:new Date().getTime(),
              })
              
           
                
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

          } else {
           setLoading(false)
           setMsgErro("Esse Nome de Grupo já Existe em Sua Conta!")
          }

        })     
         
        
     
    },
   TADesativandoFuncionario: async(Dados, Id, IdConta, IdUse, InfIdUse, setAlertTipo, setAlert)=> {
    
   
    await db.collection("Users").doc(Id).update({
     "Ativo":false, 
    }).then(async ()=>{
        await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Desativar", 
               Sessão:"Funcionários",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })
      setAlert("Desativado com Sucesso");
      setAlertTipo("success");
    });
  },
   TAAtivandoFuncionario: async(Dados, Id, IdConta, IdUse, InfIdUse, setAlertTipo, setAlert)=> {
 
    await db.collection("Users").doc(Id).update({
     "Ativo":true, 
    }).then(async ()=>{
       await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Ativar", 
               Sessão:"Funcionários",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })
      setAlert("Ativado com Sucesso");
      setAlertTipo("success");
    });
  },
   TADesativarMsgApp: async(IdUse,  InfIdUse, IdConta, MsgApp, setAlertTipo, setAlert)=> {

        
    await db.collection("Users").doc(IdConta).update({
           "MensagemApp":{
            Msg:MsgApp,
            Ativo:false,
           }
          }).then(async (doc1) => {
   
              await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Desativar", 
               Sessão:"Mensagem App",
               IdSofredor:IdConta,
              }).then(async (doc2) => {
                })

            setAlert("Desativado Aviso para o Aplicativo do Aluno");
            setAlertTipo("success");
       

          })
          .catch((error) => {
           
         
          });

          
         
        
     
    },
  TAAtivarMsgApp: async(IdUse,  InfIdUse, IdConta, MsgApp, setAlertTipo, setAlert)=> {

        
    await db.collection("Users").doc(IdConta).update({
           "MensagemApp":{
            Msg:MsgApp,
            Ativo:true
           }
          }).then(async (doc1) => {
   
              await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Ativar", 
               Sessão:"Mensagem App",
               IdSofredor:IdConta,
              }).then(async (doc2) => {
                })

            setAlert("Ativado Aviso para o Aplicativo do Aluno");
            setAlertTipo("success");
       

          })
          .catch((error) => {
           
         
          });

          
         
        
     
    },
  TADesativarMsgSistem: async(IdUse,  InfIdUse, IdConta, Msg, setAlertTipo, setAlert)=> {

        
    await db.collection("Users").doc(IdConta).update({
           "MensagemSistem":{
            Msg:Msg,
            Ativo:false,
           }
          }).then(async (doc1) => {
   
              await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Desativar", 
               Sessão:"Mensagem Sistem",
               IdSofredor:IdConta,
              }).then(async (doc2) => {
                })

            setAlert("Desativado Aviso para o Sistema do Funcionário");
            setAlertTipo("success");
       

          })
          .catch((error) => {
           
         
          });

          
         
        
     
    },
  TAAtivarMsgSistem: async(IdUse,  InfIdUse, IdConta, Msg, setAlertTipo, setAlert)=> {

        
    await db.collection("Users").doc(IdConta).update({
           "MensagemSistem":{
            Msg:Msg,
            Ativo:true
           }
          }).then(async (doc1) => {
   
              await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Ativar", 
               Sessão:"Mensagem Sistem",
               IdSofredor:IdConta,
              }).then(async (doc2) => {
                })

            setAlert("Ativado Aviso para o Sistema do Funcionário");
            setAlertTipo("success");
       

          })
          .catch((error) => {
           
         
          });

          
         
        
     
    },
  TAEditarFuncionariosClientes: async(Id, ListEsp, IdGrupo, IdConta, InfIdUse,  IdUse,  Nome,  Telefone,    Estado, Cidade, Bairro, Num, End, UsuariosContServ,  setUsuariosContServ,   setMsgErro, setLoading, setAlertTipo, setAlert, setAddList)=> {
  

  

      if(ListEsp.Telefone === Telefone){
     
         await db.collection("Users").doc(Id).update({
          Nome,
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End,
          IdGrupo,
          }).then(async (doc1) => {

            await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar", 
               Sessão:"Funcionários",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })

            setAlert("Atualizado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
            Nome,
            Estado, 
            Cidade, 
            Bairro, 
            Num, 
            End,
            IdGrupo,    
            } : item);
          setUsuariosContServ(novaLista);
          
            
          })

      } else {
        
        var ver = Telefone.replace("(", "55");
        var par1 = ver.replace(")", "");
        var par3 = par1.replace("-", "");
        
         const req = await fetch(`${URL_WHAT}phone-exists/${par3}`, 
        {
              method: 'GET',
              headers:{
                'Content-Type': 'application/json',
                'client-token': TOKEN_WHAT
              },
              
            });
    
        
          
            const json = await req.json(); 
            
          
            if(json.exists === true){

         
         await db.collection("Users")
          .where("Telefone", "==", Telefone)
          .where("IdConta", "==", IdConta)
          .where("Conta", "==", "Fun")
           .get()
          .then(async (querySnapshot)=>{
            if(querySnapshot.size === 0){

       

         await db.collection("Users").doc(Id).update({
          Telefone, 
          Nome,
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End,
          IdGrupo, 
          }).then(async (doc1) => {

            await db.collection("Acoes").add({
              dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar", 
               Sessão:"Funcionários",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })

            setAlert("Atualizado Com Sucesso");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
            Telefone, 
            Nome,
            Estado, 
            Cidade, 
            Bairro, 
            Num, 
            End,
            IdGrupo,     
            } : item);
          setUsuariosContServ(novaLista);
          
            
          })

            } else {
            setLoading(false)
           setMsgErro("Esse Número de Telefone Já é Funcionário da Empresa!")
            }
          });

          } else{
            setLoading(false)
           setMsgErro("Esse Número não está registrado no whatsapp, só é permitido número que é registrado no whatsapp!")
            }

      }

   


   
  

     
    },
  TAListFuncionariosClientes: async(Dados, IdContRes, DataFim, DataIni,  IdConta, setQuant, setUsuariosContServ, setListCliente, setListTel, setCarreg, setProgress,)=> {
   

     var Quantidade = 0;
     
          await db.collection("Users")
          .where("IdConta", "==", IdContRes)
          .where("Conta", "==", "Fun")
           .get()
          .then(async (querySnapshot)=>{
          Quantidade = querySnapshot.size;
            setQuant(querySnapshot.size);
            var res = [];
            var res2 = [];
            let listra2 = []; 
            let listra3 = []; 
            var Part = 0; 
            querySnapshot.forEach((doc) => {
            Part = Part+1;
                res.push({
                Id: doc.id,
                Ativo:doc.data().Ativo,
                Nome: doc.data().Nome, 
                Telefone:doc.data().Telefone, 
                Estado:doc.data().Estado, 
                Cidade:doc.data().Cidade, 
                Bairro:doc.data().Bairro, 
                Num:doc.data().Num, 
                End:doc.data().End,
                dataCriacao:doc.data().dataCriacao,
                IdGrupo:doc.data().IdGrupo,
                });
              const novoItem = {
                  value: doc.id,
                  label: doc.data().Nome
                };
                const existe = listra2.some(item => item.value === novoItem.value || item.label === novoItem.label);

                if (!existe) {
                  listra2.push(novoItem);
                }

                const novoItem3 = {
                  value: doc.id,
                  label: doc.data().Telefone
                };
                const existe3 = listra3.some(item => item.value === novoItem3.value || item.label === novoItem3.label);

                if (!existe3) {
                  listra3.push(novoItem3);
                }


             var Porcentagem = Part/Quantidade
             setProgress(Porcentagem*100) 
            });
           
            


         

            res.sort((a,b)=>{
              if(a.dataDaCricao < b.dataDaCricao) {
                return 1;
              } else {
                return -1;
              }
            });
             listra2.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
             listra3.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
            setCarreg(false)
            setListTel(listra3)
            setListCliente(listra2)
            setUsuariosContServ(res);
      });
      
 
  },
   TACriarFuncinariosClientes: async(IdGrupo, IdConta, InfIdUse,  IdUse,  Nome,    Telefone,    Estado, Cidade, Bairro, Num, End,  setMsgErro, setLoading, setAlertTipo, setAlert, setAddList)=> {

        var ver = Telefone.replace("(", "55");
        var par1 = ver.replace(")", "");
        var par3 = par1.replace("-", "");

         const req = await fetch(`${URL_WHAT}phone-exists/${par3}`, 
        {
              method: 'GET',
              headers:{
                'Content-Type': 'application/json',
                'client-token': TOKEN_WHAT
              },
              
            });
    
        
          
            const json = await req.json(); 
            
          
            if(json.exists === true){
              

        await db.collection("Users")
          .where("Telefone", "==", Telefone)
          .where("IdConta", "==", IdConta)
          .where("Conta", "==", "Fun")
           .get()
          .then(async (querySnapshot)=>{
            if(querySnapshot.size === 0){

        await db.collection("Users").add({
          Nome,
          Ativo:true, 
          Telefone, 
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End,
          dataCriacao:new Date().getTime(),
          IdConta:IdConta,
          Conta:"Fun",
          IdGrupo,
          }).then(async (doc1) => {
            var IdFun = doc1.id;
           
               
              await db.collection("Acoes").add({
              dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Criar", 
               Sessão:"Funcionários",
               IdSofredor:IdFun,
              }).then(async (doc2) => {
                })

            setAlert("Criado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

             setAddList({
                Id: IdFun,
                Nome,
                Ativo:true, 
                Telefone, 
                Estado, 
                Cidade, 
                Bairro, 
                Num, 
                End,
                dataCriacao:new Date().getTime(),
                IdConta:IdConta,
                Conta:"Fun",
                IdGrupo,  
              })
              
           
                
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

           } else {
            setLoading(false)
           setMsgErro("Esse Número de Telefone Já é Funcionário da Empresa!")
            }
          });
          
         
            } else{
            setLoading(false)
           setMsgErro("Esse Número não está registrado no whatsapp, só é permitido número que é registrado no whatsapp!")
            }
     
    },
  TAListHistoricoAlunos: async(Dados, IdContRes, DataFim, DataIni,  IdConta, setQuant, setUsuariosContServ, setListCliente, setListTel, setCarreg, setProgress,)=> {
    var variac = 0 
    var DateTemp = new Date(DataIni);
    var currentDate = "";
    var Dia = DateTemp.getDate(); 
    var Mes = (DateTemp.getMonth()+1);
    var Ano = DateTemp.getFullYear();
    Dia = Dia < 10 ? '0'+Dia : Dia;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+Dia;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    var variac1 = 0 
    var DateTemp1 = new Date(DataFim);
    var currentDate1 = "";
    var Dia1 = DateTemp1.getDate(); 
    var Mes1 = (DateTemp1.getMonth()+1);
    var Ano1 = DateTemp1.getFullYear();
    Dia1 = Dia1 < 10 ? '0'+Dia1 : Dia1;
    Mes1 = Mes1 < 10 ? '0'+Mes1 : Mes1;
    currentDate1 = Ano1+'-'+Mes1+'-'+Dia1;
    variac1 = new Date(currentDate1 +"T23:59:00.000").getTime();
   
     var Quantidade = 0;
     
          await db.collection("Historico")
          .where("DataDoInicio", "<=", variac1)
          .where("DataDoInicio", ">=", variac)
          .where("IdConta", "==", IdContRes)
           .get()
          .then(async (querySnapshot)=>{
          Quantidade = querySnapshot.size;
            setQuant(querySnapshot.size);
            var res = [];
            var res2 = [];
            let listra2 = []; 
            let listra3 = []; 
            querySnapshot.forEach((doc) => {

                res.push({
                Id: doc.id,
                Ativo: doc.data().Ativo,
                Treino:doc.data().Treino,
                DataDoInicio:doc.data().DataDoInicio,
                DataDoFim:doc.data().DataDoFim,
                IdAluno:doc.data().IdAluno,
                NomeTreino:doc.data().NomeTreino,
                });
                 
            });
          
            var Part = 0; 
            for(let i in  res){
              Part = Part+1;
              await db.collection("Alunos")
              .doc(res[i].IdAluno)
              .get()
              .then(async (doc1)=>{
               res2.push({
                Id: res[i].Id,
                Nome: doc1.data().Nome,  
                Telefone: doc1.data().Telefone, 
                Ativo: res[i].Ativo,
                Treino: res[i].Treino, 
                DataDoInicio:res[i].DataDoInicio,
                DataDoFim:res[i].DataDoFim,
                IdAluno:res[i].IdAluno,
                NomeTreino:res[i].NomeTreino,
                });
           const novoItem = {
                  value: res[i].IdAluno,
                  label: doc1.data().Nome
                };
                const existe = listra2.some(item => item.value === novoItem.value || item.label === novoItem.label);

                if (!existe) {
                  listra2.push(novoItem);
                }

                const novoItem3 = {
                  value: res[i].IdAluno,
                  label: doc1.data().Telefone
                };
                const existe3 = listra3.some(item => item.value === novoItem3.value || item.label === novoItem3.label);

                if (!existe3) {
                  listra3.push(novoItem3);
                }

               
              
              });
             var Porcentagem = Part/Quantidade
             setProgress(Porcentagem*100)
            }



         

            res2.sort((a,b)=>{
              if(a.DataDoInicio < b.DataDoInicio) {
                return 1;
              } else {
                return -1;
              }
            });
             listra2.sort((a,b)=>{
              if(a.select < b.select) {
                return -1;
              } else {
                return 1;
              }
            });
             listra3.sort((a,b)=>{
              if(a.select < b.select) {
                return -1;
              } else {
                return 1;
              }
            });
            setCarreg(false)
            setListTel(listra3)
            setListCliente(listra2)
            setUsuariosContServ(res2);
      });
      
 
  },
    TADesativandoMedidas: async(Dados, Id, IdConta, IdUse, InfIdUse, setAlertTipo, setAlert)=> {
    
    const Setor = "Desativando Condicional Serv";
    await db.collection("MedidasAlunos").doc(Id).update({
     "Ativo":false, 
    }).then(async ()=>{
        await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Desativar", 
               Sessão:"Medidas",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })
      setAlert("Desativado com Sucesso");
      setAlertTipo("success");
    });
  },
   TAAtivandoMedidas: async(Dados, Id, IdConta, IdUse, InfIdUse, setAlertTipo, setAlert)=> {
 
    await db.collection("MedidasAlunos").doc(Id).update({
     "Ativo":true, 
    }).then(async ()=>{
       await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Ativar", 
               Sessão:"Medidas",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })
      setAlert("Ativado com Sucesso");
      setAlertTipo("success");
    });
  },
   TAEditarMedidasAlunos: async(Id, IMC, PanturrilhaDir, PanturrilhaEsq, PernaDir, PernaEsq, Quadril, Cintura, AnteBracoDir, AnteBracoEsq, BracoDir, BracoEsq, Peitoral, Ombro, Altura, Peso, IdAluno, Nome, Telefone, IdConta, InfIdUse,  IdUse,  UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert, setAddList)=> {

        
    await db.collection("MedidasAlunos").doc(Id).update({
          IMC, 
          PanturrilhaDir, 
          PanturrilhaEsq, 
          PernaDir, 
          PernaEsq, 
          Quadril, 
          Cintura, 
          AnteBracoDir, 
          AnteBracoEsq, 
          BracoDir, 
          BracoEsq, 
          Peitoral, 
          Ombro, 
          Altura, 
          Peso, 
          }).then(async (doc1) => {
   
              await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar", 
               Sessão:"Medidas",
               IdSofredor:Id,
              }).then(async (doc2) => {
                })

            setAlert("Atualizado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

              const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
              IMC, 
              PanturrilhaDir, 
              PanturrilhaEsq, 
              PernaDir, 
              PernaEsq, 
              Quadril, 
              Cintura, 
              AnteBracoDir, 
              AnteBracoEsq, 
              BracoDir, 
              BracoEsq, 
              Peitoral, 
              Ombro, 
              Altura, 
              Peso, 
            } : item);
          setUsuariosContServ(novaLista);
              
           
                
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

          
         
        
     
    },
   TAListMedidasAlunos: async(Dados, IdContRes, DataFim, DataIni,  IdConta, setQuant, setUsuariosContServ, setListCliente, setListTel, setCarreg, setProgress,)=> {
    var variac = 0 
    var DateTemp = new Date(DataIni);
    var currentDate = "";
    var Dia = DateTemp.getDate(); 
    var Mes = (DateTemp.getMonth()+1);
    var Ano = DateTemp.getFullYear();
    Dia = Dia < 10 ? '0'+Dia : Dia;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+Dia;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    var variac1 = 0 
    var DateTemp1 = new Date(DataFim);
    var currentDate1 = "";
    var Dia1 = DateTemp1.getDate(); 
    var Mes1 = (DateTemp1.getMonth()+1);
    var Ano1 = DateTemp1.getFullYear();
    Dia1 = Dia1 < 10 ? '0'+Dia1 : Dia1;
    Mes1 = Mes1 < 10 ? '0'+Mes1 : Mes1;
    currentDate1 = Ano1+'-'+Mes1+'-'+Dia1;
    variac1 = new Date(currentDate1 +"T23:59:00.000").getTime();
   
     var Quantidade = 0;
     
          await db.collection("MedidasAlunos")
          .where("dataDaCricao", "<=", variac1)
          .where("dataDaCricao", ">=", variac)
          .where("IdConta", "==", IdContRes)
           .get()
          .then(async (querySnapshot)=>{
          Quantidade = querySnapshot.size;
            setQuant(querySnapshot.size);
            var res = [];
            var res2 = [];
            let listra2 = []; 
            let listra3 = []; 
            querySnapshot.forEach((doc) => {

                res.push({
                Id: doc.id,
                Ativo: doc.data().Ativo,
                IMC: doc.data().IMC, 
                PanturrilhaDir: doc.data().PanturrilhaDir, 
                PanturrilhaEsq: doc.data().PanturrilhaEsq, 
                PernaDir: doc.data().PernaDir, 
                PernaEsq: doc.data().PernaEsq, 
                Quadril: doc.data().Quadril, 
                Cintura: doc.data().Cintura, 
                AnteBracoDir: doc.data().AnteBracoDir, 
                AnteBracoEsq: doc.data().AnteBracoEsq, 
                BracoDir: doc.data().BracoDir, 
                BracoEsq: doc.data().BracoEsq, 
                Peitoral: doc.data().Peitoral, 
                Ombro: doc.data().Ombro, 
                Altura: doc.data().Altura, 
                Peso: doc.data().Peso, 
                IdAluno: doc.data().IdAluno, 
                dataDaCricao: doc.data().dataDaCricao,
                });
                 
            });
           
            var Part = 0; 
            for(let i in  res){
              Part = Part+1;
              await db.collection("Alunos")
              .doc(res[i].IdAluno)
              .get()
              .then(async (doc1)=>{
               res2.push({
                Id: res[i].Id,
                Nome: doc1.data().Nome,  
                Telefone: doc1.data().Telefone, 
                IMC: res[i].IMC, 
                Ativo: res[i].Ativo,
                PanturrilhaDir: res[i].PanturrilhaDir, 
                PanturrilhaEsq: res[i].PanturrilhaEsq, 
                PernaDir: res[i].PernaDir, 
                PernaEsq: res[i].PernaEsq, 
                Quadril: res[i].Quadril, 
                Cintura: res[i].Cintura, 
                AnteBracoDir: res[i].AnteBracoDir, 
                AnteBracoEsq: res[i].AnteBracoEsq, 
                BracoDir: res[i].BracoDir, 
                BracoEsq: res[i].BracoEsq, 
                Peitoral: res[i].Peitoral, 
                Ombro: res[i].Ombro, 
                Altura: res[i].Altura, 
                Peso: res[i].Peso, 
                IdAluno: res[i].IdAluno, 
                dataDaCricao: res[i].dataDaCricao,
                });
           const novoItem = {
                  value: res[i].IdAluno,
                  label: doc1.data().Nome
                };
                const existe = listra2.some(item => item.value === novoItem.value || item.label === novoItem.label);

                if (!existe) {
                  listra2.push(novoItem);
                }

                const novoItem3 = {
                  value: res[i].IdAluno,
                  label: doc1.data().Telefone
                };
                const existe3 = listra3.some(item => item.value === novoItem3.value || item.label === novoItem3.label);

                if (!existe3) {
                  listra3.push(novoItem3);
                }

               
              
              });
             var Porcentagem = Part/Quantidade
             setProgress(Porcentagem*100)
            }



         

            res2.sort((a,b)=>{
              if(a.dataDaCricao < b.dataDaCricao) {
                return 1;
              } else {
                return -1;
              }
            });
             listra2.sort((a,b)=>{
              if(a.select < b.select) {
                return -1;
              } else {
                return 1;
              }
            });
             listra3.sort((a,b)=>{
              if(a.select < b.select) {
                return -1;
              } else {
                return 1;
              }
            });
            setCarreg(false)
            setListTel(listra3)
            setListCliente(listra2)
            setUsuariosContServ(res2);
      });
      
 
  },
  TACriarMedidasAlunos: async(IMC, PanturrilhaDir, PanturrilhaEsq, PernaDir, PernaEsq, Quadril, Cintura, AnteBracoDir, AnteBracoEsq, BracoDir, BracoEsq, Peitoral, Ombro, Altura, Peso, IdAluno, Nome, Telefone, IdConta, InfIdUse,  IdUse,   setMsgErro, setLoading, setAlertTipo, setAlert, setAddList)=> {

        
    await db.collection("MedidasAlunos").add({
          Ativo:true, 
          IMC, 
          PanturrilhaDir, 
          PanturrilhaEsq, 
          PernaDir, 
          PernaEsq, 
          Quadril, 
          Cintura, 
          AnteBracoDir, 
          AnteBracoEsq, 
          BracoDir, 
          BracoEsq, 
          Peitoral, 
          Ombro, 
          Altura, 
          Peso, 
          IdAluno, 
          Nome, 
          Telefone, 
          IdConta,
          dataDaCricao:new Date().getTime(),
          }).then(async (doc1) => {
            var IdMedida = doc1.id;
           
               
              await db.collection("Acoes").add({
              dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Criar", 
               Sessão:"Medidas",
               IdSofredor:IdMedida,
              }).then(async (doc2) => {
                })

            setAlert("Criado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

             setAddList({
                Id: IdMedida,
                Ativo:true,
                IMC, 
                PanturrilhaDir, 
                PanturrilhaEsq, 
                PernaDir, 
                PernaEsq, 
                Quadril, 
                Cintura, 
                AnteBracoDir, 
                AnteBracoEsq, 
                BracoDir, 
                BracoEsq, 
                Peitoral, 
                Ombro, 
                Altura, 
                Peso, 
                IdAluno, 
                Nome, 
                Telefone, 
                IdConta,
                dataDaCricao:new Date().getTime(),
              })
              
           
                
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

          
         
        
     
    },
  TAListAlunosMedidas: async(IdConta, setListTel, setListAluno)=> {
         
          await db.collection("Alunos")
          .where("Ativo", "==", true)
          .where("IdConta", "==", IdConta)
          .get()
          .then(async (querySnapshot)=>{
           
          
            let listra2 = []; 
            let listra3 = []; 
            querySnapshot.forEach((doc) => {
               
                listra2.push({
                  value: doc.id,
                  label: doc.data().Nome,
                  Telefone:doc.data().Telefone,     
                  }); 
                listra3.push({
                  value: doc.id,
                  label:doc.data().Telefone, 
                  Nome:doc.data().Nome,    
                  });

            });
           
             listra2.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
             listra3.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
            setListTel(listra3)
            setListAluno(listra2)
           
      });
 
  },
   TAListPagamentosClientes: async(Dados, IdContRes, DataFim, DataIni,  IdConta, setQuant, setUsuariosContServ, setListCliente, setListTel, setCarreg , setProgress)=> {
    var variac = 0 
    var DateTemp = new Date(DataIni);
    var currentDate = "";
    var Dia = DateTemp.getDate(); 
    var Mes = (DateTemp.getMonth()+1);
    var Ano = DateTemp.getFullYear();
    Dia = Dia < 10 ? '0'+Dia : Dia;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+Dia;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    var variac1 = 0 
    var DateTemp1 = new Date(DataFim);
    var currentDate1 = "";
    var Dia1 = DateTemp1.getDate(); 
    var Mes1 = (DateTemp1.getMonth()+1);
    var Ano1 = DateTemp1.getFullYear();
    Dia1 = Dia1 < 10 ? '0'+Dia1 : Dia1;
    Mes1 = Mes1 < 10 ? '0'+Mes1 : Mes1;
    currentDate1 = Ano1+'-'+Mes1+'-'+Dia1;
    variac1 = new Date(currentDate1 +"T23:59:00.000").getTime();
   
         var Quantidade = 0;

          await db.collection("ClientesTiket")
          .where("TempLimitAtiv", "<=", variac1)
          .where("TempLimitAtiv", ">=", variac)
          .where("IdConta", "==", IdConta)
           .get()
          .then(async (querySnapshot)=>{
            Quantidade = querySnapshot.size;
            setQuant(querySnapshot.size);
            var res = [];
            var res2 = [];
            let listra2 = []; 
            let listra3 = []; 
            querySnapshot.forEach((doc) => {
                res.push({
                Id: doc.id,
                Nome: doc.data().Nome,  
                Telefone: doc.data().Telefone, 
                TempLimitAtiv: doc.data().TempLimitAtiv,
                IdConta:doc.data().IdConta,
                Pago:doc.data().Pago,
                AppLimit:doc.data().AppLimit,
                ValorApp:doc.data().ValorApp,
                QuantApp:doc.data().QuantApp,
                Mensalidade:doc.data().Mensalidade,
                ValorTotal:doc.data().ValorTotal,
                Alunos:doc.data().Alunos,
                DataPagamento:doc.data().DataPagamento? doc.data().DataPagamento:0,
                });
                    
            });

             var Part = 0; 
            for(let i in  res){
              Part = Part+1;
              await db.collection("Users")
              .doc(res[i].IdConta)
              .get()
              .then(async (doc1)=>{
               res2.push({
                Id: res[i].Id,
                Nome: doc1.data().Nome,  
                Telefone: doc1.data().Telefone, 
                TempLimitAtiv: res[i].TempLimitAtiv,
                IdConta:res[i].IdConta,
                Pago:res[i].Pago,
                AppLimit:res[i].AppLimit,
                ValorApp:res[i].ValorApp,
                QuantApp:res[i].QuantApp,
                Mensalidade:res[i].Mensalidade,
                ValorTotal:res[i].ValorTotal,
                Alunos:res[i].Alunos,
                DataPagamento:res[i].DataPagamento,
                });
      
              });

             var Porcentagem = Part/Quantidade
             setProgress(Porcentagem*100)
            }

            res2.sort((a,b)=>{
              if(a.TempLimitAtiv < b.TempLimitAtiv) {
                return 1;
              } else {
                return -1;
              }
            });
           
            setCarreg(false)
            setUsuariosContServ(res2);
      });
      
 
  },
  TAPagarTicketAluno: async(IdConta, IdUse,  InfIdConta, InfIdUse, Porcen, Id, Nome, Telefone, IdContaRes, DataAtual,   Mensalidade,   UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert)=> {
    console.log(Mensalidade)
    var variac = 0;
    var DateTemp = new Date(DataAtual);
    var DiaD = DateTemp.getDate();
    console.log(DateTemp.getMonth())
    if(DateTemp.getMonth() === 11){

    var now =new Date();
    var Dia = DateTemp.getDate();
    var currentDate = "";  
    var Mes = 1;
    var Ano = (DateTemp.getFullYear()+1);
    Dia = Dia < 10 ? '0'+Dia : Dia;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+Dia;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    } else{

    var now =new Date();
    var Dia = DateTemp.getDate();
    console.log(Dia)
    var currentDate = ""; 
    var Mes = (DateTemp.getMonth()+2);
    var Ano = DateTemp.getFullYear();
    Dia = Dia < 10 ? '0'+Dia : Dia;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+Dia;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    }
    
   console.log(variac)
    

        await db.collection("AlunoTicket").doc(Id).update({
          "Mensalidade":Mensalidade,
          "Pago":true,
          "Nome":Nome,
          "Telefone":Telefone,
           "DataPagamento":new Date().getTime()
          }).then(async (doc0) => {

            await db.collection("AlunoTicket").add({
               IdConta:IdConta,
               Nome, 
               Telefone,
               TempLimitAtiv:variac,
               Pago:false,
               Mensalidade:0,
               IdAluno:IdContaRes,
               DataPagamento:0
              }).then(async (doc1) => {

                 await db.collection("Alunos").doc(IdContaRes).update({
                 "TempLimitAtiv":variac,
                 "IdTicket":doc1.id,
                }).then(async (doc2) => {

                  
                    await db.collection("Acoes").add({
                      dataDaAcao:new Date().getTime(),
                      IdExecutor:IdUse,
                      NomeExecutor:InfIdUse.Nome,
                      TelefoneExecutor:InfIdUse.Telefone,
                      IdConta:IdConta,
                      Acao:"Pagar", 
                      Sessão:"Recebimentos",
                      IdSofredor:Id,
                      }).then(async (doc2) => {
                      })
                      setAlert("Tiket Pago");
                      setAlertTipo("success");
                      setLoading(false)
       const novaLista = UsuariosContServ.map(item =>
                      item.Id === Id ? { ...item, "Mensalidade":Mensalidade,
                                                  "Pago":true,
                                                  "Nome":Nome,
                                                  "Telefone":Telefone,} 
                                                  : item);

                      setUsuariosContServ([...novaLista]);
                  
                });

              })
           
             
          

         
              
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

          
          
         
          
     
    },
  TAAlunosDadosPagar: async(IdContaRes, setPorcen)=> {
       
          await db.collection("Alunos")
          .doc(IdContaRes)
          .get()
          .then(async (doc)=>{
           
          setPorcen(doc.data())
          
           });

  },
    TAListRecebimentosAlunos: async(Dados, IdContRes, DataFim, DataIni,  IdConta, setQuant, setUsuariosContServ, setListCliente, setListTel, setCarreg, setProgress,)=> {
    var variac = 0 
    var DateTemp = new Date(DataIni);
    var currentDate = "";
    var Dia = DateTemp.getDate(); 
    var Mes = (DateTemp.getMonth()+1);
    var Ano = DateTemp.getFullYear();
    Dia = Dia < 10 ? '0'+Dia : Dia;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+Dia;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    var variac1 = 0 
    var DateTemp1 = new Date(DataFim);
    var currentDate1 = "";
    var Dia1 = DateTemp1.getDate(); 
    var Mes1 = (DateTemp1.getMonth()+1);
    var Ano1 = DateTemp1.getFullYear();
    Dia1 = Dia1 < 10 ? '0'+Dia1 : Dia1;
    Mes1 = Mes1 < 10 ? '0'+Mes1 : Mes1;
    currentDate1 = Ano1+'-'+Mes1+'-'+Dia1;
    variac1 = new Date(currentDate1 +"T23:59:00.000").getTime();
   
     var Quantidade = 0;
    
          await db.collection("AlunoTicket")
          .where("TempLimitAtiv", "<=", variac1)
          .where("TempLimitAtiv", ">=", variac)
          .where("IdConta", "==", IdContRes)
           .get()
          .then(async (querySnapshot)=>{
          Quantidade = querySnapshot.size;
            setQuant(querySnapshot.size);
            var res = [];
            var res2 = [];
            let listra2 = []; 
            let listra3 = []; 
            querySnapshot.forEach((doc) => {

                res.push({
                Id: doc.id,
                Nome: doc.data().Nome,  
                Telefone: doc.data().Telefone, 
                TempLimitAtiv: doc.data().TempLimitAtiv,
                Pago:doc.data().Pago,
                Mensalidade:doc.data().Mensalidade,
                IdAluno:doc.data().IdAluno,
                DataPagamento:doc.data().DataPagamento? doc.data().DataPagamento: 0,
                });
                 
            });

            var Part = 0; 
            for(let i in  res){
              Part = Part+1;
              await db.collection("Alunos")
              .doc(res[i].IdAluno)
              .get()
              .then(async (doc1)=>{
               res2.push({
                Id: res[i].Id,
                Nome: doc1.data().Nome,  
                Telefone: doc1.data().Telefone, 
                TempLimitAtiv: res[i].TempLimitAtiv,
                Pago:res[i].Pago,
                Mensalidade:res[i].Mensalidade,
                IdAluno:res[i].IdAluno,
                DataPagamento:res[i].DataPagamento,
                });
                  
           const novoItem = {
                  value: res[i].IdAluno,
                  label: doc1.data().Nome
                };
                const existe = listra2.some(item => item.value === novoItem.value || item.label === novoItem.label);

                if (!existe) {
                  listra2.push(novoItem);
                }

                const novoItem3 = {
                  value: res[i].IdAluno,
                  label: doc1.data().Telefone
                };
                const existe3 = listra3.some(item => item.value === novoItem3.value || item.label === novoItem3.label);

                if (!existe3) {
                  listra3.push(novoItem3);
                }

               
              
              });
             var Porcentagem = Part/Quantidade
             setProgress(Porcentagem*100)
            }



         

            res2.sort((a,b)=>{
              if(a.TempLimitAtiv < b.TempLimitAtiv) {
                return 1;
              } else {
                return -1;
              }
            });
             listra2.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
             listra3.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
            setCarreg(false)
            setListTel(listra3)
            setListCliente(listra2)
            setUsuariosContServ(res2);
      });
      
 
  },
  TAEditarAlunosTreino: async(TempDescanso, TemAtulizLimit, AtualizaAtivo, Treino, Id,  IdConta, InfIdUse,  IdUse,   UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert, setAddList)=> {
   
   
    var TATempDescanso = parseInt(TempDescanso)
   var TATemAtulizLimit = parseInt(TemAtulizLimit)
    
   var variac = (86400000*30*TATemAtulizLimit)    
   var Temp = new Date().getTime()
 
         await db.collection("Alunos").doc(Id).update({
          "TempDescanso":TATempDescanso,
          "TemAtulizLimit":TATemAtulizLimit,
          "DataDaAtualizacao":Temp+variac,
          AtualizaAtivo, 
          Treino,
          }).then(async (doc1) => {

            await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"AtualizarTreinos", 
               Sessão:"Alunos",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })

            setAlert("Atualizado Com Sucesso");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
            "TempDescanso":TATempDescanso,
            "TemAtulizLimit":TemAtulizLimit,
            "DataDaAtualizacao":Temp+variac, 
            AtualizaAtivo, 
            Treino,
            } : item);
          setUsuariosContServ(novaLista);
          
            
          })

    

     
    },
  TAListTreinosSelect: async(IdConta, setListTreinSalv)=> {
    
      
          await db.collection("MemoriaTreino")
          .where("IdConta", "==",IdConta)
          .where("Ativo", "==",true)
           .get()
          .then(async (querySnapshot)=>{
           
             var res = [];
          
            querySnapshot.forEach((doc) => {
                res.push({
                id: doc.id,
                value: doc.id,
                label: doc.data().Nome,
                Nome: doc.data().Nome, 
                Ativo: doc.data().Ativo,
                NomeUser: doc.data().NomeUser, 
                TelefoneUser: doc.data().TelefoneUser, 
                Treino: doc.data().Treino,
                IdUser: doc.data().IdUser,
                dataDaCricao: doc.data().dataDaCricao,
                }); 

             

                    
            });
            res.sort((a,b)=>{
              if(a.Nome < b.Nome) {
                return -1;
              } else {
                return 1;
              }
            });
            
            setListTreinSalv(res);
      });
      
          
 
  },
  TADesativandoTreino: async(Dados, Id, IdConta, IdUse, InfIdUse, setAlertTipo, setAlert)=> {
    
   
    await db.collection("MemoriaTreino").doc(Id).update({
     "Ativo":false, 
    }).then(async ()=>{
        await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Desativar", 
               Sessão:"Treinos",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })
      setAlert("Desativado com Sucesso");
      setAlertTipo("success");
    });
  },
   TAAtivandoTreino: async(Dados, Id, IdConta, IdUse, InfIdUse, setAlertTipo, setAlert)=> {
 
    await db.collection("MemoriaTreino").doc(Id).update({
     "Ativo":true, 
    }).then(async ()=>{
       await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Ativar", 
               Sessão:"Treinos",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })
      setAlert("Ativado com Sucesso");
      setAlertTipo("success");
    });
  },
  TAEditarTreino: async(Id, InfIdUse, IdUse, IdConta, Nome, Treino, UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert)=> {
     
    await db.collection("MemoriaTreino").doc(Id).update({
          Nome,
          Treino,
          }).then(async (doc1) => {
            
              await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar", 
               Sessão:"Treinos",
               IdSofredor:Id,
              }).then(async (doc2) => {
                })

            setAlert("Atualizado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
            Nome,
            Treino, 
            } : item);
          setUsuariosContServ(novaLista);
              
           
                
             
          })
          .catch((error) => {
            console.log(error)
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

          
          
         
        
     
    },
   TAListTreinos: async(Dados, IdContRes, setQuant, setUsuariosContServ, setListCliente, setListNomeTrei, setProgress, setCarreg)=> {
       var Quantidade = 0;
          await db.collection("MemoriaTreino")
          .where("IdConta", "==",IdContRes)
           .get()
          .then(async (querySnapshot)=>{
             Quantidade = querySnapshot.size;
             if(querySnapshot.size === 0){
               setCarreg(false)
             }
              
            setQuant(querySnapshot.size);
            var res = [];
            var res2 = [];
            let listra2 = []; 
            let listra3 = []; 

            querySnapshot.forEach((doc) => {
                res.push({
                Id: doc.id,
                Nome: doc.data().Nome, 
                Ativo:doc.data().Ativo,
                NomeUser:doc.data().NomeUser, 
                TelefoneUser:doc.data().TelefoneUser, 
                Treino:doc.data().Treino,
                IdUser:doc.data().IdUser,
                dataDaCricao:doc.data().dataDaCricao,
                IdConta:doc.data().IdConta,
                }); 

                const novoItem3 = {
                  value: doc.id,
                   label: doc.data().Nome,  
                };
                const existe3 = listra3.some(item => item.value === novoItem3.value || item.label === novoItem3.label);

                if (!existe3) {
                  listra3.push(novoItem3);
                }

                
            });
              var Part = 0;

              for(let i in  res){
             
              await db.collection("Users")
              .doc(res[i].IdUser)
              .get()
              .then(async (doc1)=>{

                res2.push({
                Id: res[i].Id,
                Nome: res[i].Nome,  
                Ativo:res[i].Ativo,
                NomeUser:doc1.data().Nome, 
                TelefoneUser:doc1.data().Telefone, 
                Treino:res[i].Treino,
                IdUser:res[i].IdUser,
                dataDaCricao:res[i].dataDaCricao,
                IdConta:res[i].IdConta,
                 });
                 
                const novoItem = {
                  value: doc1.id,
                  label: doc1.data().Nome,  
                };

                const existe = listra2.some(item => item.value === novoItem.value || item.label === novoItem.label);
                if (!existe) {
                  listra2.push(novoItem);
                }


                });

                Part = Part + 1;    
                var Porcentagem = Part/Quantidade
                setProgress(Porcentagem*100)   
              }

            res2.sort((a,b)=>{
              if(a.Nome < b.Nome) {
                return -1;
              } else {
                return 1;
              }
            });
            
             listra2.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });

             listra3.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
           
            setListNomeTrei(listra3)
            setListCliente(listra2)
            setUsuariosContServ(res2);
      });
 
  },
   TACriarTreino: async(InfIdUse, IdUse, IdConta, Nome, Treino, setMsgErro, setLoading, setAlertTipo, setAlert, setAddList)=> {

         await db.collection("MemoriaTreino")
          .where("Nome", "==", Nome)
          .where("IdConta", "==", IdConta)
           .get()
          .then(async (querySnapshot)=>{
            if(querySnapshot.size === 0){

    
    await db.collection("MemoriaTreino").add({
          Nome,
          Ativo:true,
          NomeUser:InfIdUse.Nome, 
          TelefoneUser:InfIdUse.Telefone, 
          Treino,
          IdUser:IdUse,
          IdConta,
          dataDaCricao:new Date().getTime(),
          }).then(async (doc1) => {
            var IdAluno = doc1.id;
           
               
              await db.collection("Acoes").add({
              dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Criar", 
               Sessão:"Treinos",
               IdSofredor:IdAluno,
              }).then(async (doc2) => {
                })

            setAlert("Criado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

             setAddList({
                Id: IdAluno,
                Nome,
                Ativo:true,
                NomeUser:InfIdUse.Nome, 
                TelefoneUser:InfIdUse.Telefone, 
                Treino,
                IdUser:IdUse,
                dataDaCricao:new Date().getTime(),
              })
              
           
                
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

          
           } else {
            setLoading(false)
           setMsgErro("Já existe um Treino com Esse Nome!")
            }
          });
         
        
     
    },
   TAListdeCatTreino: async(IdConta, setListCategoria, setListExercicio)=> {
        
      await db.collection("Categorias")
      .where("IdConta", "==", IdConta)
      .where("Ativo", "==", true)
      .get()
      .then((querySnapshot) => {
        
        var res = []; 

        querySnapshot.forEach((doc) => {
            res.push({
              value: doc.id,
              label: doc.data().Nome,   
            });  
        });
          
            res.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
        setListCategoria(res);    
      
          });
    
         await db.collection("Exercicios")
          .where("IdConta", "==", IdConta)
          .where("Ativo", "==", true)
           .get()
          .then(async (querySnapshot)=>{
      
            var res = []; 
           
            querySnapshot.forEach((doc) => {
                res.push({
                  Id: doc.id,
                  Nome: doc.data().Nome, 
                  IdConta: doc.data().IdConta, 
                  IdCategoria: doc.data().IdCategoria,
                  Categoria: doc.data().Categoria, 
                  Ativo: doc.data().Ativo, 
                  TempoAtivo: doc.data().TempoAtivo, 
                  BenefAtivo: doc.data().BenefAtivo, 
                  FazerAtivo: doc.data().FazerAtivo, 
                  MuscuAtivo: doc.data().MuscuAtivo,  
                  Beneficios: doc.data().Beneficios, 
                  ComoFazer: doc.data().ComoFazer,  
                  UrlTrenio: doc.data().UrlTrenio,
                  UrlMusculo: doc.data().UrlMusculo,
                  dataCriacao: doc.data().dataCriacao,
    
                }); 
              
                       
            });
            res.sort((a,b)=>{
              if(a.Nome < b.Nome) {
                return -1;
              } else {
                return 1;
              }
            });
             
           
           
            setListExercicio(res);
      });
      
    },
   TADesativandoAluno: async(Dados, Id, IdConta, IdUse, InfIdUse, setAlertTipo, setAlert)=> {
    
    const Setor = "Desativando Condicional Serv";
    await db.collection("Alunos").doc(Id).update({
     "Ativo":false, 
    }).then(async ()=>{
        await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Desativar", 
               Sessão:"Alunos",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })
      setAlert("Desativado com Sucesso");
      setAlertTipo("success");
    });
  },
   TAAtivandoAluno: async(Dados, Id, IdConta, IdUse, InfIdUse, setAlertTipo, setAlert)=> {
 
    await db.collection("Alunos").doc(Id).update({
     "Ativo":true, 
    }).then(async ()=>{
       await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Ativar", 
               Sessão:"Alunos",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })
      setAlert("Ativado com Sucesso");
      setAlertTipo("success");
    });
  },
  TAEditarAlunos: async(ListEsp, Id, TelefoneRes, Imgs1Res, GratisAtiv, IdConta, InfIdUse,  IdUse, MedidasAtiv, Versao,  Nome,  Imgs2,  Telefone,   Mensalidade, DiaMes,  Estado, Cidade, Bairro, Num, End, UsuariosContServ, setUsuariosContServ, setMsgErro, setLoading, setAlertTipo, setAlert, setAddList)=> {
   var TAMensalidade = parseInt(Mensalidade)
   var TADiaMes = parseInt(DiaMes)

   if(ListEsp.GratisAtiv === GratisAtiv){
     
     if(GratisAtiv){

      if(ListEsp.Telefone === Telefone){
     
        let Url2 = "";
        if( Imgs1Res !== Imgs2){
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
        }
         } else {
           Url2 = Imgs2
         }

         await db.collection("Alunos").doc(Id).update({
          Nome,
          ImgAluno:Url2,  
          Mensalidade:TAMensalidade, 
          DiaMes:parseInt(DiaMes),  
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End,
          TempLimitAtiv:0,
          MedidasAtiv,
          GratisAtiv,
          }).then(async (doc1) => {

            await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar", 
               Sessão:"Alunos",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })

            setAlert("Atualizado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
            Id:Id,
            Nome,
            ImgAluno:Url2,  
            Mensalidade:TAMensalidade, 
            DiaMes:parseInt(DiaMes),  
            Estado, 
            Cidade, 
            Bairro, 
            Num, 
            End,
            TempLimitAtiv:0,
            MedidasAtiv,
            GratisAtiv,    
            } : item);
          setUsuariosContServ(novaLista);
          
            
          })

      } else {
        
        var ver = Telefone.replace("(", "55");
        var par1 = ver.replace(")", "");
        var par3 = par1.replace("-", "");

         const req = await fetch(`${URL_WHAT}phone-exists/${par3}`, 
        {
              method: 'GET',
              headers:{
                'Content-Type': 'application/json',
                'client-token': TOKEN_WHAT
              },
              
            });
    
        
          
            const json = await req.json(); 
            
          
            if(json.exists === true){

         
          await db.collection("Alunos")
          .where("Telefone", "==", Telefone)
          .where("IdConta", "==", IdConta)
           .get()
          .then(async (querySnapshot)=>{
            if(querySnapshot.size === 0){

        let Url2 = "";
        if( Imgs1Res !== Imgs2){
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
        }
         } else {
           Url2 = Imgs2
         }

         await db.collection("Alunos").doc(Id).update({
          Nome,
          ImgAluno:Url2,  
          Mensalidade:TAMensalidade,
          Telefone, 
          DiaMes:parseInt(DiaMes),  
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End,
          TempLimitAtiv:0,
          MedidasAtiv,
          GratisAtiv, 
          }).then(async (doc1) => {

            await db.collection("Acoes").add({
              dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar", 
               Sessão:"Alunos",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })

            setAlert("Atualizado Com Sucesso");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
            Id:Id,
             Nome,
            ImgAluno:Url2,  
            Mensalidade:TAMensalidade,
            Telefone, 
            DiaMes:parseInt(DiaMes),  
            Estado, 
            Cidade, 
            Bairro, 
            Num, 
            End,
            TempLimitAtiv:0,
            MedidasAtiv,
            GratisAtiv,    
            } : item);
          setUsuariosContServ(novaLista);
          
            
          })

            } else {
            setLoading(false)
           setMsgErro("Esse Número de Telefone Já é aluno da Empresa!")
            }
          });

          } else{
            setLoading(false)
           setMsgErro("Esse Número não está registrado no whatsapp, só é permitido número que é registrado no whatsapp!")
            }

      }

     } else {

    if(ListEsp.DiaMes === TADiaMes){

       if(ListEsp.Telefone === Telefone){
         
        let Url2 = "";
        if( Imgs1Res !== Imgs2){
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
        }
         } else {
           Url2 = Imgs2
         }

         await db.collection("Alunos").doc(Id).update({
          Nome,
          ImgAluno:Url2,  
          Mensalidade:TAMensalidade, 
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End, 
          MedidasAtiv,
          GratisAtiv,
          }).then(async (doc1) => {

            await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar", 
               Sessão:"Alunos",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })

            setAlert("Atualizado Com Sucesso");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
            Id:Id,
            Nome,
            ImgAluno:Url2,  
            Mensalidade:TAMensalidade,  
            Estado, 
            Cidade, 
            Bairro, 
            Num, 
            End,
            MedidasAtiv,
            GratisAtiv,    
            } : item);
          setUsuariosContServ(novaLista);
          
            
          })

      } else {
      
        var ver = Telefone.replace("(", "55");
        var par1 = ver.replace(")", "");
        var par3 = par1.replace("-", "");

         const req = await fetch(`${URL_WHAT}phone-exists/${par3}`, 
        {
              method: 'GET',
              headers:{
                'Content-Type': 'application/json',
                'client-token': TOKEN_WHAT
              },
              
            });
    
        
          
            const json = await req.json(); 
            
          
            if(json.exists === true){

         
          await db.collection("Alunos")
          .where("Telefone", "==", Telefone)
          .where("IdConta", "==", IdConta)
           .get()
          .then(async (querySnapshot)=>{
            if(querySnapshot.size === 0){

        let Url2 = "";
        if( Imgs1Res !== Imgs2){
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
        }
         } else {
           Url2 = Imgs2
         }

         await db.collection("Alunos").doc(Id).update({
          Nome,
          ImgAluno:Url2,  
          Mensalidade:TAMensalidade,
          Telefone,  
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End,
          MedidasAtiv,
          GratisAtiv, 
          }).then(async (doc1) => {

            await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar", 
               Sessão:"Alunos",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })

            setAlert("Atualizado Com Sucesso");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
            Id:Id,
             Nome,
            ImgAluno:Url2,  
            Mensalidade:TAMensalidade,
            Telefone,  
            Estado, 
            Cidade, 
            Bairro, 
            Num, 
            End,
            MedidasAtiv,
            GratisAtiv,    
            } : item);
          setUsuariosContServ(novaLista);
          
            
          })

            } else {
            setLoading(false)
           setMsgErro("Esse Número de Telefone Já é aluno da Empresa!")
            }
          });

          } else{
            setLoading(false)
           setMsgErro("Esse Número não está registrado no whatsapp, só é permitido número que é registrado no whatsapp!")
            }

      }

      } else {

        var variac = 0;     
        var DateTemp = new Date(ListEsp.TempLimitAtiv);
        var DiaD = DateTemp.getDate();
       
        var now =new Date();
        var Dia = now.getDate();
        var currentDate = "";
        var Mes = (DateTemp.getMonth()+1);
        var Ano = DateTemp.getFullYear();
        TADiaMes = TADiaMes < 10 ? '0'+TADiaMes : TADiaMes;
        Mes = Mes < 10 ? '0'+Mes : Mes;
        currentDate = Ano+'-'+Mes+'-'+TADiaMes;
        variac = new Date(currentDate +"T00:00:00.000").getTime();

     
        

       if(ListEsp.Telefone === Telefone){  
        
         let Url2 = "";
        if( Imgs1Res !== Imgs2){
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
        }
         } else {
           Url2 = Imgs2
         }

         await db.collection("Alunos").doc(Id).update({
          Nome,
          ImgAluno:Url2,  
          Mensalidade:TAMensalidade, 
          DiaMes:parseInt(DiaMes),  
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End,
          TempLimitAtiv:variac,
          MedidasAtiv,
          GratisAtiv,
          }).then(async (doc1) => {

              await db.collection("AlunoTicket").doc(ListEsp.IdTicket).update({
               Nome,
               Telefone,
               TempLimitAtiv:variac,
             }).then(() => {
                
              })
            await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar", 
               Sessão:"Alunos",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })

            setAlert("Atualizado Com Sucesso");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
            Id:Id,
            Nome,
            ImgAluno:Url2,  
            Mensalidade:TAMensalidade, 
            DiaMes:parseInt(DiaMes),  
            Estado, 
            Cidade, 
            Bairro, 
            Num, 
            End,
            TempLimitAtiv:variac,
            MedidasAtiv,
            GratisAtiv,    
            } : item);
          setUsuariosContServ(novaLista);
          
            
          })

      } else {
        
        var ver = Telefone.replace("(", "55");
        var par1 = ver.replace(")", "");
        var par3 = par1.replace("-", "");

        const req = await fetch(`${URL_WHAT}phone-exists/${par3}`, 
        {
              method: 'GET',
              headers:{
                'Content-Type': 'application/json',
                'client-token': TOKEN_WHAT
              },
              
            });
    
        
          
            const json = await req.json(); 
            
          
            if(json.exists === true){

         
          await db.collection("Alunos")
          .where("Telefone", "==", Telefone)
          .where("IdConta", "==", IdConta)
           .get()
          .then(async (querySnapshot)=>{
            if(querySnapshot.size === 0){

        let Url2 = "";
        if( Imgs1Res !== Imgs2){
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
        }
         } else {
           Url2 = Imgs2
         }

         await db.collection("Alunos").doc(Id).update({
          Nome,
          ImgAluno:Url2,  
          Mensalidade:TAMensalidade,
          Telefone, 
          DiaMes:parseInt(DiaMes),  
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End,
          TempLimitAtiv:variac,
          MedidasAtiv,
          GratisAtiv, 
          }).then(async (doc1) => {
            await db.collection("AlunoTicket").doc(ListEsp.IdTicket).update({
               Nome,
               Telefone,
               TempLimitAtiv:variac,
             }).then(() => {
                
              })

            await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar", 
               Sessão:"Alunos",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })

            setAlert("Atualizado Com Sucesso");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
            Id:Id,
            Nome,
            ImgAluno:Url2,  
            Mensalidade:TAMensalidade,
            Telefone, 
            DiaMes:parseInt(DiaMes),  
            Estado, 
            Cidade, 
            Bairro, 
            Num, 
            End,
            TempLimitAtiv:variac,
            MedidasAtiv,
            GratisAtiv,    
            } : item);
          setUsuariosContServ(novaLista);
          
            
          })

            } else {
            setLoading(false)
           setMsgErro("Esse Número de Telefone Já é aluno da Empresa!")
            }
          });

          } else{
            setLoading(false)
           setMsgErro("Esse Número não está registrado no whatsapp, só é permitido número que é registrado no whatsapp!")
            }

      }
              
    



      }

    }


   } else {
  if(GratisAtiv){

      if(ListEsp.Telefone === Telefone){
        
        let Url2 = "";
        if( Imgs1Res !== Imgs2){
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
        }
         } else {
           Url2 = Imgs2
         }

         await db.collection("Alunos").doc(Id).update({
          Nome,
          ImgAluno:Url2,  
          Mensalidade:TAMensalidade, 
          DiaMes: parseInt(DiaMes),  
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End,
          TempLimitAtiv:0,
          MedidasAtiv,
          GratisAtiv,        
          IdTicket:"",
          }).then(async (doc1) => {

              await db.collection("AlunoTicket").doc(ListEsp.IdTicket).delete().then(() => {
                
              })

            await db.collection("Acoes").add({
              dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar", 
               Sessão:"Alunos",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })

            setAlert("Atualizado Com Sucesso");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
            Id:Id,
            Nome,
            ImgAluno:Url2,  
            Mensalidade:TAMensalidade, 
            DiaMes: parseInt(DiaMes),  
            Estado, 
            Cidade, 
            Bairro, 
            Num, 
            End,
            TempLimitAtiv:0,
            MedidasAtiv,
            GratisAtiv,
            IdTicket:"",    
            } : item);
          setUsuariosContServ(novaLista);
          
            
          })

      } else {

        var ver = Telefone.replace("(", "55");
        var par1 = ver.replace(")", "");
        var par3 = par1.replace("-", "");

        const req = await fetch(`${URL_WHAT}phone-exists/${par3}`, 
        {
              method: 'GET',
              headers:{
                'Content-Type': 'application/json',
                'client-token': TOKEN_WHAT
              },
              
            });
    
        
          
            const json = await req.json(); 
            
          
            if(json.exists === true){

        
          await db.collection("Alunos")
          .where("Telefone", "==", Telefone)
          .where("IdConta", "==", IdConta)
           .get()
          .then(async (querySnapshot)=>{
            if(querySnapshot.size === 0){

        let Url2 = "";
        if( Imgs1Res !== Imgs2){
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
        }
         } else {
           Url2 = Imgs2
         }

         await db.collection("Alunos").doc(Id).update({
          Nome,
          ImgAluno:Url2,  
          Mensalidade:TAMensalidade,
          Telefone, 
          DiaMes: parseInt(DiaMes),  
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End,
          TempLimitAtiv:0,
          MedidasAtiv,
          GratisAtiv,
          IdTicket:"", 
          }).then(async (doc1) => {

            await db.collection("AlunoTicket").doc(ListEsp.IdTicket).delete().then(() => {
                
              })

            await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar", 
               Sessão:"Alunos",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })

            setAlert("Atualizado Com Sucesso");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
            Id:Id,
             Nome,
            ImgAluno:Url2,  
            Mensalidade:TAMensalidade,
            Telefone, 
            DiaMes:parseInt(DiaMes),  
            Estado, 
            Cidade, 
            Bairro, 
            Num, 
            End,
            TempLimitAtiv:0,
            MedidasAtiv,
            GratisAtiv,
            IdTicket:"",    
            } : item);
          setUsuariosContServ(novaLista);
          
            
          })

            } else {
            setLoading(false)
           setMsgErro("Esse Número de Telefone Já é aluno da Empresa!")
            }
          });

          } else{
            setLoading(false)
           setMsgErro("Esse Número não está registrado no whatsapp, só é permitido número que é registrado no whatsapp!")
            }

      }

   } else {

        var variac = 0;     
        var DateTemp = new Date();
        var DiaD = DateTemp.getDate();

   if(DiaD > TADiaMes){
    if(DateTemp.getMonth() === 11){

    var now =new Date();
    var Dia = now.getDate();
    var currentDate = "";  
    var Mes = 1;
    var Ano = (now.getFullYear()+1);
    TADiaMes = TADiaMes < 10 ? '0'+TADiaMes : TADiaMes;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+TADiaMes;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    } else{

    var now =new Date();
    var Dia = now.getDate();
    var currentDate = ""; 
    var Mes = (now.getMonth()+2);
    var Ano = now.getFullYear();
    TADiaMes = TADiaMes < 10 ? '0'+TADiaMes : TADiaMes;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+TADiaMes;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    }
    

    } else {

    var now =new Date();
    var Dia = now.getDate();
    var currentDate = "";
    var Mes = (now.getMonth()+1);
    var Ano = now.getFullYear();
    TADiaMes = TADiaMes < 10 ? '0'+TADiaMes : TADiaMes;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+TADiaMes;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    }

       if(ListEsp.Telefone === Telefone){
       
        let Url2 = "";
        if( Imgs1Res !== Imgs2){
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
        }
         } else {
           Url2 = Imgs2
         }
         await db.collection("AlunoTicket").add({
               IdAluno:Id,
               IdConta:IdConta,
               Nome, 
               Telefone,
               TempLimitAtiv:variac,
               Pago:false,
               Mensalidade:0,
              }).then(async (doc6) => {

         await db.collection("Alunos").doc(Id).update({
          Nome,
          ImgAluno:Url2,  
          Mensalidade:TAMensalidade, 
          DiaMes:parseInt(DiaMes),  
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End,
          TempLimitAtiv:variac,
          MedidasAtiv,
          GratisAtiv,
          IdTicket:doc6.id,
          }).then(async (doc1) => {

            
            await db.collection("Acoes").add({
              dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar", 
               Sessão:"Alunos",
               IdSofredor:Id,
              }).then(async (doc2) => {
              })

            setAlert("Atualizado Com Sucesso");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
            item.Id === Id ? { ...item,
            Id:Id,
            Nome,
            ImgAluno:Url2,  
            Mensalidade:TAMensalidade, 
            DiaMes:parseInt(DiaMes),  
            Estado, 
            Cidade, 
            Bairro, 
            Num, 
            End,
            TempLimitAtiv:variac,
            MedidasAtiv,
            GratisAtiv,
            IdTicket:doc6.id,    
            } : item);
          setUsuariosContServ(novaLista);
          
            
          })

          })
      } else {
        console.log("Entrou Aqui")
        var ver = Telefone.replace("(", "55");
        var par1 = ver.replace(")", "");
        var par3 = par1.replace("-", "");
        const req = await fetch(`${URL_WHAT}phone-exists/${par3}`, 
        {
              method: 'GET',
              headers:{
                'Content-Type': 'application/json',
                'client-token': TOKEN_WHAT
              },
              
            });
    
        
          
            const json = await req.json(); 
            
          
            if(json.exists === true){

           
          await db.collection("Alunos")
          .where("Telefone", "==", Telefone)
          .where("IdConta", "==", IdConta)
           .get()
          .then(async (querySnapshot)=>{
            if(querySnapshot.size === 0){

        let Url2 = "";
        if( Imgs1Res !== Imgs2){
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
        }
         } else {
           Url2 = Imgs2
         }
        await db.collection("AlunoTicket").add({
                IdAluno:Id,
                IdConta:IdConta,
                Nome, 
                Telefone,
                TempLimitAtiv:variac,
                Pago:false,
                Mensalidade:0,
                }).then(async (doc6) => {

                await db.collection("Alunos").doc(Id).update({
                  Nome,
                  ImgAluno:Url2,  
                  Mensalidade:TAMensalidade, 
                  DiaMes:parseInt(DiaMes),  
                  Estado, 
                  Cidade, 
                  Bairro, 
                  Num, 
                  End,
                  TempLimitAtiv:variac,
                  MedidasAtiv,
                  GratisAtiv,
                  IdTicket:doc6.id,
                  }).then(async (doc1) => {

                    
                    await db.collection("Acoes").add({
                      dataDaAcao:new Date().getTime(),
                      IdExecutor:IdUse,
                      NomeExecutor:InfIdUse.Nome,
                      TelefoneExecutor:InfIdUse.Telefone,
                      IdConta:IdConta,
                      Acao:"Atualizar", 
                      Sessão:"Alunos",
                      IdSofredor:Id,
                      }).then(async (doc2) => {
                      })

                    setAlert("Atualizado Com Sucesso");
                    setAlertTipo("success");
                    setLoading(false)

                    const novaLista = UsuariosContServ.map(item =>
                    item.Id === Id ? { ...item,
                    Id:Id,
                    Nome,
                    ImgAluno:Url2,  
                    Mensalidade:TAMensalidade, 
                    DiaMes:parseInt(DiaMes),  
                    Estado, 
                    Cidade, 
                    Bairro, 
                    Num, 
                    End,
                    TempLimitAtiv:variac,
                    MedidasAtiv,
                    GratisAtiv,
                    IdTicket:doc6.id,    
                    } : item);
                  setUsuariosContServ(novaLista);
                  
                    
                  })

                  })
     

            } else {
            setLoading(false)
           setMsgErro("Esse Número de Telefone Já é aluno da Empresa!")
            }
          });

          } else{
            setLoading(false)
           setMsgErro("Esse Número não está registrado no whatsapp, só é permitido número que é registrado no whatsapp!")
            }

      }

      

    }

  
  }
  

     
    },
   TAListAlunos: async(Dados, IdContRes, setCarreg, setQuant, setUsuariosContServ, setListCliente, setListTel, setProgress, setListMemoria)=> {
      
     var Quantidade = 0;
          await db.collection("Alunos")
          .where("IdConta", "==",IdContRes)
           .get()
          .then(async (querySnapshot)=>{
            Quantidade = querySnapshot.size; 
            if(querySnapshot.size === 0){
              setCarreg(false)
            }
            setQuant(querySnapshot.size);
            var res = [];
            let listra2 = []; 
            let listra3 = [];

            var Part = 0;
            querySnapshot.forEach((doc) => {
                res.push({
                Id: doc.id,
                Nome: doc.data().Nome, 
                Ativo: doc.data().Ativo, 
                ImgAluno: doc.data().ImgAluno, 
                Telefone: doc.data().Telefone, 
                Mensalidade: doc.data().Mensalidade, 
                DiaMes: doc.data().DiaMes,  
                Estado: doc.data().Estado, 
                Cidade: doc.data().Cidade, 
                Bairro: doc.data().Bairro, 
                Num: doc.data().Num, 
                End: doc.data().End,
                dataCriacao: doc.data().dataCriacao,
                IdConta: doc.data().IdConta,
                Conta: doc.data().Conta,
                TempLimitAtiv: doc.data().TempLimitAtiv,
                Versao: doc.data().Versao,
                MedidasAtiv: doc.data().MedidasAtiv,
                GratisAtiv: doc.data().GratisAtiv,
                TempDescanso:doc.data().TempDescanso,
                AtualizaAtivo:doc.data().AtualizaAtivo,
                TemAtulizLimit:doc.data().TemAtulizLimit,
                DataDaAtualizacao: doc.data().DataDaAtualizacao? doc.data().DataDaAtualizacao:0,
                Treino:doc.data().Treino,
                IdTicket:doc.data().IdTicket,
                }); 
               
               const novoItem = {
                  value: doc.id,
                  label: doc.data().Nome,
                };
                const existe = listra2.some(item => item.value === novoItem.value || item.label === novoItem.label);

                if (!existe) {
                  listra2.push(novoItem);
                }

                const novoItem3 = {
                  value: doc.id,
                  label: doc.data().Telefone,  
                };
                const existe3 = listra3.some(item => item.value === novoItem3.value || item.label === novoItem3.label);

                if (!existe3) {
                  listra3.push(novoItem3);
                }


            Part = Part + 1;    
            var Porcentagem = Part/Quantidade
             setProgress(Porcentagem*100)     
            });
           
            res.sort((a,b)=>{
              if(a.Nome < b.Nome) {
                return -1;
              } else {
                return 1;
              }
            });
             listra2.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
             listra3.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
         
            setListTel(listra3)
            setListCliente(listra2)
            setUsuariosContServ(res);
            setListMemoria(res)
      });
 
  },
  
    TACriarAlunos: async(GratisAtiv, IdConta, InfIdUse,  IdUse, MedidasAtiv, Versao,  Nome,  Imgs2,  Telefone,   Mensalidade, DiaMes,  Estado, Cidade, Bairro, Num, End,  setMsgErro, setLoading, setAlertTipo, setAlert, setAddList)=> {
      
    console.log(End)
    console.log(IdConta)
    var TAMensalidade = parseInt(Mensalidade)
    var TADiaMes = parseInt(DiaMes)
   


    
    var variac = 0;

    if(GratisAtiv === false){
    var DateTemp = new Date();
    var DiaD = DateTemp.getDate();
    if(DiaD > TADiaMes){
    if(DateTemp.getMonth() === 11){
    var now =new Date();
    var Dia = now.getDate();
    var currentDate = "";  
    var Mes = 1;
    var Ano = (now.getFullYear()+1);
    TADiaMes = TADiaMes < 10 ? '0'+TADiaMes : TADiaMes;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+TADiaMes;
    variac = new Date(currentDate +"T00:00:00.000").getTime();
    } else{
    var now =new Date();
    var Dia = now.getDate();
    var currentDate = ""; 
    var Mes = (now.getMonth()+2);
    var Ano = now.getFullYear();
    TADiaMes = TADiaMes < 10 ? '0'+TADiaMes : TADiaMes;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+TADiaMes;
    variac = new Date(currentDate +"T00:00:00.000").getTime();
    }
    } else {
    var now =new Date();
    var Dia = now.getDate();
    var currentDate = "";
    var Mes = (now.getMonth()+1);
    var Ano = now.getFullYear();
    TADiaMes = TADiaMes < 10 ? '0'+TADiaMes : TADiaMes;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+TADiaMes;
    variac = new Date(currentDate +"T00:00:00.000").getTime();
    }
    }
    
       
        var ver = Telefone.replace("(", "55");
        var par1 = ver.replace(")", "");
        var par3 = par1.replace("-", "");
         const req = await fetch(`${URL_WHAT}phone-exists/${par3}`, 
        {
              method: 'GET',
              headers:{
                'Content-Type': 'application/json',
                'client-token': TOKEN_WHAT
              },
              
            });
    
        
          
            const json = await req.json(); 
            
          
            if(json.exists === true){
              

        await db.collection("Alunos")
          .where("Telefone", "==", Telefone)
          .where("IdConta", "==", IdConta)
           .get()
          .then(async (querySnapshot)=>{
            if(querySnapshot.size === 0){

           
          
        let Url2 = "";
        
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
        }

      

        await db.collection("Alunos").add({
          Nome,
          Ativo:true, 
          ImgAluno:Url2, 
          Telefone, 
          Mensalidade:TAMensalidade, 
          DiaMes:parseInt(DiaMes),  
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End,
          dataCriacao:new Date().getTime(),
          IdConta:IdConta,
          Conta:"Aluno",
          TempLimitAtiv:variac,
          Versao,
          MedidasAtiv,
          GratisAtiv,
          TempDescanso:45,
          AtualizaAtivo:false,
          TemAtulizLimit:0,
          DataDaAtualizacao:0,
          IdTicket:"",
           Treino:[
            {
            Nome: "Treino A",
            Treino:[],  
            Concluido:false,
            Ativo:false,
            },
            {
            Nome: "Treino B",
            Treino:[],  
            Concluido:false,
            Ativo:false,
            },
            {
            Nome: "Treino C",
            Treino:[],  
            Concluido:false,
            Ativo:false,
            },
            {
            Nome: "Treino D",
            Treino:[],  
            Concluido:false,
            Ativo:false,
            },
            {
            Nome: "Treino E",
            Treino:[],  
            Concluido:false,
            Ativo:false,
            },
            {
            Nome: "Treino F",
            Treino:[],  
            Concluido:false,
            Ativo:false,
            },
            {
            Nome: "Treino G",
            Treino:[],  
            Concluido:false,
            Ativo:false,
            },
          ]
          }).then(async (doc1) => {
            var IdAluno = doc1.id;
           
               
              await db.collection("Acoes").add({
              dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Criar", 
               Sessão:"Alunos",
               IdSofredor:IdAluno,
              }).then(async (doc2) => {
                })


             if(GratisAtiv === false){
              await db.collection("AlunoTicket").add({
               IdAluno:IdAluno,
               IdConta:IdConta,
               Nome, 
               Telefone,
               TempLimitAtiv:variac,
               Pago:false,
               Mensalidade:0,
              }).then(async (doc6) => {

               await db.collection("Alunos").doc(IdAluno).update({
                IdTicket:doc6.id,
               })

            setAlert("Criado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

             setAddList({
                Id: IdAluno,
                Nome,
                Ativo:true, 
                ImgAluno:Url2, 
                Telefone, 
                Mensalidade:TAMensalidade, 
                DiaMes:parseInt(DiaMes),  
                Estado, 
                Cidade, 
                Bairro, 
                Num, 
                End,
                dataCriacao:new Date().getTime(),
                IdConta:IdConta,
                Conta:"Aluno",
                TempLimitAtiv:variac,
                Versao,
                MedidasAtiv,
                GratisAtiv,
                TempDescanso:45,
                AtualizaAtivo:false,
                TemAtulizLimit:0,
                IdTicket:doc6.id,
                Treino:[
                  {
                  Nome: "Treino A",
                  Treino:[],  
                  Concluido:false,
                  Ativo:false,
                  },
                  {
                  Nome: "Treino B",
                  Treino:[],  
                  Concluido:false,
                  Ativo:false,
                  },
                  {
                  Nome: "Treino C",
                  Treino:[],  
                  Concluido:false,
                  Ativo:false,
                  },
                  {
                  Nome: "Treino D",
                  Treino:[],  
                  Concluido:false,
                  Ativo:false,
                  },
                  {
                  Nome: "Treino E",
                  Treino:[],  
                  Concluido:false,
                  Ativo:false,
                  },
                  {
                  Nome: "Treino F",
                  Treino:[],  
                  Concluido:false,
                  Ativo:false,
                  },
                  {
                  Nome: "Treino G",
                  Treino:[],  
                  Concluido:false,
                  Ativo:false,
                  },
                ]
                
              })
                 

              })
              } else{

            setAlert("Criado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

             setAddList({
                Id: IdAluno,
                Nome,
                Ativo:true, 
                ImgAluno:Url2, 
                Telefone, 
                Mensalidade:TAMensalidade, 
                DiaMes:parseInt(DiaMes),  
                Estado, 
                Cidade, 
                Bairro, 
                Num, 
                End,
                dataCriacao:new Date().getTime(),
                IdConta:IdConta,
                Conta:"Aluno",
                TempLimitAtiv:variac,
                Versao,
                MedidasAtiv,
                GratisAtiv,
                TempDescanso:45,
                AtualizaAtivo:false,
                TemAtulizLimit:0,
                IdTicket:"",
                Treino:[
                  {
                  Nome: "Treino A",
                  Treino:[],  
                  Concluido:false,
                  Ativo:false,
                  },
                  {
                  Nome: "Treino B",
                  Treino:[],  
                  Concluido:false,
                  Ativo:false,
                  },
                  {
                  Nome: "Treino C",
                  Treino:[],  
                  Concluido:false,
                  Ativo:false,
                  },
                  {
                  Nome: "Treino D",
                  Treino:[],  
                  Concluido:false,
                  Ativo:false,
                  },
                  {
                  Nome: "Treino E",
                  Treino:[],  
                  Concluido:false,
                  Ativo:false,
                  },
                  {
                  Nome: "Treino F",
                  Treino:[],  
                  Concluido:false,
                  Ativo:false,
                  },
                  {
                  Nome: "Treino G",
                  Treino:[],  
                  Concluido:false,
                  Ativo:false,
                  },
                ]
              })
              }
           
                
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

           } else {
            setLoading(false)
           setMsgErro("Esse Número de Telefone Já é aluno da Empresa!")
            }
          });
          
         
            } else{
            setLoading(false)
           setMsgErro("Esse Número não está registrado no whatsapp, só é permitido número que é registrado no whatsapp!")
            }
     
    },
  TADadosIdContaIdUser: async(IdConta, IdUse, setInfIdConta, setInfIdUse)=> {
        
          await db.collection("Users")
          .doc(IdUse)
          .onSnapshot((doc) => {
           
          setInfIdUse(doc.data())
          
           });
          await db.collection("Users")
          .doc(IdConta)
          .onSnapshot((doc) => {
     
          setInfIdConta(doc.data())
          
           });
         
 
  },
  TAClientesDadosInicio: async(IdUse, setDadosCliente)=> {
        
          await db.collection("Users")
          .doc(IdUse)
          .get()
          .then(async (doc)=>{
           
          setDadosCliente(doc.data())
          
           });

         
 
  },
  TADownloadImg: async(Imgs2, setMsgErro, setLoading, setAlertTipo, setAlert )=> {
      const fileRef = storage.ref(Imgs2);

    // Pega a URL de download
    const url = await fileRef.getDownloadURL();
  
    },
    TAPagarTicketRepresentante: async(Porcen, Id, Nome, Telefone, IdConta, DataAtual,  AppLimit,  Mensalidade, QuantApp, ValorApp, Alunos, ValorTotal, UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert)=> {
   

        await db.collection("RepresentanteTiket").doc(Id).update({
          "PorcenMens":Porcen.PorcenMens,
          "Nome":Porcen.Nome,
          "Telefone":Porcen.Telefone,
          "ValorTotal":ValorTotal,
          "Pago":true,
          }).then(async (doc0) => {

              setAlert("Tiket Pago");
              setAlertTipo("success");
              setLoading(false)

              // Atualiza o objeto se Id bater
              const novaLista = UsuariosContServ.map(item =>
              item.Id === Id ? { ...item,  
              PorcenMens:Porcen.PorcenMens,
              Nome:Porcen.Nome,
              Telefone:Porcen.Telefone,
              ValorTotal:ValorTotal,
              Pago:true,} : item
              );

              setUsuariosContServ([...novaLista]);
                      
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

          
          
         
          
     
    },
  
     TAListPagamentos: async(Dados, IdContRes, DataFim, DataIni,  IdConta, setQuant, setUsuariosContServ, setListCliente, setListTel, setCarreg)=> {
    var variac = 0 
    var DateTemp = new Date(DataIni);
    var currentDate = "";
    var Dia = DateTemp.getDate(); 
    var Mes = (DateTemp.getMonth()+1);
    var Ano = DateTemp.getFullYear();
    Dia = Dia < 10 ? '0'+Dia : Dia;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+Dia;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    var variac1 = 0 
    var DateTemp1 = new Date(DataFim);
    var currentDate1 = "";
    var Dia1 = DateTemp1.getDate(); 
    var Mes1 = (DateTemp1.getMonth()+1);
    var Ano1 = DateTemp1.getFullYear();
    Dia1 = Dia1 < 10 ? '0'+Dia1 : Dia1;
    Mes1 = Mes1 < 10 ? '0'+Mes1 : Mes1;
    currentDate1 = Ano1+'-'+Mes1+'-'+Dia1;
    variac1 = new Date(currentDate1 +"T23:59:00.000").getTime();
   

    
          await db.collection("RepresentanteTiket")
          .where("TempLimitAtiv", "<=", variac1)
          .where("TempLimitAtiv", ">=", variac)
           .get()
          .then(async (querySnapshot)=>{
            setQuant(querySnapshot.size);
            var res = [];
            let listra2 = []; 
            let listra3 = []; 
            querySnapshot.forEach((doc) => {
                res.push({
                Id: doc.id,
                Nome: doc.data().Nome,  
                Telefone: doc.data().Telefone, 
                TempLimitAtiv: doc.data().TempLimitAtiv,
                IdConta:doc.data().IdConta,
                Pago:doc.data().Pago,
                Mensalidade:doc.data().Mensalidade,
                ValorTotal:doc.data().ValorTotal,
                NomeCli:doc.data().NomeCli,
                TelCli:doc.data().TelCli,
                PorcenMens:doc.data().PorcenMens,
                IdRepresentante:doc.data().IdRepresentante,   
                ExtratoImg:doc.data().ExtratoImg,
                });
                const novoItem = {
                  id: doc.id,
                  select: doc.data().Nome
                };
                const existe = listra2.some(item => item.id === novoItem.id || item.select === novoItem.select);

                if (!existe) {
                  listra2.push(novoItem);
                }

                const novoItem3 = {
                  id: doc.id,
                  select: doc.data().Telefone
                };
                const existe3 = listra3.some(item => item.id === novoItem3.id || item.select === novoItem3.select);

                if (!existe3) {
                  listra3.push(novoItem3);
                }
                    
            });
            res.sort((a,b)=>{
              if(a.TempLimitAtiv < b.TempLimitAtiv) {
                return 1;
              } else {
                return -1;
              }
            });
             listra2.sort((a,b)=>{
              if(a.select < b.select) {
                return -1;
              } else {
                return 1;
              }
            });
             listra3.sort((a,b)=>{
              if(a.select < b.select) {
                return -1;
              } else {
                return 1;
              }
            });
            setCarreg(false)
            setListTel(listra3)
            setListCliente(listra2)
            setUsuariosContServ(res);
      });
      
 
  },
   TAListRepresentantesSelect: async(Dados, setListRepres, setListRespTel)=> {
         
          await db.collection("Users")
          .where("Ativo", "==", true)
          .where("Conta", "==","Rep")
           .get()
          .then(async (querySnapshot)=>{
           
          
            let listra2 = []; 
            let listra3 = []; 
            querySnapshot.forEach((doc) => {
               
                listra2.push({
                  value: doc.id,
                  label: doc.data().Nome,      
                  }); 
                listra3.push({
                  value: doc.id,
                  label: doc.data().Telefone,      
                  });

            });
           
             listra2.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
             listra3.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
            setListRespTel(listra3)
            setListRepres(listra2)
           
      });
 
  },
   TAEditarRepresentante: async(Id, TelefoneRes, Dados, Nome, Telefone, Cidade, Estado, NomePix, Pix, PorcenMens, UsuariosContServ, setUsuariosContServ, setMsgErro, setLoading, setAlertTipo, setAlert)=> {
      
    
    var TAPorcenMens = parseInt(PorcenMens)
  

    if(TelefoneRes === Telefone){
      console.log("Entrou Sem Telefone "+Id)
       await db.collection("Users").doc(Id).update({
          Nome,
          PorcenMens:TAPorcenMens, 
          Estado,
          Cidade,
          NomePix,
          Pix,
          }).then(async (doc) => {
         
 
            setAlert("Editado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

              
            const novaLista = UsuariosContServ.map(item =>
                item.Id === Id ? { ...item, 
                Nome,
                PorcenMens:TAPorcenMens, 
                Estado,
                Cidade,
                NomePix,
                Pix, 
                } : item);
              setUsuariosContServ(novaLista);
           
   
             
          })
          .catch((error) => {
            console.log(error)
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

    } else {

    console.log("Entrou COm Telefone "+Id)
        // var ver = Telefone.replace("(", "55");
        // var par1 = ver.replace(")", "");
        // var par3 = par1.replace("-", "");
        // const req = await fetch(`${URL_WHAT}phone-exists/${par3}`, 
        // {
        //       method: 'GET',
        //       headers:{
        //         'Content-Type': 'application/json'
        //       },
              
        //     });
    
        
          
        //     const json = await req.json(); 
            
          
        //     if(json.exists === true){
              

        await db.collection("Users")
          .where("Telefone", "==", Telefone)
          .where("Conta", "==", "Rep")
           .get()
          .then(async (querySnapshot)=>{
            if(querySnapshot.size === 0){


         await db.collection("Users").doc(Id).update({
          Nome,
          PorcenMens:TAPorcenMens,
          Telefone, 
          Estado,
          Cidade,
          NomePix,
          Pix,
          }).then(async (doc) => {
         
 
            setAlert("Editado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

              
            const novaLista = UsuariosContServ.map(item =>
                item.Id === Id ? { ...item, 
                Nome,
                PorcenMens:TAPorcenMens,
                Telefone, 
                Estado,
                Cidade,
                NomePix,
                Pix, 
                } : item);
              setUsuariosContServ(novaLista);
           
   
             
          })
          .catch((error) => {
            console.log(error)
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

           } else {
            setLoading(false)
           setMsgErro("Esse Número de Telefone Já existe!")
            }
          });
          
         
          //   } else{
          //   setLoading(false)
          //  setMsgErro("Esse Número não está registrado no whatsapp, só é permitido número que é registrado no whatsapp!")
          //   }
           }
     
    },
   TADesativandoRepresentante: async(Dados, Id, setAlertTipo, setAlert)=> {
    
    const Setor = "Desativando Condicional Serv";
    await db.collection("Users").doc(Id).update({
     "Ativo":false, 
    }).then(()=>{
      setAlert("Desativado com Sucesso");
      setAlertTipo("success");
    });
  },
   TAAtivandoClientesRepresentante: async(Dados, Id, setAlertTipo, setAlert)=> {
 
    await db.collection("Users").doc(Id).update({
     "Ativo":true, 
    }).then(()=>{
      setAlert("Ativado com Sucesso");
      setAlertTipo("success");
    });
  },
   TAListRepresentantes: async(Dados, IdConta, setQuant, setUsuariosContServ, setListCliente, setListTel)=> {
         
          await db.collection("Users")
          .where("Conta", "==","Rep")
           .get()
          .then(async (querySnapshot)=>{
            setQuant(querySnapshot.size);
            var res = [];
            let listra2 = []; 
            let listra3 = []; 
            querySnapshot.forEach((doc) => {
                res.push({
                Id: doc.id,
                Nome: doc.data().Nome, 
                Ativo:doc.data().Ativo,
                PorcenMens:doc.data().PorcenMens,
                Telefone:doc.data().Telefone, 
                Estado:doc.data().Estado,
                Cidade:doc.data().Cidade,
                NomePix:doc.data().NomePix,
                Pix:doc.data().Pix,
                dataCriacao:doc.data().dataCriacao,
                IdConta:doc.data().IdConta,
                Conta:doc.data().Conta,
                }); 
                listra2.push({
                  value: doc.id,
                  label: doc.data().Nome,      
                  }); 
                listra3.push({
                  value: doc.id,
                  label: doc.data().Telefone,      
                  });      
            });
            res.sort((a,b)=>{
              if(a.Nome < b.Nome) {
                return -1;
              } else {
                return 1;
              }
            });
             listra2.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
             listra3.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
            setListTel(listra3)
            setListCliente(listra2)
            setUsuariosContServ(res);
      });
 
  },
  TACriarRepresentante: async(Dados, Nome, Telefone, Cidade, Estado, NomePix, Pix, PorcenMens, setMsgErro, setLoading, setAlertTipo, setAlert, setAddList)=> {
      
    
    var TAPorcenMens = parseInt(PorcenMens)
  
        // var ver = Telefone.replace("(", "55");
        // var par1 = ver.replace(")", "");
        // var par3 = par1.replace("-", "");
        // const req = await fetch(`${URL_WHAT}phone-exists/${par3}`, 
        // {
        //       method: 'GET',
        //       headers:{
        //         'Content-Type': 'application/json'
        //       },
              
        //     });
    
        
          
        //     const json = await req.json(); 
            
          
        //     if(json.exists === true){
              

        await db.collection("Users")
          .where("Telefone", "==", Telefone)
          .where("Conta", "==", "Rep")
           .get()
          .then(async (querySnapshot)=>{
            if(querySnapshot.size === 0){


        await db.collection("Users").add({
          Nome,
          Ativo:true,
          PorcenMens:TAPorcenMens,
          Telefone, 
          Estado,
          Cidade,
          NomePix,
          Pix,
          dataCriacao:new Date().getTime(),
          IdConta:"Geral",
          Conta:"Rep",
          }).then(async (doc) => {
            var IdConta = doc.id;
 
            setAlert("Criado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

             setAddList({
                Id:IdConta,
                Nome,
                Ativo:true,
                PorcenMens,
                Telefone, 
                Estado,
                Cidade,
                NomePix,
                Pix,
                dataCriacao:new Date().getTime(),
                IdConta:"Geral",
                Conta:"Rep",
              })
   
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

           } else {
            setLoading(false)
           setMsgErro("Esse Número de Telefone Já existe!")
            }
          });
          
         
          //   } else{
          //   setLoading(false)
          //  setMsgErro("Esse Número não está registrado no whatsapp, só é permitido número que é registrado no whatsapp!")
          //   }
     
    },
   TAPagarTicketCliente: async(Porcen, Id, Nome, Telefone, IdConta, DataAtual,  AppLimit,  Mensalidade, QuantApp, ValorApp, Alunos, ValorTotal, UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert)=> {
    console.log(Mensalidade)
    var variac = 0;
    var DateTemp = new Date(DataAtual);
    var DiaD = DateTemp.getDate();
    console.log(DateTemp.getMonth())

    if(DateTemp.getMonth() === 11){

    var now =new Date();
    var Dia = DateTemp.getDate();
    var currentDate = "";  
    var Mes = 1;
    var Ano = (DateTemp.getFullYear()+1);
    Dia = Dia < 10 ? '0'+Dia : Dia;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+Dia;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    } else {

    var now =new Date();
    var Dia = DateTemp.getDate();
    var currentDate = ""; 
    var Mes = (DateTemp.getMonth()+2);
    var Ano = DateTemp.getFullYear();
    Dia = Dia < 10 ? '0'+Dia : Dia;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+Dia;
    console.log(currentDate)
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    }
    
  
    

        await db.collection("ClientesTiket").doc(Id).update({
          "AppLimit":AppLimit,
          "Mensalidade":Mensalidade,
          "QuantApp":QuantApp,
          "ValorApp":ValorApp,
          "Alunos":Alunos,
          "ValorTotal":ValorTotal,
          "Pago":true,
          "DataPagamento":new Date().getTime()
          }).then(async (doc0) => {

            await db.collection("ClientesTiket").add({
               IdConta:IdConta,
               Nome, 
               Telefone,
               TempLimitAtiv:variac,
               Pago:false,
               AppLimit:false,
               ValorApp:0,
               QuantApp:0,
               Mensalidade:0,
               QuantAlunos:0,
               ValorTotal:0,
               Alunos:0,
               DataPagamento:0
              }).then(async (doc1) => {

                 await db.collection("Users").doc(IdConta).update({
                 "TempLimitAtiv":variac,
                  "IdTicket":doc1.id,
                }).then(async (doc2) => {

                  if(Porcen.IdRepresentante){

                 
                   await db.collection("Users")
                    .doc(Porcen.IdRepresentante)
                    .get()
                    .then(async (doc)=>{
                    
                    var NomeRep= doc.data().Nome;
                    var TelRep= doc.data().Telefone;
                    var Porcentagem = doc.data().PorcenMens;

                      await db.collection("RepresentanteTiket").add({
                      IdConta: IdConta,
                      Nome: NomeRep, 
                      Telefone: TelRep,
                      NomeCli: Porcen.Nome,
                      TelCli: Porcen.Telefone,
                      TempLimitAtiv:new Date().getTime(),
                      Pago:false,
                      Mensalidade: Mensalidade,
                      PorcenMens: Porcentagem,
                      IdRepresentante: Porcen.IdRepresentante,
                      ExtratoImg:"",
                      ValorTotal:0,
                      }).then(async (doc6) => {
         
                      setAlert("Tiket Pago");
                      setAlertTipo("success");
                      setLoading(false)

                      // Atualiza o objeto se Id bater
                      const novaLista = UsuariosContServ.map(item =>
                      item.Id === Id ? { ...item, AppLimit:AppLimit, Mensalidade:Mensalidade, QuantApp:QuantApp, ValorApp:ValorApp, Alunos:Alunos, ValorTotal:ValorTotal, Pago:true } : item
                      );

                      // Acrescenta um novo objeto no final da lista
                      const objetoNovo = {
                      Id:doc1.id,  
                      IdConta:IdConta,
                      Nome, 
                      Telefone,
                      TempLimitAtiv:variac,
                      Pago:false,
                      AppLimit:"",
                      ValorApp:"",
                      QuantApp:"",
                      Mensalidade:"",
                      QuantAlunos:"",
                      ValorTotal:"", };

                      setUsuariosContServ([...novaLista, objetoNovo]);
                       });
               
                   });

                    } else {
                      setAlert("Tiket Pago");
                      setAlertTipo("success");
                      setLoading(false)

                      // Atualiza o objeto se Id bater
                      const novaLista = UsuariosContServ.map(item =>
                      item.Id === Id ? { ...item, AppLimit:AppLimit, Mensalidade:Mensalidade, QuantApp:QuantApp, ValorApp:ValorApp, Alunos:Alunos, ValorTotal:ValorTotal, Pago:true } : item
                      );

                      // Acrescenta um novo objeto no final da lista
                      const objetoNovo = {
                      Id:doc1.id,  
                      IdConta:IdConta,
                      Nome, 
                      Telefone,
                      TempLimitAtiv:variac,
                      Pago:false,
                      AppLimit:"",
                      ValorApp:"",
                      QuantApp:"",
                      Mensalidade:"",
                      QuantAlunos:"",
                      ValorTotal:"", };

                      setUsuariosContServ([...novaLista, objetoNovo]);

                    }
                  
                });

              })
           
             
          

         
              
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

          
          
         
          
     
    },
  TAClientesDadosPagar: async(IdConta, setPorcen, setAlunos)=> {
         
          await db.collection("Users")
          .doc(IdConta)
          .get()
          .then(async (doc)=>{
           
          setPorcen(doc.data())
          
           });

            await db.collection("Alunos")
            .where("Ativo", "==", true)
            .where("IdConta", "==", IdConta)
           .get()
          .then(async (querySnapshot)=>{
           
            setAlunos(querySnapshot.size)
          });

 
  },
  TATualizandoData: async(Id, DataIni,  UsuariosContServ, setUsuariosContServ, setMsgErro, setLoading, setAlertTipo, setAlert)=> {
 

        await db.collection("ClientesTiket").doc(Id).update({
          "TempLimitAtiv":DataIni, 
          }).then(async (doc) => {
           
           
             
            setAlert("Data Editada Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
                item.Id === Id ? { ...item,  TempLimitAtiv:DataIni} : item);
              setUsuariosContServ(novaLista);

         
              
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

          
          
         
          
     
    },
    TAListRecebimentos: async(Dados, IdContRes, DataFim, DataIni,  IdConta, setQuant, setUsuariosContServ, setListCliente, setListTel, setCarreg)=> {
    var variac = 0 
    var DateTemp = new Date(DataIni);
    var currentDate = "";
    var Dia = DateTemp.getDate(); 
    var Mes = (DateTemp.getMonth()+1);
    var Ano = DateTemp.getFullYear();
    Dia = Dia < 10 ? '0'+Dia : Dia;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+Dia;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    var variac1 = 0 
    var DateTemp1 = new Date(DataFim);
    var currentDate1 = "";
    var Dia1 = DateTemp1.getDate(); 
    var Mes1 = (DateTemp1.getMonth()+1);
    var Ano1 = DateTemp1.getFullYear();
    Dia1 = Dia1 < 10 ? '0'+Dia1 : Dia1;
    Mes1 = Mes1 < 10 ? '0'+Mes1 : Mes1;
    currentDate1 = Ano1+'-'+Mes1+'-'+Dia1;
    variac1 = new Date(currentDate1 +"T23:59:00.000").getTime();
   

    
          await db.collection("ClientesTiket")
          .where("TempLimitAtiv", "<=", variac1)
          .where("TempLimitAtiv", ">=", variac)
           .get()
          .then(async (querySnapshot)=>{
            setQuant(querySnapshot.size);
            var res = [];
            let listra2 = []; 
            let listra3 = []; 
            querySnapshot.forEach((doc) => {
                res.push({
                Id: doc.id,
                Nome: doc.data().Nome,  
                Telefone: doc.data().Telefone, 
                TempLimitAtiv: doc.data().TempLimitAtiv,
                IdConta:doc.data().IdConta,
                Pago:doc.data().Pago,
                AppLimit:doc.data().AppLimit,
                ValorApp:doc.data().ValorApp,
                QuantApp:doc.data().QuantApp,
                Mensalidade:doc.data().Mensalidade,
                ValorTotal:doc.data().ValorTotal,
                Alunos:doc.data().Alunos,
                });
                const novoItem = {
                  value: doc.id,
                  label: doc.data().Nome
                };
                const existe = listra2.some(item => item.value === novoItem.value || item.label === novoItem.label);

                if (!existe) {
                  listra2.push(novoItem);
                }

                const novoItem3 = {
                  value: doc.id,
                  label: doc.data().Telefone
                };
                const existe3 = listra3.some(item => item.value === novoItem3.value || item.label === novoItem3.label);

                if (!existe3) {
                  listra3.push(novoItem3);
                }
                    
            });
            res.sort((a,b)=>{
              if(a.TempLimitAtiv < b.TempLimitAtiv) {
                return 1;
              } else {
                return -1;
              }
            });
             listra2.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
             listra3.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
            setCarreg(false)
            setListTel(listra3)
            setListCliente(listra2)
            setUsuariosContServ(res);
      });
      
 
  },
  TACriarExercicioClientes: async(Id, setPorcen)=> {
          var Quant = 0;
          var Part = 0;
          var res = []; 
          await db.collection("Exercicios")
          .where("IdConta", "==", "Geral")
          .where("Ativo", "==", true)
          .get()
          .then(async (querySnapshot)=>{
           
             Quant = querySnapshot.size;
            querySnapshot.forEach((doc) => {
                res.push({
                  Id: doc.id,
                  Nome: doc.data().Nome, 
                  IdConta: doc.data().IdConta, 
                  IdCategoria: doc.data().IdCategoria,
                  Categoria: doc.data().Categoria, 
                  Ativo: doc.data().Ativo, 
                  TempoAtivo: doc.data().TempoAtivo, 
                  BenefAtivo: doc.data().BenefAtivo, 
                  FazerAtivo: doc.data().FazerAtivo, 
                  MuscuAtivo: doc.data().MuscuAtivo,  
                  Beneficios: doc.data().Beneficios, 
                  ComoFazer: doc.data().ComoFazer,  
                  UrlTrenio: doc.data().UrlTrenio,
                  UrlMusculo: doc.data().UrlMusculo,
                  dataCriacao: doc.data().dataCriacao,
    
                }); 

                 

                
                       
            });
         var LitCat = []
          for(let i in res){
           
            if(Part <= Quant){
               
         const resultado = LitCat.find(p => p.Categoria === res[i].Categoria);
           
            if(resultado){
            console.log("Existe Categoria")
            console.log(res[i].Categoria)
             var IdCat = resultado.id

           
            console.log(IdCat)
          await db.collection("Exercicios").add({
          Nome:res[i].Nome, 
          IdConta:Id, 
          IdCategoria:IdCat,
          Categoria:res[i].Categoria, 
          Ativo:false, 
          TempoAtivo:res[i].TempoAtivo, 
          BenefAtivo:res[i].BenefAtivo, 
          FazerAtivo:res[i].FazerAtivo, 
          MuscuAtivo:res[i].MuscuAtivo,  
          Beneficios:res[i].Beneficios, 
          ComoFazer:res[i].ComoFazer,  
          UrlTrenio:res[i].UrlTrenio,
          UrlMusculo:res[i].UrlMusculo,
          dataCriacao:new Date().getTime(),
          }).then((doc3) => {
            Part = Part + 1; 
            console.log(Part)
            console.log(Quant)
            console.log((Part/Quant)*100)
             setPorcen((Part/Quant)*100)
          })
            
            } else {
             console.log("Não Existe Categoria")
            console.log(res[i].Categoria)
           await db.collection("Categorias").add({
                  Nome: res[i].Categoria,
                  DataCriar:new Date().getTime(),
                  Ativo:true,
                  IdConta: Id,
                  }).then(async (doc4)=>{
                    console.log(doc4.id)
                     LitCat.push({ id:doc4.id, Categoria:res[i].Categoria })
                     await db.collection("Exercicios").add({
                      Nome:res[i].Nome, 
                      IdConta:Id, 
                      IdCategoria:doc4.id,
                      Categoria:res[i].Categoria, 
                      Ativo:false, 
                      TempoAtivo:res[i].TempoAtivo, 
                      BenefAtivo:res[i].BenefAtivo, 
                      FazerAtivo:res[i].FazerAtivo, 
                      MuscuAtivo:res[i].MuscuAtivo,  
                      Beneficios:res[i].Beneficios, 
                      ComoFazer:res[i].ComoFazer,  
                      UrlTrenio:res[i].UrlTrenio,
                      UrlMusculo:res[i].UrlMusculo,
                      dataCriacao:new Date().getTime(),
                      }).then((doc3) => {
                        
                        Part = Part + 1; 
                        console.log(Part)
                        console.log(Quant)
                        console.log((Part/Quant)*100)
                        setPorcen((Part/Quant)*100)
                      })

                  })
            

            }
           
          

              
             }

                 }
        await db.collection("Users").doc(Id).update({
          "ExeciConcl":true, 
          }).then(async (doc) => { 

          });
              
            
      });
 
  },
  TAListClientesSelect: async(Dados, setListContas, setListContasTel)=> {
         
          await db.collection("Users")
          .where("Conta", "==","Cliente")
          .where("SubConta", "==", "Principal")
           .get()
          .then(async (querySnapshot)=>{
            
            var res = [{
                      value: "Geral",
                      label: "Geral",   
                      }]; 
            var res1 = [{
                      value: "Geral",
                      label: "Geral",   
                      }]; 
            querySnapshot.forEach((doc) => {
                res.push({
                value: doc.id,
                label: doc.data().Nome,
                Tel: doc.data().Telefone,
                }); 
                res1.push({
                value: doc.id,
                label: doc.data().Telefone,
                Nome: doc.data().Nome, 
                });     
            });
            res.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
            res1.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
            setListContas(res);
            setListContasTel(res1)
      });
 
  },
  
TAEditarTelClientes: async(Id, Telefone,  UsuariosContServ, setUsuariosContServ, setMsgErro, setLoading, setAlertTipo, setAlert  )=> {
 
        var ver = Telefone.replace("(", "55");
        var par1 = ver.replace(")", "");
        var par3 = par1.replace("-", "");

        const req = await fetch(`${URL_WHAT}phone-exists/${par3}`, 
        {
              method: 'GET',
              headers:{
                'Content-Type': 'application/json',
                'client-token': TOKEN_WHAT
              },
              
            });
    
        
          
            const json = await req.json(); 
            
          
            if(json.exists === true){
              

        await db.collection("Users")
          .where("Telefone", "==", Telefone)
          .where("Conta", "==", "Cliente")
          .where("SubConta", "==", "Principal")
           .get()
          .then(async (querySnapshot)=>{
            if(querySnapshot.size === 0){

           
      

      

        await db.collection("Users").doc(Id).update({
          Telefone, 
          }).then(async (doc) => {
           
           
             
            setAlert("Telefone Editado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

            const novaLista = UsuariosContServ.map(item =>
                item.Id === Id ? { ...item, Telefone} : item);
              setUsuariosContServ(novaLista);

         
              
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

           } else {
            setLoading(false)
           setMsgErro("Esse Número de Telefone Já está Cadastrado No Sistema!")
            }
          });
          
         
            } else{
            setLoading(false)
           setMsgErro("Esse Número não está registrado no whatsapp, só é permitido número que é registrado no whatsapp!")
            }
     
    },
  TAEditarClientes: async(InstanciaWhats, TokenWhats, WhatsAppAtiv, AcademiaAtiv, ListEsp, MedidasAtiv, Versao, SiteApp, IdRepr, Id, Dados, Imgs1Res, TempAti, DiaMesExt,  ReceberMP, Nome, AppLimit, Imgs2, TokenMP, Telefone, KeyMP, WebHookMP, Mensalidade, DiaMes, AtualAno, QuantApp, ValorApp, NomeApp, NomeEmp, Estado, Cidade, Bairro, Num, End, UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert)=> {
      
    var TAAtualAno = parseInt(AtualAno)
    var TAMensalidade = parseInt(Mensalidade)
    var TADiaMes = parseInt(DiaMes)
    var TAQuantApp = parseInt(QuantApp)
    var TAValorApp = parseInt(ValorApp)


    
    var variac = 0;
    var DateTemp = new Date(ListEsp.TempLimitAtiv);
    var DiaD = DateTemp.getDate();

    if(DiaMesExt !== TADiaMes){

   
    var now =new Date();
    var Dia = now.getDate();
    var currentDate = "";
    var Mes = (DateTemp.getMonth()+1);
    var Ano = DateTemp.getFullYear();
    TADiaMes = TADiaMes < 10 ? '0'+TADiaMes : TADiaMes;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+TADiaMes;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

  


          let Url2 = "";
         console.log(Imgs2)
        if(Imgs2 !== Imgs1Res){

        
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
        }

        }else {

        Url2 = Imgs2;

        }
      
        await db.collection("Users").doc(Id).update({
          Nome,
          AppLimit, 
          Logo:Url2, 
          TokenMP, 
          ReceberMP,
          KeyMP, 
          WebHookMP, 
          Mensalidade:TAMensalidade, 
          DiaMes:parseInt(DiaMes),  
          AtualAno:TAAtualAno, 
          QuantApp:TAQuantApp, 
          ValorApp:TAValorApp, 
          NomeApp, 
          NomeEmp, 
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End,
          TempLimitAtiv:variac,
          IdRepresentante:IdRepr,
          SiteApp,
          Versao,
          MedidasAtiv,
          AcademiaAtiv,
          InstanciaWhats, 
          TokenWhats, 
          WhatsAppAtiv,
          }).then(async (doc) => {

            await db.collection("ClientesTiket").doc(ListEsp.IdTicket).update({
               Nome,
               Telefone,
               TempLimitAtiv:variac,
             }).then(() => {

            setAlert("Atualizado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

             const novaLista = UsuariosContServ.map(item =>
                item.Id === Id ? { ...item,   Nome, 
                                              AppLimit, 
                                              Logo:Url2, 
                                              TokenMP, 
                                              Telefone, 
                                              ReceberMP,
                                              KeyMP, 
                                              WebHookMP, 
                                              Mensalidade:TAMensalidade, 
                                              DiaMes:parseInt(DiaMes), 
                                              AtualAno:TAAtualAno, 
                                              QuantApp:TAQuantApp, 
                                              ValorApp:TAValorApp, 
                                              NomeApp, 
                                              NomeEmp, 
                                              Estado, 
                                              Cidade, 
                                              Bairro, 
                                              Num, 
                                              End,
                                              TempLimitAtiv:variac,
                                              IdRepresentante:IdRepr,
                                              SiteApp,
                                              Versao,
                                              MedidasAtiv,
                                              AcademiaAtiv,
                                              InstanciaWhats, 
                                              TokenWhats, 
                                              WhatsAppAtiv,
                                            } : item);
              setUsuariosContServ(novaLista);

              })
            
              
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });






  } else {

    variac = TempAti;

          let Url2 = "";
         console.log(Imgs2)
        if(Imgs2 !== Imgs1Res){

        
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
        }

        }else {

        Url2 = Imgs2;

        }
      
        await db.collection("Users").doc(Id).update({
          Nome,
          AppLimit, 
          Logo:Url2, 
          TokenMP, 
          ReceberMP,
          KeyMP, 
          WebHookMP, 
          Mensalidade:TAMensalidade,  
          AtualAno:TAAtualAno, 
          QuantApp:TAQuantApp, 
          ValorApp:TAValorApp, 
          NomeApp, 
          NomeEmp, 
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End,
          IdRepresentante:IdRepr,
          SiteApp,
          Versao,
          MedidasAtiv,
          AcademiaAtiv,
           InstanciaWhats, 
          TokenWhats, 
          WhatsAppAtiv,
          }).then(async (doc) => {

            setAlert("Atualizado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

             const novaLista = UsuariosContServ.map(item =>
                item.Id === Id ? { ...item,   Nome, 
                                              AppLimit, 
                                              Logo:Url2, 
                                              TokenMP, 
                                              Telefone, 
                                              ReceberMP,
                                              KeyMP, 
                                              WebHookMP, 
                                              Mensalidade:TAMensalidade, 
                                              AtualAno:TAAtualAno, 
                                              QuantApp:TAQuantApp, 
                                              ValorApp:TAValorApp, 
                                              NomeApp, 
                                              NomeEmp, 
                                              Estado, 
                                              Cidade, 
                                              Bairro, 
                                              Num, 
                                              End,
                                              IdRepresentante:IdRepr,
                                              SiteApp,
                                              Versao,
                                              MedidasAtiv,
                                              AcademiaAtiv,
                                              InstanciaWhats, 
                                              TokenWhats, 
                                              WhatsAppAtiv,
                                            } : item);
              setUsuariosContServ(novaLista);

           

            
              
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

  }
   
   
    
          
     
    },
    TADesativandoClientes: async(Dados, Id, setAlertTipo, setAlert)=> {
    
    const Setor = "Desativando Condicional Serv";
    await db.collection("Users").doc(Id).update({
     "Ativo":false, 
    }).then(()=>{
      setAlert("Desativado com Sucesso");
      setAlertTipo("success");
    });
  },
   TAAtivandoClientes: async(Dados, Id, setAlertTipo, setAlert)=> {
 
    await db.collection("Users").doc(Id).update({
     "Ativo":true, 
    }).then(()=>{
      setAlert("Ativado com Sucesso");
      setAlertTipo("success");
    });
  },
   TAListClientes: async(Dados, IdConta, setQuant, setUsuariosContServ, setListCliente, setListTel)=> {
         
          await db.collection("Users")
          .where("Conta", "==","Cliente")
          .where("SubConta", "==", "Principal")
           .get()
          .then(async (querySnapshot)=>{
            setQuant(querySnapshot.size);
            var res = [];
            let listra2 = []; 
            let listra3 = []; 
            querySnapshot.forEach((doc) => {
                res.push({
                Id: doc.id,
                Nome: doc.data().Nome, 
                Ativo: doc.data().Ativo,  
                AppLimit: doc.data().AppLimit, 
                Logo: doc.data().Logo, 
                TokenMP: doc.data().TokenMP, 
                Telefone: doc.data().Telefone, 
                ReceberMP: doc.data().ReceberMP,
                KeyMP: doc.data().KeyMP, 
                WebHookMP: doc.data().WebHookMP, 
                Mensalidade: doc.data().Mensalidade, 
                DiaMes: doc.data().DiaMes, 
                AtualAno: doc.data().AtualAno, 
                QuantApp: doc.data().QuantApp, 
                ValorApp: doc.data().ValorApp, 
                NomeApp: doc.data().NomeApp, 
                NomeEmp: doc.data().NomeEmp, 
                Estado: doc.data().Estado, 
                Cidade: doc.data().Cidade, 
                Bairro: doc.data().Bairro, 
                Num: doc.data().Num, 
                End: doc.data().End,
                dataCriacao: doc.data().dataCriacao,
                IdConta: doc.data().IdConta,
                Conta: doc.data().Conta,
                SubConta: doc.data().SubConta,
                TempLimitAtiv: doc.data().TempLimitAtiv,
                IdRepresentante:doc.data().IdRepresentante,
                ExeciConcl:doc.data().ExeciConcl,
                SiteApp:doc.data().SiteApp,
                Versao:doc.data().Versao,
                MedidasAtiv:doc.data().MedidasAtiv,
                IdTicket:doc.data().IdTicket,
                AcademiaAtiv:doc.data().AcademiaAtiv?doc.data().AcademiaAtiv:false,
                InstanciaWhats:doc.data().InstanciaWhats, 
                TokenWhats:doc.data().TokenWhats, 
                WhatsAppAtiv:doc.data().WhatsAppAtiv,
                }); 
                listra2.push({
                  value: doc.id,
                  label: doc.data().Nome,      
                  }); 
                listra3.push({
                  value: doc.id,
                  label: doc.data().Telefone,      
                  });      
            });
            res.sort((a,b)=>{
              if(a.Nome < b.Nome) {
                return -1;
              } else {
                return 1;
              }
            });
             listra2.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
             listra3.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
            setListTel(listra3)
            setListCliente(listra2)
            setUsuariosContServ(res);
      });
 
  },
  TACriarClientes: async(InstanciaWhats, TokenWhats, WhatsAppAtiv, AcademiaAtiv, MedidasAtiv, Versao, SiteApp, IdRepr, Dados,  ReceberMP, Nome, AppLimit, Imgs2, TokenMP, Telefone, KeyMP, WebHookMP, Mensalidade, DiaMes, AtualAno, QuantApp, ValorApp, NomeApp, NomeEmp, Estado, Cidade, Bairro, Num, End,  setMsgErro, setLoading, setAlertTipo, setAlert, setAddList)=> {
      
    var TAAtualAno = parseInt(AtualAno)
    var TAMensalidade = parseInt(Mensalidade)
    var TADiaMes = parseInt(DiaMes)
    var TAQuantApp = parseInt(QuantApp)
    var TAValorApp = parseInt(ValorApp)


    
    var variac = 0;
    var DateTemp = new Date();
    var DiaD = DateTemp.getDate();
    if(DiaD > TADiaMes){
    if(DateTemp.getMonth() === 11){

    var now =new Date();
    var Dia = now.getDate();
    var currentDate = "";  
    var Mes = 1;
    var Ano = (now.getFullYear()+1);
    TADiaMes = TADiaMes < 10 ? '0'+TADiaMes : TADiaMes;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+TADiaMes;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    } else{

    var now =new Date();
    var Dia = now.getDate();
    var currentDate = ""; 
    var Mes = (now.getMonth()+2);
    var Ano = now.getFullYear();
    TADiaMes = TADiaMes < 10 ? '0'+TADiaMes : TADiaMes;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+TADiaMes;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    }
    

    } else {

    var now =new Date();
    var Dia = now.getDate();
    var currentDate = "";
    var Mes = (now.getMonth()+1);
    var Ano = now.getFullYear();
    TADiaMes = TADiaMes < 10 ? '0'+TADiaMes : TADiaMes;
    Mes = Mes < 10 ? '0'+Mes : Mes;
    currentDate = Ano+'-'+Mes+'-'+TADiaMes;
    variac = new Date(currentDate +"T00:00:00.000").getTime();

    }
   
    
       
        var ver = Telefone.replace("(", "55");
        var par1 = ver.replace(")", "");
        var par3 = par1.replace("-", "");
         const req = await fetch(`${URL_WHAT}phone-exists/${par3}`, 
        {
              method: 'GET',
              headers:{
                'Content-Type': 'application/json',
                'client-token': TOKEN_WHAT
              },
              
            });

            const json = await req.json(); 
            
          
            if(json.exists === true){
              

        await db.collection("Users")
          .where("Telefone", "==", Telefone)
          .where("Conta", "==", "Cliente")
          .where("SubConta", "==", "Principal")
           .get()
          .then(async (querySnapshot)=>{
            if(querySnapshot.size === 0){

           
          
        let Url2 = "";
        
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
        }

      

        await db.collection("Users").add({
          Nome,
          Ativo:true, 
          AppLimit, 
          Logo:Url2, 
          TokenMP, 
          Telefone, 
          ReceberMP,
          KeyMP, 
          WebHookMP, 
          Mensalidade:TAMensalidade, 
          DiaMes:parseInt(DiaMes), 
          AtualAno:TAAtualAno, 
          QuantApp:TAQuantApp, 
          ValorApp:TAValorApp, 
          NomeApp, 
          NomeEmp, 
          Estado, 
          Cidade, 
          Bairro, 
          Num, 
          End,
          dataCriacao:new Date().getTime(),
          IdConta:"",
          Conta:"Cliente",
          SubConta:"Principal",
          TempLimitAtiv:variac,
          IdRepresentante:IdRepr,
          ExeciConcl:false,
          SiteApp,
          Versao,
          MedidasAtiv,
          AcademiaAtiv,
          InstanciaWhats, 
          TokenWhats, 
          WhatsAppAtiv,
          MensagemSistem:{
            Msg:"",
            Ativo:false
          },
           MensagemApp:{
            Msg:"",
            Ativo:false
          },
          menu:{
            Alunos: {
              Ver: true,
              Btn: {
                  botão_Atualizar: true,
                  botão_AtualizarTreino: true,
                  botão_Desativar: true,
                  botão_Ativar: true,
                  botão_Criar: true,
              },
              },
              Categorias: {
              Ver: true,
              Btn: {
                  botão_Atualizar: true,
                  botão_Desativar: true,
                  botão_Ativar: true,
                  botão_Criar: true,
              },
              },
              Exercícios: {
              Ver: true,
              Btn: {
                  botão_Atualizar: true,
                  botão_Desativar: true,
                  botão_Ativar: true,
                  botão_Criar: true,
              },
              },
              Treinos: {
              Ver: true,
              Btn: {
                  botão_Atualizar: true,
                  botão_Desativar: true,
                  botão_Ativar: true,
                  botão_Criar: true,
              },
              },
              Recebimentos: {
              Ver: true,
              Btn: {
                  botão_Pagar: true,
                  botão_Vizualizar: true,
              },
              },
              Pagamentos: {
              Ver: true,
              Btn: {
                  botão_Vizualizar: true,
              },
              },
              Medidas: {
              Ver: true,
              Btn: {
                  botão_Atualizar: true,
                  botão_Desativar: true,
                  botão_Ativar: true,
                  botão_Criar: true,
              },
              },
              Histórico: {
              Ver: true,
              Btn: {
                  botão_Vizualizar: true,
              },
              },
              Funcionários: {
              Ver: true,
              Btn: {
                  botão_Atualizar: true,
                  botão_Desativar: true,
                  botão_Ativar: true,
                  botão_Criar: true,
              },
              },
              Permissões: {
              Ver: true,
              Btn: {
                  botão_Atualizar: true,
                  botão_Desativar: true,
                  botão_Ativar: true,
                  botão_Criar: true,
              },
              },
              Avisos: {
              Ver: true,
              Btn: {
                  botão_AtivarMsgSist: true,
                  botão_DesativarMsgSist: true,
                  botão_AtivarMsgApp: true,
                  botão_DesativarMsgApp: true,
              },
              },
              Acões: {
              Ver: true,
              Btn: {
                  botão_Vizualizar: true,
              },
              },
              },
          menuFun:{
            Alunos: {
              Ver: false,
              Btn: {
                  botão_Atualizar: false,
                  botão_AtualizarTreino: false,
                  botão_Desativar: false,
                  botão_Ativar: false,
                  botão_Criar: false,
              },
              },
              Categorias: {
              Ver: false,
              Btn: {
                  botão_Atualizar: false,
                  botão_Desativar: false,
                  botão_Ativar: false,
                  botão_Criar: false,
              },
              },
              Exercícios: {
              Ver: false,
              Btn: {
                  botão_Atualizar: false,
                  botão_Desativar: false,
                  botão_Ativar: false,
                  botão_Criar: false,
              },
              },
              Treinos: {
              Ver: false,
              Btn: {
                  botão_Atualizar: false,
                  botão_Desativar: false,
                  botão_Ativar: false,
                  botão_Criar: false,
              },
              },
              Recebimentos: {
              Ver: false,
              Btn: {
                  botão_Pagar: false,
                  botão_Vizualizar: false,
              },
              },
              Pagamentos: {
              Ver: false,
              Btn: {
                  botão_Vizualizar: false,
              },
              },
              Medidas: {
              Ver: false,
              Btn: {
                  botão_Atualizar: false,
                  botão_Desativar: false,
                  botão_Ativar: false,
                  botão_Criar: false,
              },
              },
              Histórico: {
              Ver: false,
              Btn: {
                  botão_Vizualizar: false,
              },
              },
              Funcionários: {
              Ver: false,
              Btn: {
                  botão_Atualizar: false,
                  botão_Desativar: false,
                  botão_Ativar: false,
                  botão_Criar: false,
              },
              },
              Permissões: {
              Ver: false,
              Btn: {
                  botão_Atualizar: false,
                  botão_Desativar: false,
                  botão_Ativar: false,
                  botão_Criar: false,
              },
              },
              Avisos: {
              Ver: false,
              Btn: {
                  botão_AtivarMsgSist: false,
                  botão_DesativarMsgSist: false,
                  botão_AtivarMsgApp: false,
                  botão_DesativarMsgApp: false,
              },
              },
              Acões: {
              Ver: false,
              Btn: {
                  botão_Vizualizar:false,
              },
              },
              },
          }).then(async (doc) => {

            var IdConta = doc.id;
             await db.collection("ClientesTiket").add({
               IdConta:IdConta,
               Nome, 
               Telefone,
               TempLimitAtiv:variac,
               Pago:false,
               AppLimit:false,
               ValorApp:0,
               QuantApp:0,
               Mensalidade:0,
               QuantAlunos:0,
               ValorTotal:0,
               Alunos:0,
               IdRepresentante:IdRepr,
               DataPagamento:0
              }).then(async (doc2) => {

              var IdTicket = doc2.id;

            await db.collection("Users").doc(IdConta).update({
              "IdConta":IdConta,
              "IdTicket": IdTicket,
            }).then((doc) => {
             
            setAlert("Criado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)

             setAddList({
                Id: IdConta,
                Nome,
                Ativo:true,  
                AppLimit, 
                Logo:Url2, 
                TokenMP, 
                Telefone, 
                ReceberMP,
                KeyMP, 
                WebHookMP, 
                Mensalidade:TAMensalidade, 
                DiaMes:TADiaMes, 
                AtualAno:TAAtualAno, 
                QuantApp:TAQuantApp, 
                ValorApp:TAValorApp, 
                NomeApp, 
                NomeEmp, 
                Estado, 
                Cidade, 
                Bairro, 
                Num, 
                End,
                dataCriacao:new Date().getTime(),
                IdConta:IdConta,
                Conta:"Cliente",
                SubConta:"Principal",
                TempLimitAtiv:variac,
                IdRepresentante:IdRepr,
                ExeciConcl:false,
                SiteApp,
                Versao,
                MedidasAtiv,
                IdTicket: IdTicket,
                AcademiaAtiv,
                InstanciaWhats, 
                TokenWhats, 
                WhatsAppAtiv,
                MensagemSistem:{
                    Msg:"",
                    Ativo:false
                  },
                  MensagemApp:{
                    Msg:"",
                    Ativo:false
                  },
              })
               })

            });
              
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });

           } else {
            setLoading(false)
           setMsgErro("Esse Número de Telefone Já existe!")
            }
          });
          
         
            } else{
            setLoading(false)
           setMsgErro("Esse Número não está registrado no whatsapp, só é permitido número que é registrado no whatsapp!")
            }
     
    },
   TAEditarExercicio: async(DadCont, IdConta, InfIdConta, InfIdUse, IdUse, ListEsp, Imgs1Res, Imgs2Res, Dados, Id, Nome, IdContRes, IdCategoria, Categoria, Ativo, TempoAtivo, BenefAtivo, FazerAtivo, MuscuAtivo, Imgs1,  Imgs2, Beneficios, ComoFazer,  UsuariosContServ, setMsgErro, setLoading, setAlertTipo, setAlert, setUsuariosContServ,)=> {
      
        if(ListEsp.Nome ===  Nome){
        let Url1 = "";
        let Url2 = "";
       
        if(Imgs1Res !== Imgs1){ 
        if(Imgs1 !== ""){
          const fileName = await Date.now() + Imgs1;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs1).then((doc)=> {
            
          });
          Url1 =  await fileRef.getDownloadURL();
        }
         } else {
          Url1 =Imgs1 
         }
         if(Imgs2Res !== Imgs2){ 
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
          }
          } else {
          Url2 =Imgs2 
         }
      

        await db.collection("Exercicios").doc(Id).update({
          IdCategoria,
          Categoria, 
          Ativo, 
          TempoAtivo, 
          BenefAtivo, 
          FazerAtivo, 
          MuscuAtivo,  
          Beneficios, 
          ComoFazer,  
          UrlTrenio:Url1,
          UrlMusculo:Url2,
          }).then(async (doc) => {
              if(DadCont !== "Emp"){

             await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar", 
               Sessão:"Exercícios",
               IdSofredor:Id,
              }).then(async (doc2) => {
               
              })

              }
            setAlert("Editado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)
            const novaLista = UsuariosContServ.map(item =>
                item.Id === Id ? { ...item,  
                                            IdCategoria:IdCategoria,
                                            Categoria, 
                                            Ativo:Ativo, 
                                            TempoAtivo:TempoAtivo, 
                                            BenefAtivo: BenefAtivo, 
                                            FazerAtivo: FazerAtivo, 
                                            MuscuAtivo: MuscuAtivo,  
                                            Beneficios: Beneficios, 
                                            ComoFazer: ComoFazer,  
                                            UrlTrenio: Url1,
                                            UrlMusculo: Url2, } : item
                                            );
              setUsuariosContServ(novaLista);
            
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });  
        } else {

           await db.collection("Exercicios")
          .where("Nome", "==", Nome)
          .where("IdConta", "==", IdContRes)
          .get()
          .then(async (doc)=>{
            
         if(doc.size === 0){

        let Url1 = "";
        let Url2 = "";
       
        if(Imgs1Res !== Imgs1){ 
        if(Imgs1 !== ""){
          const fileName = await Date.now() + Imgs1;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs1).then((doc)=> {
            
          });
          Url1 =  await fileRef.getDownloadURL();
        }
         } else {
          Url1 =Imgs1 
         }
         if(Imgs2Res !== Imgs2){ 
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
          }
          } else {
          Url2 =Imgs2 
         }
      

        await db.collection("Exercicios").doc(Id).update({
          Nome, 
          IdCategoria,
          Categoria, 
          Ativo, 
          TempoAtivo, 
          BenefAtivo, 
          FazerAtivo, 
          MuscuAtivo,  
          Beneficios, 
          ComoFazer,  
          UrlTrenio:Url1,
          UrlMusculo:Url2,
          }).then(async (doc) => {
         if(DadCont !== "Emp"){
             await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Atualizar", 
               Sessão:"Exercícios",
               IdSofredor:Id,
              }).then(async (doc2) => {
                console.log(doc2.id)
              })
            }

            setAlert("Editado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)
            const novaLista = UsuariosContServ.map(item =>
                item.Id === Id ? { ...item, Nome:Nome, 
                                            IdCategoria:IdCategoria,
                                            Categoria, 
                                            Ativo:Ativo, 
                                            TempoAtivo:TempoAtivo, 
                                            BenefAtivo: BenefAtivo, 
                                            FazerAtivo: FazerAtivo, 
                                            MuscuAtivo: MuscuAtivo,  
                                            Beneficios: Beneficios, 
                                            ComoFazer: ComoFazer,  
                                            UrlTrenio: Url1,
                                            UrlMusculo: Url2, } : item
                                            );
              setUsuariosContServ(novaLista);
            
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          });  


           } else {
                setLoading(false)
                setMsgErro("Já Existe Um Exercício com Esse Nome!")
              }
          });

        } 

     
    },
   TADesativandoExercicio: async(InfIdUse, InfIdConta, IdConta,  IdUse, Dados, Id, setAlertTipo, setAlert)=> {
    
    const Setor = "Desativando Condicional Serv";
    await db.collection("Exercicios").doc(Id).update({
     "Ativo":false, 
    }).then(async()=>{
       await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Desativar", 
               Sessão:"Exercícios",
               IdSofredor:Id,
              }).then(async (doc2) => {
                console.log(doc2.id)
              })
      setAlert("Desativado com Sucesso");
      setAlertTipo("success");
    });
  },
   TAAtivandoExercicio: async(InfIdUse, InfIdConta, IdConta,  IdUse, Dados, Id, setAlertTipo, setAlert)=> {
 
    await db.collection("Exercicios").doc(Id).update({
     "Ativo":true, 
    }).then(async ()=>{

       await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Ativar", 
               Sessão:"Exercícios",
               IdSofredor:Id,
              }).then(async (doc2) => {
                console.log(doc2.id)
              })
      setAlert("Ativado com Sucesso");
      setAlertTipo("success");
    });
  },
  TAListExerciciosCliente: async(Dados, IdContRes, setQuant, setUsuariosContServ, setCarreg, setListExecicios, setListCategoria, setProgress)=> {
      var Quantidade = 0;
          await db.collection("Exercicios")
          .where("IdConta", "==", IdContRes)
           .get()
          .then(async (querySnapshot)=>{
             Quantidade = querySnapshot.size; 
            setQuant(querySnapshot.size);

            if(querySnapshot.size === 0){
              setCarreg(false)
            }
           
            var res = []; 
            var res2 = [];
            let listra2 = []; 
            let listra3 = [];
            var Part = 0; 
            querySnapshot.forEach((doc) => {
                res.push({
                  Id: doc.id,
                  Nome: doc.data().Nome, 
                  IdConta: doc.data().IdConta, 
                  IdCategoria: doc.data().IdCategoria,
                  Categoria: doc.data().Categoria, 
                  Ativo: doc.data().Ativo, 
                  TempoAtivo: doc.data().TempoAtivo, 
                  BenefAtivo: doc.data().BenefAtivo, 
                  FazerAtivo: doc.data().FazerAtivo, 
                  MuscuAtivo: doc.data().MuscuAtivo,  
                  Beneficios: doc.data().Beneficios, 
                  ComoFazer: doc.data().ComoFazer,  
                  UrlTrenio: doc.data().UrlTrenio,
                  UrlMusculo: doc.data().UrlMusculo,
                  dataCriacao: doc.data().dataCriacao,
    
                }); 

               const novoItem = {
                  value: doc.id,
                  label: doc.data().Nome,
                  Categoria: doc.data().Categoria, 
                };
                const existe = listra2.some(item => item.value === novoItem.value || item.label === novoItem.label);

                if (!existe) {
                  listra2.push(novoItem);
                }

                const novoItem3 = {
                  value: doc.data().IdCategoria,
                  label: doc.data().Categoria,  
                };
                const existe3 = listra3.some(item => item.value === novoItem3.value || item.label === novoItem3.label);

                if (!existe3) {
                  listra3.push(novoItem3);
                } 
             Part = Part + 1;    
             var Porcentagem = Part/Quantidade
             setProgress(Porcentagem*100)  
                       
            });
            res.sort((a,b)=>{
              if(a.dataCriacao < b.dataCriacao) {
                return 1;
              } else {
                return -1;
              }
            });

              listra2.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });

             listra3.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
            setListCategoria(listra3)
            setListExecicios(listra2) 
            setUsuariosContServ(res);
      });
 
  },
   TAListExercicios: async(Dados, IdConta, setQuant, setUsuariosContServ, setListExecicios,)=> {

          await db.collection("Exercicios")
          .where("IdConta", "==", IdConta)
           .get()
          .then(async (querySnapshot)=>{
            setQuant(querySnapshot.size);
            var res = [];
            var res2 = [];  
            querySnapshot.forEach((doc) => {
                res.push({
                  Id: doc.id,
                  Nome: doc.data().Nome, 
                  IdConta: doc.data().IdConta, 
                  IdCategoria: doc.data().IdCategoria,
                  Categoria: doc.data().Categoria, 
                  Ativo: doc.data().Ativo, 
                  TempoAtivo: doc.data().TempoAtivo, 
                  BenefAtivo: doc.data().BenefAtivo, 
                  FazerAtivo: doc.data().FazerAtivo, 
                  MuscuAtivo: doc.data().MuscuAtivo,  
                  Beneficios: doc.data().Beneficios, 
                  ComoFazer: doc.data().ComoFazer,  
                  UrlTrenio: doc.data().UrlTrenio,
                  UrlMusculo: doc.data().UrlMusculo,
                  dataCriacao: doc.data().dataCriacao,
    
                });
                res2.push({
                  id: doc.id,
                  select: doc.data().Nome, 
                });        
            });
            res.sort((a,b)=>{
              if(a.Nome < b.Nome) {
                return -1;
              } else {
                return 1;
              }
            });
             res2.sort((a,b)=>{
              if(a.Nome < b.Nome) {
                return -1;
              } else {
                return 1;
              }
            });
            setListExecicios(res2)
            setUsuariosContServ(res);
      });
 
  },
 TACriarExercicio: async(DadCont, InfIdUse, InfIdConta, IdConta,  IdUse, Categoria, Dados, Nome, IdContRes, IdCategoria, Ativo, TempoAtivo, BenefAtivo, FazerAtivo, MuscuAtivo, Imgs1,  Imgs2, Beneficios, ComoFazer,  setMsgErro, setLoading, setAlertTipo, setAlert, setAddList)=> {
      
       await db.collection("Exercicios")
          .where("Nome", "==", Nome)
          .where("IdConta", "==", IdContRes)
          .get()
          .then(async (doc)=>{
            
         if(doc.size === 0){


        let Url1 = "";
        let Url2 = "";
       

        if(Imgs1 !== ""){
          const fileName = await Date.now() + Imgs1;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs1).then((doc)=> {
            
          });
          Url1 =  await fileRef.getDownloadURL();
        }
        if(Imgs2 !== ""){
          const fileName = await Date.now() + Imgs2;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs2).then((doc)=> {
            
          });
          Url2 =  await fileRef.getDownloadURL();
        }

      

        await db.collection("Exercicios").add({
          Nome, 
          IdConta:IdContRes, 
          IdCategoria,
          Categoria, 
          Ativo, 
          TempoAtivo, 
          BenefAtivo, 
          FazerAtivo, 
          MuscuAtivo,  
          Beneficios, 
          ComoFazer,  
          UrlTrenio:Url1,
          UrlMusculo:Url2,
          dataCriacao:new Date().getTime(),
          }).then(async (doc) => {
              if(DadCont !== "Emp"){
               await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Criar", 
               Sessão:"Exercícios",
               IdSofredor:doc.id,
              }).then(async (doc2) => {
                console.log(doc2.id)
              })
              }
             
            setAlert("Criado Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)
             setAddList({
              Id: doc.id,
              Nome:Nome, 
              IdConta:IdContRes,  
              IdCategoria:IdCategoria,
              Categoria, 
              Ativo:Ativo, 
              TempoAtivo:TempoAtivo, 
              BenefAtivo: BenefAtivo, 
              FazerAtivo: FazerAtivo, 
              MuscuAtivo: MuscuAtivo,  
              Beneficios: Beneficios, 
              ComoFazer: ComoFazer,  
              UrlTrenio: Url1,
              UrlMusculo: Url2,
              dataCriacao: new Date().getTime(), 
              })
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          }); 
           } else {
                setLoading(false)
                setMsgErro("Já Existe Um Exercício com Esse Nome!")
              }
          });
 
         

     
    },
TATranferirExercicio: async(DadCont, InfIdUse, InfIdConta, IdConta,  IdUse, Categoria, Dados, Nome, IdContRes, IdCategoria, Ativo, TempoAtivo, BenefAtivo, FazerAtivo, MuscuAtivo, Imgs1,  Imgs2, Beneficios, ComoFazer,  setMsgErro, setLoading, setAlertTipo, setAlert, setAddList)=> {
      
       await db.collection("Exercicios")
          .where("Nome", "==", Nome)
          .where("IdConta", "==", IdContRes)
          .get()
          .then(async (doc)=>{
            
         if(doc.size === 0){


        let Url1 = "";
        let Url2 = "";
       


      

        await db.collection("Exercicios").add({
          Nome, 
          IdConta:IdContRes, 
          IdCategoria,
          Categoria, 
          Ativo, 
          TempoAtivo, 
          BenefAtivo, 
          FazerAtivo, 
          MuscuAtivo,  
          Beneficios, 
          ComoFazer,  
          UrlTrenio:Imgs1,
          UrlMusculo:Imgs2,
          dataCriacao:new Date().getTime(),
          }).then(async (doc) => {
              if(DadCont !== "Emp"){
               await db.collection("Acoes").add({
               dataDaAcao:new Date().getTime(),
               IdExecutor:IdUse,
               NomeExecutor:InfIdUse.Nome,
               TelefoneExecutor:InfIdUse.Telefone,
               IdConta:IdConta,
               Acao:"Criar", 
               Sessão:"Exercícios",
               IdSofredor:doc.id,
              }).then(async (doc2) => {
                console.log(doc2.id)
              })
              }
             
            setAlert("Transferido Com Sucesso ");
            setAlertTipo("success");
            setLoading(false)
             setAddList({
              Id: doc.id,
              Nome:Nome, 
              IdConta:IdContRes,  
              IdCategoria:IdCategoria,
              Categoria, 
              Ativo:Ativo, 
              TempoAtivo:TempoAtivo, 
              BenefAtivo: BenefAtivo, 
              FazerAtivo: FazerAtivo, 
              MuscuAtivo: MuscuAtivo,  
              Beneficios: Beneficios, 
              ComoFazer: ComoFazer,  
              UrlTrenio: Url1,
              UrlMusculo: Url2,
              dataCriacao: new Date().getTime(), 
              })
             
          })
          .catch((error) => {
            setLoading(false)
           setMsgErro("Não Foi salvo, Ouve algum Erro!")
          }); 
           } else {
                setLoading(false)
                setMsgErro("Já Existe Um Exercício com Esse Nome!")
              }
          });
 
         

     
    },
   

      TAListdeCat: async(Dados, IdContRes, setListCat)=> { 
      await db.collection("Categorias")
      .where("IdConta", "==", IdContRes)
      .where("Ativo", "==", true)
      .get()
      .then((querySnapshot) => {
        setListCat([]); 
        var res = []; 

        querySnapshot.forEach((doc) => {
            res.push({
              value: doc.id,
              label: doc.data().Nome,   
            });  
        });
         
            res.sort((a,b)=>{
              if(a.label < b.label) {
                return -1;
              } else {
                return 1;
              }
            });
        setListCat(res);    
      
          });
      
    },
 TATransferirCategorias: async(UsuariosContServ,  IdContRes, Dados, Nome, setUsuariosContServ, setMsgErro, setLoading, setAlertTipo, setAlert, setAddList)=> {
    
           for(let i in  UsuariosContServ){
                 db.collection("Categorias").add({
                  Nome:UsuariosContServ[i].Nome,
                  DataCriar:new Date().getTime(),
                  Ativo:true,
                  IdConta: IdContRes,
                  }).then((doc)=>{ 
                  });
                
                }   
            setLoading(false)
            setAlert("Transferido com Sucesso");
            setAlertTipo("success");

      
  },

  TACriarCategorias: async(UsuariosContServ,  IdContRes, Dados, Nome, setUsuariosContServ, setMsgErro, setLoading, setAlertTipo, setAlert, setAddList)=> {
   
    await db.collection("Categorias")
          .where("Nome", "==", Nome)
          .where("IdConta", "==", IdContRes)
          .get()
          .then((doc)=>{
            
              if(doc.size === 0){
                db.collection("Categorias").add({
                  Nome:Nome,
                  DataCriar:new Date().getTime(),
                  Ativo:true,
                  IdConta: IdContRes,
                  }).then((doc)=>{
                    setLoading(false)
                    setAlert("Criado com Sucesso");
                    setAlertTipo("success");

                   setAddList({ Id: doc.id, Nome: Nome, Ativo: true, IdConta:IdContRes, })
                    
                  });
                
              } else {
                setLoading(false)
                setMsgErro("Essa Categoria já existe!")
              }
          });


      
  },
    TAListCategoriasExercicio: async(Dados, Conta, setListCategoria)=> {
           console.log(Conta)
          await db.collection("Categorias")
          .where("Ativo", "==", true)
          .where("IdConta", "==", Conta)
           .get()
          .then(async (querySnapshot)=>{
          
           
            var res = []; 
            querySnapshot.forEach((doc) => {
                res.push({
                  id: doc.id,
                  select: doc.data().Nome,
        
                });      
            });
            res.sort((a,b)=>{
              if(a.select < b.select) {
                return -1;
              } else {
                return 1;
              }
            });
           
            setListCategoria(res);
      });
 
  },
  TAListCategoriasClientes: async(Dados, IdContRes, setQuant, setUsuariosContServ, setCarreg)=> {
          
          await db.collection("Categorias")
          .where("IdConta", "==", IdContRes)
           .get()
          .then(async (querySnapshot)=>{
            if(querySnapshot.size === 0){
              setCarreg(false)
            }
            setQuant(querySnapshot.size);
            var res = []; 
            querySnapshot.forEach((doc) => {
                res.push({
                  Id: doc.id,
                  Nome: doc.data().Nome,
                  Ativo: doc.data().Ativo,
    
                });      
            });
            res.sort((a,b)=>{
              if(a.Nome < b.Nome) {
                return -1;
              } else {
                return 1;
              }
            });
           
            setUsuariosContServ(res);
      });
 
  },
  TAListCategorias: async(Dados, IdContRes, setQuant, setUsuariosContServ, setCarreg, setProgress)=> {
          var Quantidade = 0;
          await db.collection("Categorias")
          .where("IdConta", "==", IdContRes)
           .get()
          .then(async (querySnapshot)=>{
             Quantidade = querySnapshot.size; 

             if(querySnapshot.size === 0){
              setCarreg(false)
            }
             var Part = 0;
            setQuant(querySnapshot.size);
            var res = []; 
            querySnapshot.forEach((doc) => {
                res.push({
                  Id: doc.id,
                  Nome: doc.data().Nome,
                  Ativo: doc.data().Ativo,
                  IdConta: doc.data().IdConta,
                });
            Part = Part + 1;    
             var Porcentagem = Part/Quantidade
             setProgress(Porcentagem*100)     
                
            });
            res.sort((a,b)=>{
              if(a.Nome < b.Nome) {
                return -1;
              } else {
                return 1;
              }
            });
            setUsuariosContServ(res);
      });
 
  },
  TADesativandoCateg: async(Dados, Id, setAlertTipo, setAlert)=> {
    
    const Setor = "Desativando Condicional Serv";
    await db.collection("Categorias").doc(Id).update({
     "Ativo":false, 
    }).then(()=>{
      setAlert("Desativado com Sucesso");
      setAlertTipo("success");
    });
  },
   TAAtivandoCateg: async(Dados, Id, setAlertTipo, setAlert)=> {
 
    await db.collection("Categorias").doc(Id).update({
     "Ativo":true, 
    }).then(()=>{
      setAlert("Ativado com Sucesso");
      setAlertTipo("success");
    });
  },
  TAEditandoCategoria: async(IdContRes, Dados, Id, NomeEdit, UsuariosContServ, setUsuariosContServ, setAlert, setAlertTipo, setLoading, setMsgErro, setProgress)=> {
       
         await db.collection("Categorias")
          .where("Nome", "==", NomeEdit)
          .where("IdConta", "==", IdContRes)
          .get()
          .then(async (doc)=>{
            
            if(doc.size === 0){
            await db.collection("Categorias").doc(Id).update({
              "Nome":NomeEdit,
            }).then( async ()=>{

              var Quantidade = 0;
              
                await db.collection("Exercicios")
                .where("IdCategoria", "==", Id)
                .get()
                .then(async (querySnapshot)=>{

                Quantidade = querySnapshot.size; 
                var Part = 0;
                var res = [];
                querySnapshot.forEach((doc1) => {
                res.push({
                  Id: doc1.id,
                });
                
               });

               for(let i in res){

                await db.collection("Exercicios").doc(res[i].Id).update({
                    "Categoria":NomeEdit,
                  }).then( async ()=>{ 

                  Part = Part + 1;    
                  var Porcentagem = Part/Quantidade
                  setProgress(Porcentagem*100)
                    
                  })
                
               
                }  

              setLoading(false)
              setAlert("Editado com Sucesso");
              setAlertTipo("success");
              const novaLista = UsuariosContServ.map(item =>
                item.Id === Id ? { ...item, Nome:NomeEdit } : item
              );
              setUsuariosContServ(novaLista);

             });
             });
      } else {
                setLoading(false)
                setMsgErro("Essa Categoria já existe!")
              }
          });
  },
  SalvandoMsgProd: async(TempChat, msgProd, MsgDesat, setAlert, setAlertTipo)=> {
   
    await db.collection("EmrpesaSite").doc(EMPRESA).update({
     MsgProd:msgProd,
     MsgDesativado:MsgDesat,
     TempoChat:TempChat,
    }).then(()=>{
      setAlert("Salvo com Sucesso");
      setAlertTipo("success");
   

    });
  },

GBVerWhats: async (setIdGrav, Email, setIdUser, setListUser,  setBtn, setExistErro, setLoading) => {
        
        var ver = Email.replace("(", "55");
        var par1 = ver.replace(")", "");
        var par3 = par1.replace("-", "");
        const req = await fetch(`${URL_WHAT}phone-exists/${par3}`, 
        {
              method: 'GET',
              headers:{
                'Content-Type': 'application/json',
                'client-token': TOKEN_WHAT
              },
              
            });
    
        
          
            const json = await req.json(); 
           
          
            if(json.exists === true){
                      await db.collection("Users")
                      .where("Telefone", "==", Email)
                      .where("Ativo", "==", true)
                      .get().then((querySnapshot) => {
                        var Resp = []
                        if(querySnapshot.size === 0){
                        setExistErro("Este WhatsApp não possui conta na empresa.")
                        setBtn(false);
                        setLoading(false)
                        
                    
                        } else if(querySnapshot.size === 1) {

                          querySnapshot.forEach((doc) => {
                            setIdGrav(doc.id)
                            setIdUser(doc.id)  
                          })
                      
                            setExistErro("")
                            setBtn(true);
                            setLoading(false)
                        } else {

                          querySnapshot.forEach((doc) => {
                            Resp.push({
                              id:doc.id,
                              Conta:doc.data().Conta,
                              IdConta:doc.data().IdConta,
                            }) 

                            setExistErro("")
                            setBtn(true);
                            setLoading(false)
                            
                          })
                      

                        }
                          });  
             
            } else{
              setExistErro("Esse Whatsapp Não Existe.")
              setBtn(false);
              setLoading(false)
            }

      //  if(Existi === true){
      //        await db.collection("GBFuncionarios")
      //         .where("Telefone", "==", Email)
      //         .get().then((querySnapshot) => {
              
      //           if(querySnapshot.size !== 0){
      //             querySnapshot.forEach((doc) => {
                  
                   
                    
      //             })
              
      //           } else {
                  
      //           }
      //             });  
         
      //     } else{
      //     setExistErro(true)
      //     setLoading(false)
      //     }   
          
          
      },

  cadastroserv:async (EmailCad, SenhaCad, NomeCad, TelCad, CidadeCad, 
    EstadoCad, InstCad, ContaCad,  NomeGuerra, Patente) => {

            

              return await Auth.createUserWithEmailAndPassword(EmailCad, SenhaCad)
              .then( async () => {
                            const user =  await Auth.currentUser;
                            await user.sendEmailVerification();
                            const id = user.uid;

                                  if(ContaCad === "Lider") {

                                    return await db.collection("users").doc(id).set({
                                      patente:Patente,
                                      nomeGuerra:NomeGuerra,
                                      ocupado:false,
                                      tempAtiva: 0,
                                      ativaPerman:false,
                                      nome: NomeCad, 
                                      telefone: TelCad, 
                                      cidade: CidadeCad, 
                                      estado: EstadoCad, 
                                      instituicao: InstCad,
                                      conta:{ admin:{ativo:false, desbloqueado:false, tipo:""},
                                              app:{ativo:false, desbloqueado:false, tipo:""},
                                              NegApp:{ativo:false, desbloqueado:false, tipo:""},
                                              serv:{ativo:true, desbloqueado:false, tipo:ContaCad},
                                              servApp:{ativo:false, desbloqueado:false, tipo:"App"},
                                            },
                                      grupoid:"XUq86JOsd3YtxPRj9Qjy",
                                     
                                                
                                    })
                                    .then(() => {
                                            return db.collection("movimentacao").add({
                                              id: id,
                                              instituicao: InstCad,
                                              cidade: CidadeCad,
                                              estado: EstadoCad,
                                              telefone: TelCad,
                                              conta:ContaCad,
                                              acao:"criar",
                                              setor:"Cadastro conta serv",
                                              data: firebase.firestore.FieldValue.serverTimestamp(),
                                                
                                            })
                                          .then(async () => {
                                              return "ok";
                                        });
                                    });
                      
                                } else {

                                  
                                  return await db.collection("users").doc(id).set({
                                    nome: NomeCad, 
                                      telefone: TelCad, 
                                      cidade: CidadeCad, 
                                      estado: EstadoCad,
                                      tempAtiva: 0,
                                      ativaPerman:false, 
                                      instituicao: InstCad,
                                      conta:{ admin:{ativo:false, desbloqueado:false, tipo:""},
                                              app:{ativo:false, desbloqueado:false, tipo:""},
                                              NegApp:{ativo:false, desbloqueado:false, tipo:""},
                                              serv:{ativo:true, desbloqueado:false, tipo:ContaCad},
                                              servApp:{ativo:false, desbloqueado:false, tipo:"App"},
                                      
                                            },
                                      grupoid:"XUq86JOsd3YtxPRj9Qjy",
                                  })
                                  .then( () => {
                                          return db.collection("movimentacao").add({
                                            id: id,
                                            instituicao: InstCad,
                                            cidade: CidadeCad,
                                            estado: EstadoCad,
                                            telefone: TelCad,
                                            conta:ContaCad,
                                            acao:"criar",
                                            setor:"Cadastro conta serv",
                                            data: firebase.firestore.FieldValue.serverTimestamp(),
                                          })
                                        .then( () => {
                                            return "ok";
                                      });
                              });
                            }
                            })
                              .catch(error =>{
                                      if (error.code === 'auth/email-already-in-use') {
                                        return 'Esse endereço de email já esta em uso!';
                                      }

                                      if (error.code === 'auth/invalid-email') {
                                        return 'Esse endereço de e-mail é inválido!';
                                      }

                                      if (error.code === 'auth/operation-not-allowed') {
                                        return 'Tente novamente mais tarde!';
                                      }

                                      if (error.code === 'auth/weak-password') {
                                        return 'Digite uma senha melhor!';
                                      }
                              });
                          
                         
                        },

  AtualizanoUser:async ()=>{
    var Ids = []; 
    await db.collection("users")
    .get().then(async (querySnapshot) => {
      
     
        querySnapshot.forEach((doc) => {
          Ids.push(doc.id)
         });

         for(let i in Ids){

          await db.collection("users")
          .doc(Ids[i]).update({
            // mensagem:[
            //   {
            //     date:new Date().getTime(),
            //     autor:"Sitema",
            //     body:"Aqui você terá total atenção da empresa PixBetCash, Fique a vontade, e Bom uso do Sistema!",
            //     nome:"PixBetCash",
            //     type:"text"

            //   }
            // ],
            // DigiS:false,
            // DigiV:false,
            // vizualS:0,
            // vizualV:0,
            // ultimaMsg:{
            //   data:new Date().getTime(),
            //   id:"Sitema",
            //   msg:"Aqui você terá total atenção da empresa PixBetCash, Fique a vontade, e Bom uso do Sistema!",
            //   nome:"PixBetCash"
            // },
            // userchat:[{
            //   id:Ids[i],
            // }],
        })

         }
      
    });

   
  },

  Entrando1:async (Email, setIdUser, setNome, setLoading, setCodLast, setCadast, setCodG, setAlert)=>{
    var temp = new Date().getTime();
    let temp10 = new Date().getTime()+864000000;
    var id = "";
   
    var ver = Email.replace("(", "55");
    var par1 = ver.replace(")", "");
    var par3 = par1.replace("-", "");
 
    const req = await fetch(`https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/phone-exists/${par3}`, 
    {
          method: 'GET',
          headers:{
            'Content-Type': 'application/json'
          },
         
        });

    
      
        const json = await req.json(); 
        
        if(json.exists === true){
      
   console.log("Tel "+Email)
   await db.collection("users")
    .where("Telefone", "==", Email)
    .get().then(async (querySnapshot) => {
      console.log("Qua "+querySnapshot.size)
      if(querySnapshot.size  !== 0){
        querySnapshot.forEach((doc) => {
         setNome(doc.data().Nome);
         setIdUser(doc.id);
        });

           var last = Math.floor((Math.random() * (9999 - 1000)) + 1000);
           setCodLast(last); 
           var ver = Email.replace("(", "55");
            var par1 = ver.replace(")", "");
            var par3 = par1.replace("-", "");

            var data={
              "phone": par3,
              "message": "Código de entrada: "+last,
            }   
            const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-messages", 
            {
                  method: 'POST',
                  headers:{
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(data),
               });
                                  
               setCodG(true)
               setLoading(false)
       
      } else {

        await db.collection("users").add({
          Filial:true,
          Funcionario:false,
          Ativo:true,
          LogoEmp: "",
          ConfigEmp: {NomeEmp:"",  ValMin:"", ValMax:"", PalMin:"", PalMax:"", PorcCom:"", LinkMp:"", LinkWhats:""},
          Telefone:Email,
          DataEnt:0,
          DataEntCel:0,
          Nome:"",
          Indicados:[],
          Extrato:[],
          DataCadas: temp,
          Cash:0,
          Dinheiro:0,
          DataVenc:temp10,
          ADM:false,
          Nivel3:0,
          Nivel4:0,
          mensagem:[
            {
              date:new Date().getTime(),
              autor:"Sistema",
              body:"Aqui você terá total atenção da empresa Bet Franquias, Fique a vontade, e Bom uso do Sistema!",
              nome:"Bet Franquias",
              type:"text"

            }
          ],
          DigiS:false,
          DigiV:false,
          vizualS:0,
          vizualV:0,
          ultimaMsg:{
            data:new Date().getTime(),
            id:"Sistema",
            msg:"Aqui você terá total atenção da empresa Bet Franquias, Fique a vontade, e Bom uso do Sistema!",
            nome:"Bet Franquias"
          },
          userchat:[{}],
        })
        .then( async (docRef) => {

          setIdUser(docRef.id);
          id = docRef.id;
          var last = Math.floor((Math.random() * (9999 - 1000)) + 1000);
          setCodLast(last); 
          var ver = Email.replace("(", "55");
           var par1 = ver.replace(")", "");
           var par3 = par1.replace("-", "");

           var data={
             "phone": par3,
             "message": "Código de entrada: "+last,
           }
           console.log(last);   
           const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-messages", 
           {
                 method: 'POST',
                 headers:{
                   'Content-Type': 'application/json'
                 },
                 body: JSON.stringify(data),
              });
             
             console.log(temp)

             var IdBanco = "";
             var IdInd = "";

            //  await db.collection("BancoWhats")
            //   .where("Telefone", "==", Email)
            //   .where("DataFin", ">=", temp)
            //   .get().then((querySnapshot2) => {
            //     if(querySnapshot2.size !== 0){
            //     querySnapshot2.forEach(async (doc2) => {
            //       IdBanco = doc2.id;
            //       IdInd = doc2.data().IdUser;
              
              
            //     });
            //   }
              
            //   });


            //   await db.collection("users")
            //   .doc(IdInd)
            //   .update({
            //     Indicados: firebase.firestore.FieldValue.arrayUnion(id)
            //    })
          
            //  await  db.collection("BancoWhats")
            //   .doc(IdBanco)
            //   .update({
            //     Aprovado:true, 
            //    })
                                 
              setCodG(true)
              setLoading(false)
        })
       }
       });



         
          
        } else{
          setAlert("Esse Whatsapp Não Existe!");
          setLoading(false)
        }
  },

  CriaN2:async (Dados, Lisnomes, ListSobreNome, Bairro, Ocorr, setQInd, setOcorr, setBairro, setAlert, setAlertTipo, setCarreg)=>{
    var idUser = ""
    var temp = new Date().getTime();

    await db.collection("users")
    .where("Telefone", "==", Dados.Tel)
    .where("DataEnt", "==", Dados.DataEnt)
    .get()
    .then(async (querySnapshot2) => {
      if(querySnapshot2.size  !== 0){

        querySnapshot2.forEach((doc2)=>{
          idUser = doc2.id;
          
        })

   
        db.collection("users")
        .where("Telefone", "==", Bairro)
        .get()
        .then(async (querySnapshot3) => {
          if(querySnapshot3.size  == 0){

            await db.collection("users").add({
              Filial:true,
              Funcionario:false,
              Ativo:true,
              LogoEmp: "",
              ConfigEmp: {},
              Telefone:Bairro,
              DataEnt:0,
              Nome:Ocorr,
              Indicados:[],
              Extrato:[],
              DataCadas: temp,
              Cash:0,
              Dinheiro:0,
              DataVenc:0,
              ADM:false,
              Nivel3:0,
              Nivel4:0,
              mensagem:[],
              DigiS:false,
              DigiV:false,
              vizualS:0,
              vizualV:0,
              ultimaMsg:{
                data:new Date().getTime(),
                id:"Sistema",
                msg:"Aqui você terá total atenção da empresa PixBetCash, Fique a vontade, e Bom uso do Sistema!",
                nome:"PixBetCash"
              },
              userchat:[{}],
            })
            .then( async (docRef) => { 
        
              await db.collection("users")
              .doc(idUser)
              .update({
                Indicados: firebase.firestore.FieldValue.arrayUnion(docRef.id)
               })
               setCarreg(false)
               setOcorr("");
               setBairro("");
            });





          } else{
            setCarreg(false)
            setAlert("Esse Telefone já existe!")
            setAlertTipo("danger")

          }
        });
        
      
      

    



      }
    });

  


   
 
   
  },


  CN3:async (Dados, Ni2, Lisnomes, ListSobreNome, Bairro, Ocorr, setQInd, setOcorr, setBairro,)=>{
    var idUser = ""
    var temp = new Date().getTime();
    for(let i in Ni2){
      setQInd(i)
      for (var j = 0; j < 20; j++) {

        
        var Pime = parseInt(Math.random() * (9999 - 1111) + 1111);
        var Seg = parseInt(Math.random() * (9999 - 1111) + 1111);
        var Nume = `(11)${Pime}-${Seg}`
        console.log(Nume)
        var Nome = parseInt(Math.random() * (99 - 0) + 0);
        var SobNome = parseInt(Math.random() * (48 - 0) + 0);
        var NomeCom = `${Lisnomes[Nome]} ${ListSobreNome[SobNome]}`
        console.log(NomeCom);
        await db.collection("users").add({
          Telefone:Nume,
          DataEnt:0,
          Nome:NomeCom,
          Indicados:[],
          Extrato:[],
          DataCadas: temp,
          Cash:0,
          Dinheiro:0,
          DataVenc:0,
          ADM:false,
          Nivel3:0,
          Nivel4:0,
          mensagem:[],
          DigiS:false,
          DigiV:false,
          vizualS:0,
          vizualV:0,
          ultimaMsg:{
            data:new Date().getTime(),
            id:"Sistema",
            msg:"Aqui você terá total atenção da empresa PixBetCash, Fique a vontade, e Bom uso do Sistema!",
            nome:"PixBetCash"
          },
          userchat:[{}],
        })
        .then( async (docRef) => { 
    
          await db.collection("users")
          .doc(Ni2[i])
          .update({
            Indicados: firebase.firestore.FieldValue.arrayUnion(docRef.id)
           })
           setOcorr("");
           setBairro("");
        });

   
   
   
   
    }

       
      }


   
  },

  CN4:async (Dados, Ni3, Lisnomes, ListSobreNome, Bairro, Ocorr, setQInd, setOcorr, setBairro,)=>{
    var idUser = ""
    var temp = new Date().getTime();
    for(let i in Ni3){
      setQInd(i)
      for (var j = 0; j < 20; j++) {

        
        var Pime = parseInt(Math.random() * (9999 - 1111) + 1111);
        var Seg = parseInt(Math.random() * (9999 - 1111) + 1111);
        var Nume = `(11)${Pime}-${Seg}`
        console.log(Nume)
        var Nome = parseInt(Math.random() * (99 - 0) + 0);
        var SobNome = parseInt(Math.random() * (48 - 0) + 0);
        var NomeCom = `${Lisnomes[Nome]} ${ListSobreNome[SobNome]}`
        console.log(NomeCom);
        await db.collection("users").add({
          Telefone:Nume,
          DataEnt:0,
          Nome:NomeCom,
          Indicados:[],
          Extrato:[],
          DataCadas: temp,
          Cash:0,
          Dinheiro:0,
          DataVenc:0,
          ADM:false,
          Nivel3:0,
          Nivel4:0,
          mensagem:[],
          DigiS:false,
          DigiV:false,
          vizualS:0,
          vizualV:0,
          ultimaMsg:{
            data:new Date().getTime(),
            id:"Sistema",
            msg:"Aqui você terá total atenção da empresa PixBetCash, Fique a vontade, e Bom uso do Sistema!",
            nome:"PixBetCash"
          },
          userchat:[{}],
        })
        .then( async (docRef) => { 
    
          await db.collection("users")
          .doc(Ni3[i])
          .update({
            Indicados: firebase.firestore.FieldValue.arrayUnion(docRef.id)
           })
           setOcorr("");
           setBairro("");
        });

   
   
   
   
    }

       
      }


   
  },

  CriarNumero:async (Numeros, setNumeros, setAlert, setAlertTipo, setQNum)=>{

    var temp = new Date().getTime();
    for(let i in Numeros){
       let Q =((parseInt(i)+1)/Numeros.length)*100
       setQNum(Q)
      await db.collection("TelefonesWhats")
      .where("Telefone", "==", Numeros[i])
    .get().then(async (querySnapshot) => {

      if(querySnapshot.size  === 0){

        await db.collection("TelefonesWhats").add({
          Telefone:Numeros[i],
          DataCadas:temp,
          Tipo:"Futebol"
        })
        .then( async (docRef) => { 
    
         
        });

      } 
     });
      

    }
    setAlert("Criado Com Sucesso")
    setAlertTipo("success");
   
  },

  EnviaCamp:async (Numeros, Img, setNumeros, setAlert, setAlertTipo, setQNum)=>{

    var temp = new Date().getTime();
    for(let i in Numeros){
       let Q =((parseInt(i)+1)/Numeros.length)*100
       setQNum(Q)
       var data={
        "phone": Numeros[i],
        "image": Img,
        "caption": "Logo"
      }  
      console.log(data) 
      const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-image", 
      {
            method: 'POST',
            headers:{
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
         });


    //   await db.collection("TelefonesWhats")
    //   .where("Telefone", "==", Numeros[i])
    // .get().then(async (querySnapshot) => {

    //   if(querySnapshot.size  === 0){

    //     await db.collection("TelefonesWhats").add({
    //       Telefone:Numeros[i],
    //       DataCadas:temp,
    //       Tipo:"Futebol"
    //     })
    //     .then( async (docRef) => { 
    
         
    //     });

    //   } 
    //  });
      

    }
    setAlert("Enviado com Sucesso")
    setAlertTipo("success");
   
  },


  CriaN3:async (id, Bairro, Ocorr, setOcorr, setBairro)=>{
    console.log(id)
    var temp = new Date().getTime();
    await db.collection("users").add({
      Telefone:Bairro,
      DataEnt:0,
      Nome:Ocorr,
      Indicados:[],
      Extrato:[],
      DataCadas: temp,
      Cash:0,
      Dinheiro:0,
      DataVenc:0,
      ADM:false,
      Nivel3:0,
      Nivel4:0,
      mensagem:[],
      DigiS:false,
      DigiV:false,
      vizualS:0,
      vizualV:0,
      ultimaMsg:{
        data:new Date().getTime(),
        id:"Sistema",
        msg:"Aqui você terá total atenção da empresa PixBetCash, Fique a vontade, e Bom uso do Sistema!",
        nome:"PixBetCash"
      },
      userchat:[{}],
    })
    .then( async (docRef) => { 

      await db.collection("users")
      .doc(id)
      .update({
        Indicados: firebase.firestore.FieldValue.arrayUnion(docRef.id)
       })
       setOcorr("");
       setBairro("");
    });
   
  },

  CriaN4:async (id, Bairro, Ocorr, setOcorr, setBairro)=>{
    console.log(id)
    var temp = new Date().getTime();
    await db.collection("users").add({
      Telefone:Bairro,
      DataEnt:0,
      Nome:Ocorr,
      Indicados:[],
      Extrato:[],
      DataCadas: temp,
      Cash:0,
      Dinheiro:0,
      DataVenc:0,
      ADM:false,
      Nivel3:0,
      Nivel4:0,
      mensagem:[],
      DigiS:false,
      DigiV:false,
      vizualS:0,
      vizualV:0,
      ultimaMsg:{
        data:new Date().getTime(),
        id:"Sistema",
        msg:"Aqui você terá total atenção da empresa PixBetCash, Fique a vontade, e Bom uso do Sistema!",
        nome:"PixBetCash"
      },
      userchat:[{}],
    })
    .then( async (docRef) => { 

      await db.collection("users")
      .doc(id)
      .update({
        Indicados: firebase.firestore.FieldValue.arrayUnion(docRef.id)
       })
       setOcorr("");
       setBairro("");
    });
   
  },


  Entrando2:async (Email, setCodLast, setCodG, setLoading,  setAlert)=>{

          var last = Math.floor((Math.random() * (9999 - 1000)) + 1000);      
          setCodLast(last)
            var ver = Email.replace("(", "55");
            var par1 = ver.replace(")", "");
            var par3 = par1.replace("-", "");
        
               var data={
              "phone": par3,
              "message": "🔓 Código de acesso: "+last,
            }   
            const req = await fetch(`${URL_WHAT}send-text`, 
            {
                  method: 'POST',
                  headers:{
                    'Content-Type': 'application/json',
                    'client-token': TOKEN_WHAT
                  },
                  body: JSON.stringify(data),
                });
              
                const json = await req.json(); 
             
          

            setCodG(true)                      
            setLoading(false) 
       
     
       



         
          
       
  },

  LogandocontaServ:async (EmailCad, NomeCad, IdUse, SenhaCad, setLoading, setDados) => {
    var temp = new Date().getTime();

   
    return await db.collection("users").doc(IdUse).update({
      Nome: NomeCad,
      DataEnt:temp,
  })
  .then(async (doc) => {
    
    await localStorage.setItem('roma', "S23458765");
    await localStorage.setItem('brasil', "serv");
    setDados({DataEnt:temp, Tel:EmailCad, Nome:NomeCad});
    setLoading(false);
    return "ok";
      
  });
 
    
  },


  GeradorDeCod:async (Dados, setCarre, setCodLast, setCodG)=>{
    var temp = new Date().getTime();

    await db.collection("users")
    .where("Telefone", "==", Dados.Tel)
    .where("DataEnt", "==", Dados.DataEnt)
    .get().then(async (querySnapshot) => {
      if(querySnapshot.size  !== 0){
      

           var last = Math.floor((Math.random() * (9999 - 1000)) + 1000);
           setCodLast(last); 
           var ver = Dados.Tel.replace("(", "55");
            var par1 = ver.replace(")", "");
            var par3 = par1.replace("-", "");

            var data={
              "phone": par3,
              "message": "Código de entrada: "+last,
            }   
            const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-messages", 
            {
                  method: 'POST',
                  headers:{
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(data),
               });
              setCarre(false)                 
               setCodG(true)
              
       
      } 
       });



         
          
     
  },

  LogandocontaADM:async (IdUse, setIdConta, setDadCont, setInfIdConta, setInfIdUse, setLoading, setDados,  setUser, setConta) => {
   
 
    
    await db.collection("Users")
          .doc(IdUse)
          .onSnapshot(async (doc) => { 

          setInfIdUse(doc.data())
          setDadCont(doc.data().Conta)
          setIdConta(doc.data().IdConta)
          setDados(doc.data().menu? doc.data().menu : null)

            await db.collection("Users")
                .doc(doc.data().IdConta)
                .onSnapshot((doc) => {
            
                setInfIdConta(doc.data())
                
                  });

          if(doc.data().Conta === "Fun"){

          await db.collection("Permissoes")
            .doc(doc.data().IdGrupo)
            .onSnapshot((doc) => {
        
            setDados(doc.data().permissoes)
            
              });

              }



           });

    

    
    
  },

 

  AtivarcontaServ: async()=> {
    const autenticado =  await Auth.currentUser;
    const id = await autenticado.uid;
   return await db.collection("users").doc(id).update({
      "conta.serv.ativo": true,
  })
  .then(() => {
      return "Atualizado com sucesso!";
  });

  },

  VariacaoTemp: async()=> {
   
    await Auth.onAuthStateChanged( async function(user) {
      if (user) {
        let now = new Date()
        const id = user.uid;
        const dados = await db.collection('TempVariacao').doc(id)
        .set({
          Servidor: firebase.firestore.FieldValue.serverTimestamp(),
          Sitema: now,
      })
      }
    });
   
  },

  VarTempPegar: async(Dados, setVaria)=> {
   
    await Auth.onAuthStateChanged( async function(user) {
      if (user) {
        const id = user.uid;
        const dados = await db.collection('TempVariacao')
        .doc(id).onSnapshot((doc) => {
          if(doc.data().Servidor){
            let Vari = doc.data().Servidor.seconds - doc.data().Sitema.seconds;
            setVaria(Vari);
          }
         
      });
      }
    });
   
  },

  ConcluirApost: async(id, setConcluir, setPago)=> {
   
   
      await db.collection('NotaCambista')
        .doc(id).onSnapshot((doc) => {
         setConcluir(doc.data().Conscluido)
         setPago(doc.data().Pago)
         
      });
   
   
  },

  AnliseDados: async(Dados, setDados, setLoading)=> {
   
    await Auth.onAuthStateChanged( async function(user) {
      if (user) {
      const id = user.uid;
      let res = {};
      const dados = await db.collection('users').doc(id)
      .onSnapshot((doc) => {
        if(doc.data()){

          setLoading(false);
          
          setDados(res);
          
     
    }  
    });
     
     
      } else {
        console.log("não está logado");
        setLoading(false);
      }
    });
    
  },

  AtualizandoUsersServ: async(Nome, Telefone, Estado, Cidade, Inst, ContaTipo, setDados)=> {
    
    const autenticado =  await Auth.currentUser;
    const id = await autenticado.uid;
    const Setor = "Caixa de Edição Conta Serv";


    return await db.collection("users").doc(id).update({
      "nome": Nome,
      "telefone":Telefone,
    })
    .then(() => {
            return db.collection("movimentacao").add({
            id:id,
            instituicao: Inst,
            cidade: Cidade,
            estado: Estado,
            Conta:ContaTipo,
            acao:"Atualizar",
            setor: Setor,
            data:firebase.firestore.FieldValue.serverTimestamp(),
            })
          .then( () => {
              return db.collection('users').doc(id).get()
              .then( async (dados) => {
                const result = await dados.data();
                return result;
              });
              
        });
    });
    
  },

  ListServApp: async(Dados, setQuant, setUsuariosContServ, setCarreg )=> {
   
    await Auth.onAuthStateChanged( async function(user) {
      if (user) {
      const ID = user.uid;
      const Setor = "Lista de Apps Serv";
      const dados = await db.collection('users')
      .doc(ID).
      get()
      .then(async(dados)=>{
        const result = await dados.data();
       

          await db.collection("users")
          .where("estado", "==", result.estado)
          .where("cidade", "==", result.cidade)
          .where("instituicao", "==", result.instituicao)
          .where("conta.servApp.desbloqueado", "==", true)
            .onSnapshot((querySnapshot) => {
            setQuant(querySnapshot.size);
            var res = []; 
            querySnapshot.forEach((doc) => {
                res.push({
                  id: doc.id,
                  nome: doc.data().nome,
                  telefone: doc.data().telefone,
                  ativo: doc.data().conta.servApp.ativo,
                  nomeGuerra: doc.data().nomeGuerra? doc.data().nomeGuerra : "",
                  patente: doc.data().patente? doc.data().patente : "",
                  ativaPerman: doc.data().ativaPerman? doc.data().ativaPerman : "",
                  tempAtiva: doc.data().tempAtiva,
                  LocAtiva: doc.data().LocAtiva?doc.data().LocAtiva:false, 
                });      
            });
            console.log(res);
            setUsuariosContServ(res);
    
              });

          
        
   
       }); 
     
      } 
  
    });
    
    
  },

  LocRast: async(Cidade, Estado, setViat)=> {
    console.log(Cidade);
    console.log(Estado);
  //   db.collection("TestLoc").doc("joVmlQ9WO8mhaGGliRDS")
  //   .onSnapshot((doc) => {
  //     var tesV = doc.data().Loc.split(", ");
  //     var lati = parseFloat(tesV[0]);
  //     var longi =parseFloat(tesV[1]);
  //     setViat([{Loc:{lat:lati, lng:longi}, nome:"Renan"}])
  // });

    await db.collection("users")
    .where("LocAtiva", "==", true)
    .where("cidade", "==", Cidade)
    .where("estado", "==", Estado)
    .onSnapshot((querySnapshot) => {
      var cities = [];
      querySnapshot.forEach((doc) => {
          cities.push({
            id:doc.id,
           nome: doc.data().nome,
           Loc:doc.data().localizacao?doc.data().localizacao: null,
          });
      });
      setViat(cities)

    });

  },

  AtivandoApp: async(Id, Nome, Varia, TempAtiv, setAlertTipo, setAlert, )=> {
    let numberTem = parseInt(TempAtiv);
    const autenticado =  await Auth.currentUser;
    const id = await autenticado.uid;
    let temp = new Date().getTime();
    let now = temp + (Varia*1000);

    await db.collection("users")
    .where("ativaPerman", "==", true)
    .get().then((doc) => {
      console.log(doc.size)
      if (doc.size !== 0) {
          doc.forEach((doc) => {

            db.collection("chat").add({
              dateCriacao:now,
              ativo:true,
              idCriador:Id,
              nomeCriador:Nome,
              idSofrer:doc.id,
              userChat:[Id,doc.id],
              nomeSofrer:doc.data().nome,
              mensagem: [{autor:Id, 
                body:"Fui ativado agora e estou iniciando um chat com você",
                date:now,
                nome:Nome,
                type:"text" 
                  }],
              ultimaMsg:{data:now, id:Id, nome:Nome, msg:"Fui ativado agora e estou iniciando um chat com você"},
              vizualS:0,
              vizualC:0,
              digiC:false,
              digiS:false,
          })
          .then((docRef) => {
              
          })
 
        });
      } 
  }).catch((error) => {
      
  });

  await db.collection("users")
  .where("tempAtiva", "!=", 0)
  .get().then((doc) => {
    if (doc.size !== 0) {
        doc.forEach((doc) => {

          db.collection("chat").add({
            dateCriacao:now,
            ativo:true,
            idCriador:Id,
            nomeCriador:Nome,
            idSofrer:doc.id,
            nomeSofrer:doc.data().nome,
            userChat:[Id,doc.id],
            mensagem: [{autor:Id, 
              body:"Fui ativado agora e estou iniciando um chat com você",
              date:now,
              nome:Nome,
              type:"text" 
                }],
            ultimaMsg:{data:now, id:Id, nome:Nome, msg:"Fui ativado agora e estou iniciando um chat com você"},
            vizualS:0,
            vizualC:0,
            digiC:false,
            digiS:false,
        })
        .then((docRef) => {
            
        })

      });
    } 
}).catch((error) => {
    console.log("Error getting document:", error);
});

 await db.collection("users").doc(Id).update({
      "ativaPerman": false,
      "tempAtiva": numberTem,
      "conta.servApp.ativo": true,
  })
  .then(() => {
    setAlert("Ativado com sucesso!");
    setAlertTipo("success");
  });

  },

  AtivadoSempe: async( Id,  Nome, Varia, setAlertTipo, setAlert )=> {
    const autenticado =  await Auth.currentUser;
    const id = await autenticado.uid;
    let temp = new Date().getTime();
    let now = temp + (Varia*1000);


    await db.collection("users")
    .where("ativaPerman", "==", true)
    .get().then((doc) => {
      console.log(doc.size)
      if (doc.size !== 0) {
          doc.forEach((doc) => {

            db.collection("chat").add({
              dateCriacao:now,
              ativo:true,
              idCriador:Id,
              nomeCriador:Nome,
              idSofrer:doc.id,
              nomeSofrer:doc.data().nome,
              userChat:[Id,doc.id],
              mensagem: [{autor:Id, 
                body:"Fui ativado agora e estou iniciando um chat com você",
                date:now,
                nome:Nome,
                type:"text" 
                  }],
              ultimaMsg:{data:now, id:Id, nome:Nome, msg:"Fui ativado agora e estou iniciando um chat com você"},
              vizualS:0,
              vizualC:0,
              digiC:false,
              digiS:false,
          })
          .then((docRef) => {
              console.log("Document written with ID: ", docRef.id);
          })
 
        });
      } 
  }).catch((error) => {
      console.log("Error getting document:", error);
  });

  await db.collection("users")
  .where("tempAtiva", "!=", 0)
  .get().then((doc) => {
    if (doc.size !== 0) {
        doc.forEach((doc) => {

          db.collection("chat").add({
            dateCriacao:now,
            ativo:true,
            idCriador:Id,
            nomeCriador:Nome,
            idSofrer:doc.id,
            nomeSofrer:doc.data().nome,
            userChat:[Id,doc.id],
            mensagem: [{autor:Id, 
              body:"Fui ativado agora e estou iniciando um chat com você",
              date:now,
              nome:Nome,
              type:"text" 
                }],
            ultimaMsg:{data:now, id:Id, nome:Nome, msg:"Fui ativado agora e estou iniciando um chat com você"},
            vizualS:0,
            vizualC:0,
            digiC:false,
            digiS:false,
        })
        .then((docRef) => {
            
        })

      });
    } 
}).catch((error) => {
    console.log("Error getting document:", error);
});

  



    await db.collection("users").doc(Id).update({
      "ativaPerman": true,
      "tempAtiva":0,
      "conta.servApp.ativo": true,
  })
  .then(() => {

    setAlert("Ativado com sucesso!");
    setAlertTipo("success");
  });
   
  },
  BloqueandoAppServ: async(Dados, Id, setAlertTipo, setAlert)=> {
    
    const autenticado =  await Auth.currentUser;
    const id = await autenticado.uid;
    const Setor = "Bloquear App Serv";


    await db.collection("users").doc(Id).update({
      "conta.servApp.desbloqueado": false,
      "conta.serv.desbloqueado": false,
    })
    .then(() => {
            setAlert("Bloqueado Com Sucesso!");
            setAlertTipo("success");
             db.collection("movimentacao").add({
            id:id,
            instituicao: Dados.instituicao,
            cidade: Dados.cidade,
            estado: Dados.estado,
            Conta: Dados.conta.serv.tipo,
            acao:"Atualizar",
            setor: Setor,
            data:firebase.firestore.FieldValue.serverTimestamp(),
            idSofrer:Id,
            })
              
        });
    
  },

  DesbloqueandoAppServ: async(Dados, Id, setAlertTipo, setAlert)=> {
    
    const autenticado =  await Auth.currentUser;
    const id = await autenticado.uid;
    const Setor = "Desbloquear App Serv";


    await db.collection("users").doc(Id).update({
      "conta.servApp.desbloqueado": true,
      "tempAtiva":0,
      "ativaPerman":false,
    })
    .then(() => {
            setAlert("Desbloqueado Com Sucesso!");
            setAlertTipo("success");
             
              
        });
    
  },
  DesativandoAltoma: async()=> {
    
    const autenticado =  await Auth.currentUser;
    let temp = new Date().getTime();
  


    await db.collection("users")
    .where("tempAtiva", "!=", 0)
    .get().then((doc) => {
     
      if (doc.size !== 0) {
       
          doc.forEach(async(doc) => {
            if(doc.data().tempAtiva < temp){

              let Id = doc.id;
              await db.collection("chat")
              .where("userChat", "array-contains", Id)
              .get().then((doc) => {
                
                if (doc.size !== 0) {
                    doc.forEach((doc) => {
          
                      db.collection("chat").doc(doc.id).update({
                        "ativo": false,
                    })
                    
           
                  });
                } 
            }).catch((error) => {
               
            });
          
              await db.collection("users").doc(Id).update({
                "ativaPerman": false,
                "tempAtiva":0,
                "conta.servApp.ativo": false,
            })
            .then(() => {
              
            });


            }
        });


      } 
  }).catch((error) => {
     
  });

    
  },

  DesativandoApp: async(Dados, Id, setAlertTipo, setAlert)=> {
   
    const autenticado =  await Auth.currentUser;
    const id = await autenticado.uid;

    await db.collection("chat")
    .where("userChat", "array-contains", Id)
    .get().then((doc) => {
      console.log(doc.size)
      if (doc.size !== 0) {
          doc.forEach((doc) => {

            db.collection("chat").doc(doc.id).update({
              "ativo": false,
          })
          
 
        });
      } 
  }).catch((error) => {
     
  });


    await db.collection("users").doc(Id).update({
      "ativaPerman": false,
      "tempAtiva":0,
      "conta.servApp.ativo": false,
  })
  .then(() => {
    setAlert("Desativado com sucesso!");
    setAlertTipo("success");
  });
   
    
  },

  DesativandoLoc: async( item, setAlertTipo, setAlert)=> {
   
    const autenticado =  await Auth.currentUser;
    const id = await autenticado.uid;



    await db.collection("users").doc(item).update({
      "LocAtiva": false,
      
  })
  .then(() => {
    setAlert("Desativado Localização com sucesso!");
    setAlertTipo("success");
  });
   
    
  },

  AtivandoLoc: async( item, setAlertTipo, setAlert)=> {
   
    const autenticado =  await Auth.currentUser;
    const id = await autenticado.uid;



    await db.collection("users").doc(item).update({
      "LocAtiva": true,
      
  })
  .then(() => {
    setAlert("Ativado Localização com sucesso!");
    setAlertTipo("success");
  });
   
    
  },


  VizualizarApp: async(Id, Dados, setInfor)=> {

    await Auth.onAuthStateChanged( async function(user) {
      if (user) {
      const ID = user.uid;
      const Setor = "Vizualizar App Serv";
      await db.collection("users")
      .doc(Id)
      .get()
      .then((doc)=>{
          setInfor(doc.data());
          db.collection("movimentacao").add({
            id:ID,
            instituicao: Dados.instituicao,
            cidade: Dados.cidade,
            estado: Dados.estado,
            Conta: Dados.conta.serv.tipo,
            acao:"Vizualizar",
            setor: Setor,
            data:firebase.firestore.FieldValue.serverTimestamp(),
            idSofrer:Id,
            })
      })

      }
  
    });
    
    
  },

  ListCondicionais: async(Dados, setQuant, setUsuariosContServ)=> {
   
    await Auth.onAuthStateChanged( async function(user) {
      if (user) {
      const ID = user.uid;
      const Setor = "Lista de Condicionais";
      const dados = await db.collection('users')
      .doc(ID).
      get()
      .then(async(dados)=>{
        const result = await dados.data();
        await db.collection("movimentacao").add({
          id:ID,
          instituicao: result.instituicao,
          cidade: result.cidade,
          estado: result.estado,
          Conta: result.conta.serv.tipo,
          acao:"Vizualizar",
          setor: Setor,
          data:firebase.firestore.FieldValue.serverTimestamp(),
          });

          await db.collection("condicionais")
          .where("estado", "==", result.estado)
          .where("cidade", "==", result.cidade)
          .where("instituicao", "==", result.instituicao)
            .onSnapshot((querySnapshot) => {
            setQuant(querySnapshot.size);
            var res = []; 
            querySnapshot.forEach((doc) => {
                res.push({
                  id: doc.id,
                  nome: doc.data().nome,
                  ativo: doc.data().ativo,
    
                });      
            });
            setUsuariosContServ(res);
    
              });

          
        
   
       }); 
     
      } 
  
    });
    
    
  },

  ListItensEmp: async(Dados, setQuant, setUsuariosContServ)=> {
   
   
    var ResGet = []    
    await db.collection("ItensDaEmpresa")
    .where("Empresa", "==", EMPRESA)
    .get().then(async (querySnapshot) => {
      // .onSnapshot((querySnapshot) => {
      setQuant(querySnapshot.size);
    
      var res = []; 
      querySnapshot.forEach((doc) => {
          ResGet.push(doc.data())
          res.push({
            id: doc.id,
            nome: doc.data().nome,
            dataCriacao: doc.data().dataCriacao,
            Ativo:doc.data().Ativo,
            Tags:doc.data().Tags,
            Desconto:doc.data().Descont,
            DescontReal:doc.data().DescontReal,
            Preco:doc.data().Preco,
            PrecoReal:doc.data().PrecoReal,
            Menu:doc.data().Menu,
            Descricao:doc.data().Descricao,
            foto:doc.data().foto,
            Quant:doc.data().Quant? doc.data().Quant: 1,
            Ilimitado:doc.data().Quant? doc.data().Ilimitado: true,
            GrupTamanho:doc.data().GrupTamanho? doc.data().GrupTamanho: [],
            Tamanho:doc.data().Tamanho? doc.data().Tamanho: false,
          });      
      });
      console.log(res)
      setUsuariosContServ(res);

        });
        console.log(ResGet)
    for(let i in ResGet){
     
    //  await db.collection("ItensDaEmpresa").add({
    //   Ativo:ResGet[i].Ativo,
    //   Descont:ResGet[i].Descont,
    //   DescontReal:ResGet[i].DescontReal,
    //   Descricao:ResGet[i].Descricao,
    //   Empresa:"8tQ87beAONHRfUx5DIRy",
    //   GrupTamanho:ResGet[i].GrupTamanho,
    //   Ilimitado:ResGet[i].Ilimitado,
    //   Menu:ResGet[i].Menu,
    //   Preco:ResGet[i].Preco,
    //   PrecoReal:ResGet[i].PrecoReal,
    //   Quant:ResGet[i].Quant,
    //   Tags:ResGet[i].Tags,
    //   Tamanho:ResGet[i].Tamanho,
    //   dataCriacao:ResGet[i].dataCriacao,
    //   foto:ResGet[i].foto,
    //   nome:ResGet[i].nome,
    //   }).then(async (doc)=>{
    //    console.log(i)
    //   })
    }
  



},

  ListMenus: async(Dados, setQuant, setUsuariosContServ)=> {
   
   
    var ResGet = []      
    await db.collection("MenusSite")
    .where("Empresa", "==", EMPRESA)
    .get().then(async(querySnapshot) => {
      setQuant(querySnapshot.size);
      var res = []; 
      querySnapshot.forEach((doc) => {
        ResGet.push(doc.data())
          res.push({
            id: doc.id,
            nome: doc.data().nome,
            dataCriacao: doc.data().dataCriacao,
            Ativo:doc.data().Ativo,
            Tags:doc.data().Tags,
            Tamanho:doc.data().Tamanho,
            GrupTamanho:doc.data().GrupTamanho,
            MemFim:doc.data().MemFim? doc.data().MemFim : false,
          });      
      });
      console.log(res)
      setUsuariosContServ(res);

        });

        // console.log(ResGet)
        // for(let i in ResGet){
         
        //  await db.collection("MenusSite").add({
        //   AtiEspeci:ResGet[i].AtiEspeci?ResGet[i].AtiEspeci:false,
        //   Especifico:ResGet[i].Especifico?ResGet[i].Especifico:"",
        //   Ativo:ResGet[i].Ativo,
        //   GrupEspe:ResGet[i].GrupEspe?ResGet[i].GrupEspe:[],
        //   Empresa:"8tQ87beAONHRfUx5DIRy",
        //   GrupTamanho:ResGet[i].GrupTamanho,
        //   Tags:ResGet[i].Tags,
        //   Tamanho:ResGet[i].Tamanho,
        //   dataCriacao:ResGet[i].dataCriacao,
        //   nome:ResGet[i].nome,
        //   MemFim:ResGet[i].MemFim,
        //   }).then(async (doc)=>{
        //    console.log(i)
        //   })
        // }
    
  



},
  ListAnuncio: async(Dados, setQuant, setUsuariosContServ)=> {
   
   
       
          await db.collection("anuncios")
            .onSnapshot((querySnapshot) => {
            setQuant(querySnapshot.size);
            var res = []; 
            querySnapshot.forEach((doc) => {
                res.push({
                  id: doc.id,
                  nome: doc.data().nome,
                  dataCriacao: doc.data().dataCriacao,
                  foto: doc.data().foto,
                });      
            });
            console.log(res)
            setUsuariosContServ(res);
    
              });

          
        
   
    
    
  },

  CriarJogoCambio: async(Dados, Nome, TelCli, setAlertTipo, setAlert, setCarreg )=> {
    var id = "";
   
     await db.collection("users")
     .where("Telefone", "==", Dados.Tel)
     .where("DataEnt", "==", Dados.DataEnt)
     .get().then(async (querySnapshot) => {
       if(querySnapshot.size  !== 0){
        
        querySnapshot.forEach((doc) => {
          id = doc.id
        })



        var ver = TelCli.replace("(", "55");
        var par1 = ver.replace(")", "");
        var par3 = par1.replace("-", "");
     
        const req = await fetch(`https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/phone-exists/${par3}`, 
        {
              method: 'GET',
              headers:{
                'Content-Type': 'application/json'
              },
             
            });
    
        
          
            const json = await req.json(); 
            
            if(json.exists === true){
 
         
 
 
 
 
 
 
               db.collection("NotaCambista").add({
                

                 Nome:Dados.Nome,
                 Tel:Dados.Tel,
                 IdCri:id,
                 Cambista:true,
                 NomeComp:Nome,
                 TelComp:TelCli,
                 Pago:false,
                 Conscluido:false,
                 dataCriar: new Date().getTime(),
                 ValorPremio: 0,
                 ValorAposta: 0,
                 Bets:[],
                 ValCambis:"",
                 CotaGeral:"",
                 valorAposSimb:"R$000,00",
                 CriarJogoCambio:0,



                 }).then(async (doc)=>{

                   var res= doc.id;
                  
                  var data={
                     "phone": par3,
                     "message": `Olá ${Nome}, O Cambista ${Dados.Nome} lhe enviou Esse Link da PixBetCash, para você criar uma aposta, registre o numero da pixbetcash em sua lista de contato para ter acesso a entrada do link de forma facil. ${URL_SITE}/links/${res}`,
                     "image": "https://firebasestorage.googleapis.com/v0/b/pixbetcash.appspot.com/o/arquivo%2FLogoPixBetMp.png?alt=media&token=5ff20c89-022e-4dd1-8a87-e1becebde7f9",
                     "linkUrl": `${URL_SITE}/links/${res}`,
                     "title": "Link para Palpites de Aposta",
                     "linkDescription": `O Cambista ${Dados.Nome} lhe enviou Esse Link, para você construir sua aposta, clique nesse Link e construa sua aposta!`
                   }
                   const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-link", 
                   {
                         method: 'POST',
                         headers:{
                           'Content-Type': 'application/json'
                         },
                         body: JSON.stringify(data),
                       });
           
                       const json = await req.json();


                       setCarreg(false);
                   setAlert("Criado com Sucesso, O Link Foi enviado Para Seu Cliente!");
                   setAlertTipo("success");
                 
                 });
               
           
       } else {

        setCarreg(false);
         setAlert("Esse Telefone Não é um Whatsapp!");
         setAlertTipo("danger");
 
        } 
 
 
 
 
 
 
 
 
 
 
 
        } else {
          setCarreg(false);
         setAlert("Você não Pode Criar o Jogo Pois Você não é dono dessa conta!");
         setAlertTipo("danger");
 
        } 
     });
 
 
       
   },

   VerDadosCash: async(Dados, setCash, setReal,  setDate, setVenci, setExtrat)=> {
    var id = "";
   
     await db.collection("users")
     .where("Telefone", "==", Dados.Tel)
     .where("DataEnt", "==", Dados.DataEnt)
     .onSnapshot((querySnapshot) => {
       if(querySnapshot.size  !== 0){
        
        querySnapshot.forEach((doc) => {
          let currentDate = '';
          let now =new Date(doc.data().DataVenc);
          let hours = now.getHours();
          let minutes = now.getMinutes();
          let Dia = now.getDate();
          let Mes = (now.getMonth()+1);
          let Ano = now.getFullYear(); 
          hours = hours < 10 ? '0'+hours : hours;
          minutes = minutes < 10 ? '0'+minutes : minutes;
          Dia = Dia < 10 ? '0'+Dia : Dia;
          Mes = Mes < 10 ? '0'+Mes : Mes;
          currentDate = Dia+'/'+Mes+'/'+Ano;

          if(doc.data().DataVenc > new Date().getTime()){
            setVenci(false)
          } else {
            setVenci(true)
          }

          setCash(doc.data().Cash);
          setReal(doc.data().Dinheiro);
          setDate(currentDate);
          setExtrat(doc.data().Extrato);
        
        })

        } 
     });
 
 
       
   },
 

   EnviarLink: async(Dados, ItemLink, setAlert, setAlertTipo, setCarreg, setTentativa, setCodG, setSenha, setRobo, setModalLink, setItemLink)=> {
    var id = "";
   
     await db.collection("users")
     .where("Telefone", "==", Dados.Tel)
     .where("DataEnt", "==", Dados.DataEnt)
     .get().then(async (querySnapshot) => {
       if(querySnapshot.size  !== 0){
        
        querySnapshot.forEach((doc) => {
          id = doc.id
        })


      

        var ver = ItemLink.list.TelCli.replace("(", "55");
        var par1 = ver.replace(")", "");
        var par3 = par1.replace("-", "");
 
            
                  
                  var data={
                     "phone": par3,
                     "message": `Olá ${ItemLink.list.Nome}, O Cambista ${Dados.Nome} lhe enviou Esse Link da PixBetCash, para você criar uma aposta, registre o numero da pixbetcash em sua lista de contato para ter acesso a entrada do link de forma facil. ${URL_SITE}/links/${ItemLink.list.id}`,
                     "image": "https://firebasestorage.googleapis.com/v0/b/pixbetcash.appspot.com/o/arquivo%2FLogoPixBetMp.png?alt=media&token=5ff20c89-022e-4dd1-8a87-e1becebde7f9",
                     "linkUrl": `${URL_SITE}/links/${ItemLink.list.id}`,
                     "title": "Link para Palpites de Aposta",
                     "linkDescription": `O Cambista ${Dados.Nome} lhe enviou Esse Link, para você construir sua aposta, clique nesse Link e construa sua aposta!`
                   }
                   const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-link", 
                   {
                         method: 'POST',
                         headers:{
                           'Content-Type': 'application/json'
                         },
                         body: JSON.stringify(data),
                       });
           
                       const json = await req.json();
                     setTentativa(0);
                     setCodG(false);
                     setRobo(true);
                     setSenha("")
                     setModalLink(false);
                     setItemLink({})

                       setCarreg(false);  
                   setAlert("O Link Foi enviado Para Seu Cliente!");
                   setAlertTipo("success");
                 
              
               
           
    
 
 
 
 
 
 
 
 
 
 
 
        } else {
          setCarreg(false);
         setAlert("Você não Pode Criar o Jogo Pois Você não é dono dessa conta!");
         setAlertTipo("danger");
 
        } 
     });
 
 
       
   },
 


  CriarTime: async(Dados, Nome, Imgs,  setAlertTipo, setAlert)=> {
   var Url1 = "";
   console.log(Imgs)
    await db.collection("users")
    .where("Telefone", "==", Dados.Tel)
    .where("DataEnt", "==", Dados.DataEnt)
    .get().then(async (querySnapshot) => {
      if(querySnapshot.size  !== 0){
        

        await db.collection("Times")
        .where("nome", "==", Nome)
        .get()
        .then(async (doc)=>{
          
            if(doc.size === 0){

              if(Imgs[0].Foto !== ""){
                const fileName = await Date.now() + Imgs[0].Foto.name;
                const storageRef = await storage.ref();
                const fileRef = await storageRef.child(`arquivo/${fileName}`);
                await fileRef.put(Imgs[0].Foto).then((doc)=> {
                  
                });
                Url1 =  await fileRef.getDownloadURL();
              }







              db.collection("Times").add({
                nome:Nome,
                logo:Url1,
                dataCriar: new Date().getTime(),
                ativo:true
                }).then((doc)=>{
                  const res= doc.id;
                  setAlert("Criado com Sucesso");
                  setAlertTipo("success");
                
                });
              
            } else {
              setAlert("Esse Time já existe!");
              setAlertTipo("danger");
            }
        });











       } else {
        setAlert("Você não Pode Criar o Time Pois Você não é dono dessa conta!");
        setAlertTipo("danger");

       } 
    });


      
  },

  
  SalvandoMsgEspera: async(msgEspera, setAlert, setAlertTipo)=> {
   
    await db.collection("EmrpesaSite").doc(EMPRESA).update({
      MsgEspera:msgEspera, 
    }).then(()=>{
      setAlert("Salvo com Sucesso");
      setAlertTipo("success");
   

    });
  },

  AtivandoDelivey: async(AtivaDeli, setAlert, setAlertTipo)=> {
   
    await db.collection("EmrpesaSite").doc(EMPRESA).update({
      AtivaDelivery:AtivaDeli, 
    }).then(()=>{
      if(AtivaDeli){
        setAlert("Delivery Ativado");
        setAlertTipo("success");

      } else {
        setAlert("Delivery desativado");
        setAlertTipo("success");
      }
    
   

    });
  },

  DesativandoAnunci: async(Dados, resla, setAlertTipo, setAlert)=> {
   
    await db.collection("EmrpesaSite").doc(EMPRESA).update({
     Marketing:resla, 
    }).then(()=>{
      setAlert("Realizado com Sucesso");
      setAlertTipo("success");
   

    });
  },

  DesativandoMenu: async(Dados, id, setAlertTipo, setAlert)=> {
    console.log(id)
    await db.collection("MenusSite").doc(id).update({
     Ativo:false, 
    }).then(()=>{
      setAlert("Desativado com Sucesso");
      setAlertTipo("success");
   

    });
  },

  CriandoPedido: async(DadEmp, TelPedido, id, setAlertTipo, setAlert)=> {
    console.log(id)
    if(TelPedido){
      var ver = TelPedido.replace("(", "55");
      var par1 = ver.replace(")", "");
      var par3 = par1.replace("-", "");

      await db.collection("ClienteEmpre")
      .where("Empresa", "array-contains", EMPRESA)
      .where("Telefone", "==", par3)
      .get().then(async (querySnapshot1) => {

      

        if(querySnapshot1.size  !== 0){ //O Cliente já está cadastrado
          var IdMensgens = []
          var NomeCli = "";
          var IdCli ="";
          await querySnapshot1.forEach((doc1) => {
              NomeCli =  doc1.data().Nome;
              IdCli = doc1.id;
              IdMensgens = doc1.data().IdMensgens?doc1.data().IdMensgens:[];
             })
             await  db.collection("MesaItem").add({
              CanalChat:"1",
              NomeCli:"",
              TelCli:par3,
              Ativo:true,
              Cliente:IdCli,
              IdChat:"",
              Empresa:EMPRESA,
              Codigo: 0,
              Mesa:"Externo",
              Itens:[],
              ValorTotaL:0,
              ValorEntrega:0,
              ComissaaEntrega:0,
              dataCriacao:new Date().getTime(),
              Fechado:false,
              IniciandoProducao:false,
              IniciandoEntrega:false,
              ConcluidoEntregado:false,
              ConcluidoProducao:false,
              ConfirmacaoPedido:false,
              FormaDepagamento:null,
              Pix:false,
              Cartao:false,
              Dinheiro:false,
              ExtratoPix:null,
              TrocoDinheiro:null,
              End:[],
              Bairro:"",
              TelEntregador:"",
              Entrega:true,
              EndProximo:"",
              TaxaPorBairro:false,
              TaxaPorLocalizacao:false,
              localizacaoGps:{},
              ObervacaoPedido:null,
              Buscar:false,
              PedConstruido:false,
              ClienteEsc:true,
              TituloAcrescimo:"",
              ValorAcrescimo:"",
              UltimaMsg:{
                body:"Pedido Cirado",
                date:new Date().getTime()+7000,
                Type:"text",
            },
              }).then(async (dif) => {
                var IdMesa = dif.id;
                await db.collection("ChatCliente").add({
                  RoboAtivo:true,
                  MemEndereco:[],
                  MemSessao:"",
                  MemSubSessao:"",
                  SubSessao:"",
                  DigiBairro:{},
                    Id: IdCli,
                    DigiteNaRegra:true,
                    CanalChat:"1",
                    MsgDinamica:{
                      Funcao:"AnliseGeral",
                      Ativo:false,
                      Canal:"1",
                      Tempo:new Date().getTime()+20000,
                  },
                  
                    MemSessao:[],
                    MemPedido:{},
                    Reclamaçoes:null,
                    Localização:null,
                    Pedido:dif.id,
                    DataInicio: new Date().getTime(),
                    Empresa:EMPRESA,
                    Telefone:par3,
                    Robotizado:true,
                    Ativo:true,
                    vizualEmp:0,
                    VizualCli:1,
                    DigiEmp:false,
                    DigiCli:false,
                    FaseMsg:"Msg1A",
                    UltimaMsg:{
                        Autor:EMPRESA,
                        body:"pedido Inicial",
                        date:new Date().getTime()+7000,
                        Type:"text"
                    },
                    Mensagem:[{
                        Autor:IdCli,
                        body:"Iniciando Pedido",
                        date:new Date().getTime(),
                        Type:"text",
                        MsgPerg:false,
                        CliMsgResp:false,
                        Resp:"",
                      }, 
                    ]
                 
                })
                .then(async(docRef2) => {
                  await db.collection("MesaItem").doc(IdMesa).update({
                    IdChat:docRef2.id, 
                   }).then(()=>{
                     setAlert("Cidado com Sucesso");
                     setAlertTipo("success");
                  
               
                   });
                })
            
           
        
            });


        } else {
          await db.collection("ClienteEmpre")
          .where("Telefone", "==", par3)
          .get().then(async (querySnapshot12) => {
            var  NomeCli = ""
                  
            if(querySnapshot12.size  !== 0){//Aqui é se o cliente já está cadastrado na CWO  
              var IdCli = "";
              var IdMensgens = []
              await querySnapshot12.forEach((doc12) => {
                IdCli = doc12.id;
                NomeCli = doc12.data().Nome;
                IdMensgens = doc12.data().IdMensgens?doc12.data().IdMensgens:[];
               })

            await db.collection("ClienteEmpre")
                .doc(IdCli)
                .update({
                Empresa:firebase.firestore.FieldValue.arrayUnion(EMPRESA)
                })
                .then(async() => {})

         await  db.collection("MesaItem").add({
              CanalChat:"1",
              NomeCli:"",
              TelCli:par3,
              Ativo:true,
              Cliente:IdCli,
              IdChat:"",
              Empresa:EMPRESA,
              Codigo: 0,
              Mesa:"Externo",
              Itens:[],
              ValorTotaL:0,
              ValorEntrega:0,
              ComissaaEntrega:0,
              dataCriacao:new Date().getTime(),
              Fechado:false,
              IniciandoProducao:false,
              IniciandoEntrega:false,
              ConcluidoEntregado:false,
              ConcluidoProducao:false,
              ConfirmacaoPedido:false,
              FormaDepagamento:null,
              Pix:false,
              Cartao:false,
              Dinheiro:false,
              ExtratoPix:null,
              TrocoDinheiro:null,
              End:[],
              Bairro:"",
              TelEntregador:"",
              Entrega:true,
              EndProximo:"",
              TaxaPorBairro:false,
              TaxaPorLocalizacao:false,
              localizacaoGps:{},
              ObervacaoPedido:null,
              Buscar:false,
              PedConstruido:false,
              ClienteEsc:true,
              TituloAcrescimo:"",
              ValorAcrescimo:"",
              UltimaMsg:{
                body:"Pedido Cirado",
                date:new Date().getTime()+7000,
                Type:"text",
            },
              }).then(async (dif) => {
                var IdMesa = dif.id;
                await db.collection("ChatCliente").add({
                  RoboAtivo:true,
                  MemEndereco:[],
                  MemSessao:"",
                  MemSubSessao:"",
                  SubSessao:"",
                  DigiBairro:{},
                    Id: IdCli,
                    DigiteNaRegra:true,
                    CanalChat:"1",
                    MsgDinamica:{
                      Funcao:"AnliseGeral",
                      Ativo:false,
                      Canal:"1",
                      Tempo:new Date().getTime()+20000,
                  },
                  
                    MemSessao:[],
                    MemPedido:{},
                    Reclamaçoes:null,
                    Localização:null,
                    Pedido:dif.id,
                    DataInicio: new Date().getTime(),
                    Empresa:EMPRESA,
                    Telefone:par3,
                    Robotizado:true,
                    Ativo:true,
                    vizualEmp:0,
                    VizualCli:1,
                    DigiEmp:false,
                    DigiCli:false,
                    FaseMsg:"Msg1A",
                    UltimaMsg:{
                        Autor:EMPRESA,
                        body:"pedido Inicial",
                        date:new Date().getTime()+7000,
                        Type:"text"
                    },
                    Mensagem:[{
                        Autor:IdCli,
                        body:"Iniciando Pedido",
                        date:new Date().getTime(),
                        Type:"text",
                        MsgPerg:false,
                        CliMsgResp:false,
                        Resp:"",
                      }, 
                    ]
                 
                })
                .then(async(docRef2) => {
                  await db.collection("MesaItem").doc(IdMesa).update({
                    IdChat:docRef2.id, 
                   }).then(()=>{
                     setAlert("Cidado com Sucesso");
                     setAlertTipo("success");
                  
               
                   });
                })
            
           
        
            });
            } else {
              await db.collection("ClienteEmpre").add({
                Nome: "",
                Telefone: par3,
                dataCadas:new Date().getTime(),
                End:[],
                Empresa:firebase.firestore.FieldValue.arrayUnion(EMPRESA),
                IdMensgens:[],
            })
            .then(async (docRef) => {
               var IdCli = docRef.id;
               await  db.collection("MesaItem").add({
                CanalChat:"1",
                NomeCli:"",
                TelCli:par3,
                Ativo:true,
                Cliente:IdCli,
                IdChat:"",
                Empresa:EMPRESA,
                Codigo: 0,
                Mesa:"Externo",
                Itens:[],
                ValorTotaL:0,
                ValorEntrega:0,
                ComissaaEntrega:0,
                dataCriacao:new Date().getTime(),
                Fechado:false,
                IniciandoProducao:false,
                IniciandoEntrega:false,
                ConcluidoEntregado:false,
                ConcluidoProducao:false,
                ConfirmacaoPedido:false,
                FormaDepagamento:null,
                Pix:false,
                Cartao:false,
                Dinheiro:false,
                ExtratoPix:null,
                TrocoDinheiro:null,
                End:[],
                Bairro:"",
                TelEntregador:"",
                Entrega:true,
                EndProximo:"",
                TaxaPorBairro:false,
                TaxaPorLocalizacao:false,
                localizacaoGps:{},
                ObervacaoPedido:null,
                Buscar:false,
                PedConstruido:false,
                ClienteEsc:true,
                TituloAcrescimo:"",
                ValorAcrescimo:"",
                UltimaMsg:{
                  body:"Pedido Cirado",
                  date:new Date().getTime()+7000,
                  Type:"text",
              },
                }).then(async (dif) => {
                  var IdMesa = dif.id;
                  await db.collection("ChatCliente").add({
                    RoboAtivo:true,
                    MemEndereco:[],
                    MemSessao:"",
                    MemSubSessao:"",
                    SubSessao:"",
                    DigiBairro:{},
                      Id: IdCli,
                      DigiteNaRegra:true,
                      CanalChat:"1",
                      MsgDinamica:{
                        Funcao:"AnliseGeral",
                        Ativo:false,
                        Canal:"1",
                        Tempo:new Date().getTime()+20000,
                    },
                    
                      MemSessao:[],
                      MemPedido:{},
                      Reclamaçoes:null,
                      Localização:null,
                      Pedido:dif.id,
                      DataInicio: new Date().getTime(),
                      Empresa:EMPRESA,
                      Telefone:par3,
                      Robotizado:true,
                      Ativo:true,
                      vizualEmp:0,
                      VizualCli:1,
                      DigiEmp:false,
                      DigiCli:false,
                      FaseMsg:"Msg1A",
                      UltimaMsg:{
                          Autor:EMPRESA,
                          body:"pedido Inicial",
                          date:new Date().getTime()+7000,
                          Type:"text"
                      },
                      Mensagem:[{
                          Autor:IdCli,
                          body:"Iniciando Pedido",
                          date:new Date().getTime(),
                          Type:"text",
                          MsgPerg:false,
                          CliMsgResp:false,
                          Resp:"",
                        }, 
                      ]
                   
                  })
                  .then(async(docRef2) => {
                    await db.collection("MesaItem").doc(IdMesa).update({
                      IdChat:docRef2.id, 
                     }).then(()=>{
                       setAlert("Cidado com Sucesso");
                       setAlertTipo("success");
                    
                 
                     });
                  })
              
             
          
              });
              });

            }
          })
       

        }
         

      
      });
      if(DadEmp.ServidorZapi){
        var dateri={
          "phone":par3,
          "message":"Estamos Anotando Seu Pedido!",
        }   
        const req = await fetch(URL_SITE+"/send-messages", 
        {
              method: 'POST',
              headers:{
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(dateri),
           });
      } else {
       await db.collection("CorreioMSg")
       .add({
         Canal:"1",
         Ativo:true,
         EMPRESA:EMPRESA,
         Msg:"Estamos Anotando Seu Pedido!",
         Botao:[],
         Tel:par3,
         Type:"text",
         Agendamento:firebase.firestore.FieldValue.serverTimestamp()
       })
       .then( async (docRef) => {
      
    });
  }

    } else {
    await  db.collection("MesaItem").add({
      CanalChat:"1",
      NomeCli:"",
      TelCli:"Pedido Livre",
      Ativo:true,
      Cliente:"",
      IdChat:"",
      Empresa:EMPRESA,
      Codigo: 0,
      Mesa:"Externo",
      Itens:[],
      ValorTotaL:0,
      ValorEntrega:0,
      ComissaaEntrega:0,
      dataCriacao:new Date().getTime(),
      Fechado:false,
      IniciandoProducao:false,
      IniciandoEntrega:false,
      ConcluidoEntregado:false,
      ConcluidoProducao:false,
      ConfirmacaoPedido:false,
      FormaDepagamento:null,
      Pix:false,
      Cartao:false,
      Dinheiro:false,
      ExtratoPix:null,
      TrocoDinheiro:null,
      End:[],
      Bairro:"",
      TelEntregador:"",
      Entrega:true,
      EndProximo:"",
      TaxaPorBairro:false,
      TaxaPorLocalizacao:false,
      localizacaoGps:{},
      ObervacaoPedido:null,
      Buscar:false,
      PedConstruido:false,
      ClienteEsc:true,
      TituloAcrescimo:"",
      ValorAcrescimo:"",
      UltimaMsg:{
          body:0,
          date:0,
          Type:"ChatNull",
      },
      }).then(async (dif) => {
      setAlert("Criado com Sucesso");
      setAlertTipo("success");
   

    });
  }
  },

  DesativandoItem: async(Dados, id, setAlertTipo, setAlert)=> {
    console.log(id)
    await db.collection("ItensDaEmpresa").doc(id).update({
     Ativo:false, 
    }).then(()=>{
      setAlert("Desativado com Sucesso");
      setAlertTipo("success");
   

    });
  },
  ConcluindoPedi: async(UsuariosContServ, setAlert, setAlertTipo, setLoadConc)=> {
  var TimeAtendi =  0;
  var QuantPed = 0;
  var TotalEnt = 0;
  var TotalSemEnt = 0;
    for(let i  in UsuariosContServ){
    
        TimeAtendi = TimeAtendi + (UsuariosContServ[i].TimeAtendimento1-UsuariosContServ[i].dataCriacao)
        QuantPed = QuantPed +1;
        TotalEnt = TotalEnt+UsuariosContServ[i].ValorTotaL
        TotalSemEnt = TotalSemEnt+(UsuariosContServ[i].ValorTotaL-UsuariosContServ[i].ValorEntrega)

        await db.collection("MesaItem").doc(UsuariosContServ[i].id).update({
          Fechado:true, 
        }).then(async()=>{
          var Id = "";
          await db.collection("ChatCliente")
          .where("Pedido", "==", UsuariosContServ[i].id)
          .get().then(async (querySnapshot) => {
           
             
             querySnapshot.forEach((doc) => {
               Id = doc.id
             })
            })
     
          await db.collection("ChatCliente").doc(Id).update({
            Ativo:false,
            "MsgDinamica.Ativo":false,
            "MsgFutura2.Ativo":false,
            "MsgFutura1.Ativo":false,
            "MsgFutura3.Ativo":false,
          }).then(()=>{
          // setAlert("Pedido Concluido");
          // setAlertTipo("success");
           });
          
            
          
    
        });
     
   
  }
  var MediAtendi = TimeAtendi/QuantPed
  var MedPorMin = MediAtendi/60
  var MsgPedido = "*Informações Diaria*";
  console.log(MediAtendi)
  console.log(TotalEnt)
  console.log(TotalSemEnt)
  MsgPedido = MsgPedido + "\n===================\n"
  MsgPedido = MsgPedido + "Tempo Médio Atendimento "+MediAtendi+  "Min "
  MsgPedido = MsgPedido + "\n===================\n"
  MsgPedido = MsgPedido + "Valor Total "+TotalEnt.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
  MsgPedido = MsgPedido + "\n===================\n"
  MsgPedido = MsgPedido + "Valor Total sem Entrega "+TotalSemEnt.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
  await db.collection("CorreioMSg")
  .add({
    Canal:"1",
    Ativo:true,
    EMPRESA:EMPRESA,
    Msg:MsgPedido,
    Botao:[],
    Tel:"558695437113",
    Type:"text",
    Agendamento:firebase.firestore.FieldValue.serverTimestamp()
  }).then( async (docRef) => { 
   console.log(docRef.id)
  });

  setAlert("Concluidos com Sucesso");
  setAlertTipo("success");
  setLoadConc(false)
  },
  ExcluirPedido: async(Dados, id, setAlertTipo, setAlert)=> {
    console.log(id)
    var Id = "";
    await db.collection("MesaItem").doc(id).delete().then(async ()=>{
   
      await db.collection("ChatCliente")
      .where("Pedido", "==", id)
      .get().then(async (querySnapshot) => {
       
         
         querySnapshot.forEach((doc) => {
           Id = doc.id
         })
        })
 
      await db.collection("ChatCliente").doc(Id).delete().then(()=>{
      setAlert("Excluido com Sucesso");
      setAlertTipo("success");
       });

    });
  },
   RegistandoUsuario: async(id, setAlert,setAlertTipo)=> {

    await db.collection("GBusers").doc(id).update({
     "Registrado":true, 
    }).then(()=>{
      setAlert("Registrado com Sucesso");
      setAlertTipo("success");
     

    });
  },
   ReceberMsg: async(id, setAlert,setAlertTipo)=> {

    await db.collection("GBusers").doc(id).update({
     "ReceberMsg":"Receber", 
    }).then(()=>{
      setAlert("Esse Usuário Receberar Mensagens");
      setAlertTipo("success");
     

    });
  },
   NaoReceberMsg: async(id, setAlert,setAlertTipo)=> {

    await db.collection("GBusers").doc(id).update({
     "ReceberMsg":"Não Receber", 
    }).then(()=>{
      setAlert("Esse Usuário Não Receberar Mensagens");
      setAlertTipo("success");
     

    });
  },

  

  AtivandoItem: async(Dados, id, setAlertTipo, setAlert)=> {
   
    await db.collection("ItensDaEmpresa").doc(id).update({
     Ativo:true, 
    }).then(()=>{
      setAlert("Ativado com Sucesso");
      setAlertTipo("success");
   

    });
  },

  RegistrarEntrePedido: async(DadEmp, Dados, Entregador, TelParaEntre, IdParaEntre, EntregadorTel, setAlertTipo, setAlert)=> {
   
    await db.collection("MesaItem").doc(IdParaEntre).update({
      TelEntregador:EntregadorTel,
      NomeEntregador:Entregador,
      IniciandoEntrega:true,  
    }).then(async()=>{
    
    
        setAlert("Enviado para Entrega");
        setAlertTipo("success");
        var ver = TelParaEntre.replace("(", "55");
        var par1 = ver.replace(")", "");
        var par3 = par1.replace("-", "");
  
      
      
          var Id = "";
          var Canal = 0;
          await db.collection("ChatCliente")
          .where("Pedido", "==", IdParaEntre)
          .get().then(async (querySnapshot) => {
           
             
             querySnapshot.forEach((doc) => {
               Id = doc.id
               Canal = doc.data().CanalChat
             })
            })
     
          await db.collection("ChatCliente").doc(Id).update({
            Robotizado:true, 
            DigiteNaRegra:true, 
            "MsgDinamica.Ativo":false,
            "MsgFutura1.Ativo":false,
            "MsgFutura3.Ativo":false,
          }).then(()=>{
            setAlert("Entrega Iniciada");
            setAlertTipo("success");
           }); 

           if(DadEmp.ServidorZapi){
            var dateri={
              "phone":par3,
              "message":"Seu pedido saiu para a entrega, espere no endereço informado!",
            }   
            const req = await fetch(URL_SITE+"/send-messages", 
            {
                  method: 'POST',
                  headers:{
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(dateri),
               });
          } else {
           await db.collection("CorreioMSg")
           .add({
             Canal:Canal,
             Ativo:true,
             EMPRESA:EMPRESA,
             Msg:"Seu pedido saiu para a entrega, espere no endereço informado!",
             Botao:[],
             Tel:par3,
             Type:"text",
             Agendamento:firebase.firestore.FieldValue.serverTimestamp()
           })
           .then( async (docRef) => {
       
        });
      }
 

    });
  },

  LevarProducao: async(list, DadEmp, msgProd, Dados, id, Tel, setAlertTipo, setAlert)=> {
   
    await db.collection("MesaItem").doc(id).update({
      IniciandoProducao:true,
      TimeAtendimento1:new Date().getTime(),
    }).then(async()=>{
      if(list.UltimaMsg.Type !== "ChatNull"){
      var ver = Tel.replace("(", "55");
      var par1 = ver.replace(")", "");
      var par3 = par1.replace("-", "");

    
     
        
      
      var Id = "";
      var Canal = 0;
        await db.collection("ChatCliente")
        .where("Pedido", "==", id)
        .get().then(async (querySnapshot) => {
         
           
           querySnapshot.forEach((doc) => {
             Id = doc.id
             Canal = doc.data().CanalChat
           })
          })
   
        await db.collection("ChatCliente").doc(Id).update({
          Robotizado:true, 
          DigiteNaRegra:true, 
          "MsgDinamica.Ativo":false,
          "MsgFutura1.Ativo":false,
          "MsgFutura3.Ativo":false,
        }).then(()=>{
        //   setAlert("Enviado para Produção");
        // setAlertTipo("success");
         });
         if(DadEmp.ServidorZapi){
          var dateri={
            "phone":par3,
            "message":msgProd,
          }   
          const req = await fetch(URL_SITE+"/send-messages", 
          {
                method: 'POST',
                headers:{
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(dateri),
             });
        } else {
         await db.collection("CorreioMSg")
         .add({
           Canal:Canal,
           Ativo:true,
           EMPRESA:EMPRESA,
           Msg:msgProd,
           Botao:[],
           Tel:par3,
           Type:"text",
           Agendamento:new Date().getTime(),
         })
         .then( async (docRef) => { 
           
         });
        }
       
      }
      

    });
  },

  ConCluirProducao: async(Dados, id, Tel, setAlertTipo, setAlert)=> {
   
    await db.collection("MesaItem").doc(id).update({
      ConcluidoProducao:true, 
    }).then(async()=>{
    
      var ver = Tel.replace("(", "55");
      var par1 = ver.replace(")", "");
      var par3 = par1.replace("-", "");

    
      var Canal = 0;
        var Id = "";
        await db.collection("ChatCliente")
        .where("Pedido", "==", id)
        .get().then(async (querySnapshot) => {
         
           
           querySnapshot.forEach((doc) => {
             Id = doc.id
             Canal = doc.data().CanalChat
           })
          })
   
        await db.collection("ChatCliente").doc(Id).update({
          Robotizado:true, 
          DigiteNaRegra:true, 
          "MsgDinamica.Ativo":false,
          "MsgFutura1.Ativo":false,
          "MsgFutura3.Ativo":false,
        }).then(()=>{
          setAlert("Pedido Foi Concluido");
          setAlertTipo("success");
         });

         await db.collection("CorreioMSg")
         .add({
          Canal:Canal,
           Ativo:true,
           EMPRESA:EMPRESA,
           Msg:"Estamos preparando seu pedido para a entrega",
           Botao:[],
           Tel:par3,
           Type:"text",
           Agendamento:firebase.firestore.FieldValue.serverTimestamp()
         })
         .then( async (docRef) => { 
     
      });

    });
  },

  ConCluirProducaoSemEnt: async(Dados, id, Tel, setAlertTipo, setAlert)=> {
   
    await db.collection("MesaItem").doc(id).update({
      ConcluidoProducao:true, 
    }).then(async()=>{
    
      var ver = Tel.replace("(", "55");
      var par1 = ver.replace(")", "");
      var par3 = par1.replace("-", "");

    
      var Canal = 0;
        var Id = "";
        await db.collection("ChatCliente")
        .where("Pedido", "==", id)
        .get().then(async (querySnapshot) => {
         
           
           querySnapshot.forEach((doc) => {
             Id = doc.id
             Canal = doc.data().CanalChat
           })
          })
   
        await db.collection("ChatCliente").doc(Id).update({
          Robotizado:true, 
          DigiteNaRegra:true, 
          "MsgDinamica.Ativo":false,
          "MsgFutura1.Ativo":false,
          "MsgFutura3.Ativo":false,
        }).then(()=>{
          setAlert("Pedido Foi Concluido");
          setAlertTipo("success");
         });

         await db.collection("CorreioMSg")
         .add({
          Canal:Canal,
           Ativo:true,
           EMPRESA:EMPRESA,
           Msg:"Seu Pedido já está pronto",
           Botao:[],
           Tel:par3,
           Type:"text",
           Agendamento:firebase.firestore.FieldValue.serverTimestamp()
         })
         .then( async (docRef) => { 
       
     
      });

    });
  },

  IniciandoEntrega: async(Dados, id, Tel, setAlertTipo, setAlert)=> {
   
    await db.collection("MesaItem").doc(id).update({
      IniciandoEntrega:true, 
    }).then(async()=>{
    
      var ver = Tel.replace("(", "55");
      var par1 = ver.replace(")", "");
      var par3 = par1.replace("-", "");

    
    
        var Id = "";
        var Canal = 0;
        await db.collection("ChatCliente")
        .where("Pedido", "==", id)
        .get().then(async (querySnapshot) => {
         
           
           querySnapshot.forEach((doc) => {
             Id = doc.id
             Canal = doc.data().CanalChat
           })
          })
   
        await db.collection("ChatCliente").doc(Id).update({
          Robotizado:true, 
          DigiteNaRegra:true, 
          "MsgDinamica.Ativo":false,
          "MsgFutura1.Ativo":false,
          "MsgFutura3.Ativo":false,
        }).then(()=>{
          setAlert("Entrega Iniciada");
          setAlertTipo("success");
         }); 

         await db.collection("CorreioMSg")
         .add({
           Canal:Canal,
           Ativo:true,
           EMPRESA:EMPRESA,
           Msg:"Seu pedido saiu para a entrega, espere no endereço informado!",
           Botao:[],
           Tel:par3,
           Type:"text",
           Agendamento:firebase.firestore.FieldValue.serverTimestamp()
         })
         .then( async (docRef) => {
     
      });

    });
  },
  ConcluindoEntrega: async(Dados, id, Tel, setAlertTipo, setAlert)=> {
   
    await db.collection("MesaItem").doc(id).update({
      ConcluidoEntregado:true, 
    }).then(async()=>{
    
      var ver = Tel.replace("(", "55");
      var par1 = ver.replace(")", "");
      var par3 = par1.replace("-", "");

    
      
        var Id = "";
        var Canal = 0;
        await db.collection("ChatCliente")
        .where("Pedido", "==", id)
        .get().then(async (querySnapshot) => {
         
           
           querySnapshot.forEach((doc) => {
             Id = doc.id
             Canal = doc.data().CanalChat
           })
          })
   
        await db.collection("ChatCliente").doc(Id).update({
          Robotizado:true, 
          DigiteNaRegra:true, 
          "MsgDinamica.Ativo":false,
          "MsgFutura1.Ativo":false,
          "MsgFutura3.Ativo":false,
        }).then(()=>{
          setAlert("Entrega Concluida");
          setAlertTipo("success");
         });
       
         await db.collection("CorreioMSg")
         .add({
          Canal:Canal,
           Ativo:true,
           EMPRESA:EMPRESA,
           Msg:"Sua entrega foi concluida, Obrigado por nos escolher, agora aproveite o maxímo o sabor do seu lanche, até mais!",
           Botao:[],
           Tel:par3,
           Type:"text",
           Agendamento:firebase.firestore.FieldValue.serverTimestamp()
         })
         .then( async (docRef) => { 
      });

    });
  },

  TirandoItemPedido: async(Canal, data, ListIten, Pedido)=> {
    var PedidosItens = ListIten
   
  
      await db.collection("MesaItem").doc(data).update({
        Itens:ListIten,
      }).then(async()=>{
  
        var MsgPedido = "*Tiramos o Item do Seu Pedido*";
        var MsgPedido = "Essa Nota do Pedido no Momento";
        var TotalValor = 0
        for(let i in PedidosItens){
        
        
        MsgPedido = MsgPedido + "\n===================\n"
        MsgPedido = MsgPedido + "🛍️ "+PedidosItens[i].Sessao 
        
           
        if(PedidosItens[i].SubSessao){
            MsgPedido = MsgPedido + " Tamanho "+PedidosItens[i].SubSessao
        }
           
        MsgPedido = MsgPedido + " Sabor "+PedidosItens[i].Nome+"\n"
        
        
      
        if(PedidosItens[i].Descont){
            TotalValor = TotalValor + (PedidosItens[i].Descont*PedidosItens[i].Quant)
            MsgPedido = MsgPedido + "💰 De:"+PedidosItens[i].Preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
            MsgPedido = MsgPedido + "❤️ Por:"+PedidosItens[i].Descont.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
           
        
        } else {
            TotalValor = TotalValor + (PedidosItens[i].Preco*PedidosItens[i].Quant)
            MsgPedido = MsgPedido + "💰"+PedidosItens[i].Preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
           
        
        }
        
       
        
        }
        MsgPedido = MsgPedido + "\n===================\n"
        MsgPedido = MsgPedido + "*Total* : "+TotalValor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
  
      
        await db.collection("CorreioMSg")
        .add({
          Canal:Canal,
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg: MsgPedido,
          Botao:[],
          Tel:Pedido.TelCli,
          Type:"text",
          Agendamento:firebase.firestore.FieldValue.serverTimestamp()
        })
        .then( async (docRef) => { 
         
        });
  
  
  
        var Id = "";
        await db.collection("ChatCliente")
        .where("Pedido", "==", data)
        .get().then(async (querySnapshot) => {
         
           
           querySnapshot.forEach((doc) => {
             Id = doc.id
           })
          })
   
        await db.collection("ChatCliente").doc(Id).update({
         
          "MsgDinamica.Ativo":false,
          "MsgFutura1.Ativo":false,
          "MsgFutura2.Ativo":false,
          "MsgFutura3.Ativo":false,
          UltimaMsg:{
            Autor:EMPRESA,
            body:" Tiramos o Item do Seu Pedido",
            date:new Date().getTime()+5000,
            Type:"text"
        },
        Mensagem:firebase.firestore.FieldValue.arrayUnion(
        {
            Autor:EMPRESA,
            body:" Tiramos o Item do Seu Pedido",
            date:new Date().getTime()+5000,
            Type:"text"
        },
        
        
        
        )
        }).then(()=>{
       
         });
        
          
        
  
      });
    },
  TirandoItemPedidoNoDev: async(Canal, data, ListIten, Pedido)=> {
    var PedidosItens = ListIten
    
  
      await db.collection("MesaItem").doc(data.id).update({
        Itens:ListIten,
      }).then(async()=>{
  
        // var MsgPedido = "*Tiramos o Item do Seu Pedido*";
        // var MsgPedido = "Essa Nota do Pedido no Momento";
        // var TotalValor = 0
        // for(let i in PedidosItens){
        
        
        // MsgPedido = MsgPedido + "\n===================\n"
        // MsgPedido = MsgPedido + "🛍️ "+PedidosItens[i].Sessao 
        
            
        // if(PedidosItens[i].SubSessao){
        //     MsgPedido = MsgPedido + " Tamanho "+PedidosItens[i].SubSessao
        // }
            
        // MsgPedido = MsgPedido + " Sabor "+PedidosItens[i].Nome+"\n"
        
        
      
        // if(PedidosItens[i].Descont){
        //     TotalValor = TotalValor + (PedidosItens[i].Descont*PedidosItens[i].Quant)
        //     MsgPedido = MsgPedido + "💰 De:"+PedidosItens[i].Preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
        //     MsgPedido = MsgPedido + "❤️ Por:"+PedidosItens[i].Descont.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
            
        
        // } else {
        //     TotalValor = TotalValor + (PedidosItens[i].Preco*PedidosItens[i].Quant)
        //     MsgPedido = MsgPedido + "💰"+PedidosItens[i].Preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
            
        
        // }
        
        
        
        // }
        // MsgPedido = MsgPedido + "\n===================\n"
        // MsgPedido = MsgPedido + "*Total* : "+TotalValor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
  
      
        // await db.collection("CorreioMSg")
        // .add({
        //   Canal:Canal,
        //   Ativo:true,
        //   EMPRESA:EMPRESA,
        //   Msg: MsgPedido,
        //   Botao:[],
        //   Tel:data.Tel,
        //   Type:"text",
        //   Agendamento:firebase.firestore.FieldValue.serverTimestamp()
        // })
        // .then( async (docRef) => { 
          
        // });
  
  
  
        // var Id = "";
        // await db.collection("ChatCliente")
        // .where("Pedido", "==", data.IdChat)
        // .get().then(async (querySnapshot) => {
          
            
        //     querySnapshot.forEach((doc) => {
        //       Id = doc.id
        //     })
        //   })
    


        // await db.collection("ChatCliente").doc(Id).update({
          
        //   "MsgDinamica.Ativo":false,
        //   "MsgFutura1.Ativo":false,
        //   "MsgFutura2.Ativo":false,
        //   "MsgFutura3.Ativo":false,
        //   UltimaMsg:{
        //     Autor:EMPRESA,
        //     body:" Tiramos o Item do Seu Pedido",
        //     date:new Date().getTime()+5000,
        //     Type:"text"
        // },
        // Mensagem:firebase.firestore.FieldValue.arrayUnion(
        // {
        //     Autor:EMPRESA,
        //     body:" Tiramos o Item do Seu Pedido",
        //     date:new Date().getTime()+5000,
        //     Type:"text"
        // },
        
        
        
        // )
        // }).then(()=>{
        
        //   });
        
          
        
  
      });
    },
  
    EnviandoEndPedido: async(Canal, data, Endereco, Bairro, ValorEnt,  Pedido, setEndSalvo, setEndEdt, setLoadEnd, setAlert, setAlertTipo)=> {
     
      Endereco =Endereco +" "+ Bairro
    
        await db.collection("MesaItem").doc(data).update({
          End:[Endereco],
          ValorEntrega:0,
          Entrega:true,
          EndProximo:true,
        }).then(async()=>{
    
          setEndEdt(true)
          setLoadEnd(false)
        
          await db.collection("CorreioMSg")
          .add({
            Canal:Canal,
            Ativo:true,
            EMPRESA:EMPRESA,
            Msg:`Endereço anotado`,
            Botao:[],
            Tel:Pedido.TelCli,
            Type:"text",
            Agendamento:firebase.firestore.FieldValue.serverTimestamp()
          })
          .then( async (docRef) => { 
           
          });
    
    
    
          var Id = "";
          await db.collection("ChatCliente")
          .where("Pedido", "==", data)
          .get().then(async (querySnapshot) => {
           
             
             querySnapshot.forEach((doc) => {
               Id = doc.id
             })
            })
     
          await db.collection("ChatCliente").doc(Id).update({
           
            "MsgDinamica.Ativo":false,
            "MsgFutura1.Ativo":false,
            "MsgFutura2.Ativo":false,
            "MsgFutura3.Ativo":false,
            UltimaMsg:{
              Autor:EMPRESA,
              body:`Endereço anotado`,
              date:new Date().getTime()+5000,
              Type:"text"
          },
          Mensagem:firebase.firestore.FieldValue.arrayUnion(
          {
              Autor:EMPRESA,
              body:`Endereço anotado`,
              date:new Date().getTime()+5000,
              Type:"text"
          },
          
          
          
          )
          }).then(()=>{
            setEndSalvo(true)
            // setAlert("Endereço  Salvo");
            // setAlertTipo("success");
         
           });
          
            
          
    
        });
      },
      PagamentoSalv: async(Canal,  Troco, Pagamento, data, Endereco, Bairro, ValorEnt,  Pedido, setEndSalvo, setEndEdt, setLoadEnd, setAlert, setAlertTipo)=> {
        {/* {value:"Pix", select:"Pix"},
        {value:"Cartao", select:"Cartao"},
        {value:"Dinheiro", select:"Dinheiro"},
        {value:"Dinheiro e Cartao", select:"Dinheiro e Cartao"},
        {value:"Pix e Dinheiro", select:"Pix e Dinheiro"},
        {value:"Pix e Cartao", select:"Pix e Cartao"}, */}
        var AtivoPix = false;
        var AtivoCartao = false;
        var AtivoDinheiro = false;
        var Fraze = "";
       if(Pagamento === "Pix"){
        var AtivoPix = true;
        var AtivoCartao = false;
        var AtivoDinheiro = false;
        var Fraze = "Esperamos o Comprovante para Enviarmos para Cozinha";
       } else if(Pagamento === "Cartao"){
        var AtivoPix = false;
        var AtivoCartao = true;
        var AtivoDinheiro = false;
        var Fraze = "Enviaremos a Maquineta pelo entregador!";
       } else if(Pagamento === "Dinheiro"){
        var AtivoPix = false;
        var AtivoCartao = false;
        var AtivoDinheiro = true;
        var Fraze = "Obrigado, estamos enviando para Produção seu pedido!";
       } else  if(Pagamento === "Pix e Dinheiro"){
        var AtivoPix = true;
        var AtivoCartao = false;
        var AtivoDinheiro = true;
        var Fraze = "Esperamos o Comprovante para Enviarmos para Cozinha";
       } else if(Pagamento === "Pix e Cartao"){
        var AtivoPix = true;
        var AtivoCartao = true;
        var AtivoDinheiro = false;
        var Fraze = "Esperamos o Comprovante para Enviarmos para Cozinha";
       } else  if(Pagamento === "Dinheiro e Cartao"){
        var AtivoPix = false;
        var AtivoCartao = true;
        var AtivoDinheiro = true;
        var Fraze = "Enviaremos a Maquineta pelo entregador!";
       }
         

          await db.collection("MesaItem").doc(data).update({
            FormaDepagamento:Pagamento,
            Pix:AtivoPix,
            Cartao:AtivoCartao,
            Dinheiro:AtivoDinheiro,
            ConfirmacaoPedido:true,
            TrocoDinheiro:Troco,
          }).then(async()=>{
      
            
            setLoadEnd(false)
          
            await db.collection("CorreioMSg")
            .add({
              Canal:Canal,
              Ativo:true,
              EMPRESA:EMPRESA,
              Msg:Fraze,
              Botao:[],
              Tel:Pedido.TelCli,
              Type:"text",
              Agendamento:firebase.firestore.FieldValue.serverTimestamp()
            })
            .then( async (docRef) => { 
             
            });
      
      
      
            var Id = "";
            await db.collection("ChatCliente")
            .where("Pedido", "==", data)
            .get().then(async (querySnapshot) => {
             
               
               querySnapshot.forEach((doc) => {
                 Id = doc.id
               })
              })
       
            await db.collection("ChatCliente").doc(Id).update({
             
              "MsgDinamica.Ativo":false,
              "MsgFutura1.Ativo":false,
              "MsgFutura2.Ativo":false,
              "MsgFutura3.Ativo":false,
              UltimaMsg:{
                Autor:EMPRESA,
                body:Fraze,
                date:new Date().getTime()+5000,
                Type:"text"
            },
            Mensagem:firebase.firestore.FieldValue.arrayUnion(
            {
                Autor:EMPRESA,
                body:Fraze,
                date:new Date().getTime()+5000,
                Type:"text"
            },
            
            
            
            )
            }).then(()=>{
              setEndSalvo(true)
              // setAlert("Endereço  Salvo");
              // setAlertTipo("success");
           
             });
            
              
            
      
          });
        },
        PagamentoSalvDev: async(Canal,  Troco, Pagamento, data, Endereco, Bairro, ValorEnt,  Pedido, setEndSalvo, setEndEdt, setLoadEnd, setAlert, setAlertTipo)=> {
         
          var AtivoPix = false;
          var AtivoCartao = false;
          var AtivoDinheiro = false;
          var Fraze = "";
         if(Pagamento === "Pix"){
          var AtivoPix = true;
          var AtivoCartao = false;
          var AtivoDinheiro = false;
          var Fraze = "Esperamos o Comprovante para Enviarmos para Cozinha";
         } else if(Pagamento === "Cartao"){
          var AtivoPix = false;
          var AtivoCartao = true;
          var AtivoDinheiro = false;
          var Fraze = "Enviaremos a Maquineta pelo entregador!";
         } else if(Pagamento === "Dinheiro"){
          var AtivoPix = false;
          var AtivoCartao = false;
          var AtivoDinheiro = true;
          var Fraze = "Obrigado, estamos enviando para Produção seu pedido!";
         } else  if(Pagamento === "Pix e Dinheiro"){
          var AtivoPix = true;
          var AtivoCartao = false;
          var AtivoDinheiro = true;
          var Fraze = "Esperamos o Comprovante para Enviarmos para Cozinha";
         } else if(Pagamento === "Pix e Cartao"){
          var AtivoPix = true;
          var AtivoCartao = true;
          var AtivoDinheiro = false;
          var Fraze = "Esperamos o Comprovante para Enviarmos para Cozinha";
         } else  if(Pagamento === "Dinheiro e Cartao"){
          var AtivoPix = false;
          var AtivoCartao = true;
          var AtivoDinheiro = true;
          var Fraze = "Enviaremos a Maquineta pelo entregador!";
         }
           
  
            await db.collection("MesaItem").doc(data.id).update({
              FormaDepagamento:Pagamento,
              Pix:AtivoPix,
              Cartao:AtivoCartao,
              Dinheiro:AtivoDinheiro,
              ConfirmacaoPedido:true,
              TrocoDinheiro:Troco,
            }).then(async()=>{
        
              
              setLoadEnd(false)
            
              await db.collection("CorreioMSg")
              .add({
                Canal:Canal,
                Ativo:true,
                EMPRESA:EMPRESA,
                Msg:Fraze,
                Botao:[],
                Tel:data.Tel,
                Type:"text",
                Agendamento:firebase.firestore.FieldValue.serverTimestamp()
              })
              .then( async (docRef) => { 
               
              });
        
        
        
              var Id =data.IdChat;
              await db.collection("ChatCliente")
              .where("Pedido", "==", data)
              .get().then(async (querySnapshot) => {
               
                 
                 querySnapshot.forEach((doc) => {
                   Id = doc.id
                 })
                })
         
              await db.collection("ChatCliente").doc(Id).update({
               
                "MsgDinamica.Ativo":false,
                "MsgFutura1.Ativo":false,
                "MsgFutura2.Ativo":false,
                "MsgFutura3.Ativo":false,
                UltimaMsg:{
                  Autor:EMPRESA,
                  body:Fraze,
                  date:new Date().getTime()+5000,
                  Type:"text"
              },
              Mensagem:firebase.firestore.FieldValue.arrayUnion(
              {
                  Autor:EMPRESA,
                  body:Fraze,
                  date:new Date().getTime()+5000,
                  Type:"text"
              },
              
              
              
              )
              }).then(()=>{
                setEndSalvo(true)
                // setAlert("Endereço  Salvo");
                // setAlertTipo("success");
             
               });
              
                
              
        
            });
          },
          MsgCheou: async()=> {
           
              
                // await db.collection("CorreioMSg")
                // .add({
                //   Canal:"1",
                //   Ativo:true,
                //   EMPRESA:EMPRESA,
                //   Msg: "Algum Cliente Respondeu",
                //   Botao:[],
                //   Tel:"558695437113",
                //   Type:"text",
                //   Agendamento:firebase.firestore.FieldValue.serverTimestamp()
                // })
                // .then( async (docRef) => { 
                 
                // });
          
          
          
            },
  ColocandoPedido: async(Canal, data, NewItens, Pedido)=> {
  var PedidosItens = Pedido.Itens
  PedidosItens.push(NewItens)

    await db.collection("MesaItem").doc(data).update({
      Itens:firebase.firestore.FieldValue.arrayUnion(NewItens), 
    }).then(async()=>{

      var MsgPedido = " Anotamos Seu Pedido";
      var TotalValor = 0
      
         
      for(let i in PedidosItens){
        
        
        MsgPedido = MsgPedido + "\n===================\n"
        MsgPedido = MsgPedido + "🛍️ "+PedidosItens[i].Sessao 
        
           
        if(PedidosItens[i].SubSessao){
            MsgPedido = MsgPedido + " Tamanho "+PedidosItens[i].SubSessao
        }
           
        MsgPedido = MsgPedido + " Sabor "+PedidosItens[i].Nome+"\n"
      
      
    
      if(PedidosItens[i].Descont){
          TotalValor = TotalValor + (PedidosItens[i].Descont*PedidosItens[i].Quant)
          MsgPedido = MsgPedido + "💰 De:"+PedidosItens[i].Preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
          MsgPedido = MsgPedido + "❤️ Por:"+PedidosItens[i].Descont.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
          
      
      } else {
          TotalValor = TotalValor + (PedidosItens[i].Preco*PedidosItens[i].Quant)
          MsgPedido = MsgPedido + "💰"+PedidosItens[i].Preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
        
      
      }
      
     
      
      }
      MsgPedido = MsgPedido + "\n===================\n"
      MsgPedido = MsgPedido + "*Total* : "+TotalValor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})

    
      await db.collection("CorreioMSg")
      .add({
        Canal:Canal,
        Ativo:true,
        EMPRESA:EMPRESA,
        Msg: MsgPedido,
        Botao:[],
        Tel:Pedido.TelCli,
        Type:"text",
        Agendamento:firebase.firestore.FieldValue.serverTimestamp()
      })
      .then( async (docRef) => { 
       
      });



      var Id = "";
      await db.collection("ChatCliente")
      .where("Pedido", "==", data)
      .get().then(async (querySnapshot) => {
       
         
         querySnapshot.forEach((doc) => {
           Id = doc.id
         })
        })
 
      await db.collection("ChatCliente").doc(Id).update({
       
        "MsgDinamica.Ativo":false,
        "MsgFutura1.Ativo":false,
        "MsgFutura2.Ativo":false,
        "MsgFutura3.Ativo":false,
        UltimaMsg:{
          Autor:EMPRESA,
          body:`Anotamos Seu Pedido`,
          date:new Date().getTime()+5000,
          Type:"text"
      },
      Mensagem:firebase.firestore.FieldValue.arrayUnion(
      {
          Autor:EMPRESA,
          body:`Anotamos Seu Pedido`,
          date:new Date().getTime()+5000,
          Type:"text"
      },
      
      
      
      )
      }).then(()=>{
     
       });
      
        
      

    });
  },
 EnviarNota: async(ValoAcres, TituAcres, NomeCli, Troco, Pagamento, ExtratoPix, DadEmp, Entregar, Endereco, TaxaEnt, Observacao, Concluir, setLoadPedS, setPedSalv, Canal, data, PedList, Pedido)=> {
   
    var Ent = false;
        var EndP = false;
        var Busc = false;
        if(Entregar === false){
          Ent = false;
          EndP = false;
          Busc = true;
        } else{
          Ent = true;
          EndP = true;
          Busc = false;
        }

        var AtivoPix = false;
        var AtivoCartao = false;
        var AtivoDinheiro = false;
        var ComfirmaPag = false;
        var Fraze = "";
       if(Pagamento === "Pix"){
        var AtivoPix = true;
        var AtivoCartao = false;
        var AtivoDinheiro = false;
        var Fraze = "Esperamos o Comprovante para Enviarmos para Cozinha";
       } else if(Pagamento === "Cartao"){
        var AtivoPix = false;
        var AtivoCartao = true;
        var AtivoDinheiro = false;
        var Fraze = "Enviaremos a Maquineta pelo entregador!";
       } else if(Pagamento === "Dinheiro"){
        var AtivoPix = false;
        var AtivoCartao = false;
        var AtivoDinheiro = true;
        var Fraze = "Obrigado, estamos enviando para Produção seu pedido!";
       } else  if(Pagamento === "Pix e Dinheiro"){
        var AtivoPix = true;
        var AtivoCartao = false;
        var AtivoDinheiro = true;
        var Fraze = "Esperamos o Comprovante para Enviarmos para Cozinha";
       } else if(Pagamento === "Pix e Cartao"){
        var AtivoPix = true;
        var AtivoCartao = true;
        var AtivoDinheiro = false;
        var Fraze = "Esperamos o Comprovante para Enviarmos para Cozinha";
       } else  if(Pagamento === "Dinheiro e Cartao"){
        var AtivoPix = false;
        var AtivoCartao = true;
        var AtivoDinheiro = true;
        var Fraze = "Enviaremos a Maquineta pelo entregador!";
       }

       console.log("esta entrando aqui 1")
       var PedidosItens = PedList
       var  MsgPedido = ""
       var TotalValor = 0
      
       MsgPedido = " Nota Pedido";
               
                
                   
       for(let i in PedidosItens){
         
         
         MsgPedido = MsgPedido + "\n===================\n"
         MsgPedido = MsgPedido + "🛍️ "+PedidosItens[i].Sessao 
         
            
         if(PedidosItens[i].SubSessao){
             MsgPedido = MsgPedido + " Tamanho "+PedidosItens[i].SubSessao
         }
            
         MsgPedido = MsgPedido + " Sabor "+PedidosItens[i].Nome+"\n"
       
       
     
       if(PedidosItens[i].Descont){
           TotalValor = TotalValor + (PedidosItens[i].Descont*PedidosItens[i].Quant)
           MsgPedido = MsgPedido + "💰 De:"+PedidosItens[i].Preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
           MsgPedido = MsgPedido + "❤️ Por:"+PedidosItens[i].Descont.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
           
       
       } else {
           TotalValor = TotalValor + (PedidosItens[i].Preco*PedidosItens[i].Quant)
           MsgPedido = MsgPedido + "💰"+PedidosItens[i].Preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
         
       
       }
       
      
       
       }
       var TaxaTotal = parseInt(TaxaEnt) +TotalValor
       if(ValoAcres){
        if(TituAcres){
          MsgPedido = MsgPedido + "\n===================\n"
          MsgPedido = MsgPedido + "*Acréscimo* : "+TituAcres+"\n"
          MsgPedido = MsgPedido + "*Valor Acréscimo* : "+ parseInt(ValoAcres).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
         TaxaTotal = TaxaTotal + parseInt(ValoAcres);  
        }
      }
      MsgPedido = MsgPedido + "\n===================\n"
      MsgPedido = MsgPedido + "*Observação* : "+ Observacao
       MsgPedido = MsgPedido + "\n===================\n"
       MsgPedido = MsgPedido + "*Taxa Entrega* : "+ parseInt(TaxaEnt).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
       MsgPedido = MsgPedido + "\n===================\n"
       MsgPedido = MsgPedido + "*Total* : "+TaxaTotal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
       MsgPedido = MsgPedido + "\n===================\n"

  
        setLoadPedS(false)
       
      
      
        if(DadEmp.ServidorZapi){
          var dateri={
            "phone":data.Tel,
            "message":MsgPedido,
          }   
          const req = await fetch(URL_SITE+"/send-messages", 
          {
                method: 'POST',
                headers:{
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(dateri),
             });
        } else {
      
        await db.collection("CorreioMSg")
        .add({
          Canal:Canal,
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg: MsgPedido,
          Botao:[],
          Tel:data.Tel,
          Type:"text",
          Agendamento:new Date().getTime()
        })
        .then( async (docRef) => { 
         
        });
      }

      
  
  
  
        var Id = data.IdChat;
      
   
        await db.collection("ChatCliente").doc(Id).update({
         
          "MsgDinamica.Ativo":false,
          "MsgFutura1.Ativo":false,
          "MsgFutura2.Ativo":false,
          "MsgFutura3.Ativo":false,
          UltimaMsg:{
            Autor:EMPRESA,
            body:MsgPedido,
            date:new Date().getTime()+5000,
            Type:"text"
        },
        Mensagem:firebase.firestore.FieldValue.arrayUnion(
        {
            Autor:EMPRESA,
            body:MsgPedido,
            date:new Date().getTime()+5000,
            Type:"text"
        },
        
        
        
        )
        }).then(()=>{
       
         });
        
          
        
  
     
    },
    EnviarCardapi: async(ValoAcres, TituAcres, NomeCli, Troco, Pagamento, ExtratoPix, DadEmp, Entregar, Endereco, TaxaEnt, Observacao, Concluir, setLoadPedS, setPedSalv, Canal, data, PedList, Pedido)=> {
   
    
          setLoadPedS(false)
         
        
        
          if(DadEmp.ServidorZapi){
           for(let g in DadEmp.Cardapio){
            if(DadEmp.Cardapio[g]){
            var dateri={
              "phone":data.Tel,
              "image":  DadEmp.Cardapio[g],
              "caption": "Cardápio",
            }   
            const req = await fetch(URL_SITE+"/send-image", 
            {
                  method: 'POST',
                  headers:{
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(dateri),
               });
              }
              }
          } else {
            for(let g in DadEmp.Cardapio){
              if(DadEmp.Cardapio[g]){
          await db.collection("CorreioMSg")
          .add({
            Canal:Canal,
            Ativo:true,
            EMPRESA:EMPRESA,
            Msg: DadEmp.Cardapio[g],
            Botao:[],
            Tel:data.Tel,
            Type:"Foto",
            Agendamento:new Date().getTime()
          })
          .then( async (docRef) => { 
           
          });
        }
      }
        }
  
        
    
    
    
          var Id = data.IdChat;
        
     
          await db.collection("ChatCliente").doc(Id).update({
           
            "MsgDinamica.Ativo":false,
            "MsgFutura1.Ativo":false,
            "MsgFutura2.Ativo":false,
            "MsgFutura3.Ativo":false,
            UltimaMsg:{
              Autor:EMPRESA,
              body:"Cardapio Enviado",
              date:new Date().getTime()+5000,
              Type:"text"
          },
          Mensagem:firebase.firestore.FieldValue.arrayUnion(
          {
              Autor:EMPRESA,
              body:"Cardapio Enviado",
              date:new Date().getTime()+5000,
              Type:"text"
          },
          
          
          
          )
          }).then(()=>{
         
           });
          
            
          
    
       
      },
      EnviarPix: async(ValoAcres, TituAcres, NomeCli, Troco, Pagamento, ExtratoPix, DadEmp, Entregar, Endereco, TaxaEnt, Observacao, Concluir, setLoadPedS, setPedSalv, Canal, data, PedList, Pedido)=> {
   
    
        setLoadPedS(false)
       
       var  MsgPedido = "*Nos Envie O Comprovante para Confirma o Pedido*"+"\n"
                   MsgPedido = MsgPedido+"Pix: "+DadEmp.Pix.Numero+"\n"
                   MsgPedido = MsgPedido+"Nome: "+DadEmp.Pix.Nome+"\n"
                   MsgPedido = MsgPedido+"Tipo: "+DadEmp.Pix.Tipo+"\n"
      
        if(DadEmp.ServidorZapi){
         for(let g in DadEmp.Cardapio){
          if(DadEmp.Cardapio[g]){
            var dateri={
              "phone":data.Tel,
              "message":MsgPedido,
            }  
          const req = await fetch(URL_SITE+"/send-messages", 
          {
                method: 'POST',
                headers:{
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(dateri),
             });
            }
            }
        } else {
      
        await db.collection("CorreioMSg")
        .add({
          Canal:Canal,
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg: MsgPedido,
          Botao:[],
          Tel:data.Tel,
          Type:"text",
          Agendamento:firebase.firestore.FieldValue.serverTimestamp()
        })
        .then( async (docRef) => { 
         
        });
      }

      
  
  
  
        var Id = data.IdChat;
      
   
        await db.collection("ChatCliente").doc(Id).update({
         
          "MsgDinamica.Ativo":false,
          "MsgFutura1.Ativo":false,
          "MsgFutura2.Ativo":false,
          "MsgFutura3.Ativo":false,
          UltimaMsg:{
            Autor:EMPRESA,
            body:MsgPedido,
            date:new Date().getTime()+5000,
            Type:"text"
        },
        Mensagem:firebase.firestore.FieldValue.arrayUnion(
        {
            Autor:EMPRESA,
            body:MsgPedido,
            date:new Date().getTime()+5000,
            Type:"text"
        },
        
        
        
        )
        }).then(()=>{
       
         });
        
          
        
  
     
    },
  ColocandoPedidoDev: async(ComeAqui, ValoAcres, TituAcres, NomeCli, Troco, Pagamento, ExtratoPix, DadEmp, Entregar, Endereco, TaxaEnt, Observacao, Concluir, setLoadPedS, setPedSalv, Canal, data, PedList, Pedido)=> {
   console.log(PedList)
   var VerEnd = [];
   var TemEnd = false;
   var PegFrete = 0;
    var Ent = false;
        var EndP = false;
        var Busc = false;
        if(Entregar === false){
          Ent = false;
          EndP = false;
          Busc = true;
        } else{
          Ent = true;
          EndP = true;
          Busc = false;
        }

        var AtivoPix = false;
        var AtivoCartao = false;
        var AtivoDinheiro = false;
        var AtivoAcretDono = false;
        var ComfirmaPag = false;
        var Fraze = "";
       if(Pagamento === "Pix"){
         AtivoPix = true;
        AtivoCartao = false;
        AtivoDinheiro = false;
        Fraze = "Esperamos o Comprovante para Enviarmos para Cozinha";
       } else if(Pagamento === "Cartao"){
         AtivoPix = false;
         AtivoCartao = true;
         AtivoDinheiro = false;
         Fraze = "Enviaremos a Maquineta pelo entregador!";
       } else if(Pagamento === "Dinheiro"){
        AtivoPix = false;
        AtivoCartao = false;
        AtivoDinheiro = true;
        Fraze = "Obrigado, estamos enviando para Produção seu pedido!";
       } else  if(Pagamento === "Pix e Dinheiro"){
         AtivoPix = true;
         AtivoCartao = false;
         AtivoDinheiro = true;
         Fraze = "Esperamos o Comprovante para Enviarmos para Cozinha";
       } else if(Pagamento === "Pix e Cartao"){
         AtivoPix = true;
         AtivoCartao = true;
         AtivoDinheiro = false;
         Fraze = "Esperamos o Comprovante para Enviarmos para Cozinha";
       } else  if(Pagamento === "Dinheiro e Cartao"){
         AtivoPix = false;
         AtivoCartao = true;
         AtivoDinheiro = true;
         Fraze = "Enviaremos a Maquineta pelo entregador!";
       }  else if(Pagamento === "Acerta Com o Dono"){
         AtivoPix = false;
         AtivoCartao = false;
        AtivoDinheiro = false;
        AtivoAcretDono = true;
        var Fraze = "Enviaremos a Maquineta pelo entregador!";
       }

       console.log("esta entrando aqui 1")
       var PedidosItens = PedList
       var  MsgPedido = ""
       var TotalValor = 0
       //Calculo da taxa total 
       var VerTot = 0 
       for(let i in PedidosItens){

      if(PedidosItens[i].Descont){
        VerTot = VerTot + (PedidosItens[i].Descont)

      } else {
        VerTot = VerTot + (PedidosItens[i].Preco)

      }

      }
      if(ValoAcres){
        if(TituAcres){
     VerTot = VerTot + parseInt(ValoAcres);  
        }
      }
      VerTot = VerTot + parseInt(TaxaEnt);
      console.log("VerTot"+VerTot)


        if(PedList.length > 0){
         if(Concluir){
          
            if(Entregar){
          if(Endereco !== "" && Endereco !== " " && Endereco !== "  " && Endereco !== "   "){
            if(TaxaEnt !== 0){
              if(Pagamento === null){
                 MsgPedido = " Nota Pedido";
               
                
                   
                for(let i in PedidosItens){
                  
                  
                  MsgPedido = MsgPedido + "\n===================\n"
                  MsgPedido = MsgPedido + "🛍️ "+PedidosItens[i].Sessao 
                  
                     
                  if(PedidosItens[i].SubSessao){
                      MsgPedido = MsgPedido + " Tamanho "+PedidosItens[i].SubSessao
                  }
                     
                  MsgPedido = MsgPedido + " Sabor "+PedidosItens[i].Nome+"\n"
                
                
              
                if(PedidosItens[i].Descont){
                    TotalValor = TotalValor + (PedidosItens[i].Descont*PedidosItens[i].Quant)
                    MsgPedido = MsgPedido + "💰 De:"+PedidosItens[i].Preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
                    MsgPedido = MsgPedido + "❤️ Por:"+PedidosItens[i].Descont.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
                    
                
                } else {
                    TotalValor = TotalValor + (PedidosItens[i].Preco*PedidosItens[i].Quant)
                    MsgPedido = MsgPedido + "💰"+PedidosItens[i].Preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
                  
                
                }
                
               
                
                }
                var TaxaTotal = parseInt(TaxaEnt) +TotalValor
                if(ValoAcres){
                  if(TituAcres){
                    MsgPedido = MsgPedido + "\n===================\n"
                    MsgPedido = MsgPedido + "*Titulo Acréscimo* : "+TituAcres+"\n" 
                    MsgPedido = MsgPedido + "*Valor Acréscimo* : "+ parseInt(ValoAcres).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
                   TaxaTotal = TaxaTotal + parseInt(ValoAcres);  
                  }
                }
                MsgPedido = MsgPedido + "\n===================\n"
                MsgPedido = MsgPedido + "*Observação* : "+Observacao
                MsgPedido = MsgPedido + "\n===================\n"
                MsgPedido = MsgPedido + "*Taxa Entrega* : "+ parseInt(TaxaEnt).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
                MsgPedido = MsgPedido + "\n===================\n"
                MsgPedido = MsgPedido + "*Total* : "+TaxaTotal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
                MsgPedido = MsgPedido + "\n===================\n"
                MsgPedido = MsgPedido + "Qual é Sua Forma de Pagamento?"
              } else{

               if(Pagamento === "Pix"){
                  if(ExtratoPix){
                   if(NomeCli){
                        ComfirmaPag = true;
                         MsgPedido = "*Obrigado Por nós Escolher, Estamos preparando Seu pedido, para enviar-mos para cozinha*"
                        } else{
                          MsgPedido = "*Seu Nome Por gentileza?*"
                        }
                
                  }else {
                  

                   MsgPedido = "*Nos Envie O Comprovante para Confirma o Pedido*"+"\n"
                   MsgPedido = MsgPedido+"Pix: "+DadEmp.Pix.Numero+"\n"
                   MsgPedido = MsgPedido+"Nome: "+DadEmp.Pix.Nome+"\n"
                   MsgPedido = MsgPedido+"Tipo: "+DadEmp.Pix.Tipo+"\n"
                  }
               
                } else if(Pagamento === "Cartao"){
                 
                
                 if(NomeCli){
                  ComfirmaPag = true;
                   MsgPedido = "*Enviaremos a Maquineta pelo entregador! \n Obrigado Por nós Escolher, Estamos preparando Seu pedido, para enviar-mos para cozinha*"
                  } else{
                    MsgPedido = "*Seu Nome Por gentileza?*"
                  }
              
                } else if(Pagamento === "Dinheiro"){
                 if(Troco){
                   if(NomeCli){
                        ComfirmaPag = true;
                         MsgPedido = "*Obrigado Por nós Escolher, Estamos preparando Seu pedido, para enviar-mos para cozinha*"
                        } else{
                          MsgPedido = "*Seu Nome Por gentileza?*"
                        }
                
                  }else {
                  
                   MsgPedido = "*Nos informe se precisa de Troco!*"
                 
                  }
               
                } else  if(Pagamento === "Pix e Dinheiro"){
                 if(ExtratoPix){
                   if(Troco){
                     if(NomeCli){
                           ComfirmaPag = true;
                           MsgPedido = "*Obrigado Por nós Escolher, Estamos preparando Seu pedido, para enviar-mos para cozinha*"
                          } else{
                            MsgPedido = "*Seu Nome Por gentileza?*"
                          }
                  
                    }else {
                     MsgPedido = "*Nos informe se precisa de Troco!*"
                   
                    }
                
                  }else {
                  
                   MsgPedido = "*Nos Envie O Comprovante para Confirma o Pedido*"+"\n"
                   MsgPedido = MsgPedido+"Pix: "+DadEmp.Pix.Numero+"\n"
                   MsgPedido = MsgPedido+"Nome: "+DadEmp.Pix.Nome+"\n"
                   MsgPedido = MsgPedido+"Tipo: "+DadEmp.Pix.Tipo+"\n"
                  }
             
                } else if(Pagamento === "Pix e Cartao"){
                 if(ExtratoPix){
                   if(NomeCli){
                    ComfirmaPag = true;
                     MsgPedido = "*Enviaremos a Maquineta pelo entregador! \n Obrigado Por nós Escolher, Estamos preparando Seu pedido, para enviar-mos para cozinha*"
                    } else{
                      MsgPedido = "*Seu Nome Por gentileza?*"
                    }
                
                  }else {
                  
                   MsgPedido = "*Nos Envie O Comprovante para Confirma o Pedido*"+"\n"
                   MsgPedido = MsgPedido+"Pix: "+DadEmp.Pix.Numero+"\n"
                   MsgPedido = MsgPedido+"Nome: "+DadEmp.Pix.Nome+"\n"
                   MsgPedido = MsgPedido+"Tipo: "+DadEmp.Pix.Tipo+"\n"
                  }
                } else  if(Pagamento === "Dinheiro e Cartao"){
                 if(Troco){
                   if(NomeCli){
                    ComfirmaPag = true;
                     MsgPedido = "*Enviaremos a Maquineta pelo entregador! \n Obrigado Por nós Escolher, Estamos preparando Seu pedido, para enviar-mos para cozinha*"
                    } else{
                      MsgPedido = "*Seu Nome Por gentileza?*"
                    }
                
                  }else {
                   
                   MsgPedido = "*Nos informe se precisa de Troco!*"
                 
                  }
                } else if(Pagamento === "Acerta Com o Dono"){
                 
                
                  if(NomeCli){
                   ComfirmaPag = true;
                    MsgPedido = "Obrigado Por nós Escolher, Estamos preparando Seu pedido, para enviar-mos para cozinha*"
                   } else{
                     MsgPedido = "*Seu Nome Por gentileza?*"
                   }
               
                 }
             
              }
         

            } else{
             MsgPedido = "*Estamos Calculando A taxa de Entrega*"
           }
         

          } else{

            // await db.collection("MesaItem")
            // .where("TelCli", "==", data.Tel)
            // .orderBy("dataCriacao", "desc")
            // .limit(5)
            // .get().then(async (querySnapshot) => {
            //   if(querySnapshot.size !== 0){

             
            //   querySnapshot.forEach((doc) => {
            //     if(doc.data().Entrega){
            //       VerEnd = doc.data().End;
            //       PegFrete = doc.data().ValorEntrega;
            //       TemEnd = true;
            //     }
                
            //   })
            // }
            // })
            if(TemEnd){
              MsgPedido = "*Esse é O Endereço da Entrega?* \n "
              MsgPedido =MsgPedido+VerEnd+" \n"
              MsgPedido =MsgPedido+"*Digite:* \n 1 - Sim \n 2 - Não  "
            } else {
              MsgPedido = "*Nos Envie Seu Endereço Com o Ponto de Referência*  \n Rua da Casa  \n Numero da Casa  \n Bairro da Casa  \n Ponto de Referência"
            }
          
         }
        } else {
          if(NomeCli){
            ComfirmaPag = true;
            MsgPedido = "*Obrigado Por nós Escolher, Estamos preparando Seu pedido, para enviar-mos para cozinha*"
           } else{
             MsgPedido = "*Seu Nome Por gentileza?*"
           }
   
        }
        
       } else{
         MsgPedido = " Nota Pedido";
               
                
                   
                for(let i in PedidosItens){
                  
                  
                  MsgPedido = MsgPedido + "\n===================\n"
                  MsgPedido = MsgPedido + "🛍️ "+PedidosItens[i].Sessao 
                  
                     
                  if(PedidosItens[i].SubSessao){
                      MsgPedido = MsgPedido + " Tamanho "+PedidosItens[i].SubSessao
                  }
                     
                  MsgPedido = MsgPedido + " Sabor "+PedidosItens[i].Nome+"\n"
                
                
              
                if(PedidosItens[i].Descont){
                    TotalValor = TotalValor + (PedidosItens[i].Descont*PedidosItens[i].Quant)
                    MsgPedido = MsgPedido + "💰 De:"+PedidosItens[i].Preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
                    MsgPedido = MsgPedido + "❤️ Por:"+PedidosItens[i].Descont.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
                    
                
                } else {
                    TotalValor = TotalValor + (PedidosItens[i].Preco*PedidosItens[i].Quant)
                    MsgPedido = MsgPedido + "💰"+PedidosItens[i].Preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"
                  
                
                }
                
               
                
                }
                var TaxaTotal = TotalValor
                if(ValoAcres){
                  if(TituAcres){
                    MsgPedido = MsgPedido + "\n===================\n"
                    MsgPedido = MsgPedido + "*Acréscimo* : "+TituAcres+"\n" 
                    MsgPedido = MsgPedido + "*Valor Acréscimo* : "+ parseInt(ValoAcres).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
                   TaxaTotal = TaxaTotal + parseInt(ValoAcres);  
                  }
                }
                MsgPedido = MsgPedido + "\n===================\n"
                MsgPedido = MsgPedido + "*Total* : "+TaxaTotal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
                MsgPedido = MsgPedido + "\n===================\n"
                MsgPedido = MsgPedido + "Deseja Pedir Mais Alguma Coisa?"
       }

         } else{
          MsgPedido = "*por Favor Faça Seu Pedido?*"
        }

   
      await db.collection("MesaItem").doc(data.id).update({
        ConfirmacaoPedido:ComfirmaPag,
        FormaDepagamento:Pagamento,
        AcertComDono:AtivoAcretDono,
        Pix:AtivoPix,
        Cartao:AtivoCartao,
        Dinheiro:AtivoDinheiro,
        TrocoDinheiro:Troco,
        ExtratoPix:ExtratoPix,
        NomeCli:NomeCli,
        ComeAqui:ComeAqui,
        End:[Endereco],
        ValorEntrega:TaxaEnt,
        Entrega:Ent,
        EndProximo:EndP,
        Buscar:Busc,
        ValorTotaL:VerTot,
        ValorAcrescimo:ValoAcres,
        TituloAcrescimo:TituAcres,

        ObervacaoPedido:Observacao,
       PedConstruido:Concluir,
       Itens:PedList,
        ClienteEsc:false, 
      }).then(async()=>{
        setLoadPedS(false)
        setPedSalv(true)
        if(data.UltimaMsg.Type !== "ChatNull"){
        await db.collection("ClienteEmpre")
              .doc(data.Cliente)
              .update({
              Nome: NomeCli,
              })
              .then(async() => {
              }) 

        
      if(data.ConfirmacaoPedido === false){
        if(DadEmp.ServidorZapi){
          var dateri={
            "phone":data.Tel,
            "message":MsgPedido,
          }   
          const req = await fetch(URL_SITE+"/send-messages", 
          {
                method: 'POST',
                headers:{
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(dateri),
             });
        } else {
      
        await db.collection("CorreioMSg")
        .add({
          Canal:Canal,
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg: MsgPedido,
          Botao:[],
          Tel:data.Tel,
          Type:"text",
          Agendamento:new Date().getTime()
        
        })
        .then( async (docRef) => { 
         console.log("id Msg "+docRef.id)
        });
      }

      
  
  
  
        var Id = data.IdChat;
      console.log(Id)
        if(TemEnd){
          await db.collection("ChatCliente").doc(Id).update({
            MemEnd:VerEnd,
            FaseMsg:"Msg4A",
            MemSessao:PegFrete,
            "MsgDinamica.Ativo":false,
            "MsgFutura1.Ativo":false,
            "MsgFutura2.Ativo":false,
            "MsgFutura3.Ativo":false,
            UltimaMsg:{
              Autor:EMPRESA,
              body:MsgPedido,
              date:new Date().getTime()+5000,
              Type:"text"
          },
          Mensagem:firebase.firestore.FieldValue.arrayUnion(
          {
              Autor:EMPRESA,
              body:MsgPedido,
              date:new Date().getTime()+5000,
              Type:"text"
          },
          
          
          
          )
          }).then(()=>{
         
           });
        } else {
        await db.collection("ChatCliente").doc(Id).update({
         
          "MsgDinamica.Ativo":false,
          "MsgFutura1.Ativo":false,
          "MsgFutura2.Ativo":false,
          "MsgFutura3.Ativo":false,
          UltimaMsg:{
            Autor:EMPRESA,
            body:MsgPedido,
            date:new Date().getTime()+5000,
            Type:"text"
        },
        Mensagem:firebase.firestore.FieldValue.arrayUnion(
        {
            Autor:EMPRESA,
            body:MsgPedido,
            date:new Date().getTime()+5000,
            Type:"text"
        },
        
        
        
        )
        }).then(()=>{
       
         });
        }
        }
        
          
      }
  
      });
      
      
    },
  
    
      SalvNomeCli: async(NomeCli, Canal, data, Endereco, Bairro, ValorEnt,  Pedido, setEndSalvo, setEndEdt, setLoadEnd, setAlert, setAlertTipo)=> {
     

    
        await db.collection("MesaItem").doc(data.id).update({
          NomeCli:NomeCli,
        }).then(async()=>{
    
      
          setLoadEnd(false)
        
       
    
    
    
        
          
            
          
    
        });
      },
      EnviandoEndPedidoDev: async(TaxaEnt, Entregar, Canal, data, Endereco, Bairro, ValorEnt,  Pedido, setEndSalvo, setEndEdt, setLoadEnd, setAlert, setAlertTipo)=> {
        var Ent = false;
        var EndP = false;
        var Busc = false;
        if(Entregar === "Buscar"){
          Ent = false;
          EndP = false;
          Busc = true;
        } else{
          Ent = true;
          EndP = true;
          Busc = false;
        }
      
          await db.collection("MesaItem").doc(data.id).update({
            End:[Endereco],
            ValorEntrega:TaxaEnt,
            Entrega:Ent,
            EndProximo:EndP,
            ClienteEsc:false, 
            Buscar:Busc,
          }).then(async()=>{
      
            setEndEdt(true)
            setLoadEnd(false)
          
            await db.collection("CorreioMSg")
            .add({
              Canal:Canal,
              Ativo:true,
              EMPRESA:EMPRESA,
              Msg:`Endereço anotado`,
              Botao:[],
              Tel:data.Tel,
              Type:"text",
              Agendamento:firebase.firestore.FieldValue.serverTimestamp()
            })
            .then( async (docRef) => { 
             
            });
      
      
      
            var Id = data.IdChat;
            await db.collection("ChatCliente")
            .where("Pedido", "==", data)
            .get().then(async (querySnapshot) => {
             
               
               querySnapshot.forEach((doc) => {
                 Id = doc.id
               })
              })
       
            await db.collection("ChatCliente").doc(Id).update({
             
              "MsgDinamica.Ativo":false,
              "MsgFutura1.Ativo":false,
              "MsgFutura2.Ativo":false,
              "MsgFutura3.Ativo":false,
              UltimaMsg:{
                Autor:EMPRESA,
                body:`Endereço anotado`,
                date:new Date().getTime()+5000,
                Type:"text"
            },
            Mensagem:firebase.firestore.FieldValue.arrayUnion(
            {
                Autor:EMPRESA,
                body:`Endereço anotado`,
                date:new Date().getTime()+5000,
                Type:"text"
            },
            
            
            
            )
            }).then(()=>{
              setEndSalvo(true)
              // setAlert("Endereço  Salvo");
              // setAlertTipo("success");
           
             });
            
              
            
      
          });
        },
  FinalizandoPedido: async(List, Dados, id, Tel, setAlertTipo, setAlert)=> {
   
    await db.collection("MesaItem").doc(id).update({
      Fechado:true, 
    }).then(async()=>{
      if(List.UltimaMsg.Type !== "ChatNull"){
      var Id = "";
      await db.collection("ChatCliente")
      .where("Pedido", "==", id)
      .get().then(async (querySnapshot) => {
       
         
         querySnapshot.forEach((doc) => {
           Id = doc.id
         })
        })
 
      await db.collection("ChatCliente").doc(Id).update({
        Ativo:false,
        "MsgDinamica.Ativo":false,
        "MsgFutura2.Ativo":false,
        "MsgFutura1.Ativo":false,
        "MsgFutura3.Ativo":false,
      }).then(()=>{
      setAlert("Pedido Concluido");
      setAlertTipo("success");
       });
      
        
      }

    });
  },

  EditandoValorEnt: async(DadEmp, Dados,IdPed, NomeEnt, ValorEntr, setAlertTipo, setAlert)=> {
   var Valor = parseFloat(ValorEntr)
    await db.collection("MesaItem").doc(IdPed).update({
      ValorEntrega:Valor, 
    }).then(async()=>{
     var IdChat = ""
      await db.collection("ChatCliente")
      .where("Pedido", "==", IdPed )
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => { 
          IdChat = doc.id;
        })
      })

      await db.collection("ChatCliente")
      .doc(IdChat)
      .update({
      
      "MsgDinamica.Ativo": true,
    
      })
      .then(async() => {

      })
     if(NomeEnt){

      await db.collection('EmrpesaSite')    
      .doc(EMPRESA)
      .update({
      
      TaxasEntregas: firebase.firestore.FieldValue.arrayUnion({Nome:NomeEnt.toLowerCase(), Valor:Valor, })
 
      })
      .then(async() => {

      })
     }
     
     


      
     
      setAlert("Entrega Editada");
      setAlertTipo("success");
      

    });



  },

  FechandoPedido: async(Dados, IdPedido, setAlertTipo, setAlert, setIdPedido, setLoading, setModalVer)=> {
    for(let i in IdPedido){
      await db.collection("MesaItem").doc(IdPedido[i]).update({
        Fechado:true, 
      })

    }
    setModalVer(false)
    setLoading(false)
   
  },

  AtivandoMenu: async(Dados, id, setAlertTipo, setAlert)=> {
   console.log(id)
    await db.collection("MenusSite").doc(id).update({
     Ativo:true, 
    }).then(()=>{
      setAlert("Ativado com Sucesso");
      setAlertTipo("success");
   

    });
  },

  AtivandoCondicional: async(Dados, Id, setAlertTipo, setAlert)=> {
    const autenticado =  await Auth.currentUser;
    const id = await autenticado.uid;
    const Setor = "Ativando Condicional Serv";
    await db.collection("condicionais").doc(Id).update({
     "ativo":true, 
    }).then(()=>{
      setAlert("Ativado com Sucesso");
      setAlertTipo("success");
      db.collection("movimentacao").add({
        id:id,
        instituicao: Dados.instituicao,
        cidade: Dados.cidade,
        estado: Dados.estado,
        Conta: Dados.conta.serv.tipo,
        acao:"Atualizar",
        setor: Setor,
        data:firebase.firestore.FieldValue.serverTimestamp(),
        idSofrer:Id,
        })

    });
  },

  ListContasServ: async(Dados, setQuant, setUsuariosContServ)=> {
   
    await Auth.onAuthStateChanged( async function(user) {
      if (user) {
      const ID = user.uid;
      const Setor = "Lista Conta Serv";
      const dados = await db.collection('users')
      .doc(ID).
      get()
      .then(async(dados)=>{
        const result = await dados.data();
      

          await db.collection("users")
          .where("estado", "==", result.estado)
          .where("cidade", "==", result.cidade)
          .where("instituicao", "==", result.instituicao)
          .where("conta.serv.tipo", 'in', ['Lider', "Subordinada"])
            .onSnapshot((querySnapshot) => {
            setQuant(querySnapshot.size);
            var res = []; 
            querySnapshot.forEach((doc) => {
                res.push({
                  id: doc.id,
                  nome: doc.data().nome,
                  nomeGuerra: doc.data().nomeGuerra? doc.data().nomeGuerra : "",
                  patente: doc.data().patente? doc.data().patente : "",
                  desbloqueado: doc.data().conta.serv.desbloqueado,
    
                });      
            });
            setUsuariosContServ(res);
    
              });

          
        
   
       }); 
     
      } 
  
    });
    
    
  },


  ListAppServ: async(Dados, setQuantApp, setUsuarioApp)=> {
   
    await Auth.onAuthStateChanged( async function(user) {
      if (user) {
      const ID = user.uid;
      const Setor = "Lista Conta Serv";
      const dados = await db.collection('users')
      .doc(ID).
      get()
      .then(async(dados)=>{
        const result = await dados.data();
          await db.collection("users")
          .where("conta.servApp.tipo", "==", "App")
            .onSnapshot((querySnapshot) => {
            setQuantApp(querySnapshot.size);
            var res = []; 
            querySnapshot.forEach((doc) => {
                res.push({
                  id: doc.id,
                  nome: doc.data().nome,
                  telefone: doc.data().telefone,
                  desbloqueado: doc.data().conta.servApp.desbloqueado,
                  ativo: doc.data().conta.servApp.ativo,
    
                });      
            });
            setUsuarioApp(res);
    
              });

          
        
   
       }); 
     
      } 
  
    });
    
    
  },

  VizualizandoContas: async(Id, Dados, setInfor)=> {
    const autenticado =  await Auth.currentUser;
    const id = await autenticado.uid;
    const Setor = "Vizualizar Conta Serv";
    let res = {};
    await db.collection("users").doc(Id)
    .onSnapshot((doc) => {
       let cid = doc.data().cidade;
        let est = doc.data().estado;
        let con = doc.data().conta;
        let nome = doc.data().nome;
        let tel = doc.data().telefone;
        let inst = doc.data().instituicao;
        let grupoid = doc.data().grupoid; 
        db.collection('gruposerv').doc(grupoid)
        .onSnapshot((doce) => {
          res ={
            cidade:cid, 
            estado: est,
            conta: con,
            nome: nome,
            telefone: tel,
            instituicao: inst,
            grupo:doce.data(),
          };
          console.log(res)
        setInfor(res);
      });
    });

    await db.collection("movimentacao").add({
      id:id,
      instituicao: Dados.instituicao,
      cidade: Dados.cidade,
      estado: Dados.estado,
      Conta: Dados.conta.serv.tipo,
      acao:"Vizualizar",
      setor: Setor,
      data:firebase.firestore.FieldValue.serverTimestamp(),
      });
    
  },

  JogoCriadoCamb: async(id, setVaToCo, setValPreDemos, setValorReal, setSimAp, setValApos,setNome, setTelCli, setNomeCam, setTelCam, setConcluir, setPago, setValCambis, setQCash,  )=> {
   
    await db.collection("NotaCambista").doc(id)
    .get()
    .then((doc) => {
        


        setNomeCam(doc.data().Nome);
        setTelCam(doc.data().Tel);
        setNome(doc.data().NomeComp);
        setTelCli(doc.data().TelComp);
        setPago(doc.data().Pago);
        setConcluir(doc.data().Conscluido);
        setValPreDemos(doc.data().ValorPremio);
        setValorReal(doc.data().ValorAposta);
        setSimAp(doc.data().Bets);
        setValCambis(doc.data().ValCambis);
        setVaToCo(doc.data().CotaGeral);
        setValApos(doc.data().valorAposSimb); 
        setQCash(doc.data().CashGanha);
    });
    
  },

  EnviadoAposCam: async(id, VaToCo, ValPreDemos, ValorReal, SimAp, ValApos, Nome, TelCli, NomeCam, TelCam, Concluir, Pago, ValCambis, QCash)=> {
    console.log(ValPreDemos)
    await db.collection("NotaCambista").doc(id)
    .update({
        
      Pago:Pago,
      Conscluido:Concluir,
      ValorPremio:ValPreDemos,
      ValorAposta:ValorReal,
      Bets:SimAp,
      ValCambis:ValCambis,
      CotaGeral:VaToCo,
      valorAposSimb:ValApos,
      CashGanha:QCash,

  
    });
    
  },

  TiraConcluidoApos: async(IdApos, Concluir, setAlertTipo, setAlert)=> {
 
    await db.collection("NotaCambista").doc(IdApos)
    .update({

      Conscluido:Concluir,

    }).then(()=>{
     
    });
    
  },

  VizualizandoNoti: async(Id, Dados, setInfor)=> {
   var res = {};
    await db.collection("MensagensWhats").doc(Id)
    .get()
    .then((doc) => {
      setInfor(doc.data()) 
    });
   
 
  },

  PegaQrcode: async(NomePix, setImgQr)=> {
   

    

      const req = await fetch(`${URL_SITE}/qr-code/image`, 
      {
            method: 'GET',
            headers:{
              'Content-Type': 'application/json'
            },
          });
        
       const json = await req.json(); 
      
       setImgQr(json.value)
  
   
        
     
   
    },

 EnviandoMsg: async(Id, Infor, setEnvMas)=> {
   
  var tele = "5586995437113"
  var Btn = [];
  var Posi = 0;
  if(Infor.Btn.length !== 0){

    for(let i in Infor.Btn){
      Btn.push({
        "id": i,
        "label": Infor.Btn[i],
      })
    }

  }

  // if(Infor.PosiList === 0){
  //    Posi = 0; 
  // } else {
  //   Posi = Infor.PosiList+1;
  // }


  // for (var i = Posi; i < Infor.ListContato.length; i++) {

  // setEnvMas(i)
  // await db.collection("MensagensWhats").doc(Id)
  // .update({
  //  ListEnviada: firebase.firestore.FieldValue.arrayUnion(Infor.ListContato[i]),
  //  PosiList:i,  
  // });




//}
  
 
  if(Infor.Tipo === "Mensagem Simples"){

    var data={
          "phone": tele,
          "message": Infor.Text,
        }   
    const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-text", 
    {
          method: 'POST',
          headers:{
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data),
        });
      
     const json = await req.json(); 
     
     await db.collection("MensagemEnviada").add({
      IdMsg:Id,
      Telefone:tele,
      IdWhatsapp: json.messageId,
      Enviada:false,
      Recebida:false,
      Lida:false,
      Respondida:false,
      Reposta:"",
      dataMensagem: new Date().getTime(),
      }).then(() => {
   
      })


  } else  if(Infor.Tipo === "Video"){
    
    var data={
      "phone": tele,
      "video": Infor.Url,
      "caption": Infor.Text
    }   
const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-video", 
{
      method: 'POST',
      headers:{
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    });
  
 const json = await req.json(); 

 await db.collection("MensagemEnviada").add({
  IdMsg:Id,
  Telefone:tele,
  IdWhatsapp: json.messageId,
  Enviada:false,
  Recebida:false,
  Lida:false,
  Respondida:false,
  Reposta:"",
  dataMensagem: new Date().getTime(),
  }).then(() => {

  })

  } else  if(Infor.Tipo === "Imagem"){

    var data={
      "phone": tele,
      "image": Infor.Url,
      "caption": Infor.Text
    }   
const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-image", 
{
      method: 'POST',
      headers:{
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    });
  
 const json = await req.json(); 

 await db.collection("MensagemEnviada").add({
  IdMsg:Id,
  Telefone:tele,
  IdWhatsapp: json.messageId,
  Enviada:false,
  Recebida:false,
  Lida:false,
  Respondida:false,
  Reposta:"",
  dataMensagem: new Date().getTime(),
  }).then(() => {

  })

  } else  if(Infor.Tipo === "Audio"){

    var data={
      "phone": tele,
      "audio": Infor.Url,
    }   
const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-audio", 
{
      method: 'POST',
      headers:{
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    });
  
 const json = await req.json(); 

 await db.collection("MensagemEnviada").add({
  IdMsg:Id,
  Telefone:tele,
  IdWhatsapp: json.messageId,
  Enviada:false,
  Recebida:false,
  Lida:false,
  Respondida:false,
  Reposta:"",
  dataMensagem: new Date().getTime(),
  }).then(() => {

  })

  } else  if(Infor.Tipo === "Link"){

    var data={
      "phone": tele,
      "message":Infor.Text,
      "image": Infor.Url,
      "linkUrl": Infor.Infor.Info1,
      "title": Infor.Infor.Info2,
      "linkDescription": Infor.Infor.Info3,
    }   
const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-link", 
{
      method: 'POST',
      headers:{
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    });
  
 const json = await req.json(); 

 await db.collection("MensagemEnviada").add({
  IdMsg:Id,
  Telefone:tele,
  IdWhatsapp: json.messageId,
  Enviada:false,
  Recebida:false,
  Lida:false,
  Respondida:false,
  Reposta:"",
  dataMensagem: new Date().getTime(),
  }).then(() => {

  })

  } else  if(Infor.Tipo === "Documento"){

  } else  if(Infor.Tipo === "Localização"){
    var data={
      "phone": tele,
      "title":Infor.Text,
      "address": Infor.Infor.Info1,
      "latitude": Infor.Infor.Info2,
      "longitude": Infor.Infor.Info3,
    }   
const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-location", 
{
      method: 'POST',
      headers:{
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    });
  
 const json = await req.json(); 

 await db.collection("MensagemEnviada").add({
  IdMsg:Id,
  Telefone:tele,
  IdWhatsapp: json.messageId,
  Enviada:false,
  Recebida:false,
  Lida:false,
  Respondida:false,
  Reposta:"",
  dataMensagem: new Date().getTime(),
  }).then(() => {

  })

  } else  if(Infor.Tipo === "Contato"){

    var data={
      "phone": tele,
      "contactName": Infor.Infor.Info1,
      "contactPhone": Infor.Infor.Info2,
  
    }   
const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-contact", 
{
      method: 'POST',
      headers:{
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    });
  
 const json = await req.json(); 

 await db.collection("MensagemEnviada").add({
  IdMsg:Id,
  Telefone:tele,
  IdWhatsapp: json.messageId,
  Enviada:false,
  Recebida:false,
  Lida:false,
  Respondida:false,
  Reposta:"",
  dataMensagem: new Date().getTime(),
  }).then(() => {

  })


  } else  if(Infor.Tipo === "Texto Botões"){


    var data={
      "phone": tele,
      "message": Infor.Text,
      "buttonList": {
        "buttons": Btn,
      }
  
    }   
const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-button-list", 
  {
      method: 'POST',
      headers:{
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    });
  
 const json = await req.json(); 
 await db.collection("MensagemEnviada").add({
  IdMsg:Id,
  Telefone:tele,
  IdWhatsapp: json.messageId,
  Enviada:false,
  Recebida:false,
  Lida:false,
  Respondida:false,
  Reposta:"",
  dataMensagem: new Date().getTime(),
  }).then(() => {

  })

  } else  if(Infor.Tipo === "Imagem Botões"){
    var data={
      "phone": tele,
      "message": Infor.Text,
      "buttonList": {
        "image": Infor.Url,
        "buttons": Btn,
      }
  
    }   
const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-button-list", 
{
      method: 'POST',
      headers:{
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    });
  
 const json = await req.json(); 

 await db.collection("MensagemEnviada").add({
  IdMsg:Id,
  Telefone:tele,
  IdWhatsapp: json.messageId,
  Enviada:false,
  Recebida:false,
  Lida:false,
  Respondida:false,
  Reposta:"",
  dataMensagem: new Date().getTime(),
  }).then(() => {

  })

  }

 
      
   
 
  },

  ContruindoList: async(Id, Infor, setListTel, setMovList)=> {
    var List = [];
    var QnatList = 0 
    if(Infor.Especifica.id !== 0){
      if(Infor.Cidade !== null){

        await db.collection("TelefonesWhats")
        .where("Estado", "==", Infor.Estado )
        .where("Cidade", "==", Infor.Cidade)
        .where("Interesse", "array-contains", Infor.Especifica.id)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if(doc.data().status){
              if(doc.data().status.Ativo === true){
                
                QnatList = QnatList + 1
                setMovList(QnatList);
                List.push(doc.data().Telefone)

              }

            }else {

              QnatList = QnatList + 1
              setMovList(QnatList);
              List.push(doc.data().Telefone)

            }
          
  
          });
          setListTel(List)
          
        });
        await db.collection("MensagensWhats").doc(Id)
        .update({
         ListContato:List,
         ListEnviada: [],
         PosiList:0, 
        });
       

      } else if(Infor.Estado !== null){

        await db.collection("TelefonesWhats")
        .where("Estado", "==", Infor.Estado )
        .where("Interesse", "array-contains", Infor.Especifica.id)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            QnatList = QnatList + 1
            setMovList(QnatList);
            List.push(doc.data().Telefone)
  
          });
          setListTel(List)
          
        });
        await db.collection("MensagensWhats").doc(Id)
        .update({
         ListContato:List, 
         ListEnviada: [],
         PosiList:0, 
        });
       

      } else {

        await db.collection("TelefonesWhats")
        .where("Interesse", "array-contains", Infor.Especifica.id)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            QnatList = QnatList + 1
            setMovList(QnatList);
            List.push(doc.data().Telefone)
  
          });
          setListTel(List)
          
        });
        await db.collection("MensagensWhats").doc(Id)
        .update({
         ListContato:List, 
         ListEnviada: [],
         PosiList:0, 
        });

      }
     

    } else {
      if(Infor.Cidade !== null){

        await db.collection("TelefonesWhats")
        .where("Estado", "==", Infor.Estado )
        .where("Cidade", "==", Infor.Cidade)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            QnatList = QnatList + 1
            setMovList(QnatList);
            List.push(doc.data().Telefone)
  
          });
          setListTel(List)
          
        });
        await db.collection("MensagensWhats").doc(Id)
        .update({
         ListContato:List,
         ListEnviada: [],
         PosiList:0,  
        });
       

      } else if(Infor.Estado !== null){

        await db.collection("TelefonesWhats")
        .where("Estado", "==", Infor.Estado )
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            QnatList = QnatList + 1
            setMovList(QnatList);
            List.push(doc.data().Telefone)
  
          });
          setListTel(List)
          
        });
        await db.collection("MensagensWhats").doc(Id)
        .update({
         ListContato:List, 
         ListEnviada: [],
         PosiList:0, 
        });
       

      } else {
        
        await db.collection("TelefonesWhats")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            QnatList = QnatList + 1
            setMovList(QnatList);
            List.push(doc.data().Telefone)
  
          });
          setListTel(List)
          
        });

        await db.collection("MensagensWhats").doc(Id)
        .update({
         ListContato:List,
         ListEnviada: [],
         PosiList:0,  
        });

      }

    }
   

 
    
  },
  
  VizualizandoAnun: async(Id, Dados, setInfor, setNoticia)=> {
    const autenticado =  await Auth.currentUser;
    const id = await autenticado.uid;
    await db.collection("anuncios").doc(Id)
    .onSnapshot((doc) => {
        setInfor(doc.data());
    });

    await db.collection("noticias")
    .where("estado", "==", "Maranhão" )
    .where("cidade", "==", "Bacabal")
    .where("instituicao", "==", "Polícia Militar")
    .get()
    .then((querySnapshot) => {
      var res = []; 
      querySnapshot.forEach((doc) => {
       
          res.push({
            id: doc.id,
            dateNoti: doc.data().dataDanoti,
            titulo: doc.data().TituloAnun,
          });    
       
      });
     

      res.sort((a,b)=>{
        if(a.dateNoti < b.dateNoti) {
          return 1;
        } else {
          return -1;
        }
      });
    console.log(res);
      setNoticia(res);
    

        });
 
  },

  AtualizandoOlds: async(Lista, setPorOlds, setPorcJogos)=> {
   console.log(Lista)
   var Bet = []
   for(let i in Lista){
   
   
    const url = `https://api-football-v1.p.rapidapi.com/v3/odds?fixture=${Lista[i].list.fixture.id}`;
  
  const options = {
    method: 'GET',
    headers: {
      'X-RapidAPI-Key': '54f23e58f0msh34be965c7c7eac7p16fe9ejsne8979eb650eb',
      'X-RapidAPI-Host': 'api-football-v1.p.rapidapi.com'
    }
  };
  
  fetch(url, options)
  .then(res => res.json())
  .then((json) =>{
    var Book = json.response[0].bookmakers;
    
     Bet=[];
     for(let j in Book){
     
      if(Lista[i].list.CasaDeAposta === Book[j].name){

         for(let l in Lista[i].list.Best){
          for(let m in Book[j].bets){
            for(let n in Book[j].bets[m].values){
             if(Book[j].bets[m].name === Lista[i].list.Best[l].GrupoEng &&  Book[j].bets[m].values[n].value === Lista[i].list.Best[l].CasaEng){
              setPorOlds(l)
              setPorcJogos(parseInt(i)+1)
              Bet.push({
                GrupoEng:Lista[i].list.Best[l].GrupoEng,
                CasaEng:Lista[i].list.Best[l].CasaEng,
                Casa:Lista[i].list.Best[l].Casa,
                Grupo:Lista[i].list.Best[l].Grupo,
                Olds: parseFloat(Book[j].bets[m].values[n].odd),
                id: Lista[i].list.Best[l].id,
                idCasaOlds:Lista[i].list.Best[l].idCasaOlds,
                      })

              
        
             
             
            }

            }
          }
         }
        console.log(Book[j].bets)
      
      }
      
     }
  
     console.log(Bet) 
       db.collection("JogosCirados")
      .doc(Lista[i].list.id)
      .update({
        Best:Bet,
        }).then(() => {
          
        })
        .catch((error) => {
            // The document probably doesn't exist.
            
        });
  
  })
  .catch(err => console.error('error:' + err));
  console.log(Bet) 

   
  }
  
   
  
  // const url = `https://api-football-v1.p.rapidapi.com/v3/fixtures?id=${Id.fixture.id}`;
  
  // const options = {
  //   method: 'GET',
  //   headers: {
  //     'X-RapidAPI-Key': '54f23e58f0msh34be965c7c7eac7p16fe9ejsne8979eb650eb',
  //     'X-RapidAPI-Host': 'api-football-v1.p.rapidapi.com'
  //   }
  // };
  
  // fetch(url, options)
  // .then(res => res.json())
  // .then((json) =>{
  //   setInfor(json.response[0])
  //   console.log(json.response[0])
  
  
   
  
  // })
  // .catch(err => console.error('error:' + err));
  
      
    },

    
  AtualizandoOlds2: async(Id, DataA, Lis2bet, setAlert, setAlertTipo,)=> {
   
   
     
    db.collection("JogosCirados")
   .doc(Id.id)
   .update({
     Best:Lis2bet,
     }).then(() => {
      setAlertTipo("success");
      setAlert("Atualizado com sucesso!")
     })
     .catch((error) => {
         // The document probably doesn't exist.
         
     });

    },


    AtualizandoData: async(Id, DataA, Lis2bet, setAlert, setAlertTipo,)=> {
   
   
     
      db.collection("JogosCirados")
     .doc(Id.id)
     .update({
      DiaJogo: DataA,
       }).then(() => {
        setAlertTipo("success");
        setAlert("Atualizado com sucesso!")
       })
       .catch((error) => {
           // The document probably doesn't exist.
           
       });
  
      },

    VizualizandoTimeMode: async(Id, Dados, setInfor)=> {

      // db.collection("Testes").doc("EWuF3IsIeq2pXQVYyWii")
      // .get().then((doc) => {
      //   setInfor(doc.data().response)
        
    
        
      // });
    
    const url = `https://api-football-v1.p.rapidapi.com/v3/fixtures?id=${Id.fixture.id}`;
    
    const options = {
      method: 'GET',
      headers: {
        'X-RapidAPI-Key': '54f23e58f0msh34be965c7c7eac7p16fe9ejsne8979eb650eb',
        'X-RapidAPI-Host': 'api-football-v1.p.rapidapi.com'
      }
    };
    
    fetch(url, options)
    .then(res => res.json())
    .then((json) =>{
      setInfor(json.response[0])
      console.log(json.response[0])
    
    
     
    
    })
    .catch(err => console.error('error:' + err));
    
     
    
        
      },

VizualizandoTimes: async(Id, Dados, setInfor, setListCond)=> {

  // db.collection("Testes").doc("EWuF3IsIeq2pXQVYyWii")
  // .get().then((doc) => {
  //   setInfor(doc.data().response)
    

    
  // });

const url = `https://api-football-v1.p.rapidapi.com/v3/fixtures?id=${Id.fixture.id}`;

const options = {
  method: 'GET',
  headers: {
    'X-RapidAPI-Key': '54f23e58f0msh34be965c7c7eac7p16fe9ejsne8979eb650eb',
    'X-RapidAPI-Host': 'api-football-v1.p.rapidapi.com'
  }
};

fetch(url, options)
.then(res => res.json())
.then((json) =>{
  setInfor(json.response[0])
  console.log(json.response[0])


 

})
.catch(err => console.error('error:' + err));


    
},

  VizualResuAlds: async(Id, Dados, setQbetFor, setInfor, setListCond)=> {
  console.log(Id)
  var res = [];
  for(let i in Id.Best){
  setQbetFor(i)
   await db.collection("CasaOlds").doc(Id.Best[i].idCasaOlds)
    .get().then((doc) => {
     res.push({
      id:doc.id,
      Resultado:doc.data().Resultado,
     })
   
    });
  }
  setListCond(res)
  console.log(res)
      
    },

  VizualizandoOcorren: async(Id, Dados, setInfor)=> {
    await db.collection("MensagensWhats").doc(Id)
    .onSnapshot((doc) => {
        setInfor(doc.data());
    });

 
    
  },
VizualizandoCadastrado: async(Id, Dados, setInfor)=> {
    await db.collection("GBusers").doc(Id)
    .onSnapshot((doc) => {
        setInfor(doc.data());
    });

 
    
  },
  BloqueandoContas: async(Dados, Id, setAlertTipo, setAlert)=> {
    const autenticado =  await Auth.currentUser;
    const id = await autenticado.uid;
    const Setor = "Bloqueando Conta Serv";
    await db.collection("users")
    .doc(Id)
    .update({ 
      "conta.serv.desbloqueado": false,
      "conta.servApp.desbloqueado": false,
    }).then(()=>{
      setAlertTipo("success");
      setAlert("Bloqueado com sucesso!")
      db.collection("movimentacao").add({
        id:id,
        instituicao: Dados.instituicao,
        cidade: Dados.cidade,
        estado: Dados.estado,
        Conta: Dados.conta.serv.tipo,
        acao:"Atualizar",
        setor: Setor,
        data:firebase.firestore.FieldValue.serverTimestamp(),
        idSofrer:Id,
        });
    });

    
    
  },
MudarTelefone: async(Id, Tel, Dados, Lista, setMsgErro, setInfor, setLista, setAlert, setAlertTipo)=> {
        // var ver = Tel.replace("(", "55");
        // var par1 = ver.replace(")", "");
        // var par3 = par1.replace("-", "");
        // const req = await fetch(`${URL_WHAT}phone-exists/${par3}`, 
        // {
        //       method: 'GET',
        //       headers:{
        //         'Content-Type': 'application/json'
        //       },
              
        //     });
    
        
          
        //     const json = await req.json(); 
           
          
        //     if(json.exists === true){
            await db.collection("GBusers")
            .doc(Id)
            .update({ 
              "Telefone": Tel,
              "DataEntCel": 0,
              "Registrado": false,
              "ReceberMsg": "Indeciso",
            }).then(()=>{
              setAlertTipo("success");
              setAlert("Salvo com sucesso!")
                const novaLista = Lista.map(item =>
                  item.id === Id ? { ...item, Telefone:Tel, Registrado:false, ReceberMsg:"Indeciso"  } : item
                
                );
                setLista(novaLista);
              
            });
         
            // } else{
            //   setMsgErro("Esse Telefone Não existe") 
            // }
   

    
    
  },
  CriarGrupo: async(Dados, Nome, Valor, setAlertTipo, setAlert, setAlert1, setAlertTipo1)=> {
    const autenticado =  await Auth.currentUser;
    const id = await autenticado.uid;
    const Setor = "Criando Grupo Serv";
    await db.collection("gruposerv")
          .where("estado", "==", Dados.estado)
          .where("cidade", "==", Dados.cidade)
          .where("instituicao", "==", Dados.instituicao)
          .where("nome", "==", Nome)
          .get()
          .then(async(doc)=>{
            
              if(doc.size === 0){
                await db.collection("gruposerv").add({
                  id_criador:id,
                  nome:Nome,
                  dataCriar:firebase.firestore.FieldValue.serverTimestamp(),
                  estado:Dados.estado,
                  cidade:Dados.cidade,
                  instituicao: Dados.instituicao,
                  menu:Valor,
                  }).then((doc)=>{
                    const res= doc.id;
                    setAlert("Criado com Sucesso");
                    setAlertTipo("success");
                    db.collection("movimentacao").add({
                      id:id,
                      instituicao: Dados.instituicao,
                      cidade: Dados.cidade,
                      estado: Dados.estado,
                      Conta: Dados.conta.serv.tipo,
                      acao:"Criar",
                      setor: Setor,
                      data:firebase.firestore.FieldValue.serverTimestamp(),
                      idSofrer:res,
                      })
                  });
                
              } else {
                setAlert1("Esse Nome de Grupo já existe!");
                setAlertTipo1("danger");
              }
          });


  },

  ListGrupos: async(Dados, setQuant, setUsuariosContServ)=> {
   
    await Auth.onAuthStateChanged( async function(user) {
      if (user) {
      const ID = user.uid;
      const Setor = "Lista Grupos Serv";
      const dados = await db.collection('users')
      .doc(ID).
      get()
      .then(async(dados)=>{
        const result = await dados.data();
        await db.collection("movimentacao").add({
          id:ID,
          instituicao: result.instituicao,
          cidade: result.cidade,
          estado: result.estado,
          Conta: result.conta.serv.tipo,
          acao:"Vizualizar",
          setor: Setor,
          data:firebase.firestore.FieldValue.serverTimestamp(),
          });

          await db.collection("gruposerv")
          .where("estado", "==", result.estado)
          .where("cidade", "==", result.cidade)
          .where("instituicao", "==", result.instituicao)
            .onSnapshot((querySnapshot) => {
            setQuant(querySnapshot.size);
            var res = []; 
            querySnapshot.forEach((doc) => {
                res.push({
                  id: doc.id,
                  nome: doc.data().nome,   
                });      
            });
            setUsuariosContServ(res);
    
              });

          
        
   
       }); 
     
      } 
  
    });
    
    
  },

  ListRotasVtr: async(IdVtr, DataA, DataD, setListRotaVt, setVerRtVt, setLoading)=> {
   
          console.log(DataA)
          console.log(DataD)
          console.log(IdVtr)
      
          await db.collection("rotas")
            .where("Id", "==", IdVtr)
            .where("date", ">=", DataA)
            .where("date", "<=", DataD)
            .get().then((querySnapshot) => {
              console.log(querySnapshot.size)
              var res = []
            querySnapshot.forEach((doc) => {

              let currentDate = '';
            let now =new Date(doc.data().date);
            let hours = now.getHours();
            let minutes = now.getMinutes();
            let Dia = now.getDate();
            let Mes = (now.getMonth()+1);
            let Ano = now.getFullYear(); 
            hours = hours < 10 ? '0'+hours : hours;
            minutes = minutes < 10 ? '0'+minutes : minutes;
            Dia = Dia < 10 ? '0'+Dia : Dia;
            Mes = Mes < 10 ? '0'+Mes : Mes;
            currentDate = Dia+'/'+Mes+'/'+Ano;
            currentDate += ' ';
            currentDate += hours+':'+minutes;

               res.push({
                localizacao:doc.data().localizacao,
                date:currentDate,
              }) 
            });

            setListRotaVt(res)

              }).then(()=>{
                setLoading(false);
                setVerRtVt(true);

              });

          
        
  
     
     
  
  
    
    
  },

  ListLiga: async(Dados,  setLigasTod, setListLiga)=> {
 
    await db.collection("users")
    .where("Telefone", "==", Dados.Tel)
    .where("DataEnt", "==", Dados.DataEnt)
    .get().then(async (querySnapshot) => {
      if(querySnapshot.size  !== 0){




       const url = 'https://api-football-v1.p.rapidapi.com/v3/leagues';

       const options = {
         method: 'GET',
         headers: {
           'X-RapidAPI-Key': '54f23e58f0msh34be965c7c7eac7p16fe9ejsne8979eb650eb',
           'X-RapidAPI-Host': 'api-football-v1.p.rapidapi.com'
         }
       };
       
       fetch(url, options)
         .then(res => res.json())
         .then((json) =>{
          var res = [];
          var Lis = [];
          for(let i in  json.response){
           res.push({
            id:json.response[i].league.id,
            select: json.response[i].league.name,
            Info: json.response[i].country.name, 
           })
           Lis.push({
            id:json.response[i].league.id,
            select: json.response[i].country.name,
            Info: json.response[i].league.name, 
           })
          }
          setListLiga(Lis)
        setLigasTod(res)
    
       
       })
         .catch(err => console.error('error:' + err));

      };
     });
   

 
   
 },

 PesquisaJogoExis: async(DataA, Casa, setInfExist )=> {
 
  await db.collection("JogosCirados")
       .where("DiaJogo", "==", DataA)
       .where("Casa.name", "==", Casa.name)
       .get().then((querySnapshot) => {
        if(querySnapshot.size  !== 0){
          setInfExist("Esse jogo Já Existe!")
        }

       });
 


 
},

 
GBMudarEstado: async (EstadoLink, setEstado) => {

        
       await db.collection("GbEstado")
              .where("label", "==", EstadoLink)
               .get().then((querySnapshot) => {

               
               
               querySnapshot.forEach((doc) => {
                 
                 setEstado(doc.data().value)
                
                 
               });
               });
      },
    GBMudarCidade: async (CidadeLink, setCidade) => {
        
        
       await db.collection("GbCidade")
              .where("label", "==", CidadeLink)
               .get().then((querySnapshot) => {

               
               
               querySnapshot.forEach((doc) => {
                  
                 setCidade(doc.data().value)
                 
                 
               });
               });
      },

  ListOcorr: async(Dados, CidEst, setQuant, setUsuariosContServ, setCarreg, Dat, Dat2)=> {
      var res = [];    
    for(let i in  CidEst){
      
     
     await db.collection("GBusers")
            .where("Cidade", "==", CidEst[i].Cidade)
            .where("Estado", "==", CidEst[i].Estado)
            .get().then((querySnapshot) => {
           
           
            querySnapshot.forEach((doc) => {
             
                res.push({
                  id: doc.id,
                  DataCadas: doc.data().DataCadas,
                  ativo: doc.data().ativo, 
                  Cidade: doc.data().Cidade,
                  Estado: doc.data().Estado,
                  EntrouSist:doc.data().EntrouSist,
                  Indicador:doc.data().Indicador,
                  Nome:doc.data().Indicador,
                  QuantCompra:doc.data().QuantCompra,
                  ReceberMsg:doc.data().ReceberMsg,
                  Registrado:doc.data().Registrado,
                  Telefone:doc.data().Telefone,
                });    
              
                 
            });

           
            
    
              });
      }
  
          
       res.sort((a,b)=>{
              if(a.date < b.date) {
                return -1;
              } else {
                return 1;
              }
            });
            setCarreg(false); 
            setQuant(res.length);
            setUsuariosContServ(res);
           
        
   
    
     
    

  
    
  },

  ApostandoCASH: async(Dados, QuanJog, ValApos, ValPreDemos, ValorReal, SimAp, ValPremi, Cambis, TelCli, NomeCli, ValCambis, setCarre, setLinkEnv, setAlert, setAlertTipo, setModalVer, setSimAp, setValorReal,  setValPremi, setCambis, setTelCli, setNomeCli, setValCambis, setValPreDemos,  VaToCo, setVaToCo, setPgCash, setIdAposta, setDCash)=> {
    var Msg = ""
   var id = ""
     await db.collection("users")
     .where("Telefone", "==", Dados.Tel)
     .where("DataEnt", "==", Dados.DataEnt)
     .get().then(async (querySnapshot) => {
       if(querySnapshot.size  !== 0){
         querySnapshot.forEach(async(doc) => {
         id = doc.id;
         setDCash(doc.data().Cash);
        })
         if(Cambis === false){
   
        
   
   
   
           await db.collection("CompApostas")
           .add({
   
           Nome:Dados.Nome,
           Tel:Dados.Tel,
           IdCri:id,
           Cambista:Cambis,
           NomeComp:NomeCli,
           TelComp:TelCli,
           Pago:false,
           PremioPago:false,
           AnaliTotal:false,
           Aprovado:false,
           DataApost:new Date().getTime(),
           ValorPremio: ValPreDemos,
           ValorAposta: ValorReal,
           Bets:SimAp,
           ValCambis:ValCambis,
           CotaGeral:VaToCo,
           valorAposSimb:ValApos,
   
        
           }).then(async (def) => {
            setCarre(false);
            setIdAposta(def.id);
            setPgCash(true);
        
        
           
        
          
        
        })
         .catch((error) => {
             console.error("Error adding document: ", error);
         }); 
        
        
       } else {
   
         
         var ver = TelCli.replace("(", "55");
         var par1 = ver.replace(")", "");
         var par3 = par1.replace("-", "");
      
         const req = await fetch(`https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/phone-exists/${par3}`, 
         {
               method: 'GET',
               headers:{
                 'Content-Type': 'application/json'
               },
              
             });
     
         
           
             const json = await req.json(); 
             
             if(json.exists === true){
   
               await db.collection("CompApostas")
               .add({
       
               Nome:Dados.Nome,
               Tel:Dados.Tel,
               IdCri:id,
               Cambista:Cambis,
               NomeComp:NomeCli,
               TelComp:TelCli,
               Pago:false,
               PremioPago:false,
               Aprovado:false,
               AnaliTotal:false,
               DataApost:new Date().getTime(),
               ValorPremio: ValPreDemos,
               ValorAposta: ValorReal,
               Bets:SimAp,
               ValCambis:ValCambis,
               CotaGeral:VaToCo,
               valorAposSimb:ValApos,
       
            
               }).then(async (def) => {
                setCarre(false);
                setIdAposta(def.id);
                setPgCash(true);
            
            
            
               
            
              
            
            })
             .catch((error) => {
                 console.error("Error adding document: ", error);
             }); 
   
   
             
             
             
             
             
             
             
             
             
             
             
             
             
             } else {
   
               setModalVer(false);
               setAlert("O Telefone do Cliente Não é um Whatsapp!");
               setAlertTipo("danger");
               setCarre(false);
            
            
            
             }
       
       
       
       
       
       
       
       }
   
   
   
   
   
   
   
   
   
            
   
        
   
       } else {
         setModalVer(false);
         setAlert("Você Entrou No Sistema de Forma Errada!");
         setAlertTipo("danger");
   
       }
     });
     
     },
     
     VerHtml: async()=> {
      var data ="";
      const req = await fetch("https://us-central1-pixbetcash.cloudfunctions.net/api/criarPagamento", {
        method: 'POST',
        headers:{
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString(),
        json: true,
      });
     
      const json = await req.json();
    
      if(json){
        console.log(json.data)
      } 
    
    
    },


     ApostCambis: async(Dados, IdApos, QuanJog, ValApos, ValPreDemos, ValorReal, SimAp, ValPremi, Cambis, TelCli, NomeCli, ValCambis, setCarre, setLinkEnv, setAlert, setAlertTipo, setModalVer, setSimAp, setValorReal,  setValPremi, setCambis, setTelCli, setNomeCli, setValCambis, setValPreDemos,  VaToCo, setVaToCo)=> {
      var Msg = ""
     
       await db.collection("users")
       .where("Telefone", "==", Dados.Tel)
       .where("DataEnt", "==", Dados.DataEnt)
       .get().then(async (querySnapshot) => {
         if(querySnapshot.size  !== 0){
           querySnapshot.forEach(async(doc) => {
     
     
                 await db.collection("CompApostas")
                 .add({
         
                 Nome:Dados.Nome,
                 Tel:Dados.Tel,
                 IdCri:doc.id,
                 Cambista:Cambis,
                 NomeComp:NomeCli,
                 TelComp:TelCli,
                 Pago:false,
                 PremioPago:false,
                 Aprovado:false,
                 AnaliTotal:false,
                 DataApost:new Date().getTime(),
                 ValorPremio: ValPreDemos,
                 ValorAposta: ValorReal,
                 Bets:SimAp,
                 ValCambis:ValCambis,
                 CotaGeral:VaToCo,
                 valorAposSimb:ValApos,
         
              
                 }).then(async (def) => {

                  
                  
                 
                  var data = new URLSearchParams();
                    data.append('Valor', ValorReal);
                    data.append('Nome', Dados.Nome);
                    data.append('Tel', Dados.Tel);
                    data.append('IdApos', def.id);
              
                const req = await fetch("https://us-central1-pixbetcash.cloudfunctions.net/api/criarPagamento", {
                  method: 'POST',
                  headers:{
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  body: data.toString(),
                  json: true,
                });
               
                const json = await req.json();
              
                if(json){
                  console.log(json.resposta.response.init_point)
                  setLinkEnv(json.resposta.response.init_point);
                  setCarre(false);
                  setAlert("Aposta Criada Com Sucesso!");
                  setAlertTipo("success");
                  setModalVer(false);
                  setSimAp([]);
                  setValCambis("");
                  setValorReal(0);
                  setValPremi(0);
                  setTelCli("");
                  setNomeCli("");
                  setCambis(false);
                  setValPreDemos("");
                  setVaToCo(0)
         
                 
                 }
              
              
                 
              
                
              
              })
               .catch((error) => {
                   console.error("Error adding document: ", error);
               }); 
     
     
               
               
               
               
               
               
               
               
               
               
               
               
               
             
         
         
         
         
         
         
         
       
        
     
           })
     
         } else {
           setModalVer(false);
           setAlert("Você Entrou No Sistema de Forma Errada!");
           setAlertTipo("danger");
     
         }
       });
       
       },

 Apostando: async(Dados, QuanJog, ValApos, ValPreDemos, ValorReal, SimAp, ValPremi, Cambis, TelCli, NomeCli, ValCambis, setCarre, setLinkEnv, setAlert, setAlertTipo, setModalVer, setSimAp, setValorReal,  setValPremi, setCambis, setTelCli, setNomeCli, setValCambis, setValPreDemos,  VaToCo, setVaToCo)=> {
 var Msg = ""

  await db.collection("users")
  .where("Telefone", "==", Dados.Tel)
  .where("DataEnt", "==", Dados.DataEnt)
  .get().then(async (querySnapshot) => {
    if(querySnapshot.size  !== 0){
      querySnapshot.forEach(async(doc) => {


      if(Cambis === false){

     



        await db.collection("CompApostas")
        .add({

        Nome:Dados.Nome,
        Tel:Dados.Tel,
        IdCri:doc.id,
        Cambista:Cambis,
        NomeComp:NomeCli,
        TelComp:TelCli,
        Pago:false,
        PremioPago:false,
        AnaliTotal:false,
        Aprovado:false,
        DataApost:new Date().getTime(),
        ValorPremio: ValPreDemos,
        ValorAposta: ValorReal,
        Bets:SimAp,
        ValCambis:ValCambis,
        CotaGeral:VaToCo,
        valorAposSimb:ValApos,

     
        }).then(async (def) => {
        
         var data = new URLSearchParams();
           data.append('Valor', ValorReal);
           data.append('Nome', Dados.Nome);
           data.append('Tel', Dados.Tel);
           data.append('IdApos', def.id);
     
       const req = await fetch(" https://us-central1-pixbetcash.cloudfunctions.net/api/criarPagamento", {
         method: 'POST',
         headers:{
           'Content-Type': 'application/x-www-form-urlencoded'
         },
         body: data.toString(),
         json: true,
       });
      
       const json = await req.json();
     
       if(json){
        
         setLinkEnv(json.resposta.response.init_point);
         setCarre(false);
         setAlert("Aposta Criada Com Sucesso!");
         setAlertTipo("success");
         setModalVer(false);
         setSimAp([]);
         setValCambis("");
         setValorReal(0);
         setValPremi(0);
         setTelCli("");
         setNomeCli("");
         setCambis(false);
         setValPreDemos("");
         setVaToCo(0)

        
        }
     
     
        
     
       
     
     })
      .catch((error) => {
          console.error("Error adding document: ", error);
      }); 
     
     
    } else {

      
      var ver = TelCli.replace("(", "55");
      var par1 = ver.replace(")", "");
      var par3 = par1.replace("-", "");
   
      const req = await fetch(`https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/phone-exists/${par3}`, 
      {
            method: 'GET',
            headers:{
              'Content-Type': 'application/json'
            },
           
          });
  
      
        
          const json = await req.json(); 
          
          if(json.exists === true){

            await db.collection("CompApostas")
            .add({
    
            Nome:Dados.Nome,
            Tel:Dados.Tel,
            IdCri:doc.id,
            Cambista:Cambis,
            NomeComp:NomeCli,
            TelComp:TelCli,
            Pago:false,
            PremioPago:false,
            Aprovado:false,
            AnaliTotal:false,
            DataApost:new Date().getTime(),
            ValorPremio: ValPreDemos,
            ValorAposta: ValorReal,
            Bets:SimAp,
            ValCambis:ValCambis,
            CotaGeral:VaToCo,
            valorAposSimb:ValApos,
    
         
            }).then(async (def) => {
            
             var data = new URLSearchParams();
               data.append('Valor', ValorReal);
               data.append('Nome', Dados.Nome);
               data.append('Tel', Dados.Tel);
               data.append('IdApos', def.id);
         
           const req = await fetch("https://us-central1-pixbetcash.cloudfunctions.net/api/criarPagamento", {
             method: 'POST',
             headers:{
               'Content-Type': 'application/x-www-form-urlencoded',
             },
             body: data.toString(),
             json: true,
           });
          
           const json = await req.json();
         
           if(json){
             console.log(json.resposta.response.init_point)
             setLinkEnv(json.resposta.response.init_point);
             setCarre(false);
             setAlert("Aposta Criada Com Sucesso!");
             setAlertTipo("success");
             setModalVer(false);
             setSimAp([]);
             setValCambis("");
             setValorReal(0);
             setValPremi(0);
             setTelCli("");
             setNomeCli("");
             setCambis(false);
             setValPreDemos("");
             setVaToCo(0)
    
            
            }
         
         
            
         
           
         
         })
          .catch((error) => {
              console.error("Error adding document: ", error);
          }); 


          
          
          
          
          
          
          
          
          
          
          
          
          
          } else {

            setModalVer(false);
            setAlert("O Telefone do Cliente Não é um Whatsapp!");
            setAlertTipo("danger");
            setCarre(false);
         
         
         
          }
    
    
    
    
    
    
    
    }









         

      })

    } else {
      setModalVer(false);
      setAlert("Você Entrou No Sistema de Forma Errada!");
      setAlertTipo("danger");

    }
  });
  
  },


CashNivel2: async(idU, setCarreg)=> {
  var Id1nivel = "";
  var Id2nivel = "";
  var Id3nivel = "";
  var Id4nivel = "";
  var ValorApo = 0;
  var tempReal = new Date().getTime();

  ValorApo = parseInt(Math.random() * (100 - 50) + 50);
   console.log(ValorApo)

//1° Nivel ----
  await db.collection("users")
  .doc(idU)
  .update({
      Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:"Ganhou", Nivel:"1", Valor:(9*ValorApo), Moeda:"Cash", IdInf: ""})
  })

//2° Nivel ----
     
     await db.collection("users")
     .where("Indicados", "array-contains", idU)
     .get().then(async (querySnapshot12) => {
       if(querySnapshot12.size  !== 0){
     
     
      await querySnapshot12.forEach((doc12) => {
           Id2nivel = doc12.id;
         })
        
        
     
        await db.collection("users")
        .doc(Id2nivel)
        .update({
            Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:"Ganhou", Nivel:"2", Valor:(6*ValorApo), Moeda:"Cash", IdInf:"" })
        })
        
     
 
     
     
       } 
     })
    
   


    

       //3° Nivel ----

       await db.collection("users")
       .where("Indicados", "array-contains", Id2nivel)
       .get().then(async (querySnapshot13) => {
         if(querySnapshot13.size  !== 0){
       
       
        await querySnapshot13.forEach((doc131) => {
             Id3nivel = doc131.id;
           })
       
          
       
          await db.collection("users")
          .doc(Id3nivel)
          .update({
              Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:"Ganhou", Nivel:"3", Valor:(3*ValorApo), Moeda:"Cash", IdInf:"" })
          })
      
          
       
       
         } 
       })






        
          //4° Nivel ----    
          await db.collection("users")
          .where("Indicados", "array-contains", Id3nivel)
          .get().then(async (querySnapshot14) => {
            if(querySnapshot14.size  !== 0){
          
          
           await querySnapshot14.forEach((doc141) => {
                Id4nivel = doc141.id;
              })
          
        
             
          
             await db.collection("users")
             .doc(Id4nivel)
             .update({
                 
                 Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:"Ganhou", Nivel:"4", Valor:(1*ValorApo), Moeda:"Cash", IdInf:"" })
             })
             
          
          
            } 
          })

          setCarreg(false)

},

CashNivel3: async(Ni3, setQNi3)=> {
  var Id1nivel = "";
  var Id2nivel = "";
  var Id3nivel = "";
  var Id4nivel = "";
  var ValorApo = 0;
  var tempReal = new Date().getTime();
 for(let i in Ni3){
  setQNi3(i)
  ValorApo = parseInt(Math.random() * (10 - 5) + 5);
   console.log(ValorApo)

  var cash1 = 0;
  var TemV1 = 0;
  var NewTemV1 = 0;
  var NewCash1 = 0;
  
  await db.collection("users")
  .doc(Ni3[i])
  .get().then((doc11) => {
   cash1 = doc11.data().Cash; 
   TemV1 = doc11.data().DataVenc;
  });
  
  if(TemV1 < tempReal){
  
   NewTemV1 = tempReal+(86400000*ValorApo);
   NewCash1 = cash1 + (9*ValorApo);
  
  }else {
  
  NewTemV1 = TemV1+(86400000*ValorApo);
  NewCash1 = cash1 + (9*ValorApo);
  
  }
  
  await db.collection("users")
  .doc(Ni3[i])
  .update({
      Cash:NewCash1,
      DataVenc:NewTemV1,
      Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:"Ganhou", Nivel:"1", Valor:(9*ValorApo), Moeda:"Cash", IdInf: ""})
  })





     //2° Nivel ----
     var cash2 = 0;
     var TemV2 = 0;
     var NewTemV2 = 0;
     var NewCash2 = 0;
     var Status2 = "";
     
     await db.collection("users")
     .where("Indicados", "array-contains", Ni3[i])
     .get().then(async (querySnapshot12) => {
       if(querySnapshot12.size  !== 0){
     
     
      await querySnapshot12.forEach((doc12) => {
           Id2nivel = doc12.id;
         })
     
     await db.collection("users")
     .doc(Id2nivel)
     .get().then((doc13) => {
      cash2 = doc13.data().Cash; 
      TemV2 = doc13.data().DataVenc;
     });
     
   
        
        NewCash2 = cash2 + (6*ValorApo);
        Status2 = "Ganhou";
        
       
     
        await db.collection("users")
        .doc(Id2nivel)
        .update({
            Cash:NewCash2,
            Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:"Ganhou", Nivel:"2", Valor:(6*ValorApo), Moeda:"Cash", IdInf:"" })
        })
        
     
 
     
     
       } 
     })
    
   


    

       //3° Nivel ----
       var cash3 = 0;
       var TemV3 = 0;
       var NewTemV3 = 0;
       var NewCash3 = 0;
       var Status3 = "";

       await db.collection("users")
       .where("Indicados", "array-contains", Id2nivel)
       .get().then(async (querySnapshot13) => {
         if(querySnapshot13.size  !== 0){
       
       
        await querySnapshot13.forEach((doc131) => {
             Id3nivel = doc131.id;
           })
       
       await db.collection("users")
       .doc(Id3nivel)
       .get().then((doc132) => {
        cash3 = doc132.data().Cash; 
        TemV3 = doc132.data().DataVenc;
       });
       
     
          
          NewCash3 = cash3 + (3*ValorApo);
          Status3 = "Ganhou";
         
       
          await db.collection("users")
          .doc(Id3nivel)
          .update({
              Cash:NewCash3,
              Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:"Ganhou", Nivel:"3", Valor:(3*ValorApo), Moeda:"Cash", IdInf:"" })
          })
      
          
       
       
         } 
       })






        
          //4° Nivel ----
          var cash4 = 0;
          var TemV4 = 0;
          var NewTemV4 = 0;
          var NewCash4 = 0;
          var Status4 = "";
          
          await db.collection("users")
          .where("Indicados", "array-contains", Id3nivel)
          .get().then(async (querySnapshot14) => {
            if(querySnapshot14.size  !== 0){
          
          
           await querySnapshot14.forEach((doc141) => {
                Id4nivel = doc141.id;
              })
          
          await db.collection("users")
          .doc(Id4nivel)
          .get().then((doc142) => {
           cash4 = doc142.data().Cash; 
           TemV4 = doc142.data().DataVenc;
          });
          
         
             
             NewCash4 = cash4 + (1*ValorApo);
             Status4 = "Ganhou";
             
          
             await db.collection("users")
             .doc(Id4nivel)
             .update({
                 Cash:NewCash4,
                 Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:"Ganhou", Nivel:"4", Valor:(1*ValorApo), Moeda:"Cash", IdInf:"" })
             })
             
          
          
            } 
          })

 } 

},
CashNivel4: async(Ni4, setQNi4)=> {
  var Id1nivel = "";
  var Id2nivel = "";
  var Id3nivel = "";
  var Id4nivel = "";
  var ValorApo = 0;
  var tempReal = new Date().getTime();
 for(let i in Ni4){
  setQNi4(i)
  ValorApo = parseInt(Math.random() * (10 - 5) + 5);
   console.log(ValorApo)

  var cash1 = 0;
  var TemV1 = 0;
  var NewTemV1 = 0;
  var NewCash1 = 0;
  
  await db.collection("users")
  .doc(Ni4[i])
  .get().then((doc11) => {
   cash1 = doc11.data().Cash; 
   TemV1 = doc11.data().DataVenc;
  });
  
  if(TemV1 < tempReal){
  
   NewTemV1 = tempReal+(86400000*ValorApo);
   NewCash1 = cash1 + (9*ValorApo);
  
  }else {
  
  NewTemV1 = TemV1+(86400000*ValorApo);
  NewCash1 = cash1 + (9*ValorApo);
  
  }
  
  await db.collection("users")
  .doc(Ni4[i])
  .update({
      Cash:NewCash1,
      DataVenc:NewTemV1,
      Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:"Ganhou", Nivel:"1", Valor:(9*ValorApo), Moeda:"Cash", IdInf: ""})
  })





     //2° Nivel ----
     var cash2 = 0;
     var TemV2 = 0;
     var NewTemV2 = 0;
     var NewCash2 = 0;
     var Status2 = "";
     
     await db.collection("users")
     .where("Indicados", "array-contains", Ni4[i])
     .get().then(async (querySnapshot12) => {
       if(querySnapshot12.size  !== 0){
     
     
      await querySnapshot12.forEach((doc12) => {
           Id2nivel = doc12.id;
         })
     
     await db.collection("users")
     .doc(Id2nivel)
     .get().then((doc13) => {
      cash2 = doc13.data().Cash; 
      TemV2 = doc13.data().DataVenc;
     });
     
   
        
        NewCash2 = cash2 + (6*ValorApo);
        Status2 = "Ganhou";
        
       
     
        await db.collection("users")
        .doc(Id2nivel)
        .update({
            Cash:NewCash2,
            Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:"Ganhou", Nivel:"2", Valor:(6*ValorApo), Moeda:"Cash", IdInf:"" })
        })
        
     
 
     
     
       } 
     })
    
   


    

       //3° Nivel ----
       var cash3 = 0;
       var TemV3 = 0;
       var NewTemV3 = 0;
       var NewCash3 = 0;
       var Status3 = "";

       await db.collection("users")
       .where("Indicados", "array-contains", Id2nivel)
       .get().then(async (querySnapshot13) => {
         if(querySnapshot13.size  !== 0){
       
       
        await querySnapshot13.forEach((doc131) => {
             Id3nivel = doc131.id;
           })
       
       await db.collection("users")
       .doc(Id3nivel)
       .get().then((doc132) => {
        cash3 = doc132.data().Cash; 
        TemV3 = doc132.data().DataVenc;
       });
       
     
          
          NewCash3 = cash3 + (3*ValorApo);
          Status3 = "Ganhou";
         
       
          await db.collection("users")
          .doc(Id3nivel)
          .update({
              Cash:NewCash3,
              Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:"Ganhou", Nivel:"3", Valor:(3*ValorApo), Moeda:"Cash", IdInf:"" })
          })
      
          
       
       
         } 
       })






        
          //4° Nivel ----
          var cash4 = 0;
          var TemV4 = 0;
          var NewTemV4 = 0;
          var NewCash4 = 0;
          var Status4 = "";
          
          await db.collection("users")
          .where("Indicados", "array-contains", Id3nivel)
          .get().then(async (querySnapshot14) => {
            if(querySnapshot14.size  !== 0){
          
          
           await querySnapshot14.forEach((doc141) => {
                Id4nivel = doc141.id;
              })
          
          await db.collection("users")
          .doc(Id4nivel)
          .get().then((doc142) => {
           cash4 = doc142.data().Cash; 
           TemV4 = doc142.data().DataVenc;
          });
          
         
             
             NewCash4 = cash4 + (1*ValorApo);
             Status4 = "Ganhou";
             
          
             await db.collection("users")
             .doc(Id4nivel)
             .update({
                 Cash:NewCash4,
                 Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:"Ganhou", Nivel:"4", Valor:(1*ValorApo), Moeda:"Cash", IdInf:"" })
             })
             
          
          
            } 
          })

 } 

},

  PgCshAti: async(Dados, VCash, IdAposta, setCarre, setLinkEnv, setAlert, setAlertTipo, setModalVer, setSimAp, setValorReal,  setValPremi, setCambis, setTelCli, setNomeCli, setValCambis, setValPreDemos, VaToCo, setVaToCo, setPgCash, setIdAposta, setDCash, setValApos, setVCash, setRobo, setCodG, setTentativa, setSenha   )=> {
    var Msg = ""
    var CashBn = 0;
    var IdUser = "";
    var Tel = Dados.Tel;
    var DataEnt = Dados.DataEnt; 
    var tempReal = new Date().getTime();
    var Time =(new Date().getTime());
     await db.collection("users")
     .where("Telefone", "==", Dados.Tel)
     .where("DataEnt", "==", Dados.DataEnt)
     .get().then(async (querySnapshot) => {
       if(querySnapshot.size  !== 0){
         querySnapshot.forEach(async(doc) => {
          CashBn = doc.data().Cash;
          IdUser = doc.id;
        })

         if(CashBn >= VCash){
            var CashAt = CashBn-VCash;
          await db.collection("users")
          .doc(IdUser)
          .update({
            Cash: CashAt,
            Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:"Pagou", Nivel:"1", Valor:VCash, Moeda:"Cash", IdInf:IdAposta })
          })
          .then(async () => {

            await db.collection("CompApostas")
            .doc(IdAposta)
            .update({
              Pago: true,
              DatePago:tempReal,
              PgCash:true,
            })
            .then(async () => {
              var Id1nivel = "";
              var Id2nivel = "";
              var Id3nivel = "";
              var Id4nivel = "";
              var ValorApo = 0;

              await db.collection("CompApostas")
              .doc(IdAposta)
              .get().then(async(doc) => {
              Id1nivel = doc.data().IdCri;
              ValorApo =parseInt(doc.data().ValorAposta);


          if(Id1nivel === IdUser){

            if(doc.data().Pago === true){

            if(doc.data().Cambista === true){

                let currentDate25 = '';
                let now25 =new Date(Time);
                let hours25 = now25.getHours();
                let minutes25 = now25.getMinutes();
                let Dia25 = now25.getDate();
                let Mes25 = (now25.getMonth()+1);
                let Ano25 = now25.getFullYear(); 
                hours25 = hours25 < 10 ? '0'+hours25 : hours25;
                minutes25 = minutes25 < 10 ? '0'+minutes25 : minutes25;
                Dia25 = Dia25 < 10 ? '0'+Dia25 : Dia25;
                Mes25 = Mes25 < 10 ? '0'+Mes25 : Mes25;
                currentDate25 = Dia25+'/'+Mes25+'/'+Ano25;
                currentDate25 += ' ';
                currentDate25 += hours25+':'+minutes25;

                  var Msg = ""

                  Msg = Msg + `----- Boleto de Aposta PixBetCash -----\n`
                  Msg = Msg + `Nome: ${doc.data().NomeComp}\n`
                  Msg = Msg + `Telefone: ${doc.data().TelComp}\n`
                  Msg = Msg + `Pagamento Aprovado\n`
                  Msg = Msg + `Data: ${currentDate25}\n`
                  Msg = Msg + `----------------------------------------------\n`
                  
                  for(let i in doc.data().Bets){

                  let currentDate = '';
                  let now =new Date((doc.data().Bets[i].dataJogo) * 1000);
                  let hours = now.getHours();
                  let minutes = now.getMinutes();
                  let Dia = now.getDate();
                  let Mes = (now.getMonth()+1);
                  let Ano = now.getFullYear(); 
                  hours = hours < 10 ? '0'+hours : hours;
                  minutes = minutes < 10 ? '0'+minutes : minutes;
                  Dia = Dia < 10 ? '0'+Dia : Dia;
                  Mes = Mes < 10 ? '0'+Mes : Mes;
                  currentDate = Dia+'/'+Mes+'/'+Ano;
                  currentDate += ' ';
                  currentDate += hours+':'+minutes;


                  Msg = Msg + `⚽${doc.data().Bets[i].CasaTime.name.substr(0, 15)} X  ${doc.data().Bets[i].ForaTime.name.substr(0, 15)} \n ☝🏽 Palpite: ${doc.data().Bets[i].Casa} | Cota: ${doc.data().Bets[i].Olds} \n 🥅 (${doc.data().Bets[i].Grupo}) \n ⌚️ ${currentDate}\n ---------------------------------------------\n`
                  }

                  Msg = Msg + `Cota Total: ${doc.data().CotaGeral}\n`;
                  Msg = Msg + `Valor Prêmio: R$ ${doc.data().ValorPremio}\n`;
                  Msg = Msg + `Valor Pago: ${doc.data().valorAposSimb}\n`;
                  Msg = Msg + `Cambista: --------------------\n`;
                  Msg = Msg + `Nome: ${doc.data().Nome}\n`;
                  Msg = Msg + `Telefone: ${doc.data().Tel}\n`;
                  Msg = Msg + `Cambista Ganhará 10% em Cima do Prêmio:\n`;
                  Msg = Msg + `Valor: R$ ${doc.data().ValCambis}\n`;
                  


                  var ver = doc.data().TelComp.replace("(", "55");
                  var par1 = ver.replace(")", "");
                  var par3 = par1.replace("-", "");

                  var data={
                    "phone": par3,
                    "message": Msg,
                  }   
                  const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-messages", 
                  {
                        method: 'POST',
                        headers:{
                          'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(data),
                     });


                } else {

                let currentDate25 = '';
                      let now25 =new Date(Time);
                      let hours25 = now25.getHours();
                      let minutes25 = now25.getMinutes();
                      let Dia25 = now25.getDate();
                      let Mes25 = (now25.getMonth()+1);
                      let Ano25 = now25.getFullYear(); 
                      hours25 = hours25 < 10 ? '0'+hours25 : hours25;
                      minutes25 = minutes25 < 10 ? '0'+minutes25 : minutes25;
                      Dia25 = Dia25 < 10 ? '0'+Dia25 : Dia25;
                      Mes25 = Mes25 < 10 ? '0'+Mes25 : Mes25;
                      currentDate25 = Dia25+'/'+Mes25+'/'+Ano25;
                      currentDate25 += ' ';
                      currentDate25 += hours25+':'+minutes25;

                  var Msg = ""

                  Msg = Msg + `----- Boleto de Aposta PixBetCash -----\n`
                  Msg = Msg + `Nome: ${doc.data().Nome}\n`
                  Msg = Msg + `Telefone: ${doc.data().Tel}\n`
                  Msg = Msg + `Pagamento Aprovado\n`
                  Msg = Msg + `Data: ${currentDate25}\n`
                  Msg = Msg + `----------------------------------------------\n`
                  
                  for(let i in doc.data().Bets){

                  let currentDate = '';
                  let now =new Date((doc.data().Bets[i].dataJogo) * 1000);
                  let hours = now.getHours();
                  let minutes = now.getMinutes();
                  let Dia = now.getDate();
                  let Mes = (now.getMonth()+1);
                  let Ano = now.getFullYear(); 
                  hours = hours < 10 ? '0'+hours : hours;
                  minutes = minutes < 10 ? '0'+minutes : minutes;
                  Dia = Dia < 10 ? '0'+Dia : Dia;
                  Mes = Mes < 10 ? '0'+Mes : Mes;
                  currentDate = Dia+'/'+Mes+'/'+Ano;
                  currentDate += ' ';
                  currentDate += hours+':'+minutes;


                  Msg = Msg + `⚽${doc.data().Bets[i].CasaTime.name.substr(0, 15)} X  ${doc.data().Bets[i].ForaTime.name.substr(0, 15)} \n ☝🏽 Palpite: ${doc.data().Bets[i].Casa} | Cota: ${doc.data().Bets[i].Olds} \n 🥅 (${doc.data().Bets[i].Grupo}) \n ⌚️ ${currentDate}\n ---------------------------------------------\n`
                  }

                  Msg = Msg + `Cota Total: ${doc.data().CotaGeral}\n`;
                  Msg = Msg + `Valor Premio: R$ ${doc.data().ValorPremio}\n`;
                  Msg = Msg + `Valor Pago: ${doc.data().valorAposSimb}\n`;
                  


                  var ver = doc.data().Tel.replace("(", "55");
                  var par1 = ver.replace(")", "");
                  var par3 = par1.replace("-", "");

                  var data={
                    "phone": par3,
                    "message": Msg,
                  }   
                  const req = await fetch("https://api.z-api.io/instances/3A9D95BC49F730DF458B76215AA2744C/token/A2A3E65C2FE0E21916E8A2AE/send-messages", 
                  {
                        method: 'POST',
                        headers:{
                          'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(data),
                     });

                  



                  }




    //1° nivel ------
    
    var cash1 = 0;
    var TemV1 = 0;
    var NewTemV1 = 0;
    var NewCash1 = 0;
    
    await db.collection("users")
    .doc(Id1nivel)
    .get().then((doc11) => {
     cash1 = doc11.data().Cash; 
     TemV1 = doc11.data().DataVenc;
    });
    
    if(TemV1 < tempReal){
    
     NewTemV1 = tempReal+(86400000*ValorApo);
     NewCash1 = cash1 + (9*ValorApo);
    
    }else {
    
    NewTemV1 = TemV1+(86400000*ValorApo);
    NewCash1 = cash1 + (9*ValorApo);
    
    }
    
    await db.collection("users")
    .doc(Id1nivel)
    .update({
        Cash:NewCash1,
        DataVenc:NewTemV1,
        Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:"Ganhou", Nivel:"1", Valor:(9*ValorApo), Moeda:"Cash", IdInf: IdAposta })
    })


     //2° Nivel ----
     var cash2 = 0;
     var TemV2 = 0;
     var NewTemV2 = 0;
     var NewCash2 = 0;
     var Status2 = "";
     
     await db.collection("users")
     .where("Indicados", "array-contains", Id1nivel)
     .get().then(async (querySnapshot12) => {
       if(querySnapshot12.size  !== 0){
     
     
      await querySnapshot12.forEach((doc12) => {
           Id2nivel = doc12.id;
         })
     
     await db.collection("users")
     .doc(Id2nivel)
     .get().then((doc13) => {
      cash2 = doc13.data().Cash; 
      TemV2 = doc13.data().DataVenc;
     });
     
     if(TemV2 < tempReal){
         NewCash2 = cash2;
         Status2 = "Perdeu";
        
        }else {
        
        NewCash2 = cash2 + (6*ValorApo);
        Status2 = "Ganhou";
        
        }
     
        await db.collection("users")
        .doc(Id2nivel)
        .update({
            Cash:NewCash2,
            Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:Status2, Nivel:"2", Valor:(6*ValorApo), Moeda:"Cash", IdInf:IdAposta })
        })
        
     
 
     
     
       } 
     })
    
   


    

       //3° Nivel ----
       var cash3 = 0;
       var TemV3 = 0;
       var NewTemV3 = 0;
       var NewCash3 = 0;
       var Status3 = "";

       await db.collection("users")
       .where("Indicados", "array-contains", Id2nivel)
       .get().then(async (querySnapshot13) => {
         if(querySnapshot13.size  !== 0){
       
       
        await querySnapshot13.forEach((doc131) => {
             Id3nivel = doc131.id;
           })
       
       await db.collection("users")
       .doc(Id3nivel)
       .get().then((doc132) => {
        cash3 = doc132.data().Cash; 
        TemV3 = doc132.data().DataVenc;
       });
       
       if(TemV3 < tempReal){
           NewCash3 = cash3;
           Status3 = "Perdeu";
          }else {
          
          NewCash3 = cash3 + (3*ValorApo);
          Status3 = "Ganhou";
          }
       
          await db.collection("users")
          .doc(Id3nivel)
          .update({
              Cash:NewCash3,
              Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:Status3, Nivel:"3", Valor:(3*ValorApo), Moeda:"Cash", IdInf:IdAposta })
          })
      
          
       
       
         } 
       })






        
          //4° Nivel ----
          var cash4 = 0;
          var TemV4 = 0;
          var NewTemV4 = 0;
          var NewCash4 = 0;
          var Status4 = "";
          
          await db.collection("users")
          .where("Indicados", "array-contains", Id3nivel)
          .get().then(async (querySnapshot14) => {
            if(querySnapshot14.size  !== 0){
          
          
           await querySnapshot14.forEach((doc141) => {
                Id4nivel = doc141.id;
              })
          
          await db.collection("users")
          .doc(Id4nivel)
          .get().then((doc142) => {
           cash4 = doc142.data().Cash; 
           TemV4 = doc142.data().DataVenc;
          });
          
          if(TemV4 < tempReal){
              NewCash4 = cash4;
              Status4 = "Perdeu";
             }else {
             
             NewCash4 = cash4 + (1*ValorApo);
             Status4 = "Ganhou";
             }
          
             await db.collection("users")
             .doc(Id4nivel)
             .update({
                 Cash:NewCash4,
                 Extrato: firebase.firestore.FieldValue.arrayUnion({Data:tempReal, Status:Status4, Nivel:"4", Valor:(1*ValorApo), Moeda:"Cash", IdInf:IdAposta })
             })
             
          
          
            } 
          })


            }


            }

            });
           
            setCarre(false);
            setAlert("Aposta Paga com Sucesso!");
            setAlertTipo("success");
            setModalVer(false);
            setSimAp([]);
            setValCambis("");
            setValorReal(0);
            setValPremi(0);
            setTelCli("");
            setNomeCli("");
            setCambis(false);
            setValPreDemos("");
            setVaToCo(0)
            setIdAposta("");
            setPgCash(false);
            setDCash(0);
            setValApos("R$000,00")
            setVCash(0);
            setCodG(false)
            setTentativa(0)
            setSenha("")
            setRobo(true)
           
           
           
           
            })


            
        //     var data = new URLSearchParams();
        //     data.append('DataEnt', DataEnt);
        //     data.append('Tel', Tel);
        //     data.append('IdApos', IdAposta);
      
        // const req = await fetch("https://us-central1-pixbetcash.cloudfunctions.net/api/PagamentoCash", {
        //   method: 'POST',
        //   headers:{
        //     'Content-Type': 'application/x-www-form-urlencoded'
        //   },
        //   body: data.toString(),
        //   json: true,
        // });
       
        // const json = await req.json();
      
        // if(json){
      
       

          
 
         
        //  }
          })
           
           

        
       } 
   
   
  
   
        
   
       } else {
         setModalVer(false);
         setAlert("Você Entrou No Sistema de Forma Errada!");
         setAlertTipo("danger");
   
       }
     });
     
     },

  ListJogosCambista: async(Dados, setQuant, setUsuariosContServ, setCarreg, Dat, Dat2, setAlert, setAlertTipo)=> {
   

    
    let Antes = Dat;
    let Depois = Dat2;
    var idUser = ""
    console.log(Antes);
    console.log(Depois);
    await db.collection("users")
    .where("Telefone", "==", Dados.Tel)
    .where("DataEnt", "==", Dados.DataEnt)
    .get()
    .then(async (querySnapshot2) => {
      if(querySnapshot2.size  !== 0){

        querySnapshot2.forEach((doc2)=>{
          idUser = doc2.id;
          
        })
        console.log(idUser);
           await db.collection("NotaCambista")
             .where("dataCriar", ">=", Antes)
             .where("dataCriar", "<=", Depois)
             .where("IdCri", "==", idUser)
             .get().then((querySnapshot) => {
             setQuant(querySnapshot.size);
             var res = []; 
             querySnapshot.forEach((doc) => {
               
                 res.push({
                   id: doc.id,
                   dataJogo:doc.data().dataCriar,
                   NomeCam:doc.data().Nome,
                   TelCam :doc.data().Tel,
                   Nome:doc.data().NomeComp,
                   TelCli:doc.data().TelComp,
                   Pago:doc.data().Pago,
                   Concluir:doc.data().Conscluido,
                   ValPreDemos:doc.data().ValorPremio,
                   ValorReal:doc.data().ValorAposta,
                   SimAp:doc.data().Bets,
                   ValCambis:doc.data().ValCambis,
                   VaToCo:doc.data().CotaGeral,
                   ValApos:doc.data().valorAposSimb,
                   Cash:doc.data().CashGanha, 
 
                  
                 });    
               
               setCarreg(false);    
             });
             console.log(res)
             res.sort((a,b)=>{
               if(a.dataJogo > b.dataJogo) {
                 return 1;
               } else {
                 return -1;
               }
             });
             console.log(res)
             setUsuariosContServ(res);
             
     
               });
 
             } else {
               setAlert("Você está acessando essa conta de forma incorreta!");
               setAlertTipo("danger");
       
              }
             
             
             
             })
           
         
    
      
     
     
   },

   

  ListJogos: async(Dados, setQuant, setUsuariosContServ, setCarreg, Dat, Dat2, setAlert, setAlertTipo)=> {
   
   let Antes = Dat/1000;
   let Depois = Dat2/1000;
   console.log(Antes);
   console.log(Depois);
   await db.collection("users")
   .where("Telefone", "==", Dados.Tel)
   .where("DataEnt", "==", Dados.DataEnt)
   .get().then(async (querySnapshot) => {
     if(querySnapshot.size  !== 0){
    
          await db.collection("JogosCirados")
            .where("DiaJogo", ">=", Antes)
            .where("DiaJogo", "<=", Depois)
            .onSnapshot(async (querySnapshot) => {
            setQuant(querySnapshot.size);
            var res = []; 
           await querySnapshot.forEach((doc) => {
              
                res.push({
                  id: doc.id,
                  dataJogo: doc.data().DiaJogo,
                  Analisado:doc.data().Analisado?doc.data().Analisado:false,
                  AtualApi:doc.data().AtualApi,
                  Atualizei:doc.data().Atualizei,
                  Best:doc.data().Best,
                  Casa:doc.data().Casa,
                  CasaDeAposta:doc.data().CasaDeAposta,
                  Estadio:doc.data().Estadio,
                  Fora:doc.data().Fora,
                  dataCriacao:doc.data().dataCriacao,
                  fixture:doc.data().fixture,
                  liga:doc.data().liga,
                  LinkResu: doc.data().LinkResu? doc.data().LinkResu: "",
                  LinkJogo: doc.data().LinkJogo? doc.data().LinkJogo: "",
                 
                });    
              
              
            });

            var Resli = []
            console.log(res)
            for(let i in res){
            
             await db.collection("CompApostas")
              .where("JogosId", "array-contains", res[i].id)
              .get().then((doc1) => {
                
                if (doc1.size !== 0) {
                 Resli.push({
                  id: res[i].id,
                  dataJogo:  res[i].dataJogo,
                  Analisado: res[i].Analisado,
                  AtualApi: res[i].AtualApi,
                  Atualizei: res[i].Atualizei,
                  Best: res[i].Best,
                  Casa: res[i].Casa,
                  CasaDeAposta: res[i].CasaDeAposta,
                  Estadio: res[i].Estadio,
                  Fora: res[i].Fora,
                  dataCriacao: res[i].dataCriacao,
                  fixture: res[i].fixture,
                  liga: res[i].liga,
                  LinkResu: res[i].LinkResu,
                  LinkJogo: res[i].LinkJogo,
                  JogosApos:doc1.size,
                 })
                } else{
                  Resli.push({
                    id: res[i].id,
                    dataJogo:res[i].dataJogo,
                    Analisado:res[i].Analisado,
                    AtualApi:res[i].AtualApi,
                    Atualizei:res[i].Atualizei,
                    Best:res[i].Best,
                    Casa: res[i].Casa,
                    CasaDeAposta:res[i].CasaDeAposta,
                    Estadio:res[i].Estadio,
                    Fora:res[i].Fora,
                    dataCriacao:res[i].dataCriacao,
                    fixture:res[i].fixture,
                    liga:res[i].liga,
                    LinkResu:res[i].LinkResu,
                    LinkJogo:res[i].LinkJogo,
                    JogosApos:doc1.size,
                   })

                }
                
            }).catch((error) => {
               
            });

          }
         

            Resli.sort((a,b)=>{
              if(a.dataJogo > b.dataJogo) {
                return 1;
              } else {
                return -1;
              }
            });
            console.log(Resli)
            setCarreg(false);    
            setUsuariosContServ(Resli);
            
    
              });

            } else {
              setAlert("Você está acessando essa conta de forma incorreta!");
              setAlertTipo("danger");
      
             }
            
            
            
            })
          
                
        
     
    
    
  },

  ListPagamentos: async(Dados, setQuant, setUsuariosContServ, setCarreg, Dat, Dat2, setAlert, setAlertTipo)=> {
   
    let Antes = Dat/1000;
    let Depois = Dat2/1000;
    console.log(Antes);
    console.log(Depois);
    await db.collection("users")
    .where("Telefone", "==", Dados.Tel)
    .where("DataEnt", "==", Dados.DataEnt)
    .get().then(async (querySnapshot) => {
      if(querySnapshot.size  !== 0){
     
           await db.collection("users")
             .where("Dinheiro", ">", 0)
             .get().then((querySnapshot) => {
             setQuant(querySnapshot.size);
             var res = []; 
             querySnapshot.forEach((doc) => {
              
              let currentDate1 = '';
              let now1 =new Date(doc.data().DateDinheiro);
              let Dia1 = now1.getDate();
              let Mes1 = (now1.getMonth()+1);
              let Ano1 = now1.getFullYear();
              let hora = now1.getHours();
              let minuto = now1.getMinutes();
              hora = hora < 10 ? '0'+hora : hora;
              minuto = minuto < 10 ? '0'+minuto : minuto;
              Dia1 = Dia1 < 10 ? '0'+Dia1 : Dia1;
              Mes1 = Mes1 < 10 ? '0'+Mes1 : Mes1;
              currentDate1 = Ano1+'-'+Mes1+'-'+Dia1;

                 res.push({
                   id: doc.id,
                   Nome: doc.data().Nome,
                   Tel:doc.data().Telefone,
                   Dinheiro:doc.data().Dinheiro, 
                   DatePedido:doc.data().DateDinheiro, 
                   Data:currentDate1,     
                 });    
               
               setCarreg(false);    
             });
             console.log(res)
             res.sort((a,b)=>{
               if(a.dataJogo > b.dataJogo) {
                 return 1;
               } else {
                 return -1;
               }
             });
             console.log(res)
             setUsuariosContServ(res);
             
     
               });
 
             } else {
               setAlert("Você está acessando essa conta de forma incorreta!");
               setAlertTipo("danger");
       
              }
             
             
             
             })
           
         
    
      
     
     
   },

   ListNive1: async(Dados, setQuant, setUsuariosContServ, setCarreg, setNi2, Dat, Dat2, setAlert, setAlertTipo)=> {
   
    let Antes = Dat/1000;
    let Depois = Dat2/1000;
    console.log(Antes);
    console.log(Depois);
    var Ind = []
    await db.collection("users")
    .where("Telefone", "==", Dados.Tel)
    .where("DataEnt", "==", Dados.DataEnt)
    .get().then(async (querySnapshot) => {
      if(querySnapshot.size  !== 0){


             var res = []; 
             querySnapshot.forEach((doc) => {
            Ind = doc.data().Indicados;
            setNi2(doc.data().Indicados)
            });
         
             for(let i in Ind){
              await db.collection("users")
              .doc(Ind[i])
              .get().then(async (doc1) => { 
               
                let currentDate1 = '';
                let now1 =new Date(doc1.data().DataCadas);
                let Dia1 = now1.getDate();
                let Mes1 = (now1.getMonth()+1);
                let Ano1 = now1.getFullYear();
                let hora = now1.getHours();
                let minuto = now1.getMinutes();
                hora = hora < 10 ? '0'+hora : hora;
                minuto = minuto < 10 ? '0'+minuto : minuto;
                Dia1 = Dia1 < 10 ? '0'+Dia1 : Dia1;
                Mes1 = Mes1 < 10 ? '0'+Mes1 : Mes1;
                currentDate1 = Ano1+'-'+Mes1+'-'+Dia1;
  
                   res.push({
                     id: doc1.id,
                     Nome: doc1.data().Nome,
                     Tel:doc1.data().Telefone,
                     DateCadas:doc1.data().DataCadas,
                     Data:currentDate1,
                     Cash: doc1.data().Cash,
                     Qind: doc1.data().Indicados.length,   
                   });    

              });
            
            }



             
               
               setCarreg(false);    
             
             console.log(res)
           
             
             setUsuariosContServ(res);
             
     
              
 
             } else {
               setAlert("Você está acessando essa conta de forma incorreta!");
               setAlertTipo("danger");
       
              }
             
             
             
             })
           
         
    
      
     
     
   },

   ListNive3: async(Dados, Ni2, setList3, setNi3,  setQuant, setUsuariosContServ, setCarreg, setNi2, Dat, Dat2, setAlert, setAlertTipo)=> {
   
    let Antes = Dat/1000;
    let Depois = Dat2/1000;
    console.log(Antes);
    console.log(Depois);
    var Ind = []
    await db.collection("users")
    .where("Telefone", "==", Dados.Tel)
    .where("DataEnt", "==", Dados.DataEnt)
    .get().then(async (querySnapshot) => {
      if(querySnapshot.size  !== 0){

             
             var res = []; 
         
             for(let i in Ni2){
              await db.collection("users")
              .doc(Ni2[i])
              .get().then(async (doc1) => {
                   for(let l in doc1.data().Indicados){
                    Ind.push(doc1.data().Indicados[l]);
                   }
                  
           
              });
            
            }
            setNi3(Ind)
            console.log(Ind)
            for(let j in Ind){
              await db.collection("users")
              .doc(Ind[j])
              .get().then(async (doc2) => {
               
                let currentDate1 = '';
                let now1 =new Date(doc2.data().DataCadas);
                let Dia1 = now1.getDate();
                let Mes1 = (now1.getMonth()+1);
                let Ano1 = now1.getFullYear();
                let hora = now1.getHours();
                let minuto = now1.getMinutes();
                hora = hora < 10 ? '0'+hora : hora;
                minuto = minuto < 10 ? '0'+minuto : minuto;
                Dia1 = Dia1 < 10 ? '0'+Dia1 : Dia1;
                Mes1 = Mes1 < 10 ? '0'+Mes1 : Mes1;
                currentDate1 = Ano1+'-'+Mes1+'-'+Dia1;
  
                   res.push({
                     id: doc2.id,
                     Nome: doc2.data().Nome,
                     Tel:doc2.data().Telefone,
                     DateCadas:doc2.data().DataCadas,
                     Data:currentDate1,
                     Cash: doc2.data().Cash, 
                     Qind: doc2.data().Indicados.length,     
                   });    

              });

             }



             
               
               setCarreg(false);    
             
             console.log(res)
           
             
             setList3(res);
             
     
              
 
             } else {
               setAlert("Você está acessando essa conta de forma incorreta!");
               setAlertTipo("danger");
       
              }
             
             
             
             })
           
         
    
      
     
     
   },

   ListNive4: async(Dados, Ni3, setList4, setNi4,  setQuant, setUsuariosContServ, setCarreg, setNi2,  setAlert, setAlertTipo)=> {
   
  
    var Ind = []
    await db.collection("users")
    .where("Telefone", "==", Dados.Tel)
    .where("DataEnt", "==", Dados.DataEnt)
    .get().then(async (querySnapshot) => {
      if(querySnapshot.size  !== 0){

             
             var res = []; 
         
             for(let i in Ni3){
              await db.collection("users")
              .doc(Ni3[i])
              .get().then(async (doc1) => {
                   for(let l in doc1.data().Indicados){
                    Ind.push(doc1.data().Indicados[l]);
                   }
                  
           
              });
            
            }
            setNi4(Ind)
            console.log(Ind)
            for(let j in Ind){
              await db.collection("users")
              .doc(Ind[j])
              .get().then(async (doc2) => {
               
                let currentDate1 = '';
                let now1 =new Date(doc2.data().DataCadas);
                let Dia1 = now1.getDate();
                let Mes1 = (now1.getMonth()+1);
                let Ano1 = now1.getFullYear();
                let hora = now1.getHours();
                let minuto = now1.getMinutes();
                hora = hora < 10 ? '0'+hora : hora;
                minuto = minuto < 10 ? '0'+minuto : minuto;
                Dia1 = Dia1 < 10 ? '0'+Dia1 : Dia1;
                Mes1 = Mes1 < 10 ? '0'+Mes1 : Mes1;
                currentDate1 = Ano1+'-'+Mes1+'-'+Dia1;
  
                   res.push({
                     id: doc2.id,
                     Nome: doc2.data().Nome,
                     Tel:doc2.data().Telefone,
                     DateCadas:doc2.data().DataCadas,
                     Data:currentDate1,
                     Cash: doc2.data().Cash,
                     Qind: doc2.data().Indicados.length,      
                   });    

              });

             }



             
               
               setCarreg(false);    
             
             console.log(res)
           
             
             setList4(res);
             
     
              
 
             } else {
               setAlert("Você está acessando essa conta de forma incorreta!");
               setAlertTipo("danger");
       
              }
             
             
             
             })
           
         
    
      
     
     
   },

  ListJogosLinks: async(Dados, setQuant, setUsuariosContServ, setCarreg, Dat, Dat2, setAlert, setAlertTipo)=> {
   

    
    let Antes = Dat/1000;
    let Depois = Dat2/1000;
    console.log(Antes);
    console.log(Depois);
 
     
           await db.collection("JogosCirados")
             .where("DiaJogo", ">=", Antes)
             .where("DiaJogo", "<=", Depois)
             .get().then((querySnapshot) => {
             setQuant(querySnapshot.size);
             var res = []; 
             querySnapshot.forEach((doc) => {
               
                 res.push({
                   id: doc.id,
                   dataJogo: doc.data().DiaJogo,
                   Analisado:doc.data().Analisado,
                   AtualApi:doc.data().AtualApi,
                   Atualizei:doc.data().Atualizei,
                   Best:doc.data().Best,
                   Casa:doc.data().Casa,
                   CasaDeAposta:doc.data().CasaDeAposta,
                   Estadio:doc.data().Estadio,
                   Fora:doc.data().Fora,
                   dataCriacao:doc.data().dataCriacao,
                   fixture:doc.data().fixture,
                   liga:doc.data().liga,
               
                  
                 });    
               
               setCarreg(false);    
             });
             console.log(res)
             res.sort((a,b)=>{
               if(a.dataJogo > b.dataJogo) {
                 return 1;
               } else {
                 return -1;
               }
             });
             console.log(res)
             setUsuariosContServ(res);
             
     
               });
 
          
           
         
    
      
     
     
   },
 


  ListTime: async(Dados, setQuant, setUsuariosContServ, setCarreg, setAlert, setAlertTipo)=> {
   
     await db.collection("users")
     .where("Telefone", "==", Dados.Tel)
     .where("DataEnt", "==", Dados.DataEnt)
     .get().then(async (querySnapshot) => {
       if(querySnapshot.size  !== 0){

        await db.collection("Times")
        .onSnapshot((querySnapshot) => {
        setQuant(querySnapshot.size);
        var res = []; 
        querySnapshot.forEach((doc) => {
         
            res.push({
              id: doc.id,
              dateCri: doc.data().dataCriar,
              nome: doc.data().nome,
              logo:doc.data().logo,
            });    
          setCarreg(false);    
        });
  
        res.sort((a,b)=>{
          if(a.dateCri < b.dateCri) {
            return 1;
          } else {
            return -1;
          }
        });
      
        setUsuariosContServ(res);
        
  
          });



       } else {
        setAlert("Você está acessando essa conta de forma incorreta!");
        setAlertTipo("danger");

       }
      
      
      
      })
   

  

    
  






},

 

  ListNoti: async(Dados, setQuant, setUsuariosContServ, setCarreg)=> {
   
  
   

          await db.collection("MensagensWhats")
            .onSnapshot((querySnapshot) => {
            setQuant(querySnapshot.size);
            var res = []; 
            querySnapshot.forEach((doc) => {
             
                res.push({
                  id: doc.id,
                  dateNoti: doc.data().dataCriacao,
                  titulo: doc.data().Titulo,
                  visitas:0,
                });    
              setCarreg(false);    
            });

            res.sort((a,b)=>{
              if(a.dateNoti < b.dateNoti) {
                return 1;
              } else {
                return -1;
              }
            });
          
            setUsuariosContServ(res);
            
    
              });

          
        
   
      
     
    
    
    
  },
  

DadosGruposServ: async(Dados, Id, setInfor)=> {
  const autenticado =  await Auth.currentUser;
  const id = await autenticado.uid;
  const Setor = "Vizualizar Grupo Serv";
  await db.collection("gruposerv").doc(Id)
  .onSnapshot((doc) => {
      setInfor(doc.data().menu);
  });

  await db.collection("movimentacao").add({
    id:id,
    instituicao: Dados.instituicao,
    cidade: Dados.cidade,
    estado: Dados.estado,
    Conta: Dados.conta.serv.tipo,
    acao:"Vizualizar",
    setor: Setor,
    data:firebase.firestore.FieldValue.serverTimestamp(),
    });
  
},

EditarGrupo: async(Dados, Id, nome, Valor, setAlertTipo, setAlert)=> {
  const autenticado =  await Auth.currentUser;
  const id = await autenticado.uid;
  const Setor = "Editando Grupo Serv";
  await db.collection("gruposerv").doc(Id).update({
    "nome":nome,
    "menu":Valor,
    }).then((doc)=>{

     const colle =  db.collection("users")
     colle.where('grupo.id', '==', Id).get().then(response => {
      let batch = db.batch()
      response.docs.forEach((doc) => {
          const docRef = db.collection("users").doc(doc.id)
          batch.update(docRef, {"grupo.nome":nome, "grupo.menu":Valor})
      })
      batch.commit().then(() => {
        setAlert("Editado com Sucesso!");
        setAlertTipo("success");
      })
  })

      

    });

},


    Gruposconta: async(Dados, setListGrupo)=> {
      await db.collection("gruposerv")
      .where("estado", "==", Dados.estado)
      .where("cidade", "==", Dados.cidade)
      .where("instituicao", "==", Dados.instituicao)
        .onSnapshot((querySnapshot) => {
        var res = []; 
        querySnapshot.forEach((doc) => {
            res.push({
              id: doc.id,
              select: doc.data().nome,   
            });      
        });
       
        setListGrupo(res);
      
          });
      
    },

    VerTimes: async(Dados, setListCond)=> {

      await db.collection("Times")
      .onSnapshot((querySnapshot) => {
        var res = []; 
        querySnapshot.forEach((doc) => {
            res.push({
              id: doc.id,
              select: doc.data().nome,
              logo:doc.data().logo,   
            });      
        });
        setListCond(res);
      
          });
      
    },

    PegEspe: async(Dados, setListCond1)=> {
      await db.collection("ListaDeGosto")
      .get()
      .then((querySnapshot) => {
        var res = []; 
        querySnapshot.forEach((doc) => {
            res.push({
              id: doc.data().Number,
              select: doc.data().Gosto,   
            });      
        });
        setListCond1(res);
      
          });
      
    },

    MudAtivo: async(IdVtr, setAtiVtr, setAlert, setAlertTipo)=> {
     
      await db.collection("servAtivo")
      .where("IdUser", "==", IdVtr)
      .get()
      .then((querySnapshot) => {
       if(querySnapshot.size !== 0 ){
        let res = "";
        querySnapshot.forEach((doc) => {
          res = doc.id;           
        });
         db.collection("servAtivo")
        .doc(res)
        .update({
        "Ativo":1,
        }).then(()=>{
          setAlert("Espere Um Momento para Analise!");
          setAlertTipo("success");
        });

       } else {
        db.collection("servAtivo").add({
          IdUser: IdVtr,
          Ativo:1,
      })
      .then((docRef) => {
        setAlert("Espere Um Momento para Analise!");
        setAlertTipo("success");
      })
        
       }
      

        
        
      });
        
    },

    VendoAtivo: async(IdVtr, setAtiVtr)=> {
     
      await db.collection("servAtivo")
      .where("IdUser", "==", IdVtr)
      .onSnapshot((querySnapshot) => {
       if(querySnapshot.size !== 0 ){
        let res = 1;

        querySnapshot.forEach((doc) => {
          res = doc.data().Ativo;           
        });
        
        setAtiVtr(res)
       } else {
        setAtiVtr(1)
        
       }
      

        
        
      });
        
    },
    
    DesbloquearConta: async(Dados, Id, Grupo, setAlert, setAlertTipo)=> {
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      const Setor = "Desbloqueando Conta Serv";
      await db.collection("gruposerv")
      .where("estado", "==", Dados.estado)
      .where("cidade", "==", Dados.cidade)
      .where("instituicao", "==", Dados.instituicao)
      .where("nome", "==", Grupo)
      .get()
      .then((querySnapshot) => {
       
       let res = "";

        querySnapshot.forEach((doc) => {
          res = doc.id;           
        });
         db.collection("users")
        .doc(Id)
        .update({
         "grupoid": res,
          "conta.serv.desbloqueado": true,
          "conta.servApp.desbloqueado": true,
          "tempAtiva":0,
          "ativaPerman":false,
        }).then(()=>{
          setAlert("Desbloqueado com Sucesso!");
          setAlertTipo("success");
          db.collection("movimentacao").add({
            id:id,
            instituicao: Dados.instituicao,
            cidade: Dados.cidade,
            estado: Dados.estado,
            Conta: Dados.conta.serv.tipo,
            acao:"Atualizar",
            setor: Setor,
            data:firebase.firestore.FieldValue.serverTimestamp(),
            idSofrer:Id,
            })
        });
        
      });
        
    },

    DadosdeGraficos: async(Dados, ListDias, setListDados, setListLoc, QuatD,  setLoading )=> {
      
      let list = [];
      let listCod = [];
      for (var i = 0; i < QuatD; i++) {
        let march = i+1;
        let Antes = ListDias[i];
        let Depois = ListDias[march];

      await db.collection("users")
      .where("DataCadas", ">=", Antes)
      .where("DataCadas", "<=", Depois)
      .get()
      .then((querySnapshot) => {
          

        list.push(
          querySnapshot.size,
          );  
         

        querySnapshot.forEach((doc) => {
           
          listCod.push({
            id: doc.id,
            dateIn: doc.data().DataCadas,
          });  
               
        });
       
      });
      }

     
    setListLoc(listCod);
    setListDados(list);
    setLoading(false)

      // await db.collection("gruposerv")
      // .where("estado", "==", Dados.estado)
      // .where("cidade", "==", Dados.cidade)
      // .where("instituicao", "==", Dados.instituicao)
      // .where("nome", "==", Grupo)
      // .get()
      // .then((querySnapshot) => {
       
      //  const res = [];

      //   querySnapshot.forEach((doc) => {
      //     res.push({
      //       id: doc.id,
      //       menu: doc.data().menu,   
      //     });             
      //   });
       
      
        
      // });
        
    },

    DadosdeGraficos2: async(Dados, ListDias, setListDados, setListLoc, QuatD,  setLoading )=> {
      
      let list = [];
      let listCod = [];
      for (var i = 0; i < QuatD; i++) {
        let march = i+1;
        let Antes = ListDias[i];
        let Depois = ListDias[march];

      await db.collection("CompApostas")
      .where("DataApost", ">=", Antes)
      .where("DataApost", "<=", Depois)
      .where("Pago", "==", true)
      .get()
      .then((querySnapshot) => {
          

        list.push(
          querySnapshot.size,
          );  
         

        querySnapshot.forEach((doc) => {
           
          listCod.push({
            id: doc.id,
            dateIn: doc.data().DataApost,
            ValorApos: doc.data().ValorAposta,
          });  
               
        });
       
      });
      }

     
    setListLoc(listCod);
    setListDados(list);
    setLoading(false)

      // await db.collection("gruposerv")
      // .where("estado", "==", Dados.estado)
      // .where("cidade", "==", Dados.cidade)
      // .where("instituicao", "==", Dados.instituicao)
      // .where("nome", "==", Grupo)
      // .get()
      // .then((querySnapshot) => {
       
      //  const res = [];

      //   querySnapshot.forEach((doc) => {
      //     res.push({
      //       id: doc.id,
      //       menu: doc.data().menu,   
      //     });             
      //   });
       
      
        
      // });
        
    },

    CadasContas: async(DadEmp, Dados, Telefone,  setAlert, setAlertTipo, setCarreg)=> {
     
    await db.collection("users")
      .where("Telefone", "==", Telefone)
      .get()
      .then(async (querySnapshot) => {
       var ide =""
       if(querySnapshot.size === 0){
        setCarreg(false)
        setAlert("Telefone Não Está Registrado na CWO, peça para Seu funcionário se registra no site cartaoweb.online !");
          setAlertTipo("danger");

       } else {

        querySnapshot.forEach((doc) => {
          
                ide = doc.id;
                
              });

     db.collection("EmrpesaSite").doc(EMPRESA)
    .update({
      Contas:firebase.firestore.FieldValue.arrayUnion({Id:ide, Telefone:Telefone, Ativo:true, Conta:"Geral"}),
    }).then((doc)=>{

      db.collection("users").doc(ide)
      .update({
        ADM:firebase.firestore.FieldValue.arrayUnion(EMPRESA),
      }).then((doc)=>{
        setCarreg(false)
        setAlert("Telefone Registrado com Sucesso!");
          setAlertTipo("success");
     
     
       })
    
    
    
      })
              

        



       }

       
       
      
        
      });




   
  },
  CadasEntregador: async(DadEmp, Dados, Telefone,  Nome, setAlert, setAlertTipo, setCarreg)=> {
     
    await db.collection("Entregadores")
      .where("Empresa", "==", EMPRESA)
      .where("Telefone", "==", Telefone)
      .get()
      .then(async (querySnapshot) => {
       var ide =""
       if(querySnapshot.size === 0){
       
       
    

        await db.collection("Entregadores")
        .where("Empresa", "==", EMPRESA)
        .where("Nome", "==", Nome)
        .get()
        .then(async (querySnapshot) => {
         var ide =""
         if(querySnapshot.size === 0){
         
         
      
  
       db.collection("Entregadores")
      .add({
        Empresa:EMPRESA,
        Ativo:true,
        Telefone:Telefone,
        Nome:Nome,
      }).then((doc)=>{
  
        setAlert("Entregador Registrado com Sucesso!");
        setAlertTipo("success");
      
      
      
        })
  
      } else {
        setAlert("Existe Algum Entregador com Esse Nome na sua Empresa, Por favor Coloque Outro Nome!");
        setAlertTipo("danger");
      }
     });

    } else {
      setAlert("Esse Telefone do Entregador ja está Registrado!");
      setAlertTipo("danger");
    }
   });
              

        



     

       
       
   




   
  },


  ListEntregadorAdd: async(Dados, setListaEntregador )=> {
 

    await db.collection('Entregadores')
   .where("Empresa", "==", EMPRESA)
   .where("Ativo", "==", true)
   .onSnapshot( async (querySnapshot) => {
    var res = [];
    
       querySnapshot.forEach((doc) => {
        res.push({
  
          Telefone:doc.data().Telefone,
          select:doc.data().Nome,
          id:doc.id,
     
        })
       });
       
  
    
   
       setListaEntregador(res)
 
     
   })
   
   
  
  
  
  
  },

 ListEntregador: async(Dados,  setQuant, setUsuariosContServ )=> {
 

    await db.collection('Entregadores')
   .where("Empresa", "==", EMPRESA)
   .onSnapshot( async (querySnapshot) => {
    var res = [];
     setQuant(querySnapshot.size);
       querySnapshot.forEach((doc) => {
        res.push({
          Empresa:doc.data().Empresa,
          Ativo:doc.data().Ativo,
          Telefone:doc.data().Telefone,
          Nome:doc.data().Nome,
         id:doc.id,
     
        })
       });
       console.log(res)
  
    
   
  setUsuariosContServ(res)
 
     
   })
   
   
  
  
  
  
  },

    TelefoneCriar: async(Dados, Telefone, setAlert, setAlertTipo, setCarreg)=> {
        console.log("entrou")
      const Setor = "Criar Telefone Serv";
      await db.collection("EmrpesaSite").doc(EMPRESA)
      .update({
        numero:Telefone,
      }).then((doc)=>{
        setCarreg(false)
        setAlert("Telefone criado com Sucesso!");
          setAlertTipo("success");
     
     
       })

    },

    CriarLinks: async(EndBairro, TipPix, NomePix, NumPix, Img1Env, LinkImg1, Img2Env, LinkImg2, Img3Env, LinkImg3, Img4Env, LinkImg4, Dados, Cidade, Estado, Rua, Num, Bairro, Lng, Lat, BairroEnt, Funciona, Instag, InstagVer, Face, FaceVer, Loc, LocVer, setAlert, setAlertTipo, setCarreg)=> {
      
    const Setor = "Criar Telefone Serv";
    let Url1 = "";
 
    if(LinkImg1 === false){
      if(Img1Env.name !== ""){
      
        const fileName = await Date.now() + Img1Env.name;
        const storageRef = await storage.ref();
        const fileRef = await storageRef.child(`arquivo/${fileName}`);
        await await fileRef.put(Img1Env).then((doc)=> {
          
        });
        Url1 =  await fileRef.getDownloadURL();
      }

    } else {
      Url1 = Img1Env;
    }

    let Url2 = "";
 
    if(LinkImg2 === false){
      if(Img2Env.name !== ""){
      
        const fileName = await Date.now() + Img2Env.name;
        const storageRef = await storage.ref();
        const fileRef = await storageRef.child(`arquivo/${fileName}`);
        await await fileRef.put(Img2Env).then((doc)=> {
          
        });
        Url2 =  await fileRef.getDownloadURL();
      }

    } else {
      Url2 = Img2Env;
    }


    let Url3 = "";
 
    if(LinkImg3 === false){
      if(Img3Env.name !== ""){
      
        const fileName = await Date.now() + Img3Env.name;
        const storageRef = await storage.ref();
        const fileRef = await storageRef.child(`arquivo/${fileName}`);
        await await fileRef.put(Img3Env).then((doc)=> {
          
        });
        Url3 =  await fileRef.getDownloadURL();
      }

    } else {
      Url3 = Img3Env;
    }

    let Url4 = "";
 
    if(LinkImg4 === false){
      if(Img4Env.name !== ""){
      
        const fileName = await Date.now() + Img4Env.name;
        const storageRef = await storage.ref();
        const fileRef = await storageRef.child(`arquivo/${fileName}`);
        await await fileRef.put(Img4Env).then((doc)=> {
          
        });
        Url4 =  await fileRef.getDownloadURL();
      }

    } else {
      Url4 = Img4Env;
    }


    await db.collection("EmrpesaSite").doc(EMPRESA)
    .update({
      Cardapio:[Url1, Url2, Url3, Url4,],
      Redes:{
        Instagram:{Link: Instag, Ativo: InstagVer },
        Facebook:{Link:Face , Ativo:FaceVer },
        Localizacao:{Link:Loc , Ativo:LocVer }
      },
      Funcionamento:Funciona,
      Endereco:{
        Cidade:Cidade, 
        Estado:Estado, 
        Rua:Rua, 
        Numero:Num, 
        Bairro:Bairro,
        Lng:parseFloat(Lng), 
        Lat:parseFloat(Lat), 
      },
      Pix:{
      Nome:NomePix,
      Numero:NumPix,
      Tipo:TipPix,
      },
      BairroEntregas:BairroEnt,
      TaxaPorBairro:EndBairro,
      TaxaPorLocalizacao:false,

    }).then((doc)=>{
      setCarreg(false)
      setAlert("Salvo com Sucesso!");
        setAlertTipo("success");
   
   
     })

  },

    DadasEmp: async(Dados, setQuant, setUsuariosContServ,  setCarreg)=> {
   
       console.log("Ver Status "+status)
        const dados = await db.collection('EmrpesaSite')
        .doc(EMPRESA)
        .onSnapshot(async(dados)=>{
          setUsuariosContServ(dados.data());
          setCarreg(false)
  
         }); 
       
      
      
      
    },

    DadasEmpresasIni: async(Dados, setDadEmp,  setCarreg, setVisitante)=> {
   
   
    

      if(EMPRESA){

     var Emp = {} 
      const dados = await db.collection('EmrpesaSite')
      .doc(EMPRESA)
      .onSnapshot(async(dados)=>{
        setDadEmp(dados.data());
        setCarreg(false)
       
       }); 
      
       if(Emp){
     
        }

  var sfDocRef = db.collection('EmrpesaSite').doc(EMPRESA);

// Uncomment to initialize the doc.
// sfDocRef.set({ population: 0 });

return db.runTransaction((transaction) => {
    // This code may get re-run multiple times if there are conflicts.
    return transaction.get(sfDocRef).then((sfDoc) => {
        if (!sfDoc.exists) {
            throw "Document does not exist!";
        }

        // Add one person to the city population.
        // Note: this could be done without a transaction
        //       by updating the population using FieldValue.increment()
        var newPopulation = sfDoc.data().Visitantes + 1;
        transaction.update(sfDocRef, { Visitantes: newPopulation });
        setVisitante(newPopulation)
      });
}).then((doc) => {
 
    console.log(doc);
}).catch((error) => {
    console.log("Transaction failed: ", error);
});
    

}
    
    
    
  },

  MenusItens: async(Email, Tag, Menu, setItensGeral, setCarreg )=> {
   if(Tag === "" && Menu === ""){
    var res = [];
    const dados = await db.collection('MenusSite')
    .where("Empresa", "==", EMPRESA)
    .where("Ativo", "==", true)
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
         res.push({
          nome:doc.data().nome,
          Tags:doc.data().Tags,
         })
        });
    })
    
    
    var resList = [];

    for(let i in res){
     var List = []
      await db.collection('ItensDaEmpresa')
      .where("Empresa", "==", EMPRESA)
      .where("Menu", "==", res[i].nome)
       .where("Ativo", "==", true)
       .get()
       .then((querySnapshot) => {
           querySnapshot.forEach((doc) => {
             List.push({
             id:doc.id,
             nome:doc.data().nome,
             Descricao:doc.data().Descricao,
             foto:doc.data().foto,
             Preco:doc.data().Preco,
             PrecoReal:doc.data().PrecoReal,
             Descont:doc.data().Descont,
             DescontReal:doc.data().DescontReal,
             Tags:doc.data().Tags,
            })
           });
       })
       resList.push({
        nome:res[i].nome,
        Ref:"#"+res[i].nome,
        Tags:res[i].Tags,
        ListaItens:List
       })

    }
    

  
     
      setItensGeral(resList);
      setCarreg(false)

   } else {

    var res = [];
    const dados = await db.collection('MenusSite')
    .where("Empresa", "==", EMPRESA)
    .where("Ativo", "==", true)
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
         res.push({
          nome:doc.data().nome,
          Tags:doc.data().Tags,
         })
        });
    })
    
    
    var resList = [];

    for(let i in res){
     var List = []
      await db.collection('ItensDaEmpresa')
      .where("Empresa", "==", EMPRESA)
      .where("Menu", "==", res[i].nome)
       .where("Ativo", "==", true)
       .get()
       .then((querySnapshot) => {
           querySnapshot.forEach((doc) => {
            if(res[i].nome === Menu){
             if(doc.data().Tags.includes(Tag)){
              List.push({
                id:doc.id,
                nome:doc.data().nome,
                Descricao:doc.data().Descricao,
                foto:doc.data().foto,
                Preco:doc.data().Preco,
                PrecoReal:doc.data().PrecoReal,
                Descont:doc.data().Descont,
                DescontReal:doc.data().DescontReal,
                Tags:doc.data().Tags,
               })
             }

            } else {
              List.push({
                id:doc.id,
                nome:doc.data().nome,
                Descricao:doc.data().Descricao,
                foto:doc.data().foto,
                Preco:doc.data().Preco,
                PrecoReal:doc.data().PrecoReal,
                Descont:doc.data().Descont,
                DescontReal:doc.data().DescontReal,
                Tags:doc.data().Tags,
               })

            }
            
           });
       })
       resList.push({
        nome:res[i].nome,
        Ref:"#"+res[i].nome,
        Tags:res[i].Tags,
        ListaItens:List
       })

    }
    

  
     
      setItensGeral(resList);
      setCarreg(false)
   }
   

    
   
  
  
  
},

ItensVendidoHoje: async(DatIni, DatFim, setItens)=> {
   console.log()
  var res = [];
   await db.collection('MesaItem')
  .where("Empresa", "==", EMPRESA)
  .where("Fechado", "==", true)
  .where("dataCriacao", ">=", DatIni)
  .where("dataCriacao", "<=", DatFim)
  .onSnapshot((querySnapshot) => {
     console.log(querySnapshot.size)
      querySnapshot.forEach((doc) => {
       res.push({
        id:doc.id,
        Producao:doc.data().Producao,
        dataCriacao:doc.data().dataCriacao,
        Itens:doc.data().Itens,
        Mesa:doc.data().Mesa,
        Codigo:doc.data().Codigo?doc.data().Codigo:"",
       })
      });
      setItens(res)
    
  })
  
 
 
  
 
 
 
 
 },

PedidoMesaFiltro: async(Ddat, Adat, FechAti, MesaVer, setLoading, setQuant, setUsuariosContServ,  setAbrirFilt)=> {
 
 var res = [];
  await db.collection('MesaItem')
 .where("Empresa", "==", EMPRESA)
 .where("Mesa", "==", MesaVer)
 .where("Fechado", "==", FechAti)
 .where("dataCriacao", ">=", Ddat)
 .where("dataCriacao", "<=", Adat)
 .get()
 .then((querySnapshot) => {
   setQuant(querySnapshot.size);
     querySnapshot.forEach((doc) => {
      res.push({
        Tel:doc.data().TelCli,
       NomeCli:doc.data().NomeCli?doc.data().NomeCli:"",
       id:doc.id,
       Cliente:doc.data().Cliente,
       Codigo:doc.data().Codigo?doc.data().Codigo:"",
       ComissaoEntrega:doc.data().ComissaaEntrega,
       ConcluidoEntregado:doc.data().ConcluidoEntregado,
       ConcluidoProducao:doc.data().ConcluidoProducao,
       ConfirmacaoPedido:doc.data().ConfirmacaoPedido,
       End:doc.data().End,
       ExtratoPix:doc.data().ExtratoPix,
       FormaDepagamento:doc.data().FormaDepagamento,
       IdChat:doc.data().IdChat,
       IniciandoEntrega:doc.data().IniciandoEntrega,
       IniciandoProducao:doc.data().IniciandoProducao,
       Itens:doc.data().Itens,
       TelEntregador:doc.data().TelEntregador,
       ValorEntrega:doc.data().ValorEntrega,
       ValorTotaL:doc.data().ValorTotaL,
       dataCriacao:doc.data().dataCriacao,
       Entrega:doc.data().Entrega,
       ObervacaoPedido:doc.data().ObervacaoPedido?doc.data().ObervacaoPedido:"",
       TrocoDinheiro:doc.data().TrocoDinheiro?doc.data().TrocoDinheiro:"",
       localizacaoGps:doc.data().localizacaoGps?doc.data().localizacaoGps.lng?doc.data().localizacaoGps:null:null,
       Pix:doc.data().Pix,
       Cartao:doc.data().Cartao,
       Dinheiro:doc.data().Dinheiro,
       TaxaPorBairro:doc.data().TaxaPorBairro?doc.data().TaxaPorBairro:false,
       Buscar:doc.data().Buscar?doc.data().Buscar:false,
       EndProximo:doc.data().EndProximo?doc.data().EndProximo:false,
       IdChat:doc.data().IdChat?doc.data().IdChat:null,
       CanalChat:doc.data().CanalChat?doc.data().CanalChat:null, 
       RoboAtivo:doc.data().RoboAtivo === false?doc.data().RoboAtivo:true, 
       ClienteEsc:doc.data().ClienteEsc?doc.data().ClienteEsc:false,
       PedConstruido:doc.data().PedConstruido,
       TituloAcrescimo:doc.data().TituloAcrescimo?doc.data().TituloAcrescimo:"",
       ValorAcrescimo:doc.data().ValorAcrescimo?doc.data().ValorAcrescimo:"",
       NomeEntregador:doc.data().NomeEntregador?doc.data().NomeEntregador:"",
       TimeAtendimento1:doc.data().TimeAtendimento1?doc.data().TimeAtendimento1:null,
       UltimaMsg:doc.data().UltimaMsg?doc.data().UltimaMsg:{body:"", date:0, Type:null  },
      })
     });
     setUsuariosContServ(res)
     setLoading(false)
     setAbrirFilt(false)
 })
 


 




},

PedidoMesa: async(Mver, setLoading, setQuant, setUsuariosContServ )=> {
   console.log(Mver)
  var res = [];
   await db.collection('MesaItem')
  .where("Empresa", "==", EMPRESA)
  .where("Mesa", "==", Mver)
  .where("Fechado", "==", false)
  .onSnapshot((querySnapshot) => {
    setQuant(querySnapshot.size);
      querySnapshot.forEach((doc) => {
       res.push({
        id:doc.id,
        Producao:doc.data().Producao,
        dataCriacao:doc.data().dataCriacao,
        Itens:doc.data().Itens,
        Mesa:doc.data().Mesa,
        Codigo:doc.data().Codigo?doc.data().Codigo:"",
       })
      });
      setUsuariosContServ(res)
      setLoading(false)
  })
  
 

  
 



},

PedidoDelivery: async(Dados, setLoading, setQuant, setUsuariosContServ )=> {
 

 

  await db.collection('MesaItem')
 .where("Empresa", "==", EMPRESA)
 .where("Mesa", "==", "Externo")
 .where("Fechado", "==", false)
 .onSnapshot( async (querySnapshot) => {
  var res = [];
   setQuant(querySnapshot.size);
     querySnapshot.forEach((doc) => {
      res.push({
       Tel:doc.data().TelCli,
       NomeCli:doc.data().NomeCli?doc.data().NomeCli:"",
       id:doc.id,
       Cliente:doc.data().Cliente,
       Codigo:doc.data().Codigo?doc.data().Codigo:"",
       ComissaoEntrega:doc.data().ComissaaEntrega,
       ConcluidoEntregado:doc.data().ConcluidoEntregado,
       ConcluidoProducao:doc.data().ConcluidoProducao,
       ConfirmacaoPedido:doc.data().ConfirmacaoPedido,
       End:doc.data().End,
       ExtratoPix:doc.data().ExtratoPix,
       FormaDepagamento:doc.data().FormaDepagamento,
       IdChat:doc.data().IdChat,
       IniciandoEntrega:doc.data().IniciandoEntrega,
       IniciandoProducao:doc.data().IniciandoProducao,
       Itens:doc.data().Itens,
       TelEntregador:doc.data().TelEntregador,
       ValorEntrega:doc.data().ValorEntrega,
       ValorTotaL:doc.data().ValorTotaL,
       dataCriacao:doc.data().dataCriacao,
       Entrega:doc.data().Entrega,
       ObervacaoPedido:doc.data().ObervacaoPedido?doc.data().ObervacaoPedido:"",
       TrocoDinheiro:doc.data().TrocoDinheiro?doc.data().TrocoDinheiro:"",
       localizacaoGps:doc.data().localizacaoGps?doc.data().localizacaoGps.lng?doc.data().localizacaoGps:null:null,
       Pix:doc.data().Pix,
       Cartao:doc.data().Cartao,
       Dinheiro:doc.data().Dinheiro,
       TaxaPorBairro:doc.data().TaxaPorBairro?doc.data().TaxaPorBairro:false,
       Buscar:doc.data().Buscar?doc.data().Buscar:false,
       EndProximo:doc.data().EndProximo?doc.data().EndProximo:false,
       IdChat:doc.data().IdChat?doc.data().IdChat:null,
       CanalChat:doc.data().CanalChat?doc.data().CanalChat:null, 
       RoboAtivo:doc.data().RoboAtivo === false?doc.data().RoboAtivo:true, 
       ClienteEsc:doc.data().ClienteEsc?doc.data().ClienteEsc:false,
       PedConstruido:doc.data().PedConstruido,
       TituloAcrescimo:doc.data().TituloAcrescimo?doc.data().TituloAcrescimo:"",
       ValorAcrescimo:doc.data().ValorAcrescimo?doc.data().ValorAcrescimo:"",
       NomeEntregador:doc.data().NomeEntregador?doc.data().NomeEntregador:"",
       TimeAtendimento1:doc.data().TimeAtendimento1?doc.data().TimeAtendimento1:null,
       UltimaMsg:doc.data().UltimaMsg?doc.data().UltimaMsg:{body:"", date:0, Type:null  },
       AcertComDono:doc.data().AcertComDono?doc.data().AcertComDono:false, 
       ComeAqui:doc.data().ComeAqui?doc.data().ComeAqui:false, 
      })
     });
 

     res.sort((a,b)=>{
      if(a.dataCriacao < b.dataCriacao) {
        return 1;
      } else {
        return -1;
      }
    });
  
 
setUsuariosContServ(res)
setLoading(false)
   
 })
 
 




},

  MeusMenus: async(Dados, setVerMenus, setItensGeral )=> {
   
    var res = [];
    const dados = await db.collection('MenusSite')
    .where("Empresa", "==", EMPRESA)
    .where("Ativo", "==", true)
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
         res.push({
          select:doc.data().nome,
          Tags:doc.data().Tags,
          Tamanho:doc.data().Tamanho,
          GrupTamanho:doc.data().GrupTamanho,
         })
        });
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });
   
      setVerMenus(res);

      var resList = [];
     await db.collection('ItensGerais')
      .where("Ativo", "==", true)
      .get()
      .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            resList.push({
            id:doc.id,
            select:doc.data().nome,
            Descricao:doc.data().Descricao,
            foto:doc.data().foto,
            Preco:doc.data().Preco,
            
           })
          });
      })
      .catch((error) => {
          console.log("Error getting documents: ", error);
      });
     
      setItensGeral(resList);
 

    
   
  
  
  
},

    DesativandoTelefone: async(Dados, Id, setAlertTipo, setAlert)=> {
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      const Setor = "Desativando Telefone Serv";
      await db.collection("telefone").doc(Id).update({
       "ativo":false, 
      }).then(()=>{
        setAlert("Desativado com Sucesso");
        setAlertTipo("success");
        db.collection("movimentacao").add({
          id:id,
          instituicao: Dados.instituicao,
          cidade: Dados.cidade,
          estado: Dados.estado,
          Conta: Dados.conta.serv.tipo,
          acao:"Atualizar",
          setor: Setor,
          data:firebase.firestore.FieldValue.serverTimestamp(),
          idSofrer:Id,
          })
  
      });
    },

    AtivandoEntregador: async(id,  setAlertTipo, setAlert, setModalVer, setTelVer, setContVer )=> {
     
      await db.collection("Entregadores").doc(id).update({
        Ativo:true, 
      }).then(()=>{
        setAlert("Ativado com Sucesso");
        setAlertTipo("success");
        setModalVer(false);
        setTelVer("");
        setContVer()
  
      });
    },
    DesativandoEntregador: async(id,  setAlertTipo, setAlert, setModalVer, setTelVer, setContVer )=> {
     
      await db.collection("Entregadores").doc(id).update({
        Ativo:false, 
      }).then(()=>{
        setAlert("Desativado com Sucesso");
        setAlertTipo("success");
        setModalVer(false);
        setTelVer("");
        setContVer()
  
      });
    },

    ExcluindoEntregador: async(id,  setAlertTipo, setAlert, setModalVer, setTelVer, setContVer )=> {
     
      await db.collection("Entregadores").doc(id).delete({
        Ativo:false, 
      }).then(()=>{
        setAlert("Excluido com Sucesso");
        setAlertTipo("success");
        setModalVer(false);
        setTelVer("");
        setContVer()
  
      });
    },
   MudandoConta: async(List,  setAlertTipo, setAlert, setModalVer, setTelVer, setContVer )=> {
     
      await db.collection("EmrpesaSite").doc(EMPRESA).update({
        Contas:List, 
      }).then(()=>{
        setAlert("Modificado com Sucesso");
        setAlertTipo("success");
        setModalVer(false);
        setTelVer("");
        setContVer()
  
      });
    },


    AtivandoTelefone: async(Dados, Id, setAlertTipo, setAlert)=> {
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      const Setor = "Ativando Telefone Serv";
      await db.collection("telefone").doc(Id).update({
       "ativo":true, 
      }).then(()=>{
        setAlert("Ativado com Sucesso");
        setAlertTipo("success");
        db.collection("movimentacao").add({
          id:id,
          instituicao: Dados.instituicao,
          cidade: Dados.cidade,
          estado: Dados.estado,
          Conta: Dados.conta.serv.tipo,
          acao:"Atualizar",
          setor: Setor,
          data:firebase.firestore.FieldValue.serverTimestamp(),
          idSofrer:Id,
          })
  
      });
    },

    AvisandoMsg: async(Dados, setAvisando)=> {
    
  



    //   var TiraPalavra = [" tamanho ", "na", "com borda", "na",  "ne", " quero ", " quero ", " uma ", " sabor ",  " eu ", " querer ", " quere", " vou ", "vou ", " pra ", " mim ", " meu ", "meu ", " bem ", " faz ", " por ", " por ", " favor ", " de ", " sabor ", " sabor ",  " mais ", " pedir ",  ]
      var PalQuant = ["2", "1", "1"]
    // var QuantRepet = 0;
    // var TagMModi = " pizza "
      var Msg = "Boa noite, uma pizza familia sabor três queijos, pizza nordestina e frango catupiry, um refri de 1 litro guarana e uma vitamina de graviola"
     var Ned = Msg.indexOf("pizza", 2)

      //   const regex = new RegExp(TagMModi, "g");
    //   QuantRepet = Msg.match(regex).length
    
     

      //   var MsgArray = Msg.toLowerCase().split(" ") 
      
    //   var VerItens = [];
    //   var Itens = [];
    //   var Tema = "";
    
   
     

    //   var SesseaoMenus = []
    //   await db.collection("MenusSite")
    //   .where("Empresa", "==", EMPRESA)
    //   .get().then(async (querySnapshot23) => {
    //       await querySnapshot23.forEach((doc23) => {

    //          SesseaoMenus.push({
    //               id:doc23.id,
    //               body:doc23.data().nome,
    //               GrupTamanho:doc23.data().GrupTamanho,
    //               MemFim:doc23.data().MemFim,
    //               Tamanho:doc23.data().Tamanho,
    //               Ativo:doc23.data().Ativo,
    //           })
          
    //           })

    //   });

    //   //Pegando os itens 
    //   var Menus = [];
    //   var SubMenus = [];
    //   var ItensMenus = [];
    //   for(let i in SesseaoMenus){
    //       if(SesseaoMenus[i].Tamanho){
    //           //Pegou todos os tamanhos de cada sessão 
    //           for(let l in SesseaoMenus[i].GrupTamanho){
    //            var Letra1 = SesseaoMenus[i].GrupTamanho[l].Tamanho.replaceAll(" ", "").substr(0, 1).toLowerCase();
    //            var Letra2 = SesseaoMenus[i].GrupTamanho[l].Tamanho.replaceAll(" ", "").substr(1, 1).toLowerCase();
    //            var ArrTemas = [`${Letra1}${Letra2} `, ` ${Letra1}${Letra2}`, `  ${Letra1}`, `${Letra1} ${Letra2}`, ` ${Letra1} `]
               
    //               Menus.push({
    //                   Descont:SesseaoMenus[i].GrupTamanho[l].DescontReal,
    //                   Nome: SesseaoMenus[i].GrupTamanho[l].Tamanho,
    //                   Preco: SesseaoMenus[i].GrupTamanho[l].PrecoReal,
    //                   QuantSb:SesseaoMenus[i].GrupTamanho[l].Qsabor,
    //                   body: SesseaoMenus[i].GrupTamanho[l].DescontReal?SesseaoMenus[i].GrupTamanho[l].Tamanho+"\n"+"❤️ De: "+"~"+SesseaoMenus[i].GrupTamanho[l].PrecoReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"~"+" Por "+SesseaoMenus[i].GrupTamanho[l].DescontReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"+"===================\n"  :    SesseaoMenus[i].GrupTamanho[l].Tamanho+"\n"+"💰 "+SesseaoMenus[i].GrupTamanho[l].PrecoReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"+"===================\n" ,
    //                   MemFim:SesseaoMenus[i].MemFim,
    //                   Sessao:SesseaoMenus[i].body,
    //                   AtivoSessao:SesseaoMenus[i].Ativo,
    //                   AtivoTamanho:SesseaoMenus[i].GrupTamanho[l].Ativo,
    //                   Temas:ArrTemas,
    //               })
    //       }

          

  
   
    //       await db.collection("ItensDaEmpresa")
    //       .where("Empresa", "==", EMPRESA)
    //       .where("Menu", "==", SesseaoMenus[i].body)
    //       .get().then(async (querySnapshot23) => {
             
    //           await querySnapshot23.forEach((doc23) => {

    //               SubMenus.push({
                   
    //                   Descricao:doc23.data().Descricao,
    //                   Nome: doc23.data().nome,
    //                   Quant: doc23.data().Quant,
    //                   Ilimitado:doc23.data().Ilimitado,
    //                   foto: doc23.data().foto,
    //                   id: doc23.id,
    //                   GrupTamanho:doc23.data().GrupTamanho,
    //                   Sessao:SesseaoMenus[i].body,
    //                   AtivoSabor:doc23.data().Ativo,
    //               })
              
    //               })

    //       });

         

     
    //       for(let l in SubMenus){
    //           for(let m in SubMenus[l].GrupTamanho){
    //               for(let j in Menus){
                     
    //                       if(SubMenus[l].Sessao === Menus[j].Sessao){
    //                           if(SubMenus[l].GrupTamanho[m].select === Menus[j].Nome){
                                 
    //                                   ItensMenus.push({
    //                                       Descont: Menus[j].Descont,
    //                                       Tamanho: Menus[j].Nome,
    //                                       ComTam:true,
    //                                       Preco:Menus[j].Preco,
    //                                       QuantSb:Menus[j].QuantSb,
    //                                       body: Menus[j].body ,
    //                                       MemFim:Menus[j].MemFim,
    //                                       Sessao:Menus[j].Sessao,
    //                                       Descricao:SubMenus[l].Descricao,
    //                                       Nome:SubMenus[l].Nome,
    //                                       Quant:SubMenus[l].Quant,
    //                                       Ilimitado:SubMenus[l].Ilimitado,
    //                                       foto:SubMenus[l].foto,
    //                                       AtivoTamanho:Menus[j].AtivoTamanho === false ? false:SubMenus[l].GrupTamanho[m].Ativo,
    //                                       AtivoSabor:SubMenus[l].AtivoSabor,
    //                                       AtivoSessao:Menus[j].AtivoSessao,
    //                                       Temas:Menus[j].Temas,
    //                                      })

                                     
                                
    //                           }

    //                       }

                      
                
                  
    //           }
    //           }
    //       }

      
         

         

          
          

    //       }else {
    //           await db.collection("ItensDaEmpresa")
    //           .where("Empresa", "==", EMPRESA)
    //           .where("Menu", "==", SesseaoMenus[i].body)
    //           .get().then(async (querySnapshot23) => {
                 
    //               await querySnapshot23.forEach((doc23) => {

    //                   ItensMenus.push({
    //                       ComTam:false,
    //                       Descont:doc23.data().DescontReal,
    //                       Descricao:doc23.data().Descricao,
    //                       Nome: doc23.data().nome,
    //                       Preco: doc23.data().PrecoReal,
    //                       Quant: doc23.data().Quant,
    //                       Ilimitado:doc23.data().Ilimitado,
    //                       foto: doc23.data().foto,
    //                       id: doc23.id,
    //                       Observacao: "",
    //                       body:doc23.data().Descricao ?  doc23.data().DescontReal?"📦 *"+doc23.data().nome+"* "+"\n"+"📝 Ingredientes: "+doc23.data().Descricao+"\n"+"❤️ De: "+"~"+doc23.data().PrecoReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"~"+" Por "+doc23.data().DescontReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"+"===================\n"  :  "📦 *"+doc23.data().nome+"* "+"\n"+"📝Ingredientes:"+doc23.data().Descricao+"\n"+"💰 "+doc23.data().PrecoReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"+"===================\n":doc23.data().DescontReal?"📦 *"+doc23.data().nome+"* "+"\n"+"❤️ De: "+"~"+doc23.data().PrecoReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"~"+" Por "+doc23.data().DescontReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"+"===================\n"  :   "📦 *"+doc23.data().nome+"* "+"\n"+"💰 "+doc23.data().PrecoReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"+"===================\n" ,
    //                       Tamanho:"",
    //                       ItemEspeci:false,
    //                       Sessao:SesseaoMenus[i].body,
    //                       MemFim:SesseaoMenus[i].MemFim,
    //                       AtivoTamanho:false,
    //                       AtivoSabor:doc23.data().Ativo,
    //                       AtivoSessao:SesseaoMenus[i].Ativo,
    //                       Temas:[],
    //                   })
                  
    //                   })

    //           });
        
    //       }
    //   }
      

      
    //   ItensMenus = ItensMenus.filter(function (a) {
    //       return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    //   }, Object.create(null))


    //  console.log(ItensMenus)
    //   var Pronto = false;

    //     //Remonto a frase
    //         var MatReg = []
    //         for(let i in MsgArray){
              
    //           if(i == 0){
    //             MatReg.push(MsgArray[i].length)
    //           } else{
    //             MatReg.push(MsgArray[i].length+3)
    //           }
    //         }
            
    //         // Posição da frase
    //         var Calc =[];
    //         for(let i in MatReg){
    //          if(i == 0){
    //            Calc.push({
    //              ini: 0,
    //              fim:MatReg[i]-1
    //            })
    //          } else{
    //            Calc.push({
    //              ini:Calc[i-1].fim-1,
    //              fim:(Calc[i-1].fim+MatReg[i]-1)-1
    //            })
    //          }
       
    //         }
    //         Java3foobarScript
    //         console.log(MatReg)
    //         console.log(Calc)
    //       //Divido a nova frase
    //         var DivNome4 = []
    //         for (var i = 0; i <= Msg.length-4; i++) {
           
    //           DivNome4.push(Msg.toLowerCase().slice(i, (i+4)))
              
    //       }
    //         console.log(DivNome4)

  //     for (let a = 0; a < 3; a++) {
  //     console.log("Contage "+a)
  //       if (Pronto === true) {//Quando não tiver mais nada pra analizar
  //          break;
  //       }

  //      if(Itens.length > 0 ){//Se tiver Vamos ver Se tem tamanho e sabor
  //       for(let d in Itens){//Analisando os Itens
  //         if(Itens[d].ItemComTam === true){//Se tiver tamanho 
  //         if(Itens[d].SubSessao !== ""){//Preenchendo a Sessão
            
  //           var ItemComTam = false;
  //           var Sessao = "";
  //           var GrupSessao =[];
  //           var AtiSessao = false;
  //           var Tamanho = "";
  //           var Sabor = "";
             
  //           //Remonto a frase
  //           var MatReg = []
  //           for(let i in MsgArray){
              
  //             if(i == 0){
  //               MatReg.push(MsgArray[i].length)
  //             } else{
  //               MatReg.push(MsgArray[i].length+3)
  //             }
  //           }
            
  //           // Posição da frase
  //           var Calc =[];
  //           for(let i in MatReg){
  //            if(i == 0){
  //              Calc.push({
  //                ini: 0,
  //                fim:MatReg[i]-1
  //              })
  //            } else{
  //              Calc.push({
  //                ini:Calc[i-1].fim-1,
  //                fim:(Calc[i-1].fim+MatReg[i]-1)-1
  //              })
  //            }
       
  //           }
    
  //           console.log(MatReg)
  //           console.log(Calc)
  //         //Divido a nova frase
  //           var DivNome4 = []
  //           for (var i = 0; i <= Msg.length-4; i++) {
           
  //             DivNome4.push(Msg.toLowerCase().slice(i, (i+4)))
              
  //         }
  //           console.log(DivNome4)
    
  //           var NotSessao = "";
  //           var QuatSes = 0;
  //           for(let j in DivNome4){
             
  //              for(let i in ItensMenus){
  //                 //Vendo Se Foi escrita a Sessão                                                                                 
  //                if(ItensMenus[i].Sessao === Itens[d].Sessao){
 
  //                           //   NotSessao === ItensMenus[i].Sessao
  //                           //  GrupSessao.push(ItensMenus[i])  
  //                           //  Sessao = ItensMenus[i].Sessao;
  //                           //  AtiSessao = ItensMenus[i].AtivoSessao;
  //                           //  ItemComTam = ItensMenus[i].ComTam; 
  //                     } 
  //                   }     
  //                 if(NotSessao){   
                     
  //                    } else {
  //                       //caçando o index da pagina
  //                      var Ind = 0;
  //                        console.log("Pisiçao Divisal "+j)
    
    
  //                        for(let l in Calc){//Pegando a posição da Palavra achada
                          
  //                          if(Calc[l].ini < j && j < Calc[l].fim){
  //                            console.log("Pisiçao Frase "+l)
  //                            Ind = l
  //                          }
  //                        }
    
  //                        console.log(MsgArray[Ind-1])
                         
  //                         if(MsgArray[Ind-1] === "dois" || MsgArray[Ind-1] === "2" || MsgArray[Ind-1] === "duas"){
  //                           console.log("Entrou Aqui ")
                             
  //                             QuatSes=2;
  //                          } else if(MsgArray[Ind-1] === "três" || MsgArray[Ind-1] === "3" || MsgArray[Ind-1] === "tres"){
  //                           console.log("Entrou Aqui ")
                             
  //                             QuatSes=3;
  //                          } else {
    
  //                           QuatSes=1;
         
  //                          }
    
                        
                        
    
  //                        console.log("Pisiçao Frase Ind "+MsgArray[Ind])
  //                        //var RemoEle = MsgArray.indexOf(Ind)
                      
  //                        MsgArray = MsgArray.filter((item, index) => item !== MsgArray[Ind] );
       
  //                        console.log(MsgArray)
  //                        var MsgEdit = ""
  //                        for(let b in MsgArray){
  //                          MsgEdit = MsgEdit+MsgArray[b]+" " 
  //                        }
  //                        Msg = MsgEdit;
  //                        console.log(Msg)
       
       
  //                        NotSessao = ItensMenus[i].Sessao
  //                        GrupSessao.push(ItensMenus[i])
  //                        Sessao = ItensMenus[i].Sessao;
  //                        AtiSessao = ItensMenus[i].AtivoSessao;
  //                        ItemComTam = ItensMenus[i].ComTam; 
  //                    }
                     
                 
       
                 
                 
       
            
             
  //          }
        
  //          console.log("Sessao "+NotSessao)
  //          VerItens.push({
  //           Ativado:AtiSessao,
  //           Sessao:NotSessao,
  //          })
  //       if(AtiSessao){  
  //        if(QuatSes === 2){
  //           Itens.push({
  //         Date:new Date().getTime(),
  //         Descont:0,
  //         Descricao:[],
  //         Foto:[],
  //         ItemEspeci:true,
  //         Nome:[],
  //         Preco:0,
  //         Quant:1,
  //         Sessao:NotSessao,
  //         SubSessao:"",
  //         ItemComTam:ItemComTam
  //        }, 
  //        {
  //         Date:new Date().getTime(),
  //         Descont:0,
  //         Descricao:[],
  //         Foto:[],
  //         ItemEspeci:true,
  //         Nome:[],
  //         Preco:0,
  //         Quant:1,
  //         Sessao:NotSessao,
  //         SubSessao:"",
  //         ItemComTam:ItemComTam
  //        })
    
  //        } else  if(QuatSes === 3){
  //         Itens.push({
  //       Date:new Date().getTime(),
  //       Descont:0,
  //       Descricao:[],
  //       Foto:[],
  //       ItemEspeci:true,
  //       Nome:[],
  //       Preco:0,
  //       Quant:1,
  //       Sessao:NotSessao,
  //       SubSessao:"",
  //       ItemComTam:ItemComTam
  //      }, 
  //      {
  //       Date:new Date().getTime(),
  //       Descont:0,
  //       Descricao:[],
  //       Foto:[],
  //       ItemEspeci:true,
  //       Nome:[],
  //       Preco:0,
  //       Quant:1,
  //       Sessao:NotSessao,
  //       SubSessao:"",
  //       ItemComTam:ItemComTam
  //      },
  //      {
  //       Date:new Date().getTime(),
  //       Descont:0,
  //       Descricao:[],
  //       Foto:[],
  //       ItemEspeci:true,
  //       Nome:[],
  //       Preco:0,
  //       Quant:1,
  //       Sessao:NotSessao,
  //       SubSessao:"",
  //       ItemComTam:ItemComTam
  //      },
       
  //      )
    
  //      } else {
  //         Itens.push({
  //           Date:new Date().getTime(),
  //           Descont:0,
  //           Descricao:[],
  //           Foto:[],
  //           ItemEspeci:true,
  //           Nome:[],
  //           Preco:0,
  //           Quant:1,
  //           Sessao:NotSessao,
  //           SubSessao:"",
  //           ItemComTam:ItemComTam
  //          } )
    
  //        } 
    
  //       }
  //          }else{

  //         }

  //         } else {

  //         } 
        
  //       }

  //      } else {//Entra aqui se não tiver Itens na lista

  //     var ItemComTam = false;
  //     var Sessao = "";
  //     var GrupSessao =[];
  //     var AtiSessao = false;
  //     var Tamanho = "";
  //     var Sabor = "";

  //       var MatReg = []
  //       for(let i in MsgArray){
          
  //         if(i == 0){
  //           MatReg.push(MsgArray[i].length)
  //         } else{
  //           MatReg.push(MsgArray[i].length+3)
  //         }
  //       }
        

  //       var Calc =[];
  //       for(let i in MatReg){
  //        if(i == 0){
  //          Calc.push({
  //            ini: 0,
  //            fim:MatReg[i]-1
  //          })
  //        } else{
  //          Calc.push({
  //            ini:Calc[i-1].fim-1,
  //            fim:(Calc[i-1].fim+MatReg[i]-1)-1
  //          })
  //        }
   
  //       }

  //       console.log(MatReg)
  //       console.log(Calc)

  //       var DivNome4 = []
  //       for (var i = 0; i <= Msg.length-4; i++) {
       
  //         DivNome4.push(Msg.toLowerCase().slice(i, (i+4)))
          
  //     }
  //       console.log(DivNome4)

  //       var NotSessao = "";
  //       var QuatSes = 0;
  //       for(let j in DivNome4){
         
  //          for(let i in ItensMenus){
  //             //Vendo Se Foi escrita a Sessão                                                                                 
  //            if(ItensMenus[i].Sessao.toLowerCase().includes(DivNome4[j])){
  //                if(NotSessao){
  //                    if(NotSessao === ItensMenus[i].Sessao){
   
  //                        GrupSessao.push(ItensMenus[i])
                        
  //                        Sessao = ItensMenus[i].Sessao;
  //                        AtiSessao = ItensMenus[i].AtivoSessao;
  //                        ItemComTam = ItensMenus[i].ComTam; 
  //                    }
                 
  //                } else {
  //                   //caçando o index da pagina
  //                  var Ind = 0;
  //                    console.log("Pisiçao Divisal "+j)


  //                    for(let l in Calc){//Pegando a posição da Palavra achada
                      
  //                      if(Calc[l].ini < j && j < Calc[l].fim){
  //                        console.log("Pisiçao Frase "+l)
  //                        Ind = l
  //                      }
  //                    }

  //                    console.log(MsgArray[Ind-1])
                     
  //                     if(MsgArray[Ind-1] === "dois" || MsgArray[Ind-1] === "2" || MsgArray[Ind-1] === "duas"){
  //                       console.log("Entrou Aqui ")
                         
  //                         QuatSes=2;
  //                      } else if(MsgArray[Ind-1] === "três" || MsgArray[Ind-1] === "3" || MsgArray[Ind-1] === "tres"){
  //                       console.log("Entrou Aqui ")
                         
  //                         QuatSes=3;
  //                      } else {

  //                       QuatSes=1;
     
  //                      }

                    
                    

  //                    console.log("Pisiçao Frase Ind "+MsgArray[Ind])
  //                    //var RemoEle = MsgArray.indexOf(Ind)
                  
  //                    MsgArray = MsgArray.filter((item, index) => item !== MsgArray[Ind] );
   
  //                    console.log(MsgArray)
  //                    var MsgEdit = ""
  //                    for(let b in MsgArray){
  //                      MsgEdit = MsgEdit+MsgArray[b]+" " 
  //                    }
  //                    Msg = MsgEdit;
  //                    console.log(Msg)
   
   
  //                    NotSessao = ItensMenus[i].Sessao
  //                    GrupSessao.push(ItensMenus[i])
  //                    Sessao = ItensMenus[i].Sessao;
  //                    AtiSessao = ItensMenus[i].AtivoSessao;
  //                    ItemComTam = ItensMenus[i].ComTam; 
  //                }
                 
  //            }
   
             
             
   
  //        }
         
  //      }
    
  //      console.log("Sessao "+NotSessao)
  //      VerItens.push({
  //       Ativado:AtiSessao,
  //       Sessao:NotSessao,
  //      })
  //   if(AtiSessao){  
  //    if(QuatSes === 2){
  //       Itens.push({
  //     Date:new Date().getTime(),
  //     Descont:0,
  //     Descricao:[],
  //     Foto:[],
  //     ItemEspeci:true,
  //     Nome:[],
  //     Preco:0,
  //     Quant:1,
  //     Sessao:NotSessao,
  //     SubSessao:"",
  //     ItemComTam:ItemComTam
  //    }, 
  //    {
  //     Date:new Date().getTime(),
  //     Descont:0,
  //     Descricao:[],
  //     Foto:[],
  //     ItemEspeci:true,
  //     Nome:[],
  //     Preco:0,
  //     Quant:1,
  //     Sessao:NotSessao,
  //     SubSessao:"",
  //     ItemComTam:ItemComTam
  //    })

  //    } else  if(QuatSes === 3){
  //     Itens.push({
  //   Date:new Date().getTime(),
  //   Descont:0,
  //   Descricao:[],
  //   Foto:[],
  //   ItemEspeci:true,
  //   Nome:[],
  //   Preco:0,
  //   Quant:1,
  //   Sessao:NotSessao,
  //   SubSessao:"",
  //   ItemComTam:ItemComTam
  //  }, 
  //  {
  //   Date:new Date().getTime(),
  //   Descont:0,
  //   Descricao:[],
  //   Foto:[],
  //   ItemEspeci:true,
  //   Nome:[],
  //   Preco:0,
  //   Quant:1,
  //   Sessao:NotSessao,
  //   SubSessao:"",
  //   ItemComTam:ItemComTam
  //  },
  //  {
  //   Date:new Date().getTime(),
  //   Descont:0,
  //   Descricao:[],
  //   Foto:[],
  //   ItemEspeci:true,
  //   Nome:[],
  //   Preco:0,
  //   Quant:1,
  //   Sessao:NotSessao,
  //   SubSessao:"",
  //   ItemComTam:ItemComTam
  //  },
   
  //  )

  //  } else {
  //     Itens.push({
  //       Date:new Date().getTime(),
  //       Descont:0,
  //       Descricao:[],
  //       Foto:[],
  //       ItemEspeci:true,
  //       Nome:[],
  //       Preco:0,
  //       Quant:1,
  //       Sessao:NotSessao,
  //       SubSessao:"",
  //       ItemComTam:ItemComTam
  //      } )

  //    } 

  //   }
  //      }
     
  //    }
    
 

    //  console.log(VerItens)
    //  console.log(Itens)


   



    


      
    
     

    
   
   

    











     // const client = new speech.blogger
    //  async function main() {
    //   const client = new JWT({
    //     email: "cwoapp@cwoapp-bd594.iam.gserviceaccount.com",
    //     key: "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQC3yMhrqVhAhg5H\nzqDRsq6AdyFuVZvqEX3atjRwdUzbUbOrPIQ+stKejU8yVuWW+QVhEby+0rVCM5HH\namxBoApxUgbq+W5vjBbMxr9FCw063u6O6CnmhqDHvoFVNNeZarvBSCkQ+5NQe84O\nP3h5cyBHmRl/cyenAroN9AfA6wQwEaAPTwEYjr73UFZZ39L5Cx5LQe7zc9BEycOe\nNnJIvSwDHgwJu575gDdNXPdPFCH17mZsh+irkIYrb57fpufLKLdBcPiH/YkFRro9\n7rG/0D0z95X+2sVyme44XegLOgOwnSujPX9N2UG7N0/9Ja0finue7zPFsB9qKBwn\nGjJNLx+HAgMBAAECggEABe+1BgjLoIZeqX6sd5mLtsKUHsEifQZg8sR9PD9b8RC9\npWc2keNyJb3SwmUO1I2T9ZHTxLRjcDv83XkC/iurAARHmyWkUHNp9ZCwj5rO5NBb\n9vf37S1s9r+hAIDpV61/zNfMv1ZZ2nkBuf+lgzwZpJn2uja5H9U8fifG3avylyAs\nkycgx8OHUZASdLYuR4Hh8r6W2WAoE5BFNIIzhkRGW9JgdW3sRkhp1QwhwgqS9Uf2\nVfoAItSYm+Jcx2k+T67gNNPpKiAYBhRNKe3sVt1F338xLTGBA+FGA+OT3M9++LoY\ndRnj4s+fOyX3xgW48qgLFXY27fb/9COoGPhuI7NBgQKBgQDn9hyJBvsdThzqVXjX\ngGciRIgVPgJtio+aF3wsoDP15tBQfKlMpWJlm3E4fixJ6w2gNWbXmztVhSJkJCUc\npO80y3V6PdaHm+1gRCrsHdvxo7AXTZaNSehnRAaWysg+q4oI9j131kUa1YOZ47RN\n8rLsi7fU6nKRC2VCj96kCdcONwKBgQDK1IspI9BDJepSqTkYqsR8rRBMhJlcCvfM\nZRmCSGfdrxtkEsbC562Ug8hqmXOgzrQoBD5Dzv6d3Ef9TKZZQOayp5PJxhp9vFmM\n7WfboK8xq/AglmQX531S8ok5qdBIyDX7YDu7HUnXOxHK5qG1O6n8RP2m6QkHFX8Z\na72gCapRMQKBgGSpEMkGFoMpGrM2VDJwrlDYnJVbS4Jt1tNvzZswClxzxYKoFnAE\ndSbSxddWKbIKJueXRQHbg2whUkNSzCgaCxRGFrztiONgbyqPanD8pC3AcvIp4WN+\n5zOo+ZMGfM91cXliIlqWyXZTocBuaBhLcgnkt+nVs9HtuAuik2NsQb8RAoGABWKX\nP0RgJyg+jGtJxMnj5ZuCr0Vl/PedlKOqhbb+avhXNdT5yfr0tNi63XmthDt4tQdH\nz+0S/YX3s1XxpLUAawXf+p9z3Jq/lepHs6EUhbEW8waLKcdPoIAn/Ivxp70JEd+A\nNnuUlk5PLp/o8zLeVIBQa7oML0/2y+n8Yt9e0kECgYAdCP5RvE0Kfv/nzZ1aqJy7\nnsivCwHD+7CDNiyvVkCHF5CEo0eJqbAxf10H8BmQq8gnCCO7XzjGLdnfrw8KII1P\nwyHRtSb3GckUFDXFWABCieiMe8MEs2Huvk9WJr1ZIw3gNnYUGI9ie04LWStiKYDV\nQOsmZDLJ5XInvXZXwP92PQ==\n-----END PRIVATE KEY-----\n",
    //     scopes: ['https://www.googleapis.com/auth/cloud-platform'],
    //   });
    //   const url = `https://dns.googleapis.com/dns/v1/projects/cwoapp-bd594`;
    //   const res = await client.request({url});
    //   URLVer = res;
    //   console.log(res.data);
    // }
    //   const client = new speech.SpeechClient({
    //     keyFilename:URLVer })
    //   console.log(URLVer)
    //      const Arqui = `data:audio/ogg;base64, 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`;

    //   const audio = {
    //     content:Arqui
    //   }
    //   const config = {
    //     encoding:'LINEAR16',
    //     sampleRateHertz: 16000,
    //     languageCode: "pt-BR",
    //     enableWordTimeOffsets: false
    //   }
    //   const request = {
    //     audio:audio,
    //     config:config,
    //   }
      // const [response] = await client.recognize(request)
      // const transcription = response.results.map(result =>
      //   result.alternatives[0].transcript).join('\n');
      //   console.log("Trancricao "+transcription)



      // await db.collection("aviso")
      // .where("estado", "==", Dados.estado)
      // .where("cidade", "==", Dados.cidade)
      // .where("instituicao", "==", Dados.instituicao)
      // .onSnapshot((querySnapshot) => {
        
      //  const res = [];

      //   querySnapshot.forEach((doc) => {
      //     res.push({
      //       id: doc.id,
      //       tipo: doc.data().tipo,
      //       icons: doc.data().icons,
      //       frase: doc.data().frase,
      //       ativo: doc.data().ativo,
      //       cor: doc.data().cor,  
      //     });             
      //   });
        
      //   setAvisando(res);
        
      // });
        
    },

    AtivandoAviso: async(Dados, Msg, Cor, setAlertTipo, setAlert)=> {
     
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      const Setor = "Ativando Aviso Serv";
      await db.collection("tagaviso")
      .where("nome", "==", Cor)
      .onSnapshot((querySnapshot) => {
        const res = [];
        querySnapshot.forEach((doc) => {
          res.push({
            simb:doc.data().simbolo,
            tom:doc.data().cor,
          });
   
        });
        
       db.collection("aviso")
        .where("estado", "==", Dados.estado)
        .where("cidade", "==", Dados.cidade)
        .where("instituicao", "==", Dados.instituicao)
        .get()
        .then((querySnapshot) => {
         
            
          if(querySnapshot.size === 0){
            
             db.collection("aviso")
            .add({
              frase: Msg,
              ativo: true,
              cor: Cor,
              icons: res[0].simb,
              tipo: res[0].tom,
              cidade: Dados.cidade,
              estado: Dados.estado,
              instituicao: Dados.instituicao,
            }).then((doc)=>{
              setAlert("Ativado com Sucesso!");
                setAlertTipo("success");
              const resu = doc.id;
              db.collection("movimentacao").add({
                id:id,
                instituicao: Dados.instituicao,
                cidade: Dados.cidade,
                estado: Dados.estado,
                Conta: Dados.conta.serv.tipo,
                acao:"Criar",
                setor: Setor,
                data:firebase.firestore.FieldValue.serverTimestamp(),
                idSofrer:resu,
                })
            })

          } else {
            
            querySnapshot.forEach((doc) => {   
           
           
            
             
             db.collection("aviso").doc(doc.id).update({
              "frase": Msg,
              "ativo": true,
              "cor": Cor,
              "icons": res[0].simb,
              "tipo": res[0].tom,
              "cidade": Dados.cidade,
              "estado": Dados.estado,
              "instituicao": Dados.instituicao,
             }).then(()=>{
               setAlert("Ativado com Sucesso");
               setAlertTipo("success");
               db.collection("movimentacao").add({
                 id:id,
                 instituicao: Dados.instituicao,
                 cidade: Dados.cidade,
                 estado: Dados.estado,
                 Conta: Dados.conta.serv.tipo,
                 acao:"Atualizar",
                 setor: Setor,
                 data:firebase.firestore.FieldValue.serverTimestamp(),
                 idSofrer:doc.id,
                 })
         
             });
            });
          }
          
        });
      });
    },

    CriandoAvisoApp: async(Dados, MsgApp, setAlertTipo, setAlert)=> {
     
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      await db.collection("avisoAppVit")
      .where("estado", "==", Dados.estado)
      .where("cidade", "==", Dados.cidade)
      .where("instituicao", "==", Dados.instituicao)
      .get()
      .then((querySnapshot) => {
       
          
        if(querySnapshot.size === 0){
    
      db.collection("avisoAppVit").add({
        ativo:true,
        body: MsgApp,
        cidade: Dados.cidade,
        estado:  Dados.estado,
        instituicao: Dados.instituicao,
      }).then((docRef) => {
        setAlert("Ativado com Sucesso");
        setAlertTipo("success");
       })
        }else {

          querySnapshot.forEach((doc) => {
            db.collection("avisoAppVit").doc(doc.id).update({
              "ativo": true,
              "body":  MsgApp,
             }).then(()=>{
              setAlert("Ativado com Sucesso");
              setAlertTipo("success");
            });

          });


        }


      });
  
    },

    DesativandoAviso: async(Dados, IdAviso, setAlertTipo, setAlert)=> {
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      const Setor = "Desativando Aviso Serv";
      await db.collection("aviso").doc(IdAviso).update({
       "ativo":false, 
      }).then(()=>{
        setAlert("Desativado com Sucesso");
        setAlertTipo("success");
        db.collection("movimentacao").add({
          id:id,
          instituicao: Dados.instituicao,
          cidade: Dados.cidade,
          estado: Dados.estado,
          Conta: Dados.conta.serv.tipo,
          acao:"Atualizar",
          setor: Setor,
          data:firebase.firestore.FieldValue.serverTimestamp(),
          idSofrer:IdAviso,
          })
  
      });
    },

    DesativandoAvisoApp: async(AppAvi, setAlertTipo, setAlert)=> {
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      await db.collection("avisoAppVit").doc(AppAvi).update({
       "ativo":false, 
      }).then(()=>{
        setAlert("Desativado com Sucesso");
        setAlertTipo("success");
      });
    },

    ExcluirTelefone: async(Dados, Id, setAlertTipo, setAlert)=> {
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      const Setor = "Excluir Telefone Serv";
      await db.collection("telefone").doc(Id).delete().then(() => {
        setAlert("Excluido com Sucesso");
        setAlertTipo("success");
    }).catch((error) => {
      setAlert("Erro ao Excluir");
      setAlertTipo("danger");
      db.collection("movimentacao").add({
        id:id,
        instituicao: Dados.instituicao,
        cidade: Dados.cidade,
        estado: Dados.estado,
        Conta: Dados.conta.serv.tipo,
        acao:"Remover",
        setor: Setor,
        data:firebase.firestore.FieldValue.serverTimestamp(),
        })
    });
    },

    ExcluirJogo: async(Id, setAlert, setAlertTipo, setId)=> {
      // const autenticado =  await Auth.currentUser;
      // const id = await autenticado.uid;
      const Setor = "Excluir Telefone Serv";
      await db.collection("JogosCirados").doc(Id).delete().then(() => {
        setAlert("Excluido com Sucesso");
        setAlertTipo("success");
        setId("")
    }).catch((error) => {
      setAlert("Erro ao Excluir");
      setAlertTipo("danger");
      setId("")
      // db.collection("movimentacao").add({
      //   id:id,
      //   instituicao: Dados.instituicao,
      //   cidade: Dados.cidade,
      //   estado: Dados.estado,
      //   Conta: Dados.conta.serv.tipo,
      //   acao:"Remover",
      //   setor: Setor,
      //   data:firebase.firestore.FieldValue.serverTimestamp(),
      //   })
    });
    },


    PegarCondicionais: async(Condicao,  setCondicao)=> {
      await Auth.onAuthStateChanged( async function(user) {
        if (user) {
        const ID = user.uid;
        const dados = await db.collection('users')
        .doc(ID).
        get()
        .then(async(dados)=>{
          const result = await dados.data();
    
              await db.collection("condicionais")
              .where("estado", "==", result.estado)
              .where("cidade", "==", result.cidade)
              .where("instituicao", "==", result.instituicao)
              .where("ativo", "==", true)
              .onSnapshot((querySnapshot) => {
                
              const res = [];
  
                querySnapshot.forEach((doc) => {
                  res.push({
                    id: doc.id,
                    nome: doc.data().nome,
                  });             
                });
               
                setCondicao(res);
                
              });
            });
          }
        });
        
    },

    PegarAvisoApp: async(AvApp, setAvApp)=> {
      await Auth.onAuthStateChanged( async function(user) {
        if (user) {
        const ID = user.uid;
        const dados = await db.collection('users')
        .doc(ID).
        get()
        .then(async(dados)=>{
          const result = await dados.data();
              console.log(result);
              await db.collection("avisoAppVit")
              .where("estado", "==", result.estado)
              .where("cidade", "==", result.cidade)
              .where("instituicao", "==", result.instituicao)
              .where("ativo", "==", true)
              .onSnapshot((querySnapshot) => {
                
                const res = [];
    
                  querySnapshot.forEach((doc) => {
                    res.push({
                      id: doc.id,
                      body: doc.data().body,
                      ativo: doc.data().ativo,
                    });             
                  });
                 
                setAvApp(res);
                  
                });
            });
          }
        });
        
    },

    EnviarAudio: async (Som, data, Nome) => {
    //let Cont = VizuS + 1;
      // let temp = new Date().getTime();
      // let now = temp + (Varia*1000);
      let Url1 = "";
      let now = new Date();
      const uploadUri = Som;
      let filename = Date.now() + '.mp3';
      const storageRef = storage.ref(`audio/${filename}`);
       await storageRef.putString(Som.split(',')[1], "base64", {contentType: 'audio/mp3'}).then(function(snapshot) {
        console.log();
      });
      Url1 =  await storageRef.getDownloadURL();

      await db.collection("ChatCliente")
      .doc(data)
      .update({
    
      UltimaMsg:{
         Autor:EMPRESA,
         body:Som,
         date:new Date().getTime(),
         Type:"audio"
     },
      Mensagem: firebase.firestore.FieldValue.arrayUnion (
     {
         Autor:EMPRESA,
         body:Som,
         date:new Date().getTime(),
         Type:"audio",
     },
     
     
     )
      })
      .then(async() => {
        await db.collection("CorreioMSg")
        .add({
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg: Url1,
          Botao:[],
          Tel:Nome,
          Type:"audio",
          Agendamento:firebase.firestore.FieldValue.serverTimestamp()
        })
        .then( async (docRef) => { 
         
        });
   
        
      }).catch((error) => {
         
      });  
     
   
    },

    PesquisarList: async(Dados, setChatlist)=> {

     
      
       
    
         
          await db.collection("ChatCliente")
          .where("Empresa", "==", EMPRESA)
          .where("Ativo", "==", true)
          .where("Robotizado", "==", false)
            .onSnapshot((querySnapshot) => {
        
              const res = [];
       
               querySnapshot.forEach((doc) => {
                
                  res.push({
                    id: doc.data().UltimaMsg.Autor,
                    nome: doc.data().Telefone?doc.data().Telefone:"",
                    data: doc.data().UltimaMsg.date,
                    msg: doc.data().UltimaMsg.body,
                    idChat:doc.id,
                    QuantMsg: doc.data().Mensagem.length,
                    Vizualizar:doc.data().vizualEmp?doc.data().vizualEmp:0,
                    Pedido:doc.data().Pedido?doc.data().Pedido:"",
                    digitar:doc.data().digitar?doc.data().digitar:false,
                    ocupado:doc.data().ocupado?doc.data().ocupado:false,
                    idOc:  "",
                    NomeOc: "",
                    CanalChat:doc.data().CanalChat?doc.data().CanalChat:0,
                  });    
                
                         
               });

               res.sort((a,b)=>{
                 if(a.data < b.data) {
                   return 1;
                 } else {
                   return -1;
                 }
               });
              // console.log(res);
              setChatlist(res);
            
               
             });
           
           

    },


    PegarBO: async(BoPesq, setInfo)=> {
    
    
         
            await db.collection("ocorrencia")
            .where("ativo", "==", true)
            .where("Ocorr", "==", BoPesq)
            .onSnapshot((querySnapshot) => {
        
       
               querySnapshot.forEach((doc) => {
            setInfo(doc.data())
                         
               });

           
            
        
    
      });
        
    },

    PegarBOAut: async(BoPesq, setInfo)=> {
    
    
         
      await db.collection("ocorrencia")
      .doc(BoPesq)
      .onSnapshot((querySnapshot) => {

      setInfo(querySnapshot.data())
                   });
  
},
    PesquisarListPM: async(Dados, setChatListPM)=> {
      await Auth.onAuthStateChanged( async function(user) {
        if (user) {
        let ID = user.uid;
        const Setor = "Lista de Condicionais";
       
          
            await db.collection("chat")
            .where("ativo", "==", true)
             .where("userChat", "array-contains", ID)
            .onSnapshot((querySnapshot) => {
        
              const res = [];
       
               querySnapshot.forEach((doc) => {
                 let NomeChat = "";
                 let Vizual = 0;
                 let digi =false;
                 let Status = "";
              
                  // if(doc.data().idSofrer === ID) {
                  //   NomeChat = doc.data().nomeCriador;
                  //   Vizual = doc.data().vizualS;
                  //   digi = doc.data().digiC;
                  //   Status = "Sofredor";
                  // } else {
                  //   NomeChat = doc.data().nomeSofrer
                  //   Vizual = doc.data().vizualC;
                  //   digi = doc.data().digiS;
                  //   Status = "Criador";
                  // }
                  res.push({
                    id: doc.data().UltimaMsg.Autor,
                    nome: doc.data().Telefone,
                    data: doc.data().UltimaMsg.date,
                    msg: doc.data().UltimaMsg.body,
                    idChat:doc.id,
                    QuantMsg: doc.data().Mensagem.length,
                    Vizualizar: Vizual,
                    digitar: digi,
                    Sta: Status,
                    ocupado:  false,
                    idOc:  "",
                    NomeOc: "",
                  });    
                
                         
               });

               res.sort((a,b)=>{
                 if(a.data < b.data) {
                   return 1;
                 } else {
                   return -1;
                 }
               });
              
              setChatListPM(res);
            
               
             });
           
           
     
         
       
        } 
    
      });
        
    },
    PesquisaItens: async(Dados, setItens)=> {

    //Montando o Menu(Inicio)
    var SesseaoMenus = []
      await db.collection("MenusSite")
      .where("Empresa", "==", EMPRESA)
      .get().then(async (querySnapshot23) => {
          await querySnapshot23.forEach((doc23) => {

              SesseaoMenus.push({
                  id:doc23.id,
                  body:doc23.data().nome,
                  GrupTamanho:doc23.data().GrupTamanho,
                  MemFim:doc23.data().MemFim,
                  Tamanho:doc23.data().Tamanho,
                  Ativo:doc23.data().Ativo,
                  TagsMenus:doc23.data().Tags,
                  AtiEspeci:doc23.data().AtiEspeci?doc23.data().AtiEspeci:false,
                  GrupEspe:doc23.data().GrupEspe?doc23.data().GrupEspe:[],
                  Especifico:doc23.data().Especifico?doc23.data().Especifico:"",

              })
          
              })

      });

        //Pegando os itens 
        var Menus = [];
        var SubMenus = [];
        var ItensMenus = [];
        for(let i in SesseaoMenus){
            if(SesseaoMenus[i].Tamanho){
                //Pegou todos os tamanhos de cada sessão 
                for(let l in SesseaoMenus[i].GrupTamanho){
                var Letra1 = SesseaoMenus[i].GrupTamanho[l].Tamanho.replaceAll(" ", "").substr(0, 1).toLowerCase();
                var Letra2 = SesseaoMenus[i].GrupTamanho[l].Tamanho.replaceAll(" ", "").substr(1, 1).toLowerCase();
                var ArrTemas = [`${Letra1}${Letra2} `, ` ${Letra1}${Letra2}`, `  ${Letra1}`, `${Letra1} ${Letra2}`, ` ${Letra1} `]
                
                    Menus.push({
                        Descont:SesseaoMenus[i].GrupTamanho[l].DescontReal,
                        Nome: SesseaoMenus[i].GrupTamanho[l].Tamanho,
                        Preco: SesseaoMenus[i].GrupTamanho[l].PrecoReal,
                        QuantSb:SesseaoMenus[i].GrupTamanho[l].Qsabor,
                        body: SesseaoMenus[i].GrupTamanho[l].DescontReal?SesseaoMenus[i].GrupTamanho[l].Tamanho+"\n"+"❤️ De: "+"~"+SesseaoMenus[i].GrupTamanho[l].PrecoReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"~"+" Por "+SesseaoMenus[i].GrupTamanho[l].DescontReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"+"===================\n"  :    SesseaoMenus[i].GrupTamanho[l].Tamanho+"\n"+"💰 "+SesseaoMenus[i].GrupTamanho[l].PrecoReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"+"===================\n" ,
                        MemFim:SesseaoMenus[i].MemFim,
                        Sessao:SesseaoMenus[i].body,
                        AtivoSessao:SesseaoMenus[i].Ativo,
                        AtivoTamanho:SesseaoMenus[i].GrupTamanho[l].Ativo,
                        Temas:ArrTemas,
                        TagsMenus:SesseaoMenus[i].TagsMenus,
                        TagsTamanhos:SesseaoMenus[i].GrupTamanho[l].TagsTamanho,
                        AtiEspeci:SesseaoMenus[i].AtiEspeci,
                        GrupEspe:SesseaoMenus[i].GrupEspe,
                        Especifico:SesseaoMenus[i].Especifico,
                    })
            }

            



            await db.collection("ItensDaEmpresa")
            .where("Empresa", "==", EMPRESA)
            .where("Menu", "==", SesseaoMenus[i].body)
            .get().then(async (querySnapshot23) => {
                
                await querySnapshot23.forEach((doc23) => {

                    SubMenus.push({
                    
                        Descricao:doc23.data().Descricao,
                        Nome: doc23.data().nome,
                        Quant: doc23.data().Quant,
                        Ilimitado:doc23.data().Ilimitado,
                        foto: doc23.data().foto,
                        id: doc23.id,
                        GrupTamanho:doc23.data().GrupTamanho,
                        Sessao:SesseaoMenus[i].body,
                        AtivoSabor:doc23.data().Ativo,
                        TagsItens:doc23.data().Tags,
                    })
                
                    })

            });

            

        
            for(let l in SubMenus){
                for(let m in SubMenus[l].GrupTamanho){
                    for(let j in Menus){
                        
                            if(SubMenus[l].Sessao === Menus[j].Sessao){
                                if(SubMenus[l].GrupTamanho[m].select === Menus[j].Nome){
                                    
                                        ItensMenus.push({
                                            Descont: Menus[j].Descont,
                                            Tamanho: Menus[j].Nome,
                                            ComTam:true,
                                            Preco:Menus[j].Preco,
                                            QuantSb:Menus[j].QuantSb,
                                            body: Menus[j].body,
                                            MemFim:Menus[j].MemFim,
                                            Sessao:Menus[j].Sessao,
                                            Descricao:SubMenus[l].Descricao,
                                            Nome:SubMenus[l].Nome,
                                            Quant:SubMenus[l].Quant,
                                            Ilimitado:SubMenus[l].Ilimitado,
                                            foto:SubMenus[l].foto,
                                            AtivoTamanho:Menus[j].AtivoTamanho === false ? false:SubMenus[l].GrupTamanho[m].Ativo,
                                            AtivoSabor:SubMenus[l].AtivoSabor,
                                            AtivoSessao:Menus[j].AtivoSessao,
                                            Temas:Menus[j].Temas,
                                            TagsItens:SubMenus[l].TagsItens,
                                            TagsMenus:Menus[j].TagsMenus,
                                            TagsTamanhos:Menus[j].TagsTamanhos,
                                            AtiEspeci:Menus[j].AtiEspeci,
                                            GrupEspe:Menus[j].GrupEspe,
                                            Especifico:Menus[j].Especifico,
                                            })

                                        
                                
                                }

                            }

                        
                
                    
                }
                }
            }









        }else {
            await db.collection("ItensDaEmpresa")
            .where("Empresa", "==", EMPRESA)
            .where("Menu", "==", SesseaoMenus[i].body)
            .get().then(async (querySnapshot23) => {
                
                await querySnapshot23.forEach((doc23) => {

                    ItensMenus.push({
                        ComTam:false,
                        Descont:doc23.data().DescontReal,
                        Descricao:doc23.data().Descricao,
                        Nome: doc23.data().nome,
                        Preco: doc23.data().PrecoReal,
                        Quant: doc23.data().Quant,
                        Ilimitado:doc23.data().Ilimitado,
                        foto: doc23.data().foto,
                        id: doc23.id,
                        Observacao: "",
                        body:doc23.data().Descricao ?  doc23.data().DescontReal?"📦 *"+doc23.data().nome+"* "+"\n"+"📝 Ingredientes: "+doc23.data().Descricao+"\n"+"❤️ De: "+"~"+doc23.data().PrecoReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"~"+" Por "+doc23.data().DescontReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"+"===================\n"  :  "📦 *"+doc23.data().nome+"* "+"\n"+"📝Ingredientes:"+doc23.data().Descricao+"\n"+"💰 "+doc23.data().PrecoReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"+"===================\n":doc23.data().DescontReal?"📦 *"+doc23.data().nome+"* "+"\n"+"❤️ De: "+"~"+doc23.data().PrecoReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"~"+" Por "+doc23.data().DescontReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"+"===================\n"  :   "📦 *"+doc23.data().nome+"* "+"\n"+"💰 "+doc23.data().PrecoReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+"\n"+"===================\n" ,
                        Tamanho:"",
                        ItemEspeci:false,
                        Sessao:SesseaoMenus[i].body,
                        MemFim:SesseaoMenus[i].MemFim,
                        AtivoTamanho:false,
                        AtivoSabor:doc23.data().Ativo,
                        AtivoSessao:SesseaoMenus[i].Ativo,
                        Temas:[],
                        TagsItens:doc23.data().Tags,
                        TagsMenus:SesseaoMenus[i].TagsMenus,
                        AtiEspeci:SesseaoMenus[i].AtiEspeci,
                        GrupEspe:SesseaoMenus[i].GrupEspe,
                        Especifico:SesseaoMenus[i].Especifico,
                    })
                
                    })

            });
    
        }
         }
        ItensMenus = ItensMenus.filter(function (a) {
        return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null))

  setItens(ItensMenus)
  console.log(ItensMenus)
      
  },
    
     PesquisarNumOc: async(Dados, setCodOc)=> {
        
        const dados = await db.collection('ultimaOcorr')
        .doc("FTKRA384rOgVMPawzEpf")
        .onSnapshot((querySnapshot) => {
          console.log(querySnapshot);
          setCodOc(querySnapshot.data());
      });
        
    },

    AddOcorrencia: async(Dados, came,  Varia, setAlert, setAlertTipo)=> {
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
      let nowD = now/1000
      await db.collection("ocorrencia")
      .add({
      ativo:true,
      cidade: Dados.cidade,
      estado: Dados.estado,
      instituicao:"Polícia Militar",
      nomevitima: came,
      condicionais:[],
      idvitima: id,
      localizacao:{lat: 0, lng: 0},
      userChat:[
        { id: id,
          nome: Dados.nome,}],
      mensagem:[{
        autor:id,
        nome: Dados.nome,
        body:"Ocorrência criada pelo sistema",
        date: now,
        type:"text"
      }],     
      dataInicio:{seconds: nowD},
      ultimaMsg:{id:id, nome: came, data:now, msg:"Ocorrência criada pelo sistema"},
      DigiS:false,
      DigiV:false,
      vizualS:0,
      vizualV:1,
      vtr: "",
      atendenteCopom: "",
      componentesVtr: "",
      periodo: "",
      rua: "",
      numero: "",
      bairro: "",
      conduzidos:"",
      vitimas:"",
      objetosApre:"",
      grupoOcrr:"",
      Ocorr:"",
      resultado: "",
      relato:"",
      providencias:"",
      testemunha:"",
      excluir:false,
      autores:"",
      objRoubados:"",
      Cpu:"",
      BO:{
        Codigo:"",
        Ca:"",
        Setor:"",
        Local:"",
        Bairro:"",
        PontoRef:"",
        Envolvido1:{
          Tipo:"",
          Nome:"",
          Alcunha: "",
          Filiacao: "",
          DataNasc:"",
          Sexo: "",
          EstadoCivil: "",
          Naturalidade: "",
          Nacionalidade: "",
          Endereco: "",
          Bairro: "",
          Cidade: "",
          Cep:"",
          Uf: "",
          Rg: "",
          Cnh: "",
          OrgExpe: "",
          Cpf: "",
          Fone: "",
          Celular: "",
        },
        Envolvido2:{
          Tipo:"",
          Nome:"",
          Alcunha: "",
          Filiacao: "",
          DataNasc:"",
          Sexo: "",
          EstadoCivil: "",
          Naturalidade: "",
          Nacionalidade: "",
          Endereco: "",
          Bairro: "",
          Cidade: "",
          Cep:"",
          Uf: "",
          Rg: "",
          Cnh: "",
          OrgExpe: "",
          Cpf: "",
          Fone: "",
          Celular: "",
        },
        Envolvido3:{
          Tipo:"",
          Nome:"",
          Alcunha: "",
          Filiacao: "",
          DataNasc:"",
          Sexo: "",
          EstadoCivil: "",
          Naturalidade: "",
          Nacionalidade: "",
          Endereco: "",
          Bairro: "",
          Cidade: "",
          Cep:"",
          Uf: "",
          Rg: "",
          Cnh: "",
          OrgExpe: "",
          Cpf: "",
          Fone: "",
          Celular: "",
        },
        Envolvido4:{
          Tipo:"",
          Nome:"",
          Alcunha: "",
          Filiacao: "",
          DataNasc:"",
          Sexo: "",
          EstadoCivil: "",
          Naturalidade: "",
          Nacionalidade: "",
          Endereco: "",
          Bairro: "",
          Cidade: "",
          Cep:"",
          Uf: "",
          Rg: "",
          Cnh: "",
          OrgExpe: "",
          Cpf: "",
          Fone: "",
          Celular: "",
        },
        InfoOc:{
          Historico: "",
          ObjApre: "",
        },
        Parentesco1:{
          Nome: "",
          Alcunha: "",
          Endereco: "",
          GrauPare: "",
          Bairro: "",
          Cidade: "",
          Uf: "",
        },
        Parentesco2:{
          Nome: "",
          Alcunha: "",
          Endereco: "",
          GrauPare: "",
          Bairro: "",
          Cidade: "",
          Uf: "",
        },
        Parentesco3:{
          Nome: "",
          Alcunha: "",
          Endereco: "",
          GrauPare: "",
          Bairro: "",
          Cidade: "",
          Uf: "",
        },
        Parentesco4:{
          Nome: "",
          Alcunha: "",
          Endereco: "",
          GrauPare: "",
          Bairro: "",
          Cidade: "",
          Uf: "",
        },
        CadasOC:{
          ModusOp: "",
          Veiculo: "",
          Armas: "",
        },
        Quadrilha:{
         ModusOp: "",
          Nome: "",
          Chefe: "",
        },
        CadasVeicu1:{
          Marca:"",
          Modelo: "",
          Chassi:"",
          Placa: "",
          Uf: "",
          Cor: "",
          Tipo: "",
          Proprietario: "",
          Endereco: "",
          Cidade: "",
          Estado: "",
          Historico: "",
        },
        CadasVeicu2:{
          Marca:"",
          Modelo: "",
          Chassi:"",
          Placa: "",
          Uf: "",
          Cor: "",
          Tipo: "",
          Proprietario: "",
          Endereco: "",
          Cidade: "",
          Estado: "",
          Historico: "",
        },

      }
      }).then(async (doc)=>{
       setAlert("Ocorrência Cirada Com sucesso");
       setAlertTipo("success");
       
      }).catch((error) => {
        setAlert("Ocorrência não Foi Criada Com sucesso");
        setAlertTipo("danger");
      });  
    },

    sendMessage: async(DadEmp, IdPedido, Canal, data, text, Nome, TemUmlt, Varia, VizuS)=> {
      let Cont = VizuS + 1;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
      await db.collection("ChatCliente")
      .doc(data)
      .update({
      UltimaMsg:{
         Autor:EMPRESA,
         body:text,
         date:new Date().getTime(),
         Type:"text"
     },
      Mensagem: firebase.firestore.FieldValue.arrayUnion (
     {
         Autor:EMPRESA,
         body:text,
         date:new Date().getTime(),
         Type:"text",
     },
     
     
     )
      })
      .then(async() => {
        if(DadEmp.ServidorZapi){
          var data={
            "phone": Nome,
            "message":text,
          }   
          const req = await fetch(URL_SITE+"/send-messages", 
          {
                method: 'POST',
                headers:{
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
             });
        } else {
       
        await db.collection("CorreioMSg")
        .add({
          Canal:Canal,
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg:text,
          Botao:[],
          Tel:Nome,
          Type:"text",
          Agendamento: new Date().getTime(),

        })
        .then( async (docRef) => { 
          console.log(docRef.id)
        });
      }
   
        await  db.collection("MesaItem")
        .doc(IdPedido)
       .update({
         ClienteEsc:false,
       
          })
      }).catch((error) => {
         
      });   
    },
    Soinstante: async(DadEmp, Msg, IdPedido, Canal, data, text, Nome, TemUmlt, Varia, VizuS)=> {
      let Cont = VizuS + 1;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
      await db.collection("ChatCliente")
      .doc(data)
      .update({
      UltimaMsg:{
         Autor:EMPRESA,
         body:Msg,
         date:new Date().getTime(),
         Type:"text"
     },
      Mensagem: firebase.firestore.FieldValue.arrayUnion (
     {
         Autor:EMPRESA,
         body:Msg,
         date:new Date().getTime(),
         Type:"text",
     },
     
     
     )
      })
      .then(async() => {
        if(DadEmp.ServidorZapi){
          var data={
            "phone": Nome,
            "message":Msg,
          }   
          const req = await fetch(URL_SITE+"/send-messages", 
          {
                method: 'POST',
                headers:{
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
             });
        } else {
        await db.collection("CorreioMSg")
        .add({
          Canal:Canal,
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg:Msg,
          Botao:[],
          Tel:Nome,
          Type:"text",
          Agendamento:new Date().getTime(),
        })
        .then( async (docRef) => { 
         
        });
      }
   
       
      }).catch((error) => {
         
      });   
    },
    EnviandoSim: async(IdPedido, Canal, data, text, Nome, TemUmlt, Varia, VizuS)=> {
      let Cont = VizuS + 1;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
      await db.collection("ChatCliente")
      .doc(data)
      .update({
      UltimaMsg:{
         Autor:EMPRESA,
         body:"Sim",
         date:new Date().getTime(),
         Type:"text"
     },
      Mensagem: firebase.firestore.FieldValue.arrayUnion (
     {
         Autor:EMPRESA,
         body:"Sim",
         date:new Date().getTime(),
         Type:"text",
     },
     
     
     )
      })
      .then(async() => {
        console.log("Canal 2 "+Canal)
        await db.collection("CorreioMSg")
        .add({
          Canal:Canal,
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg:"Sim",
          Botao:[],
          Tel:Nome,
          Type:"text",
          Agendamento:firebase.firestore.FieldValue.serverTimestamp()
        })
        .then( async (docRef) => { 
         
        });
   
        await  db.collection("MesaItem")
        .doc(IdPedido)
       .update({
         ClienteEsc:false,
       
          })
      }).catch((error) => {
         
      });   
    },
    EnviadoOK: async(IdPedido, Canal, data, text, Nome, TemUmlt, Varia, VizuS)=> {
      let Cont = VizuS + 1;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
      await db.collection("ChatCliente")
      .doc(data)
      .update({
      UltimaMsg:{
         Autor:EMPRESA,
         body:"Ok",
         date:new Date().getTime(),
         Type:"text"
     },
      Mensagem: firebase.firestore.FieldValue.arrayUnion (
     {
         Autor:EMPRESA,
         body:"Ok",
         date:new Date().getTime(),
         Type:"text",
     },
     
     
     )
      })
      .then(async() => {
        console.log("Canal 2 "+Canal)
        await db.collection("CorreioMSg")
        .add({
          Canal:Canal,
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg:"OK",
          Botao:[],
          Tel:Nome,
          Type:"text",
          Agendamento:firebase.firestore.FieldValue.serverTimestamp()
        })
        .then( async (docRef) => { 
         
        });
   
        await  db.collection("MesaItem")
        .doc(IdPedido)
       .update({
         ClienteEsc:false,
       
          })
      }).catch((error) => {
         
      });   
    },
    pegTamanho: async(IdPedido, Canal, data, text, Nome, TemUmlt, Varia, VizuS)=> {
      let Cont = VizuS + 1;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
      await db.collection("ChatCliente")
      .doc(data)
      .update({
      UltimaMsg:{
         Autor:EMPRESA,
         body:"Qual o Tamanho?",
         date:new Date().getTime(),
         Type:"text"
     },
      Mensagem: firebase.firestore.FieldValue.arrayUnion (
     {
         Autor:EMPRESA,
         body:"Qual o Tamanho?",
         date:new Date().getTime(),
         Type:"text",
     },
     
     
     )
      })
      .then(async() => {
        console.log("Canal 2 "+Canal)
        await db.collection("CorreioMSg")
        .add({
          Canal:Canal,
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg:"Qual o Tamanho?",
          Botao:[],
          Tel:Nome,
          Type:"text",
          Agendamento:firebase.firestore.FieldValue.serverTimestamp()
        })
        .then( async (docRef) => { 
         
        });
   
        await  db.collection("MesaItem")
        .doc(IdPedido)
       .update({
         ClienteEsc:false,
       
          })
      }).catch((error) => {
         
      });   
    },
    EnviadoProgMsg: async(DadEmp, Msg, IdPedido, Canal, data, text, Nome, TemUmlt, Varia, VizuS)=> {
      let Cont = VizuS + 1;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
      await db.collection("ChatCliente")
      .doc(data)
      .update({
      UltimaMsg:{
         Autor:EMPRESA,
         body:Msg,
         date:new Date().getTime(),
         Type:"text"
     },
      Mensagem: firebase.firestore.FieldValue.arrayUnion (
     {
         Autor:EMPRESA,
         body:Msg,
         date:new Date().getTime(),
         Type:"text",
     },
     
     
     )
      })
      .then(async() => {
        if(DadEmp.ServidorZapi){
          var data={
            "phone": Nome,
            "message":Msg,
          }   
          const req = await fetch(URL_SITE+"/send-messages", 
          {
                method: 'POST',
                headers:{
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
             });
        } else {

        await db.collection("CorreioMSg")
        .add({
          Canal:Canal,
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg:Msg,
          Botao:[],
          Tel:Nome,
          Type:"text",
          Agendamento:new Date().getTime()
        })
        .then( async (docRef) => { 
         
        });
      }
   
        await  db.collection("MesaItem")
        .doc(IdPedido)
       .update({
         ClienteEsc:false,
       
          })
      }).catch((error) => {
         
      });   
    },
    pegTamanho: async(IdPedido, Canal, data, text, Nome, TemUmlt, Varia, VizuS)=> {
      let Cont = VizuS + 1;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
      await db.collection("ChatCliente")
      .doc(data)
      .update({
      UltimaMsg:{
         Autor:EMPRESA,
         body:"Qual o Tamanho?",
         date:new Date().getTime(),
         Type:"text"
     },
      Mensagem: firebase.firestore.FieldValue.arrayUnion (
     {
         Autor:EMPRESA,
         body:"Qual o Tamanho?",
         date:new Date().getTime(),
         Type:"text",
     },
     
     
     )
      })
      .then(async() => {
        console.log("Canal 2 "+Canal)
        await db.collection("CorreioMSg")
        .add({
          Canal:Canal,
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg:"Qual o Tamanho?",
          Botao:[],
          Tel:Nome,
          Type:"text",
          Agendamento:firebase.firestore.FieldValue.serverTimestamp()
        })
        .then( async (docRef) => { 
         
        });
   
        await  db.collection("MesaItem")
        .doc(IdPedido)
       .update({
         ClienteEsc:false,
       
          })
      }).catch((error) => {
         
      });   
    },
    pegSabor: async(IdPedido, Canal, data, text, Nome, TemUmlt, Varia, VizuS)=> {
      let Cont = VizuS + 1;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
      await db.collection("ChatCliente")
      .doc(data)
      .update({
      UltimaMsg:{
         Autor:EMPRESA,
         body:"Qual o Sabor?",
         date:new Date().getTime(),
         Type:"text"
     },
      Mensagem: firebase.firestore.FieldValue.arrayUnion (
     {
         Autor:EMPRESA,
         body:"Qual o Sabor?",
         date:new Date().getTime(),
         Type:"text",
     },
     
     
     )
      })
      .then(async() => {
        console.log("Canal 2 "+Canal)
        await db.collection("CorreioMSg")
        .add({
          Canal:Canal,
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg:"Qual o Sabor?",
          Botao:[],
          Tel:Nome,
          Type:"text",
          Agendamento:firebase.firestore.FieldValue.serverTimestamp()
        })
        .then( async (docRef) => { 
         
        });
   
        await  db.collection("MesaItem")
        .doc(IdPedido)
       .update({
         ClienteEsc:false,
       
          })
      }).catch((error) => {
         
      });   
    },
    pegTamanhoSabor: async(IdPedido, Canal, data, text, Nome, TemUmlt, Varia, VizuS)=> {
      let Cont = VizuS + 1;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
      await db.collection("ChatCliente")
      .doc(data)
      .update({
      UltimaMsg:{
         Autor:EMPRESA,
         body:"Qual o Tamanho e o Sabor?",
         date:new Date().getTime(),
         Type:"text"
     },
      Mensagem: firebase.firestore.FieldValue.arrayUnion (
     {
         Autor:EMPRESA,
         body:"Qual o Tamanho e o Sabor?",
         date:new Date().getTime(),
         Type:"text",
     },
     
     
     )
      })
      .then(async() => {
        console.log("Canal 2 "+Canal)
        await db.collection("CorreioMSg")
        .add({
          Canal:Canal,
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg:"Qual o Tamanho e o Sabor?",
          Botao:[],
          Tel:Nome,
          Type:"text",
          Agendamento:firebase.firestore.FieldValue.serverTimestamp()
        })
        .then( async (docRef) => { 
         
        });
   
        await  db.collection("MesaItem")
        .doc(IdPedido)
       .update({
         ClienteEsc:false,
       
          })
      }).catch((error) => {
         
      });   
    },

    RobotizarItem: async(data, Tele, DadEmp, setAlert, setAlertTipo)=> {
     console.log(data)

     await db.collection("ChatCliente")
     .doc(data)
     .update({
       FaseMsg:"",
       DigiteNaRegra:true,
       Robotizado:true,
       RoboAtivo:true,
       "MsgDinamica.Ativo":true,
       "MsgFutura1.Ativo":true,
       "MsgFutura2.Ativo":true,
       "MsgFutura3.Ativo":true,
     }).then(async() => {
      //  setAlert("Robo Ativado");
      //  setAlertTipo("success");
    
       
     }).catch((error) => {
        
     });   
    },

    RobotizarEnd: async(data, IdPedido, Tele, DadEmp)=> {
    
      
      var MsgEmp = DadEmp.MsgAuto;

      var QMsg= MsgEmp.Msg7A.Msg.length;
      var Sorteio = Math.floor(Math.random() * (QMsg - 1 + 1)) + 1;
      var Result =parseInt(Sorteio);
      var Num = Result-1;
      var AutoMsg = MsgEmp.Msg7A.Msg[Num];
      var TempMsg =  MsgEmp.Msg7A.TempoSeg;

      var QMsg3= MsgEmp.Msg17A.Msg.length;
      var QMsg4= MsgEmp.Msg17B.Msg.length;
      var QMsg5= MsgEmp.Msg17C.Msg.length;
      var Sorteio3 = Math.floor(Math.random() * (QMsg3 - 1 + 1)) + 1;
      var Sorteio4 = Math.floor(Math.random() * (QMsg4 - 1 + 1)) + 1;
      var Sorteio5 = Math.floor(Math.random() * (QMsg5 - 1 + 1)) + 1;

      var Result3 =parseInt(Sorteio3);
      var Result4 =parseInt(Sorteio4);
      var Result5 =parseInt(Sorteio5);

      var Num3 = Result3-1;
      var Num4 = Result4-1;
      var Num5 = Result5-1;
      var AutoMsg3 = MsgEmp.Msg17A.Msg[Num3];
      var AutoMsg4= MsgEmp.Msg17B.Msg[Num4];
      var AutoMsg5= MsgEmp.Msg17C.Msg[Num5];
      var Tempo3 = MsgEmp.Msg17A.TempoSeg + new Date().getTime();
      var Tempo4 = MsgEmp.Msg17B.TempoSeg + new Date().getTime();
      var Tempo5 = MsgEmp.Msg17C.TempoSeg + new Date().getTime();
      await db.collection("MesaItem")
      .doc(IdPedido)
      .update({
        localizacaoGps:{}
      }).then((doc)=>{
          //PedidosItens = doc.data().Itens;
      })
   
      await db.collection("ChatCliente")
      .doc(data)
      .update({
        
        FaseMsg: "Msg7A",
        MemSessao:[],
        Sessao:"",
        DigiteNaRegra:true,
        Robotizado:true, 
        RoboAtivo:true,
        MsgFutura1:{
            Ativo:true,
            Msg:AutoMsg3,
            Tempo:Tempo3,
        },
        MsgFutura2:{
            Ativo:true,
            Msg:AutoMsg4,
            Tempo:Tempo4,
        },
        MsgFutura3:{
            Ativo:true,
            Msg:AutoMsg5,
            Tempo:Tempo5,
        },
        UltimaMsg:{
            Autor:EMPRESA,
            body:`${AutoMsg}`,
            date:new Date().getTime()+5000,
            Type:"text"
        },
        Mensagem:firebase.firestore.FieldValue.arrayUnion (
       
        {
            Autor:EMPRESA,
            body:`${AutoMsg}`,
            Botao:[],
            date:new Date().getTime()+7000,
            Type:"text"
        },
        
        
        )
      }).then(async() => {

        await db.collection("CorreioMSg")
        .add({
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg:`*${AutoMsg}*`,
          Botao:[],
          Tel:Tele,
          Type:"text",
          Agendamento:firebase.firestore.FieldValue.serverTimestamp()
        })
        .then( async (docRef) => { 
         
        });
   
        
      }).catch((error) => {
         
      });   
    },
    RobotizarPag: async(data, Tele, DadEmp)=> {

      var MsgEmp = DadEmp.MsgAuto;

  

      var QMsg3= MsgEmp.Msg17A.Msg.length;
      var QMsg4= MsgEmp.Msg17B.Msg.length;
      var QMsg5= MsgEmp.Msg17C.Msg.length;
      var Sorteio3 = Math.floor(Math.random() * (QMsg3 - 1 + 1)) + 1;
      var Sorteio4 = Math.floor(Math.random() * (QMsg4 - 1 + 1)) + 1;
      var Sorteio5 = Math.floor(Math.random() * (QMsg5 - 1 + 1)) + 1;

      var Result3 =parseInt(Sorteio3);
      var Result4 =parseInt(Sorteio4);
      var Result5 =parseInt(Sorteio5);

      var Num3 = Result3-1;
      var Num4 = Result4-1;
      var Num5 = Result5-1;
      var AutoMsg3 = MsgEmp.Msg17A.Msg[Num3];
      var AutoMsg4= MsgEmp.Msg17B.Msg[Num4];
      var AutoMsg5= MsgEmp.Msg17C.Msg[Num5];
      var Tempo3 = MsgEmp.Msg17A.TempoSeg + new Date().getTime();
      var Tempo4 = MsgEmp.Msg17B.TempoSeg + new Date().getTime();
      var Tempo5 = MsgEmp.Msg17C.TempoSeg + new Date().getTime();
         
   
      await db.collection("ChatCliente")
      .doc(data)
      .update({
        FaseMsg: "Msg8A",
        MemSessao:[],
        Sessao:"",
        DigiteNaRegra:true,
        Robotizado:true, 
        RoboAtivo:true,
        MsgFutura1:{
            Ativo:true,
            Msg:AutoMsg3,
            Tempo:Tempo3,
        },
        MsgFutura2:{
            Ativo:true,
            Msg:AutoMsg4,
            Tempo:Tempo4,
        },
        MsgFutura3:{
            Ativo:true,
            Msg:AutoMsg5,
            Tempo:Tempo5,
        },
        UltimaMsg:{
            Autor:EMPRESA,
            body:"*Qual Vai ser a forma de pagamento?* \n Pix \n Cartão de Credito \n Dinheiro",
            date:new Date().getTime()+5000,
            Type:"text"
        },
        Mensagem:firebase.firestore.FieldValue.arrayUnion (
       
        {
            Autor:EMPRESA,
            body:"*Qual Vai ser a forma de pagamento?* \n Pix \n Cartão de Credito \n Dinheiro",
            Botao:[],
            date:new Date().getTime()+7000,
            Type:"text"
        },
        
        
        )
      }).then(async() => {

        await db.collection("CorreioMSg")
        .add({
          Ativo:true,
          EMPRESA:EMPRESA,
          Msg:"*Qual Vai ser a forma de pagamento?* \n Pix \n Cartão de Credito \n Dinheiro",
          Botao:[],
          Tel:Tele,
          Type:"text",
          Agendamento:firebase.firestore.FieldValue.serverTimestamp()
        })
        .then( async (docRef) => { 
         
        });
   
        
      }).catch((error) => {
         
      });   
    },
    RobotizarFim: async(data, Tele, DadEmp)=> {

      var MsgEmp = DadEmp.MsgAuto;

  

      var QMsg3= MsgEmp.Msg17A.Msg.length;
      var QMsg4= MsgEmp.Msg17B.Msg.length;
      var QMsg5= MsgEmp.Msg17C.Msg.length;
      var Sorteio3 = Math.floor(Math.random() * (QMsg3 - 1 + 1)) + 1;
      var Sorteio4 = Math.floor(Math.random() * (QMsg4 - 1 + 1)) + 1;
      var Sorteio5 = Math.floor(Math.random() * (QMsg5 - 1 + 1)) + 1;

      var Result3 =parseInt(Sorteio3);
      var Result4 =parseInt(Sorteio4);
      var Result5 =parseInt(Sorteio5);

      var Num3 = Result3-1;
      var Num4 = Result4-1;
      var Num5 = Result5-1;
      var AutoMsg3 = MsgEmp.Msg17A.Msg[Num3];
      var AutoMsg4= MsgEmp.Msg17B.Msg[Num4];
      var AutoMsg5= MsgEmp.Msg17C.Msg[Num5];
      var Tempo3 = MsgEmp.Msg17A.TempoSeg + new Date().getTime();
      var Tempo4 = MsgEmp.Msg17B.TempoSeg + new Date().getTime();
      var Tempo5 = MsgEmp.Msg17C.TempoSeg + new Date().getTime();
         
   
      await db.collection("ChatCliente")
      .doc(data)
      .update({
        FaseMsg: "Msg9A",
        MemSessao:[],
        Sessao:"",
        DigiteNaRegra:true,
        Robotizado:true, 
        RoboAtivo:true,
        MsgFutura1:{
            Ativo:false,
            Msg:AutoMsg3,
            Tempo:Tempo3,
        },
        MsgFutura2:{
            Ativo:false,
            Msg:AutoMsg4,
            Tempo:Tempo4,
        },
        MsgFutura3:{
            Ativo:false,
            Msg:AutoMsg5,
            Tempo:Tempo5,
        },
     
      }).then(async() => {

      
   
        
      }).catch((error) => {
         
      });   
    },


    DesRobotizar: async(data )=> {
  
      await db.collection("ChatCliente")
      .doc(data)
      .update({
        DigiteNaRegra:false,
        MemSessao:"",
        MemPedido:"",
        MemProdutos:"",
        MemSubSessao:"",
        Sessao:"",
        EscolhaSabor:0,
        MenSabor:"",
        Robotizado:false,
        RoboAtivo:false,
        "MsgDinamica.Ativo":false,
        "MsgFutura1.Ativo":false,
        "MsgFutura2.Ativo":false,
        "MsgFutura3.Ativo":false,
      }).then(async() => {
       
   
        
      }).catch((error) => {
         
      });   
    },

    DesRobotizarDeli: async(IdPed, setAlert, setAlertTipo)=> {
      var data = ""
      await db.collection("ChatCliente")
      .where("Empresa", "==", EMPRESA)
      .where("Pedido", "==", IdPed)
      .where("Ativo", "==", true)
        .onSnapshot(async (querySnapshot) => {
     
            
        querySnapshot.forEach((doc) => {
          data =doc.id;
        })


      await db.collection("ChatCliente")
      .doc(data)
      .update({
        DigiteNaRegra:false,
        MemSessao:"",
        MemPedido:"",
        MemProdutos:"",
        MemSubSessao:"",
        Sessao:"",
        EscolhaSabor:0,
        MenSabor:"",
        Robotizado:false,
        RoboAtivo:false,
        "MsgDinamica.Ativo":false,
        "MsgFutura1.Ativo":false,
        "MsgFutura2.Ativo":false,
        "MsgFutura3.Ativo":false,
      }).then(async() => {
        setAlert("Robo Desativado ");
        setAlertTipo("success");
     
        
      }).catch((error) => {
         
      });   
    })
    },

    sendMessageLink: async(data, text, nome, TemUmlt, Varia, VizuS)=> {
      let Cont = VizuS + 1;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
         await db.collection("users")
         .doc(data).update({
           mensagem: firebase.firestore.FieldValue.arrayUnion ({
             autor:"Sistema",
             nome: "BetFranquias",
             body: text,
             date: now,
             type:"Link"
           }),
           ultimaMsg:{id:"Sistema", nome: "BetFranquias", data: now, msg:"Link"},
           vizualS: Cont, 
       }).then((doc)=>{
    
   
        // db.collection("ocorrencia")
        // .doc(data)
        // .get().then((doc) => {
         
        //   if (doc.exists) {
        //       console.log(res);
        //   } else {
        //       // doc.data() will be undefined in this case
        //       console.log("No such document!");
        //   }
      }).catch((error) => {
         
      });   
    },

    EnviarImgChat: async(data, text, nome, TemUmlt, Varia, VizuS, Imgs)=> {
      let Url1 = "";
      let Url2 = "";
      let Url3 = "";
      let Url4 = "";

      if(Imgs[0].Foto !== ""){
        const fileName = await Date.now() + Imgs[0].Foto.name;
        const storageRef = await storage.ref();
        const fileRef = await storageRef.child(`arquivo/${fileName}`);
        await await fileRef.put(Imgs[0].Foto).then((doc)=> {
          
        });
        Url1 =  await fileRef.getDownloadURL();
      }
      
      let Cont = VizuS + 1;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
         await db.collection("users")
         .doc(data).update({
           mensagem: firebase.firestore.FieldValue.arrayUnion ({
             autor:"Sistema",
             nome: "BetFranquias",
             body: Url1,
             date: now,
             type:"image"
           }),
           ultimaMsg:{id:"Sistema", nome: "BetFranquias", data: now, msg:"image"},
           vizualS: Cont, 
       }).then((doc)=>{
    
   
        // db.collection("ocorrencia")
        // .doc(data)
        // .get().then((doc) => {
         
        //   if (doc.exists) {
        //       console.log(res);
        //   } else {
        //       // doc.data() will be undefined in this case
        //       console.log("No such document!");
        //   }
      }).catch((error) => {
         
      });   
 
      
     },

    EnviandoOc: async(data, text, nome, TemUmlt, Varia, VizuS, IdPM, activeChatPM, NomePM, Nome)=> {
      let Cont = VizuS + 1;
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
         await db.collection("chat")
         .doc(activeChatPM).update({
           mensagem: firebase.firestore.FieldValue.arrayUnion ({
             autor:id,
             nome: nome,
             body: "Ocorrência foi enviada para seu celular, entre na sessão ocorrência",
             date: now,
             type:"text"
           }),
           ultimaMsg:{id:id, nome: nome, data: now, msg: "Ocorrência foi enviada para seu celular, entre na sessão ocorrência"},
           Ocupado:true,
           idOC:data,
           NomeOc: Nome,
       }).then((doc)=>{
    
   
       
      }).catch((error) => {
         
      }); 

      await db.collection("ocorrencia")
      .doc(data).update({
        mensagem: firebase.firestore.FieldValue.arrayUnion ({
          autor:id,
          nome: nome,
          body: "Viatura já está a caminho",
          date: now,
          type:"text"
        }),
        ultimaMsg:{id:id, nome: nome, data: now, msg:"Viatura já está a caminho"},
        vizualS: Cont,
        IdPM:IdPM,
        NomePM:NomePM,
        PmIndo:true,
        IdChat:activeChatPM,
        userChat:firebase.firestore.FieldValue.arrayUnion ({
          id: IdPM,
          nome: NomePM,
        }),
    }).then((doc)=>{

   }).catch((error) => {
      
   });     
    },

    ReenviandoOc: async(data, text, nome, TemUmlt, Varia, VizuS, IdPM, activeChatPM, NomePM)=> {
      let Cont = VizuS + 1;
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
         await db.collection("chat")
         .doc(activeChatPM).update({
           mensagem: firebase.firestore.FieldValue.arrayUnion ({
             autor:id,
             nome: nome,
             body: "A Ocorrência vai ser direcionada para outro PM, por isso está sendo retirada de você",
             date: now,
             type:"text"
           }),
           ultimaMsg:{id:id, nome: nome, data: now, msg: "A Ocorrência vai ser direcionada para outro PM, por isso está sendo retirada de você"},
           Ocupado:false,
           idOC:"",
           NomeOc:"",
       }).then((doc)=>{
    
   
       
      }).catch((error) => {
         
      }); 

      await db.collection("ocorrencia")
      .doc(data).update({
        mensagem: firebase.firestore.FieldValue.arrayUnion ({
          autor:id,
          nome: nome,
          body: "Desculpe, estamos Reenviando outra Viatura, no momento aguarde! ",
          date: now,
          type:"text"
        }),
        ultimaMsg:{id:id, nome: nome, data: now, msg:"Desculpe, estamos Reenviando outra Viatura, no momento aguarde!"},
        vizualS: Cont,
        IdPM:"",
        PmIndo:false,
        NomePM:"",
    }).then((doc)=>{

   }).catch((error) => {
      
   });     
    },

    sendMessagePM: async(data, text, nome, TemUmlt, Varia, Vizul, Status)=> {
      let Cont = Vizul + 1;
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
      if(Status === "Sofredor" ) {
        await db.collection("chat")
        .doc(data).update({
          mensagem: firebase.firestore.FieldValue.arrayUnion ({
            autor:id,
            nome: nome,
            body: text,
            date: now,
            type:"text"
          }),
          ultimaMsg:{id:id, nome: nome, data: now, msg:text},
          vizualS:Cont,
      }).then((doc)=>{
   
     }).catch((error) => {
        
     }); 

      } else {
        await db.collection("chat")
        .doc(data).update({
          mensagem: firebase.firestore.FieldValue.arrayUnion ({
            autor:id,
            nome: nome,
            body: text,
            date: now,
            type:"text"
          }),
          ultimaMsg:{id:id, nome: nome, data: now, msg:text},
          vizualC:Cont, 
      }).then((doc)=>{

     }).catch((error) => {
        
     });   
      }
      
    },

    sendMessageBotao: async(data, text, nome, TemUmlt, Varia)=> {
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
         await db.collection("ocorrencia")
         .doc(data).update({
           mensagem: firebase.firestore.FieldValue.arrayUnion ({
             autor:id,
             nome: nome,
             body: "Clique E Envie sua Localização",
             date: now,
             type:"botao"
           }),
           ultimaMsg:{id:id, nome: nome, data: now, msg:text} 
       }).then((doc)=>{
    
   
        // db.collection("ocorrencia")
        // .doc(data)
        // .get().then((doc) => {
         
        //   if (doc.exists) {
        //       console.log(res);
        //   } else {
        //       // doc.data() will be undefined in this case
        //       console.log("No such document!");
        //   }
      }).catch((error) => {
         
      });   
    },

    sendMessageBotaoPM: async(data, text, nome, TemUmlt, Varia)=> {
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
         await db.collection("chat")
         .doc(data).update({
           mensagem: firebase.firestore.FieldValue.arrayUnion ({
             autor:id,
             nome: nome,
             body: "Clique E Envie sua Localização",
             date: now,
             type:"botao"
           }),
           ultimaMsg:{id:id, nome: nome, data: now, msg:"Clique E Envie sua Localização"} 
       }).then((doc)=>{
    
   
        // db.collection("ocorrencia")
        // .doc(data)
        // .get().then((doc) => {
         
        //   if (doc.exists) {
        //       console.log(res);
        //   } else {
        //       // doc.data() will be undefined in this case
        //       console.log("No such document!");
        //   }
      }).catch((error) => {
         
      });   
    },


    AtulUltOc: async(Let1, Let2, Let3, NumVal)=> {
   
         await db.collection("ultimaOcorr")
         .doc("FTKRA384rOgVMPawzEpf").update({
           letra1:Let1,
           letra2:Let2,
           letra3:Let3,
           numero:NumVal,
       }).then((doc)=>{
      }).catch((error) => {
         
      });   
    },

    AddCon: async(activeChat, id, nome, setAlertTipo, setAlert)=> {
      const autenticado =  await Auth.currentUser;
    
     
         await db.collection("ocorrencia")
         .doc(activeChat).update({
           condicionais: firebase.firestore.FieldValue.arrayUnion ({
             id:id,
             nome: nome,
           }), 
       }).then((doc)=>{
        setAlert("Adicionado com sucesso");
        setAlertTipo("success");
      }).catch((error) => {
        setAlert("Ocorreu erro na adição");
        setAlertTipo("danger");
      });   
    },

    

    PesquisarConversa: async(data, Dados, setAtivo, setList, setUser, setTemUmlt, setDateIni)=> {
     
         
        await db.collection("ChatCliente")
        .doc(data)
          .onSnapshot((doc) => {
           // setAtivo(doc.data().RoboAtivo)
              const res = [];
              if(doc.data()){
                setList(doc.data().Mensagem);
              }
              
                 
                
                         
                });
              
            
               
            

          

           
          
     
    },

    PesquisarConversaPM: async(data, Dados, setList, setUser,  setVizuM, setVizuT, setDigiM, setDigiT, setStatus, setLocPM, setIdPM, setNomePM,  setLoading)=> {
     console.log(data)
      await Auth.onAuthStateChanged( async function(user) {
        if (user) {
        const ID = user.uid;
        setUser(ID);
        if(data !== null){
          db.collection("chat").doc(data)
          .onSnapshot((doc) => {
            setList(doc.data().mensagem);
            if(ID === doc.data().idCriador ){
              setVizuM(doc.data().vizualC);
              setDigiM(doc.data().digiC);
              setStatus("Criador");
              setVizuT(doc.data().vizualS);
              setDigiT(doc.data().digiS);
              setIdPM(doc.data().idSofrer);
              setNomePM(doc.data().nomeSofrer)
            } else{
              setNomePM(doc.data().nomeCriador)
              setIdPM(doc.data().idCriador)
              setVizuM(doc.data().vizualS);
              setDigiM(doc.data().digiS);
              setStatus("Sofredor");
              setVizuT(doc.data().vizualC);
              setDigiT(doc.data().digiC);
              setLocPM(doc.data().localizacao ? doc.data().localizacao : {});
            }

            setLoading(false);
          });
        }
      
          
       
        } 
    
      }); 

      
        
    },

    CriandoJogos: async (Dados, Id, DataA, Infor, Casa, Fora, Cond, Bets, setAlert, setAlertTipo, setVisi2, setInfCarreg) => {   
      await db.collection("users")
      .where("Telefone", "==", Dados.Tel)
      .where("DataEnt", "==", Dados.DataEnt)
      .get().then(async (querySnapshot) => {
        if(querySnapshot.size  !== 0){
       
        var res = [];
        var IdList = [];

         for(let i in Bets){
          setInfCarreg(parseInt(((i+1)/Bets.length)*10)  )
        await db.collection("CasaOlds").add({
            Grupo: Bets[i].Grupo,
            Casa: Bets[i].Casa,
            Casa: Casa,
            Fora: Fora,
            fixture:Id.fixture,
            liga:Id.league,
            Resultado:"Em Analise",
            dataCriacao:new Date().getTime(),
            QuantEsc:0,
            QuantPag:0,
        })
        .then((docRef) => {
            res.push({
              idCasaOlds:docRef.id,
              id:Bets[i].id,
              Grupo:Bets[i].Grupo,
              Casa:Bets[i].Casa,
              Olds:Bets[i].Olds,
              GrupoEng:Bets[i].GrupoEng,
              CasaEng:Bets[i].CasaEng,
            })

        })
        .catch((error) => {
            console.error("Error adding document: ", error);
        });
         
        
        
        }

        await db.collection("JogosCirados").add({
          Ativo:true,
          fixture:Id.fixture,
          liga:Id.league,
          DiaJogo: DataA,
          AtualApi:Id.update,
          Atualizei:new Date().getTime(),
          Casa:Casa,
          Fora:Fora,
          Best:res,
          dataCriacao:new Date().getTime(),
          CasaDeAposta:Cond,
          Estadio:Infor.fixture.venue.name,
          Analisado:false,
        }).then(()=>{
          setVisi2(false);
          setAlert("Adicionado com sucesso");
          setAlertTipo("success");
          

        })





 
        }else {
          setAlert("Você está tentando entrar de forma incorreta!")
          setAlertTipo("danger");
        };
       });
     
    
     
           
    },


    CriandoJogosPix: async (Dados, Liga, DataA, Infor, Casa, Fora, Cond, Bets, LinkResul, LinkJo, ResulSite, setAlert, setAlertTipo, setVisi2, setInfCarreg) => {   
  
      var Result = "";

      if(ResulSite === "SportCenter"){
        Result = LinkResul + "/match" 
      } else {
        Result = LinkResul
      }
      console.log(Result)
      console.log(LinkJo)
      
      await db.collection("users")
      .where("Telefone", "==", Dados.Tel)
      .where("DataEnt", "==", Dados.DataEnt)
      .get().then(async (querySnapshot) => {
        if(querySnapshot.size  !== 0){
       
        var res = [];
        var IdList = [];

         for(let i in Bets){
          setInfCarreg(parseInt(((i+1)/Bets.length)*10)  )
        await db.collection("CasaOlds").add({
            Grupo: Bets[i].Grupo,
            Casa: Bets[i].Casa,
            Casa: Casa,
            Fora: Fora,
            fixture:"",
            liga: Liga,
            Resultado:"Em Analise",
            dataCriacao:new Date().getTime(),
            QuantEsc:0,
            QuantPag:0,
            linkRe:Result,
            
        })
        .then((docRef) => {
            res.push({
              idCasaOlds:docRef.id,
              Grupo:Bets[i].Grupo,
              Casa:Bets[i].Casa,
              Olds:Bets[i].Olds,
              LinkResul:Result,
            
            })

        })
        .catch((error) => {
            console.error("Error adding document: ", error);
        });
         
        
        
        }

        await db.collection("JogosCirados").add({
          Ativo:true,
          fixture:"",
          liga:Liga,
          DiaJogo: DataA,
          AtualApi: 0,
          Atualizei:new Date().getTime(),
          Casa:Casa,
          Fora:Fora,
          Best:res,
          dataCriacao:new Date().getTime(),
          CasaDeAposta:Cond,
          Estadio:"",
          Analisado:false,
          LinkResu:Result,
          LinkJogo:LinkJo,
        }).then(()=>{
          setVisi2(false);
          setAlert("Adicionado com sucesso");
          setAlertTipo("success");
          

        })





 
        }else {
          setAlert("Você está tentando entrar de forma incorreta!")
          setAlertTipo("danger");
        };
       });
     
    
     
           
    },


    EnviOcSalvar: async (Id, Vtr, AtenCop, CompVt,  Conduz, Viti, ObjAp, ResulOc, Relato, Prov, setAlert, setAlertTipo, Arq, Pdf,  setVisi2, Test, Autor, NumOc, ObjRF) => {   
 
      if(Arq !== "" ){
          const fileName = await Date.now() + Arq.name;
          const storageRef = storage.ref();
          const fileRef = storageRef.child(`arquivo/${fileName}`);
          await fileRef.put(Arq).then((doc)=> {
            
          });
          const Url =  await fileRef.getDownloadURL();
          await db.collection('ocorrencia')
          .doc(Id)
          .update({
            vtr: Vtr,
            atendenteCopom: AtenCop,
            componentesVtr: CompVt,
            conduzidos:Conduz,
            vitimas:Viti,
            objetosApre:ObjAp,
            grupoOcrr:Url,
            resultado: ResulOc,
            relato:Relato,
            providencias:Prov,
            testemunha:Test,
            autores:Autor,
            Ocorr:NumOc,
            objRoubados:ObjRF,
          }).then(()=>{
            setVisi2(false);
            setAlertTipo("success");
            setAlert("Editado com sucesso");
          });

      } else {
        console.log("entrou");
        await db.collection('ocorrencia')
        .doc(Id)
        .update({
          vtr: Vtr,
          atendenteCopom: AtenCop,
          componentesVtr: CompVt,
          conduzidos:Conduz,
          vitimas:Viti,
          objetosApre:ObjAp,
          resultado: ResulOc,
          relato:Relato,
          providencias:Prov,
          testemunha:Test,
          autores:Autor,
          Ocorr:NumOc,
          objRoubados:ObjRF,
        }).then(()=>{
          setVisi2(false);
          setAlertTipo("success");
          setAlert("Editado com sucesso");
        });
      }
     
           
    },

    EnviVtr: async (data, Vtr, AtenCop, CompVt, Periodo, Rua, Numero, Bairro, Cidade, Estado, Lat, Lng, Conduz, Viti, ObjAp, ResulOc, Relato, Prov, tempoMad, Test, Autor, ObjRF) => {   
      await db.collection('ocorrencia')
      .doc(data)
      .update({
        dataInicio:{seconds:tempoMad},
        vtr: Vtr,
        atendenteCopom: AtenCop,
        componentesVtr: CompVt,
        periodo: Periodo,
        rua: Rua,
        numero: Numero,
        bairro: Bairro,
        cidade: Cidade,
        estado: Estado,
        localizacao:{lat: Lat, lng:Lng},
        conduzidos:Conduz,
        vitimas:Viti,
        objetosApre:ObjAp,
        grupoOcrr:"",
        resultado: ResulOc,
        relato:Relato,
        providencias:Prov,
        testemunha:Test,
        autores:Autor,
        objRoubados:ObjRF,
      })
           
    },

    EnviNum: async (data, NuOc) => {  
      console.log("entrou nume"); 
      await db.collection('ocorrencia')
      .doc(data)
      .update({
        Ocorr:NuOc,
      })
           
    },
    DadosPedido: async (data, setPedido) => {   
      console.log()
      await db.collection('MesaItem')
      .doc(data)
      .onSnapshot((doc) => {
         setPedido(doc.data())
      });
       
           
    },

    DadosForm: async (data, setVtr, setAtenCop, setCompVt, setRua, setNumero, setBairro, setCidade, setEstado, setLat, setLng, setConduz, setViti, setObjAp, setResulOc, setRelato, setProv, setDataTime, setTest, setNumOc, setAutor, setObjRF  ) => {   
      console.log()
      await db.collection('ocorrencia')
      .doc(data)
      .get()
      .then((doc) => {
        setVtr(doc.data().vtr);
        setAtenCop(doc.data().atendenteCopom);
        setCompVt(doc.data().componentesVtr);
        setRua(doc.data().rua);
        setNumero(doc.data().numero);
        setBairro(doc.data().bairro);
        setEstado(doc.data().estado);
        setCidade(doc.data().cidade);
        setLat(doc.data().localizacao.lat);
        setLng(doc.data().localizacao.lng);
        setConduz(doc.data().conduzidos);
        setViti(doc.data().vitimas);
        setObjAp(doc.data().objetosApre);
        setResulOc(doc.data().resultado);
        setRelato(doc.data().relato);
        setProv(doc.data().providencias);
        setDataTime(doc.data().dataInicio.seconds*1000);
        setNumOc(doc.data().Ocorr);
        setTest(doc.data().testemunha);
        setAutor(doc.data().autores);
        setObjRF(doc.data().objRoubados);
      });
       
           
    },


    MsgLida: async (Id, V) => {   
      await db.collection("ChatCliente").doc(Id).update({
        'vizualEmp': V
    })
    .then(() => {
      
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });   
           
    },

    MsgLidaPM: async (activeChatPM, VizulPM) => {
      
      await Auth.onAuthStateChanged( async function(user) {
        if (user) {
        let ID = user.uid;
      
        await db.collection("chat")
        .doc(activeChatPM)
        .get().then((doc) => {
          console.log("entrou");
          if(doc.data().idSofrer === ID) {
            db.collection('chat').doc(activeChatPM).update({
              'vizualS': VizulPM,
          })
          .then(() => {
            
          })
          .catch((error) => {
              // The document probably doesn't exist.
              console.error("Error updating document: ", error);
          });   

          } else {

            db.collection('chat').doc(activeChatPM).update({
              'vizualC': VizulPM,
          })
          .then(() => {
            
          })
          .catch((error) => {
              // The document probably doesn't exist.
              console.error("Error updating document: ", error);
          });   

          }
             
    
              
              
     
        
          
      }).catch((error) => {
         
      });


        
        }});
    
     
     
           
    },

    Digitando: async (data) => {
      await Auth.onAuthStateChanged( async function(user) {
        if (user) {
        await db.collection('ocorrencia')
       .doc(data)
       .update({
        DigiS: true
    })
    .then(() => {
        
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });   
           
     
        
       
        } 
    
      }); 
     
   
    },

    DigitandoPM: async (data, Status) => {
      await Auth.onAuthStateChanged( async function(user) {
        if (user) {
          if(Status === "Criador"){
            await db.collection('chat')
            .doc(data)
            .update({
              digiC: true,
         })
         .then(() => {
             
         })
         .catch((error) => {
             // The document probably doesn't exist.
             console.error("Error updating document: ", error);
         });  

          } else {
            await db.collection('chat')
            .doc(data)
            .update({
              digiS: true,
         })
         .then(() => {
             
         })
         .catch((error) => {
             // The document probably doesn't exist.
             console.error("Error updating document: ", error);
         });  

          }
   
           
     
        
       
        } 
    
      }); 
     
   
    },

    NaoDigitandoPM: async (data, Status) => {
      await Auth.onAuthStateChanged( async function(user) {
        if (user) {
          if(Status === "Criador"){
            await db.collection('chat')
            .doc(data)
            .update({
              digiC: false,
         })
         .then(() => {
             
         })
         .catch((error) => {
             // The document probably doesn't exist.
             console.error("Error updating document: ", error);
         });  

          } else {
            await db.collection('chat')
            .doc(data)
            .update({
              digiS: false,
         })
         .then(() => {
             
         })
         .catch((error) => {
             // The document probably doesn't exist.
             console.error("Error updating document: ", error);
         });  

          }
   
           
     
        
       
        } 
    
      }); 
     
   
    },

    NaoDigitando: async (data) => {
      await Auth.onAuthStateChanged( async function(user) {
        if (user) {
     await db.collection('ocorrencia')
       .doc(data)
       .update({
        DigiS: false
    })
    .then(() => {
       
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });   
           
     
        
       
        } 
    
      }); 
     
   
    },


    ConcluirOc: async(data, Exc, NuOc)=> {
      console.log("entrou 1");
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      await db.collection('ocorrencia') 
      .doc(data)
      .get().then((doc) => {
        let Me = doc.data().IdChat;
        if(Me === undefined){
          db.collection('ocorrencia')
          .doc(data)
          .update({
           ativo: false,
           dataFim: firebase.firestore.FieldValue.serverTimestamp(),
           excluir:Exc,
           Ocorr:NuOc,
       })
       .then(() => {
          
       })
       .catch((error) => {
          
       });   

        } else {
          db.collection("chat")
          .doc(Me).update({
            Ocupado:false,
            idOC:"",
            NomeOc: "",
        }).then((doc)=>{
  
          db.collection('ocorrencia')
          .doc(data)
          .update({
           ativo: false,
           dataFim: firebase.firestore.FieldValue.serverTimestamp(),
           excluir:Exc,
           Ocorr:NuOc,
       })
       .then(() => {
          
       })
       .catch((error) => {
          
       });   
         
        
       }).catch((error) => {
          
       }); 

        }
       
     

      })


     
      
    },
    ConOcorrencia: async(data, Exc)=> {
      console.log("entrou 2");
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;

      db.collection('ocorrencia') 
      .doc(data)
      .get().then((doc) => {
        
        let Me = doc.data().IdChat;

        if(Me === undefined){
          db.collection('ocorrencia')
          .doc(data)
          .update({
           ativo: false,
           dataFim: firebase.firestore.FieldValue.serverTimestamp(),
           excluir:Exc,
       })
       .then(() => {
          
       })
       .catch((error) => {
           // The document probably doesn't exist.
           
       }); 

        } else {
          db.collection("chat")
          .doc(Me).update({
            Ocupado:false,
            idOC:"",
            NomeOc: "",
        }).then((doc)=>{
  
         db.collection('ocorrencia')
          .doc(data)
          .update({
           ativo: false,
           dataFim: firebase.firestore.FieldValue.serverTimestamp(),
           excluir:Exc,
       })
       .then(() => {
          
       })
       .catch((error) => {
           // The document probably doesn't exist.
           
       }); 
         
        
       }).catch((error) => {
          
       }); 

        }
   

      })

       
      
    },


      ExcluirOc: async(data, Varia, nome)=> {
        
        
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
      let temp = new Date().getTime();
      let now = temp + (Varia*1000);
      await db.collection('ocorrencia') 
      .doc(data)
      .get().then((doc) => {
       
        let Me = doc.data().IdChat;
        console.log("entrou aqui"+ Me);
        if(Me === undefined){
          db.collection('ocorrencia')
          .doc(data)
           .delete();

        } else{
          db.collection("chat")
          .doc(Me).update({
            mensagem: firebase.firestore.FieldValue.arrayUnion ({
              autor:id,
              nome: nome,
              body: "Ocorrência foi excluida",
              date: now,
              type:"text"
            }),
            ultimaMsg:{id:id, nome: nome, data: now, msg: "Ocorrência foi excluida"},
            Ocupado:false,
            idOC:"",
            NomeOc: "",
        }).then((doc)=>{
          
          db.collection('ocorrencia')
          .doc(data)
           .delete();
        
       }).catch((error) => {
          
       }); 

        }
        

      })

      
    },

    EnviarLocali: async(activeChat, la, ln, setAlert, setAlertTipo  )=> {
      console.log(la);
      console.log(ln);
      console.log(activeChat);
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
       await db.collection('ocorrencia')
       .doc(activeChat)
       .update({
        "localizacao":{lat: la, lng: ln},
    })
    .then(() => {
       setAlertTipo("success");
       setAlert("Endereço enviado com sucesso");
    })
    .catch((error) => {
      setAlertTipo("danger");
      setAlert("Endereço não enviado, Houve algum erro");
    });   
      
    },

    AddCondi: async(activeChat, Forms)=> {
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
       await db.collection('ocorrencia')
       .doc(activeChat)
       .update({
        condicionais: Forms,
    })
    .then(() => {
       
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });   
    },

    ExcluirCondi: async(activeChat, Cont, setAlertTipo, setAlert )=> {
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
       await db.collection('ocorrencia')
       .doc(activeChat)
       .update({
        condicionais: Cont,
    })
    .then(() => {
      setAlert(" ");
      setAlertTipo("");
       
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });   
    },

    ExcluirCondiRev: async(Id, cond, setAlertTipo, setAlert )=> {
      const autenticado =  await Auth.currentUser;
      const id = await autenticado.uid;
       await db.collection('ocorrencia')
       .doc(Id)
       .update({
        condicionais: cond,
    })
    .then(() => {
      setAlert(" ");
      setAlertTipo("");
       
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });   
    },
      


    PegarCond: async(activeChat, setForms, setLoc)=> {
 
      await db.collection('ocorrencia')
      .doc(activeChat)
      .onSnapshot((doc) => {
        if(doc.data()){
        setLoc(doc.data().localizacao);
        if(doc.data().condicionais) {
          setForms(doc.data().condicionais);
        } else {
          setForms([]);
        }
      }
       
    });
    },

    PegarCondForms: async(activeChat, setCondVer)=> {
      
      await db.collection('ocorrencia')
      .doc(activeChat)
      .onSnapshot((doc) => {
        if(doc.data().condicionais) {
          setCondVer(doc.data().condicionais);
        } else {
          setCondVer([]);
        }
       
    });


    },

    CriandoNoti: async(TituNoti, Forms, Forms1, Infoma, TituAnun , NumEsp, Cidade, Estado, Cond, setAlertTipo, setAlert, Imgs, setVisi1)=> {
      
     await  setVisi1(true)
     if(Cond === "Mensagem" || Cond === "Localização" || Cond === "Contato" || Cond === "Texto Botões"){
      await db.collection("MensagensWhats").add({
        Titulo:TituNoti,
        Text:TituAnun,
        Url:"",
        Infor:Infoma,
        Btn:Forms,
        RespBtn:Forms1,
        Especifica:NumEsp,
        Cidade:Cidade,
        Estado:Estado,
        Tipo:Cond,
        dataCriacao: new Date().getTime(),
        }).then(() => {
          setAlert("Criado Com Sucesso ");
          setAlertTipo("success");
          setVisi1(false);
           
        })
        .catch((error) => {
          setAlert("Ouve algum Erro! ");
          setAlertTipo("danger");
          setVisi1(false);
        });  
     } else {

     
        let Url1 = "";
        let Url2 = "";
        let Url3 = "";
        let Url4 = "";

        if(Imgs[0].Foto !== ""){
          const fileName = await Date.now() + Imgs[0].Foto.name;
          const storageRef = await storage.ref();
          const fileRef = await storageRef.child(`arquivo/${fileName}`);
          await await fileRef.put(Imgs[0].Foto).then((doc)=> {
            
          });
          Url1 =  await fileRef.getDownloadURL();
        }

        // if(Imgs[1].Foto !== ""){
        //   const fileName = await Date.now() + Imgs[1].Foto.name;
        //   const storageRef = await storage.ref();
        //   const fileRef = await storageRef.child(`arquivo/${fileName}`);
        //   await await fileRef.put(Imgs[1].Foto).then((doc)=> {
            
        //   });
        //   Url2 =  await fileRef.getDownloadURL();
        // }

        // if(Imgs[2].Foto !== ""){
        //   const fileName = await Date.now() + Imgs[2].Foto.name;
        //   const storageRef = await storage.ref();
        //   const fileRef = await storageRef.child(`arquivo/${fileName}`);
        //   await await fileRef.put(Imgs[2].Foto).then((doc)=> {
            
        //   });
        //   Url3 =  await fileRef.getDownloadURL();
        // }

        // if(Imgs[3].Foto !== ""){
        //   const fileName = await Date.now() + Imgs[3].Foto.name;
        //   const storageRef = await storage.ref();
        //   const fileRef = await storageRef.child(`arquivo/${fileName}`);
        //   await await fileRef.put(Imgs[3].Foto).then((doc)=> {
            
        //   });
        //   Url4 =  await fileRef.getDownloadURL();

        await db.collection("MensagensWhats").add({
          Titulo:TituNoti,
          Text:TituAnun,
          Url:Url1,
          Infor:Infoma,
          Btn:Forms,
          RespBtn:Forms1,
          Especifica:NumEsp,
          Cidade:Cidade,
          Estado:Estado,
          Tipo:Cond,
          dataCriacao:new Date().getTime(),
          }).then(() => {
            setAlert("Criado Com Sucesso ");
            setAlertTipo("success");
            setVisi1(false);
             
          })
          .catch((error) => {
            setAlert("Ouve algum Erro! ");
            setAlertTipo("danger");
            setVisi1(false);
          });  
         }

     
    },

    CriandoMenu: async(Dados, TagMenus, MemFim, Tamanho, GrupTamanho,  setAlertTipo, setAlert, Imgs, Nome)=> {
      
      
      
   



      await db.collection("MenusSite").add({
        Empresa:EMPRESA,
        nome:Nome,
        dataCriacao:new Date().getTime(),
        Tags:TagMenus,
        Ativo:true,
        Tamanho:Tamanho,
        GrupTamanho:GrupTamanho,
        MemFim:MemFim,
       
        }).then(() => {
          setAlert("Menu Criado Com Sucesso ");
          setAlertTipo("success");
        
           
        })
        .catch((error) => {
          setAlert("Ouve algum Erro! ");
          setAlertTipo("danger");
        
        });  
   
  },

  EditandoItens: async(Id, Dados, ListTags, Tamanho, GrupTamanho, Ilimitado, QuanItens, Imgs, Nome, Descri, Preco, PrecoReal, Descont, DescontReal, Menu, Tags, LinkExterno, setAlertTipo, setAlert, setCarreg )=> {
      
    var Quant = parseInt(QuanItens)
      
    let Url1 = "";
 
    if(LinkExterno === false){
      if(Imgs.name !== ""){
      
        const fileName = await Date.now() + Imgs.name;
        const storageRef = await storage.ref();
        const fileRef = await storageRef.child(`arquivo/${fileName}`);
        await await fileRef.put(Imgs).then((doc)=> {
          
        });
        Url1 =  await fileRef.getDownloadURL();
      }

    } else {
      Url1 = Imgs;
    }
  
    var TagsMenus = []
    for(let i in Tags){
      //if(GrupTags.includes(GrupTags[i]+"," ) === false){
      TagsMenus.push(
        Tags[i],
        Tags[i]+",",
        Tags[i]+".",
        Tags[i]+";",
        Tags[i]+":",
        Tags[i]+"s",
        Tags[i]+"r",

      )
  //  }
    }


    await db.collection("ItensDaEmpresa").doc(Id)
    .update({
      Empresa:EMPRESA,
      nome:Nome,
      Descricao:Descri,
      foto:Url1,
      dataCriacao:new Date().getTime(),
      Preco:Preco,
      PrecoReal:parseFloat(PrecoReal),
      Descont:Descont,
      DescontReal:parseFloat(DescontReal),
      Menu:Menu,
      Tags:TagsMenus,
      Ativo:true,
      Ilimitado:Ilimitado,
      Quant:Quant,
      Tamanho:Tamanho, 
      GrupTamanho:GrupTamanho,

      }).then(() => {
        setCarreg(false)
        setAlert("Item Editado Com Sucesso ");
        setAlertTipo("success");
      
         
      })
      .catch((error) => {
        setAlert("Ouve algum Erro! ");
        setAlertTipo("danger");
      
      });  
      if(LinkExterno === false){
      await db.collection("ItensGerais").add({
        Empresa:EMPRESA,
        nome:Nome,
        Descricao:Descri,
        foto:Url1,
        dataCriacao:new Date().getTime(),
        Preco:Preco,
        PrecoReal:PrecoReal,
        Descont:Descont,
        DescontReal:DescontReal,
        Ativo:true,
        Tags:Tags,
        }).then(() => {
          
        
           
        })
        .catch((error) => {
          setAlert("Ouve algum Erro! ");
          setAlertTipo("danger");
        
        });  
      }
 
},

EnviandoMesa: async(Dados, Mesa, Prod, setMesa, setAlert, setAlertTipo, setModalVer)=> {


  await db.collection("MesaItem").add({
    Empresa:EMPRESA,
    Codigo:Dados.Nome.substring(0,20),
    Mesa:Mesa,
    Itens:[Prod],
    dataCriacao:new Date().getTime(),
    Fechado:false,
    Producao:false,

    }).then(() => {
      setMesa("")
      setModalVer(false)
      setAlert("Item Enviado Com Sucesso ");
      setAlertTipo("success");
    
       
    })
   

},

EnviandoPedidoEmp: async( MesaVer, Codig, ListPed, setListPed, setModalVer)=> {


  await db.collection("MesaItem").add({
    Empresa:EMPRESA,
    Codigo:Codig,
    Mesa:MesaVer,
    Itens:ListPed,
    dataCriacao:new Date().getTime(),
    Fechado:false,
    Producao:false,

    }).then(() => {

      setListPed([])
      setModalVer(false)
    
       
    })
   

},

  CriandoItens: async(Dados, Tamanho, GrupTamanho, Ilimitado, QuanItens, Imgs, Nome, Descri, Preco, PrecoReal, Descont, DescontReal, Menu, Tags, LinkExterno, setAlertTipo, setAlert, setCarreg )=> {
      
    var Quant = parseInt(QuanItens)
      
    let Url1 = "";
 
    if(LinkExterno === false){
      if(Imgs.name !== ""){
      
        const fileName = await Date.now() + Imgs.name;
        const storageRef = await storage.ref();
        const fileRef = await storageRef.child(`arquivo/${fileName}`);
        await await fileRef.put(Imgs).then((doc)=> {
          
        });
        Url1 =  await fileRef.getDownloadURL();
      }

    } else {
      Url1 = Imgs;
    }
  



    await db.collection("ItensDaEmpresa").add({
      Empresa:EMPRESA,
      nome:Nome,
      Descricao:Descri,
      foto:Url1,
      dataCriacao:new Date().getTime(),
      Preco:Preco,
      PrecoReal:parseFloat(PrecoReal),
      Descont:Descont,
      DescontReal:parseFloat(DescontReal),
      Menu:Menu,
      Tags:Tags,
      Ativo:true,
      Ilimitado:Ilimitado,
      Quant:Quant,
      GrupTamanho:GrupTamanho,
      Tamanho:Tamanho,
      }).then((dif) => {
        console.log(dif.id)
        setCarreg(false)
        setAlert("Item Criado Com Sucesso ");
        setAlertTipo("success");
      
         
      })
      .catch((error) => {
        setAlert("Ouve algum Erro! ");
        setAlertTipo("danger");
      
      });  
      if(LinkExterno === false){
      await db.collection("ItensGerais").add({
        Empresa:EMPRESA,
        nome:Nome,
        Descricao:Descri,
        foto:Url1,
        dataCriacao:new Date().getTime(),
        Preco:Preco,
        PrecoReal:PrecoReal,
        Descont:Descont,
        DescontReal:DescontReal,
        Ativo:true,
  
        }).then(() => {
          
        
           
        })
        .catch((error) => {
          setAlert("Ouve algum Erro! ");
          setAlertTipo("danger");
        
        });  
      }
 
},

    CriandoAnun: async(Dados,  setAlertTipo, setAlert, Imgs, Nome)=> {
      
      
      
         let Url1 = "";
      
 
         if(Imgs.name !== ""){
           
           const fileName = await Date.now() + Imgs.name;
           const storageRef = await storage.ref();
           const fileRef = await storageRef.child(`arquivo/${fileName}`);
           await await fileRef.put(Imgs).then((doc)=> {
             
           });
           Url1 =  await fileRef.getDownloadURL();
         }
 

 
         await db.collection("anuncios").add({
         
           nome:Nome,
           foto:Url1,
           dataCriacao:new Date().getTime(),
          
           }).then(() => {
             setAlert("Anuncio Criado Com Sucesso ");
             setAlertTipo("success");
           
              
           })
           .catch((error) => {
             setAlert("Ouve algum Erro! ");
             setAlertTipo("danger");
           
           });  
      
     },

     EditandoMenu: async(Dados, Especi, GrupEspeci, AtiEspeci, MemFim, Tamanho, GrupTamanho, Id, Nome, GrupTags, setAlertTipo, setAlert, )=> {
      var TagsMenus = []
      for(let i in GrupTags){
        //if(GrupTags.includes(GrupTags[i]+"," ) === false){
        TagsMenus.push(
          GrupTags[i],
          GrupTags[i]+",",
          GrupTags[i]+".",
          GrupTags[i]+";",
          GrupTags[i]+":",
          GrupTags[i]+"s",
          GrupTags[i]+"r",

        )
    //  }
      }
      var GrupTamanhoReset = []
      var EdiTagsTam = []
      for(let i in GrupTamanho){
         EdiTagsTam = []
        for(let j in GrupTamanho[i].TagsTamanho){
          //if(GrupTamanho[i].TagsTamanho.includes(GrupTamanho[i].TagsTamanho[j]+",") === false){
          EdiTagsTam.push(
            GrupTamanho[i].TagsTamanho[j],
            GrupTamanho[i].TagsTamanho[j]+",",
            GrupTamanho[i].TagsTamanho[j]+".",
            GrupTamanho[i].TagsTamanho[j]+";",
            GrupTamanho[i].TagsTamanho[j]+":",
            GrupTamanho[i].TagsTamanho[j]+"s",
            GrupTamanho[i].TagsTamanho[j]+"r",
 
          )
          //}
        }
        GrupTamanhoReset.push(
          {
            Tamanho:GrupTamanho[i].Tamanho, 
            Preco:GrupTamanho[i].Preco, 
            PrecoReal:GrupTamanho[i].PrecoReal, 
            Qsabor:GrupTamanho[i].Qsabor, 
            Descont:GrupTamanho[i].Descont, 
            DescontReal:GrupTamanho[i].DescontReal, 
            Ativo:GrupTamanho[i].Ativo,
            TagsTamanho:EdiTagsTam  
          }
        )
      }

        await db.collection("MenusSite")
        .doc(Id)
        .update({
         nome:Nome,
         Tags:TagsMenus,
         Tamanho:Tamanho,
         GrupTamanho:GrupTamanhoReset,
         MemFim:MemFim,
         AtiEspeci:AtiEspeci,
         Especifico:Especi,
         GrupEspe:GrupEspeci,

          }).then(() => {
            setAlert("Menu Editado Com Sucesso ");
            setAlertTipo("success");
          
             
          })
          .catch((error) => {
            setAlert("Ouve algum Erro! ");
            setAlertTipo("danger");
          
          });  

    


     
   
  },


     EditandoAnun: async(Dados, Id, setAlertTipo, setAlert, Imgs, Nome, Link, DataIni, DataFim, res1, Viz, Img1, res2, idNot, Not )=> {
      
      console.log(Imgs);
      
      let Url1 = "";
   

      if(Imgs.name ){
        
        const fileName = await Date.now() + Imgs.name;
        const storageRef = await storage.ref();
        const fileRef = await storageRef.child(`arquivo/${fileName}`);
        await await fileRef.put(Imgs).then((doc)=> {
          
        });
        Url1 =  await fileRef.getDownloadURL();
        await db.collection("anuncios")
        .doc(Id)
        .update({
          instituicao: Dados.instituicao,
          cidade: Dados.cidade,
          estado: Dados.estado,
          ativo:res1,
          nome:Nome,
          foto:Url1,
          QuantVi:Viz,
          link:Link,
          DataIni:DataIni,
          DataFim:DataFim,
          noticia:res2,
          idNot: idNot,
           nomeNot: Not,

          }).then(() => {
            setAlert("Anuncio Criado Com Sucesso ");
            setAlertTipo("success");
          
             
          })
          .catch((error) => {
            setAlert("Ouve algum Erro! ");
            setAlertTipo("danger");
          
          });  

      } else {
         await db.collection("anuncios")
      .doc(Id)
      .update({
        instituicao: Dados.instituicao,
        cidade: Dados.cidade,
        estado: Dados.estado,
        ativo:res1,
        nome:Nome,
        QuantVi:Viz,
        link:Link,
        DataIni:DataIni,
        DataFim:DataFim,
        noticia:res2,
        idNot: idNot,
        nomeNot: Not,
        }).then(() => {
          setAlert("Anuncio Criado Com Sucesso ");
          setAlertTipo("success");
        
           
        })
        .catch((error) => {
          setAlert("Ouve algum Erro! ");
          setAlertTipo("danger");
        
        });  

      }



     
   
  },

    EditandoNoti: async(Dados, Id, Data, value, TituNoti , TituAnun , setAlertTipo, setAlert, Imgs, setVisi1)=> {
      
      await  setVisi1(true)
      
         let Url1 = "";
         let Url2 = "";
         let Url3 = "";
         let Url4 = "";
 
         if(Imgs[0].Foto !== ""){
           if(Imgs[0].Foto.name){
            const fileName = await Date.now() + Imgs[0].Foto.name;
            const storageRef = await storage.ref();
            const fileRef = await storageRef.child(`arquivo/${fileName}`);
            await await fileRef.put(Imgs[0].Foto).then((doc)=> {
              
            });
            Url1 =  await fileRef.getDownloadURL();

           } else {
              Url1 = Imgs[0].Foto 
           }
          
         }
 
         if(Imgs[1].Foto !== ""){
          if(Imgs[1].Foto.name){
           const fileName = await Date.now() + Imgs[1].Foto.name;
           const storageRef = await storage.ref();
           const fileRef = await storageRef.child(`arquivo/${fileName}`);
           await await fileRef.put(Imgs[1].Foto).then((doc)=> {
             
           });
           Url2 =  await fileRef.getDownloadURL();
          } else {
            Url2 = Imgs[1].Foto 
         }
         }
 
         if(Imgs[2].Foto !== ""){
          if(Imgs[2].Foto.name){
           const fileName = await Date.now() + Imgs[2].Foto.name;
           const storageRef = await storage.ref();
           const fileRef = await storageRef.child(`arquivo/${fileName}`);
           await await fileRef.put(Imgs[2].Foto).then((doc)=> {
             
           });
           Url3 =  await fileRef.getDownloadURL();
          } else {
            Url3 = Imgs[2].Foto 
         }
         }
 
         if(Imgs[3].Foto !== ""){
          if(Imgs[3].Foto.name){
           const fileName = await Date.now() + Imgs[3].Foto.name;
           const storageRef = await storage.ref();
           const fileRef = await storageRef.child(`arquivo/${fileName}`);
           await await fileRef.put(Imgs[3].Foto).then((doc)=> {
             
           });
           Url4 =  await fileRef.getDownloadURL();
         }
        } else {
          Url4 = Imgs[3].Foto 
       }
 
         await db.collection("noticias")
         .doc(Id)
         .update({
           body:value,
           Titulo:TituNoti,
           TituloAnun:TituAnun,
           dataDanoti:Data,
           foto1:Url1,
           foto2:Url2,
           foto3:Url3,
           foto4:Url4,
    
           }).then(() => {
             setAlert("Notícia Editada Com Sucesso ");
             setAlertTipo("success");
             setVisi1(false);
              
           })
           .catch((error) => {
             setAlert("Ouve algum Erro! ");
             setAlertTipo("danger");
             setVisi1(false);
           });  
      
     },
     ExcluirNoti: async( Id,  setAlertTipo, setAlert)=> {
            setAlert(" ");
              setAlertTipo("");
     
 
      await db.collection("noticias")
      .doc(Id)
      .delete().then(() => {
          setAlert("Notícia Excluida Com Sucesso ");
          setAlertTipo("Danger");
       
           
        })
        .catch((error) => {
          setAlert("Ouve algum Erro! ");
          setAlertTipo("danger");
         
        });  
   
  },

     AtivarNoti: async( id,  setAlertTipo, setAlert)=> {
      
     
 
         await db.collection("noticias")
         .doc(id)
         .update({
           ativo:true,
    
           }).then(() => {
             setAlert("Notícia Ativada Com Sucesso ");
             setAlertTipo("success");
          
              
           })
           .catch((error) => {
             setAlert("Ouve algum Erro! ");
             setAlertTipo("danger");
            
           });  
      
     },

     DesativarNoti: async(id,  setAlertTipo, setAlert)=> {
      
     
 
      await db.collection("noticias")
      .doc(id)
      .update({
        ativo:false,
 
        }).then(() => {
          setAlert("Notícia Desativada Com Sucesso ");
          setAlertTipo("success");
       
           
        })
        .catch((error) => {
          setAlert("Ouve algum Erro! ");
          setAlertTipo("danger");
         
        });  
   
  },


  sairdaconta: async()=> {
    await Auth.signOut().then( async () => {
      await localStorage.setItem('roma', "L23252679");
      await localStorage.setItem('brasil', "Admin");
      
    });
  },
  
 













  

  // Inicio de entradas de dados para teste
  gerarDados: async()=> {
    // Esse dado de teste serve para testar a conta Serv vendo se ela está desativada e ativando ela
    await db.collection('users').doc('fd5xCA0VX7g7C5EfQI3J8o5WkfH2').set({
     
              nome: "Luiz Carlos", 
              telefone: "(99) 9965-7894", 
              cidade: "Altos", 
              estado: "Piauí", 
              instituicao: "Polícia",
              conta:{ admin:{ativo:false, desbloqueado: false, tipo:""},
                      app:{ativo:false, desbloqueado: false, tipo:""},
                      negApp:{ativo:false, desbloqueado: false, tipo:""},
                      serv:{ativo:false, desbloqueado: false, tipo:"Lider"},
                      servApp:{ativo:false, desbloqueado: false, tipo:""},
              
                    },
                    grupo:{
                      id:"mjcq9CMFFexmf5JPvTtX",
                      nome:"Geral",
                      menu:{
                          contas:{
                                  listaServ:{
                                           Ver:true,
                                           btn_vizualizar:true,
                                           btn_excluir:true,
                                           btn_editar:true,
                                          }
                                  }
                                }
                            },
            
    }).then(() => {
      console.log("1° dado adicionado !");
                  })
                  .catch((error) => {
                      console.error("Erro Ao adicionar : ", error);
                  });




    await db.collection('users').doc('MIA1uRFHHTTxBp8wopztoWp5eko2').set({
     

              nome: "Carlos Daniel", 
              telefone: "(99) 9965-7894", 
              cidade: "Altos", 
              estado: "Pauí", 
              instituicao: "Bombeiro",
              conta:{ admin:{ativo:false, desbloqueado: false, tipo:""},
                      app:{ativo:false, desbloqueado: false, tipo:""},
                      negApp:{ativo:false, desbloqueado: false, tipo:""},
                      serv:{ativo:true, desbloqueado: false, tipo:"Lider"},
                      servApp:{ativo:false, desbloqueado: false, tipo:""},
              
                    },
                    grupo:{
                      id:"mjcq9CMFFexmf5JPvTtX",
                      nome:"Geral",
                      menu:{
                          contas:{
                                  listaServ:{
                                           Ver:true,
                                           btn_vizualizar:true,
                                           btn_excluir:true,
                                           btn_editar:true,
                                          }
                                  }
                                }
                            },

    }).then(() => {
      console.log("2° dado adicionado !");
                  })
                  .catch((error) => {
                      console.error("Erro Ao adicionar : ", error);
                  });

    


  },



  // excluido todos os dados de teste
  excluirDados: async()=> {
    await db.collection('users')
    .doc('fd5xCA0VX7g7C5EfQI3J8o5WkfH2')
    .delete()
    .then(() => {
      console.log("1° dados Excluido !");
                  })
                  .catch((error) => {
                      console.error("Erro Ao adicionar : ", error);
                  });

    await db.collection('users')
    .doc('MIA1uRFHHTTxBp8wopztoWp5eko2')
    .delete()
    .then(() => {
      console.log("2° dado excluido !");
                  })
                  .catch((error) => {
                      console.error("Erro Ao adicionar : ", error);
                  });

  },

  DesbloqueioContaServ: async()=> {
    return await db.collection("users").doc('fd5xCA0VX7g7C5EfQI3J8o5WkfH2').update({
      "conta.serv.desbloqueado": true,
  })
  .then(() => {
      console.log("1º  conta foi desbloqueada");
  });
  },



  AprovarOlds: async(Dados, Id, TimePriFora, TimePriCasa, TimeSegFora, TimeSegCasa, TimeGerCasa, TimeGerFora, HistGols, Escan, setPorBets, setAlert, setAlertTipo)=> {
   
   
    await db.collection("users")
    .where("Telefone", "==", Dados.Tel)
    .where("DataEnt", "==", Dados.DataEnt)
    .get().then(async (querySnapshot) => {
      if(querySnapshot.size  !== 0){

        db.collection("JogosCirados")
        .doc(Id.id)
        .update({
          Analisado: true
       })

        console.log(Id.Best)
        for(let i in Id.Best){
         setPorBets(parseInt(i)+1/Id.Best.length)
          //Inicio ---------
          if(Id.Best[i].Grupo === "Vencedor da partida"  && Id.Best[i].Casa === "Casa"){
           if(TimeGerCasa > TimeGerFora ){
             db.collection("CasaOlds")
             .doc(Id.Best[i].idCasaOlds)
             .update({
              Resultado: "Aprovado"
            })
             
           } else {
            db.collection("CasaOlds")
            .doc(Id.Best[i].idCasaOlds)
            .update({
             Resultado: "Reprovado"
           })
           }
          }
          //Fim -------------

            //Inicio ---------
            if(Id.Best[i].Grupo === "Vencedor da partida"  && Id.Best[i].Casa === "Empate"){
              if(TimeGerCasa == TimeGerFora ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
            if(Id.Best[i].Grupo === "Vencedor da partida"  && Id.Best[i].Casa === "Fora"){
              if(TimeGerCasa < TimeGerFora ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------

            //Inicio ---------
            if(Id.Best[i].Grupo === "Vencedor do segundo tempo"  && Id.Best[i].Casa === "Fora"){
              if(TimeSegCasa < TimeSegFora ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
            if(Id.Best[i].Grupo === "Vencedor do segundo tempo"  && Id.Best[i].Casa === "Empate"){
              if(TimeSegCasa == TimeSegFora ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
               //Inicio ---------
            if(Id.Best[i].Grupo === "Vencedor do segundo tempo"  && Id.Best[i].Casa === "Casa"){
              if(TimeSegCasa > TimeSegFora ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------

              //Inicio ---------
             if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Acima 0.5'){
              if(0.5 < (TimeGerCasa+TimeGerFora) ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
              if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Abaixo 0.5'){
                if(0.5 > (TimeGerCasa+TimeGerFora) ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Acima 1.5'){
                if(1.5 < (TimeGerCasa+TimeGerFora) ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Abaixo 1.5'){
                if(1.5 > (TimeGerCasa+TimeGerFora) ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Acima 2.5'){
                if(2.5 < (TimeGerCasa+TimeGerFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })

                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Abaixo 2.5'){
                if(2.5 > (TimeGerCasa+TimeGerFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Acima 3.5'){
                if(3.5 < (TimeGerCasa+TimeGerFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Abaixo 3.5'){
                if(3.5 > (TimeGerCasa+TimeGerFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Acima 4.5'){
                if(4.5 < (TimeGerCasa+TimeGerFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Abaixo 4.5'){
                if(4.5 > (TimeGerCasa+TimeGerFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Acima 5.5'){
                if(5.5 < (TimeGerCasa+TimeGerFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                    //Inicio ---------
              if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Abaixo 5.5'){
                if(5.5 > (TimeGerCasa+TimeGerFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                   //Inicio ---------
              if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Acima 6.5'){
                if(6.5 < (TimeGerCasa+TimeGerFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Abaixo 6.5'){
                if(6.5 > (TimeGerCasa+TimeGerFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Acima 7.5'){
                if(7.5 < (TimeGerCasa+TimeGerFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Golos Acima/Abaixo"  && Id.Best[i].Casa === 'Abaixo 7.5'){
                if(7.5 > (TimeGerCasa+TimeGerFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------

                 //Inicio ---------
             if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Acima 0.5'){
              if(0.5 < (TimePriCasa+TimePriFora) ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Abaixo 0.5'){
                if(0.5 > (TimePriCasa+TimePriFora) ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Acima 1.5'){
                if(1.5 < (TimePriCasa+TimePriFora) ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Abaixo 1.5'){
                if(1.5 > (TimePriCasa+TimePriFora) ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Acima 2.5'){
                if(2.5 < (TimePriCasa+TimePriFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })

                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Abaixo 2.5'){
                if(2.5 > (TimePriCasa+TimePriFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Acima 3.5'){
                if(3.5 < (TimePriCasa+TimePriFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Abaixo 3.5'){
                if(3.5 > (TimePriCasa+TimePriFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Acima 4.5'){
                if(4.5 < (TimePriCasa+TimePriFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Abaixo 4.5'){
                if(4.5 > (TimePriCasa+TimePriFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Acima 5.5'){
                if(5.5 < (TimePriCasa+TimePriFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                    //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Abaixo 5.5'){
                if(5.5 > (TimePriCasa+TimePriFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                   //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Acima 6.5'){
                if(6.5 < (TimePriCasa+TimePriFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Abaixo 6.5'){
                if(6.5 > (TimePriCasa+TimePriFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Acima 7.5'){
                if(7.5 < (TimePriCasa+TimePriFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo do Primeiro Tempo"  && Id.Best[i].Casa === 'Abaixo 7.5'){
                if(7.5 > (TimePriCasa+TimePriFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                      //Inicio ---------
             if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Acima 0.5'){
              if(0.5 < (TimeSegCasa+TimeSegFora) ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Abaixo 0.5'){
                if(0.5 > (TimeSegCasa+TimeSegFora) ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Acima 1.5'){
                if(1.5 < (TimeSegCasa+TimeSegFora) ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Abaixo 1.5'){
                if(1.5 > (TimeSegCasa+TimeSegFora) ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Acima 2.5'){
                if(2.5 < (TimeSegCasa+TimeSegFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })

                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Abaixo 2.5'){
                if(2.5 > (TimeSegCasa+TimeSegFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Acima 3.5'){
                if(3.5 < (TimeSegCasa+TimeSegFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Abaixo 3.5'){
                if(3.5 > (TimeSegCasa+TimeSegFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Acima 4.5'){
                if(4.5 < (TimeSegCasa+TimeSegFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Abaixo 4.5'){
                if(4.5 > (TimeSegCasa+TimeSegFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Acima 5.5'){
                if(5.5 < (TimeSegCasa+TimeSegFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                    //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Abaixo 5.5'){
                if(5.5 > (TimeSegCasa+TimeSegFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                   //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Acima 6.5'){
                if(6.5 < (TimeSegCasa+TimeSegFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Abaixo 6.5'){
                if(6.5 > (TimeSegCasa+TimeSegFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Acima 7.5'){
                if(7.5 < (TimeSegCasa+TimeSegFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Gols Acima/Abaixo - Segundo Tempo"  && Id.Best[i].Casa === 'Abaixo 7.5'){
                if(7.5 > (TimeSegCasa+TimeSegFora) ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                   //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado no Intervalo | Resultado Final"  && Id.Best[i].Casa === "Casa/Casa"){
                if(TimePriCasa > TimePriFora && TimeGerCasa > TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado no Intervalo | Resultado Final"  && Id.Best[i].Casa === "Empate/Casa"){
                if(TimePriCasa == TimePriFora && TimeGerCasa > TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado no Intervalo | Resultado Final"  && Id.Best[i].Casa === "Fora/Casa"){
                if(TimePriCasa < TimePriFora && TimeGerCasa > TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado no Intervalo | Resultado Final"  && Id.Best[i].Casa === "Casa/Empate"){
                if(TimePriCasa > TimePriFora && TimeGerCasa == TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado no Intervalo | Resultado Final"  && Id.Best[i].Casa === "Empate/Empate"){
                if(TimePriCasa == TimePriFora && TimeGerCasa == TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado no Intervalo | Resultado Final"  && Id.Best[i].Casa === "Fora/Empate"){
                if(TimePriCasa < TimePriFora && TimeGerCasa == TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado no Intervalo | Resultado Final"  && Id.Best[i].Casa === "Casa/Fora"){
                if(TimePriCasa > TimePriFora && TimeGerCasa < TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado no Intervalo | Resultado Final"  && Id.Best[i].Casa === "Empate/Fora"){
                if(TimePriCasa == TimePriFora && TimeGerCasa < TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado no Intervalo | Resultado Final"  && Id.Best[i].Casa === "Fora/Fora"){
                if(TimePriCasa < TimePriFora && TimeGerCasa < TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Time da Casa - Nenhum Gol Solfrido"  && Id.Best[i].Casa === "Sim"){
                if( TimeGerFora === 0  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Time da Casa - Nenhum Gol Solfrido"  && Id.Best[i].Casa === "Não"){
                if( TimeGerFora !== 0  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Time de Fora - Nenhum Gol Solfrido"  && Id.Best[i].Casa === "Sim"){
                if( TimeGerCasa === 0  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Time de Fora - Nenhum Gol Solfrido"  && Id.Best[i].Casa === "Não"){
                if(TimeGerCasa !== 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Ambas as equipes marcam"  && Id.Best[i].Casa === "Sim"){
                if(TimeGerFora !== 0 && TimeGerCasa !== 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Ambas as equipes marcam"  && Id.Best[i].Casa === "Não"){
                if(TimeGerFora === 0 || TimeGerCasa === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "0x0"){
                if(TimeGerCasa === 0  && TimeGerFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "0x1"){
                if(TimeGerCasa === 0  && TimeGerFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "0x2"){
                if(TimeGerCasa === 0  && TimeGerFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "0x3"){
                if(TimeGerCasa === 0  && TimeGerFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "0x4"){
                if(TimeGerCasa === 0  && TimeGerFora === 4 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "0x5"){
                if(TimeGerCasa === 0  && TimeGerFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "0x6"){
                if(TimeGerCasa === 0  && TimeGerFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "0x7"){
                if(TimeGerCasa === 0  && TimeGerFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "1x0"){
                if(TimeGerCasa === 1  && TimeGerFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "1x1"){
                if(TimeGerCasa === 1  && TimeGerFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "1x2"){
                if(TimeGerCasa === 1  && TimeGerFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "1x3"){
                if(TimeGerCasa === 1  && TimeGerFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "1x4"){
                if(TimeGerCasa === 1  && TimeGerFora === 4 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "1x5"){
                if(TimeGerCasa === 1  && TimeGerFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "1x6"){
                if(TimeGerCasa === 1  && TimeGerFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "1x7"){
                if(TimeGerCasa === 1  && TimeGerFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "2x0"){
                if(TimeGerCasa === 2  && TimeGerFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "2x1"){
                if(TimeGerCasa === 2  && TimeGerFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "2x2"){
                if(TimeGerCasa === 2  && TimeGerFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "2x3"){
                if(TimeGerCasa === 2  && TimeGerFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "2x4"){
                if(TimeGerCasa === 2  && TimeGerFora === 4 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "2x5"){
                if(TimeGerCasa === 2  && TimeGerFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "2x6"){
                if(TimeGerCasa === 2  && TimeGerFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "2x7"){
                if(TimeGerCasa === 2  && TimeGerFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "3x0"){
                if(TimeGerCasa === 3  && TimeGerFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "3x1"){
                if(TimeGerCasa === 3  && TimeGerFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "3x2"){
                if(TimeGerCasa === 3  && TimeGerFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "3x3"){
                if(TimeGerCasa === 3  && TimeGerFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "3x4"){
                if(TimeGerCasa === 3  && TimeGerFora === 4 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "3x5"){
                if(TimeGerCasa === 3  && TimeGerFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "3x6"){
                if(TimeGerCasa === 3  && TimeGerFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "3x7"){
                if(TimeGerCasa === 3  && TimeGerFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "4x0"){
                if(TimeGerCasa === 4  && TimeGerFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "4x1"){
                if(TimeGerCasa === 4  && TimeGerFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "4x2"){
                if(TimeGerCasa === 4  && TimeGerFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "4x3"){
                if(TimeGerCasa === 4  && TimeGerFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "4x4"){
                if(TimeGerCasa === 4  && TimeGerFora === 4 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "4x5"){
                if(TimeGerCasa === 4  && TimeGerFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "4x6"){
                if(TimeGerCasa === 4  && TimeGerFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "4x7"){
                if(TimeGerCasa === 4  && TimeGerFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "5x0"){
                if(TimeGerCasa === 5  && TimeGerFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "5x1"){
                if(TimeGerCasa === 5  && TimeGerFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "5x2"){
                if(TimeGerCasa === 5  && TimeGerFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "5x3"){
                if(TimeGerCasa === 5  && TimeGerFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "5x4"){
                if(TimeGerCasa === 5  && TimeGerFora === 4 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "5x5"){
                if(TimeGerCasa === 5  && TimeGerFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "5x6"){
                if(TimeGerCasa === 5  && TimeGerFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "5x7"){
                if(TimeGerCasa === 5  && TimeGerFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "6x0"){
                if(TimeGerCasa === 6  && TimeGerFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "6x1"){
                if(TimeGerCasa === 6  && TimeGerFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "6x2"){
                if(TimeGerCasa === 6  && TimeGerFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "6x3"){
                if(TimeGerCasa === 6  && TimeGerFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "6x4"){
                if(TimeGerCasa === 6  && TimeGerFora === 4 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "6x5"){
                if(TimeGerCasa === 6  && TimeGerFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "6x6"){
                if(TimeGerCasa === 6  && TimeGerFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "6x7"){
                if(TimeGerCasa === 6  && TimeGerFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "7x0"){
                if(TimeGerCasa === 7  && TimeGerFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "7x1"){
                if(TimeGerCasa === 7  && TimeGerFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "7x2"){
                if(TimeGerCasa === 7  && TimeGerFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "7x3"){
                if(TimeGerCasa === 7  && TimeGerFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "7x4"){
                if(TimeGerCasa === 7  && TimeGerFora === 4 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "7x5"){
                if(TimeGerCasa === 7  && TimeGerFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "7x6"){
                if(TimeGerCasa === 7  && TimeGerFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Placar Exato"  && Id.Best[i].Casa === "7x7"){
                if(TimeGerCasa === 7  && TimeGerFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "0x0"){
                if(TimePriCasa === 0  && TimePriFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "0x1"){
                if(TimePriCasa === 0  && TimePriFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "0x2"){
                if(TimePriCasa === 0  && TimePriFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "0x3"){
                if(TimePriCasa === 0  && TimePriFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
             //Inicio ---------
             if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "0x4"){
              if(TimePriCasa === 0  && TimePriFora === 4 ){

                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {

               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              
              }
             }
             //Fim -------------
              //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "0x5"){
                if(TimePriCasa === 0  && TimePriFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "0x6"){
                if(TimePriCasa === 0  && TimePriFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "0x7"){
                if(TimePriCasa === 0  && TimePriFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "1x0"){
                if(TimePriCasa === 1  && TimePriFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "1x1"){
                if(TimePriCasa === 1  && TimePriFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "1x2"){
                if(TimePriCasa === 1  && TimePriFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "1x3"){
                if(TimePriCasa === 1  && TimePriFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
             //Inicio ---------
             if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "1x4"){
              if(TimePriCasa === 1  && TimePriFora === 4 ){

                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {

               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              
              }
             }
             //Fim -------------
              //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "1x5"){
                if(TimePriCasa === 1  && TimePriFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "1x6"){
                if(TimePriCasa === 1  && TimePriFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "1x7"){
                if(TimePriCasa === 1  && TimePriFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "2x0"){
                if(TimePriCasa === 2  && TimePriFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "2x1"){
                if(TimePriCasa === 2  && TimePriFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "2x2"){
                if(TimePriCasa === 2  && TimePriFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "2x3"){
                if(TimePriCasa === 2  && TimePriFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
             //Inicio ---------
             if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "2x4"){
              if(TimePriCasa === 2  && TimePriFora === 4 ){

                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {

               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              
              }
             }
             //Fim -------------
              //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "2x5"){
                if(TimePriCasa === 2  && TimePriFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "2x6"){
                if(TimePriCasa === 2  && TimePriFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "2x7"){
                if(TimePriCasa === 2  && TimePriFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "3x0"){
                if(TimePriCasa === 3  && TimePriFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "3x1"){
                if(TimePriCasa === 3  && TimePriFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "3x2"){
                if(TimePriCasa === 3  && TimePriFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "3x3"){
                if(TimePriCasa === 3  && TimePriFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
             //Inicio ---------
             if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "3x4"){
              if(TimePriCasa === 3  && TimePriFora === 4 ){

                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {

               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              
              }
             }
             //Fim -------------
              //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "3x5"){
                if(TimePriCasa === 3  && TimePriFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "3x6"){
                if(TimePriCasa === 3  && TimePriFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "3x7"){
                if(TimePriCasa === 3  && TimePriFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "4x0"){
                if(TimePriCasa === 4  && TimePriFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "4x1"){
                if(TimePriCasa === 4  && TimePriFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "4x2"){
                if(TimePriCasa === 4  && TimePriFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "4x3"){
                if(TimePriCasa === 4  && TimePriFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
             //Inicio ---------
             if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "4x4"){
              if(TimePriCasa === 4  && TimePriFora === 4 ){

                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {

               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              
              }
             }
             //Fim -------------
              //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "4x5"){
                if(TimePriCasa === 4  && TimePriFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "4x6"){
                if(TimePriCasa === 4  && TimePriFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "4x7"){
                if(TimePriCasa === 4  && TimePriFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "5x0"){
                if(TimePriCasa === 5  && TimePriFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "5x1"){
                if(TimePriCasa === 5  && TimePriFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "5x2"){
                if(TimePriCasa === 5  && TimePriFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "5x3"){
                if(TimePriCasa === 5  && TimePriFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
             //Inicio ---------
             if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "5x4"){
              if(TimePriCasa === 5  && TimePriFora === 4 ){

                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {

               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              
              }
             }
             //Fim -------------
              //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "5x5"){
                if(TimePriCasa === 5  && TimePriFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "5x6"){
                if(TimePriCasa === 5  && TimePriFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "5x7"){
                if(TimePriCasa === 5  && TimePriFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "6x0"){
                if(TimePriCasa === 6  && TimePriFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "6x1"){
                if(TimePriCasa === 6  && TimePriFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "6x2"){
                if(TimePriCasa === 6  && TimePriFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "6x3"){
                if(TimePriCasa === 6  && TimePriFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
             //Inicio ---------
             if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "6x4"){
              if(TimePriCasa === 6  && TimePriFora === 4 ){

                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {

               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              
              }
             }
             //Fim -------------
              //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "6x5"){
                if(TimePriCasa === 6  && TimePriFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "6x6"){
                if(TimePriCasa === 6  && TimePriFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "6x7"){
                if(TimePriCasa === 6  && TimePriFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "7x0"){
                if(TimePriCasa === 7  && TimePriFora === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "7x1"){
                if(TimePriCasa === 7  && TimePriFora === 1 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "7x2"){
                if(TimePriCasa === 7  && TimePriFora === 2 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "7x3"){
                if(TimePriCasa === 7  && TimePriFora === 3 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
             //Inicio ---------
             if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "7x4"){
              if(TimePriCasa === 7  && TimePriFora === 4 ){

                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {

               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              
              }
             }
             //Fim -------------
              //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "7x5"){
                if(TimePriCasa === 7  && TimePriFora === 5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "7x6"){
                if(TimePriCasa === 7  && TimePriFora === 6 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Resultado Exato - Primeiro Tempo"  && Id.Best[i].Casa === "7x7"){
                if(TimePriCasa === 7  && TimePriFora === 7 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla"  && Id.Best[i].Casa === "Casa/Casa"){
                if(TimeGerCasa > TimeGerFora || TimeGerCasa > TimeGerFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla"  && Id.Best[i].Casa === "Empate/Casa"){
                if(TimeGerCasa === TimeGerFora || TimeGerCasa > TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla"  && Id.Best[i].Casa === "Fora/Casa"){
                if(TimeGerCasa < TimeGerFora || TimeGerCasa > TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla"  && Id.Best[i].Casa === "Casa/Empate"){
                if(TimeGerCasa > TimeGerFora || TimeGerCasa == TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla"  && Id.Best[i].Casa === "Empate/Empate"){
                if(TimeGerCasa == TimeGerFora || TimeGerCasa == TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla"  && Id.Best[i].Casa === "Fora/Empate"){
                if(TimeGerCasa < TimeGerFora || TimeGerCasa == TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla"  && Id.Best[i].Casa === "Casa/Fora"){
                if(TimeGerCasa > TimeGerFora || TimeGerCasa < TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla"  && Id.Best[i].Casa === "Empate/Fora"){
                if(TimeGerCasa === TimeGerFora || TimeGerCasa < TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla"  && Id.Best[i].Casa === "Fora/Fora"){
                if(TimeGerCasa < TimeGerFora || TimeGerCasa < TimeGerFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
          if(Id.Best[i].Grupo === "Vencedor do primeiro tempo"  && Id.Best[i].Casa === "Casa"){
            if(TimePriCasa > TimePriFora ){
              db.collection("CasaOlds")
              .doc(Id.Best[i].idCasaOlds)
              .update({
               Resultado: "Aprovado"
             })
              
            } else {
             db.collection("CasaOlds")
             .doc(Id.Best[i].idCasaOlds)
             .update({
              Resultado: "Reprovado"
            })
            }
           }
           //Fim -------------
 
             //Inicio ---------
             if(Id.Best[i].Grupo === "Vencedor do primeiro tempo"  && Id.Best[i].Casa === "Empate"){
               if(TimePriCasa == TimePriFora ){
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Aprovado"
                })
                 
               } else {
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Reprovado"
               })
               }
              }
              //Fim -------------
               //Inicio ---------
             if(Id.Best[i].Grupo === "Vencedor do primeiro tempo"  && Id.Best[i].Casa === "Fora"){
               if(TimePriCasa < TimePriFora ){
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Aprovado"
                })
                 
               } else {
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Reprovado"
               })
               }
              }
              //Fim -------------
                //Inicio ---------
          if(Id.Best[i].Grupo === "Equipe a marcar primeiro"  && Id.Best[i].Casa === "Casa"){
            if(HistGols[0].Time === "casa" ){
              db.collection("CasaOlds")
              .doc(Id.Best[i].idCasaOlds)
              .update({
               Resultado: "Aprovado"
             })
              
            } else {
             db.collection("CasaOlds")
             .doc(Id.Best[i].idCasaOlds)
             .update({
              Resultado: "Reprovado"
            })
            }
           }
           //Fim -------------
              //Inicio ---------
          if(Id.Best[i].Grupo === "Equipe a marcar primeiro"  && Id.Best[i].Casa === "Empate"){
            if(HistGols.length === 0 ){
              db.collection("CasaOlds")
              .doc(Id.Best[i].idCasaOlds)
              .update({
               Resultado: "Aprovado"
             })
              
            } else {
             db.collection("CasaOlds")
             .doc(Id.Best[i].idCasaOlds)
             .update({
              Resultado: "Reprovado"
            })
            }
           }
           //Fim -------------
               //Inicio ---------
             if(Id.Best[i].Grupo === "Equipe a marcar primeiro"  && Id.Best[i].Casa === "Fora"){
               if(HistGols[0].Time === "fora" ){
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Aprovado"
                })
                 
               } else {
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Reprovado"
               })
               }
              }
              //Fim -------------
               //Inicio ---------
          if(Id.Best[i].Grupo === "Equipe a marcar por último"  && Id.Best[i].Casa === "Casa"){
            if(HistGols[HistGols.length - 1].Time === "casa" ){
              db.collection("CasaOlds")
              .doc(Id.Best[i].idCasaOlds)
              .update({
               Resultado: "Aprovado"
             })
              
            } else {
             db.collection("CasaOlds")
             .doc(Id.Best[i].idCasaOlds)
             .update({
              Resultado: "Reprovado"
            })
            }
           }
           //Fim -------------
              //Inicio ---------
          if(Id.Best[i].Grupo === "Equipe a marcar por último"  && Id.Best[i].Casa === "Empate"){
            if(HistGols.length === 0 ){
              db.collection("CasaOlds")
              .doc(Id.Best[i].idCasaOlds)
              .update({
               Resultado: "Aprovado"
             })
              
            } else {
             db.collection("CasaOlds")
             .doc(Id.Best[i].idCasaOlds)
             .update({
              Resultado: "Reprovado"
            })
            }
           }
           //Fim -------------
               //Inicio ---------
             if(Id.Best[i].Grupo === "Equipe a marcar por último"  && Id.Best[i].Casa === "Fora"){
               if(HistGols[HistGols.length - 1].Time === "fora" ){
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Aprovado"
                })
                 
               } else {
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Reprovado"
               })
               }
              }
              //Fim -------------
                 //Inicio ---------
          if(Id.Best[i].Grupo === "Ganha o 1° e 2° Tempo"  && Id.Best[i].Casa === "Casa"){
            if(TimePriCasa > TimePriFora && TimeSegCasa > TimeSegFora ){
              db.collection("CasaOlds")
              .doc(Id.Best[i].idCasaOlds)
              .update({
               Resultado: "Aprovado"
             })
              
            } else {
             db.collection("CasaOlds")
             .doc(Id.Best[i].idCasaOlds)
             .update({
              Resultado: "Reprovado"
            })
            }
           }
           //Fim -------------
               //Inicio ---------
             if(Id.Best[i].Grupo === "Ganha o 1° e 2° Tempo"  && Id.Best[i].Casa === "Fora"){
               if(TimePriCasa < TimePriFora && TimeSegCasa < TimeSegFora ){
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Aprovado"
                })
                 
               } else {
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Reprovado"
               })
               }
              }
              //Fim -------------
               
                  //Inicio ---------
             if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Acima 0.5'){
              if(TimeGerCasa > 0.5){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Abaixo 0.5'){
                if(TimeGerCasa < 0.5){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Acima 1.5'){
                if(TimeGerCasa > 1.5 ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Abaixo 1.5'){
                if(TimeGerCasa < 1.5){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Acima 2.5'){
                if(TimeGerCasa > 2.5){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })

                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Abaixo 2.5'){
                if(TimeGerCasa < 2.5){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Acima 3.5'){
                if(TimeGerCasa > 3.5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Abaixo 3.5'){
                if(3.5 > TimeGerCasa ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Acima 4.5'){
                if(4.5 < TimeGerCasa ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Abaixo 4.5'){
                if(4.5 > TimeGerCasa ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Acima 5.5'){
                if(5.5 < TimeGerCasa ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                    //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Abaixo 5.5'){
                if(5.5 > TimeGerCasa ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                   //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Acima 6.5'){
                if(6.5 < TimeGerCasa ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Abaixo 6.5'){
                if(6.5 > TimeGerCasa ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Acima 7.5'){
                if(7.5 < TimeGerCasa ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time da Casa"  && Id.Best[i].Casa === 'Abaixo 7.5'){
                if(7.5 > TimeGerCasa ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim ------------- 
                 //Inicio ---------
             if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Acima 0.5'){
              if(TimeGerFora > 0.5){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Abaixo 0.5'){
                if(TimeGerFora < 0.5){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Acima 1.5'){
                if(TimeGerFora > 1.5 ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Abaixo 1.5'){
                if(TimeGerFora < 1.5){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Acima 2.5'){
                if(TimeGerFora > 2.5){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })

                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Abaixo 2.5'){
                if(TimeGerFora < 2.5){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Acima 3.5'){
                if(TimeGerFora > 3.5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Abaixo 3.5'){
                if(3.5 > TimeGerFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Acima 4.5'){
                if(4.5 < TimeGerFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Abaixo 4.5'){
                if(4.5 > TimeGerFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Acima 5.5'){
                if(5.5 < TimeGerFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                    //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Abaixo 5.5'){
                if(5.5 > TimeGerFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                   //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Acima 6.5'){
                if(6.5 < TimeGerFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Abaixo 6.5'){
                if(6.5 > TimeGerFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Acima 7.5'){
                if(7.5 < TimeGerFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Total de Gols Time de Fora"  && Id.Best[i].Casa === 'Abaixo 7.5'){
                if(7.5 > TimeGerFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim ------------- 
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla - No Primeiro Tempo"  && Id.Best[i].Casa === "Casa/Casa"){
                if(TimePriCasa > TimePriFora || TimePriCasa > TimePriFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla - No Primeiro Tempo"  && Id.Best[i].Casa === "Empate/Casa"){
                if(TimePriCasa === TimePriFora || TimePriCasa > TimePriFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla - No Primeiro Tempo"  && Id.Best[i].Casa === "Fora/Casa"){
                if(TimePriCasa < TimePriFora || TimePriCasa > TimePriFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla - No Primeiro Tempo"  && Id.Best[i].Casa === "Casa/Empate"){
                if(TimePriCasa > TimePriFora || TimePriCasa === TimePriFora){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla - No Primeiro Tempo"  && Id.Best[i].Casa === "Empate/Empate"){
                if(TimePriCasa === TimePriFora || TimePriCasa === TimePriFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla - No Primeiro Tempo"  && Id.Best[i].Casa === "Fora/Empate"){
                if(TimePriCasa < TimePriFora || TimePriCasa === TimePriFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla - No Primeiro Tempo"  && Id.Best[i].Casa === "Casa/Fora"){
                if(TimePriCasa > TimePriFora || TimePriCasa < TimePriFora){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla - No Primeiro Tempo"  && Id.Best[i].Casa === "Empate/Fora"){
                if(TimePriCasa === TimePriFora || TimePriCasa < TimePriFora  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Chance dupla - No Primeiro Tempo"  && Id.Best[i].Casa === "Fora/Fora"){
                if(TimePriCasa < TimePriFora || TimePriCasa < TimePriFora ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                   //Inicio ---------
              if(Id.Best[i].Grupo === "Ambas as equipes marcam - No Primeiro Tempo"  && Id.Best[i].Casa === "Sim"){
                if(TimePriFora !== 0 && TimePriCasa !== 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Ambas as equipes marcam - No Primeiro Tempo"  && Id.Best[i].Casa === "Não"){
                if(TimePriFora === 0 || TimePriCasa === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Ambas as equipes marcam - No Segunda Tempo"  && Id.Best[i].Casa === "Sim"){
                if(TimeSegFora !== 0 && TimeSegCasa !== 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Ambas as equipes marcam - No Segunda Tempo"  && Id.Best[i].Casa === "Não"){
                if(TimeSegFora === 0 || TimeSegCasa === 0 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
            if(Id.Best[i].Grupo === "Ganha Sem Levar Gol"  && Id.Best[i].Casa === "Casa"){
              if(TimeGerCasa > TimeGerFora &&  TimeGerFora === 0 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
               //Inicio ---------
            if(Id.Best[i].Grupo === "Ganha Sem Levar Gol"  && Id.Best[i].Casa === "Fora"){
              if(TimeGerCasa < TimeGerFora && TimeGerCasa === 0){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
            if(Id.Best[i].Grupo === "Soma do Resultado Final do Jogo Impar/par"  && Id.Best[i].Casa === "Impar"){
              if((TimeGerCasa + TimeGerFora)%2 !== 0 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
               //Inicio ---------
            if(Id.Best[i].Grupo === "Soma do Resultado Final do Jogo Impar/par" && Id.Best[i].Casa === "Par"){
              if((TimeGerCasa + TimeGerFora)%2 === 0){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
            if(Id.Best[i].Grupo === "Soma do Jogo No Primeiro Tempo Impar/par"  && Id.Best[i].Casa === "Impar"){
              if((TimePriCasa + TimePriFora)%2 !== 0 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
               //Inicio ---------
            if(Id.Best[i].Grupo === "Soma do Jogo No Primeiro Tempo Impar/par" && Id.Best[i].Casa === "Par"){
              if((TimePriCasa + TimePriFora)%2 === 0){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
            if(Id.Best[i].Grupo === "Resultado Final do Time da Casa Impar/par"  && Id.Best[i].Casa === "Impar"){
              if((TimeGerCasa)%2 !== 0 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
               //Inicio ---------
            if(Id.Best[i].Grupo === "Resultado Final do Time da Casa Impar/par" && Id.Best[i].Casa === "Par"){
              if((TimeGerCasa)%2 === 0){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
            if(Id.Best[i].Grupo === "Resultado Final do Time de Fora Impar/par"  && Id.Best[i].Casa === "Impar"){
              if((TimeGerFora)%2 !== 0 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
               //Inicio ---------
            if(Id.Best[i].Grupo === "Resultado Final do Time de Fora Impar/par" && Id.Best[i].Casa === "Par"){
              if((TimeGerFora)%2 === 0){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols do jogo"  && Id.Best[i].Casa === 0){
              if((TimeGerCasa+TimeGerFora) === 0 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols do jogo"  && Id.Best[i].Casa === 1){
              if((TimeGerCasa+TimeGerFora) === 1 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
               //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols do jogo"  && Id.Best[i].Casa === 2){
              if((TimeGerCasa+TimeGerFora) === 2 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols do jogo"  && Id.Best[i].Casa === 3){
              if((TimeGerCasa+TimeGerFora) === 3 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols do jogo"  && Id.Best[i].Casa === 4){
              if((TimeGerCasa+TimeGerFora) === 4 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols do jogo"  && Id.Best[i].Casa === 5){
              if((TimeGerCasa+TimeGerFora) === 5 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols do jogo"  && Id.Best[i].Casa === 6){
              if((TimeGerCasa+TimeGerFora) === 6 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols do jogo"  && Id.Best[i].Casa === 7){
              if((TimeGerCasa+TimeGerFora) === 7 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols do jogo"  && Id.Best[i].Casa === "Mais que 7"){
              if((TimeGerCasa+TimeGerFora) > 7 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
            if(Id.Best[i].Grupo === "Ganha o 1° ou 2° Tempo"  && Id.Best[i].Casa === "Casa"){
              if(TimePriCasa > TimePriFora ||  TimeSegCasa > TimeSegFora ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
               //Inicio ---------
            if(Id.Best[i].Grupo === "Ganha o 1° ou 2° Tempo"  && Id.Best[i].Casa === "Fora"){
              if(TimePriCasa < TimePriFora ||  TimeSegCasa < TimeSegFora){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols/ Time da Casa"  && Id.Best[i].Casa === 0){
              if( TimeGerCasa === 0 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols/ Time da Casa"  && Id.Best[i].Casa === 1){
              if( TimeGerCasa === 1 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols/ Time da Casa"  && Id.Best[i].Casa === 2){
              if( TimeGerCasa === 2 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols/ Time da Casa"  && Id.Best[i].Casa === 3){
              if( TimeGerCasa === 3 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols/ Time da Casa"  && Id.Best[i].Casa === "Mais que 3"){
              if( TimeGerCasa > 3 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols/Time de Fora"  && Id.Best[i].Casa === 0){
              if( TimeGerFora === 0 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols/Time de Fora"  && Id.Best[i].Casa === 1){
              if( TimeGerFora === 1 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols/Time de Fora"  && Id.Best[i].Casa === 2){
              if( TimeGerFora === 2 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols/Time de Fora"  && Id.Best[i].Casa === 3){
              if( TimeGerFora === 3 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de Gols/Time de Fora"  && Id.Best[i].Casa === "Mais que 3"){
              if( TimeGerFora > 3 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de gols do segundo tempo"  && Id.Best[i].Casa === 0){
              if( (TimeSegCasa+TimeSegFora )=== 0 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de gols do segundo tempo"  && Id.Best[i].Casa === 1){
              if( (TimeSegCasa+TimeSegFora ) === 1 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de gols do segundo tempo"  && Id.Best[i].Casa === 2){
              if( (TimeSegCasa+TimeSegFora ) === 2 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de gols do segundo tempo"  && Id.Best[i].Casa === 3){
              if( (TimeSegCasa+TimeSegFora ) === 3 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de gols do segundo tempo"  && Id.Best[i].Casa === 4){
              if( (TimeSegCasa+TimeSegFora ) === 4 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de gols do segundo tempo"  && Id.Best[i].Casa === 5){
              if( (TimeSegCasa+TimeSegFora ) === 5 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             //Inicio ---------
            if(Id.Best[i].Grupo === "Número exato de gols do segundo tempo"  && Id.Best[i].Casa === "Mais que 5"){
              if( (TimeSegCasa+TimeSegFora ) > 5 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
              if(Id.Best[i].Grupo === "Time da casa marca um gol"  && Id.Best[i].Casa === "Sim"){
                if( TimeGerCasa !== 0  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Time da casa marca um gol"  && Id.Best[i].Casa === "Não"){
                if( TimeGerCasa === 0  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Time de Fora marca um gol"  && Id.Best[i].Casa === "Sim"){
                if( TimeGerFora !== 0  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Time de Fora marca um gol"  && Id.Best[i].Casa === "Não"){
                if( TimeGerFora === 0  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Time de Fora marca um gol"  && Id.Best[i].Casa === "Não"){
                if( TimeGerFora === 0  ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                  //Inicio ---------
             if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Acima 0.5'){
              if(Escan > 0.5){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Abaixo 0.5'){
                if(Escan < 0.5){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                  //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Acima 1.5'){
                if(Escan > 1.5 ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Abaixo 1.5'){
                if(Escan < 1.5){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Acima 2.5'){
                if(Escan > 2.5){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })

                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Abaixo 2.5'){
                if(Escan < 2.5){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Acima 3.5'){
                if(Escan > 3.5 ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Abaixo 3.5'){
                if(3.5 > Escan ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Acima 4.5'){
                if(4.5 < Escan ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Abaixo 4.5'){
                if(4.5 > Escan ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Acima 5.5'){
                if(5.5 < Escan ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                    //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Abaixo 5.5'){
                if(5.5 > Escan ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                   //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Acima 6.5'){
                if(6.5 < Escan ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Abaixo 6.5'){
                if(6.5 > Escan ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Acima 7.5'){
                if(7.5 < Escan ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Abaixo 7.5'){
                if(7.5 > Escan ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim ------------- 
                //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Acima 8.5'){
                if(8.5 < Escan ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Abaixo 8.5'){
                if(8.5 > Escan ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim ------------- 
                //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Acima 9.5'){
                if(9.5 < Escan ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Abaixo 9.5'){
                if(9.5 > Escan ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim ------------- 
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Acima 10.5'){
                if(10.5 < Escan ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Quantidade De Escanteio"  && Id.Best[i].Casa === 'Abaixo 10.5'){
                if(10.5 > Escan ){

                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {

                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                
                }
               }
               //Fim ------------- 
               if(Id.Best[i].Grupo === "Número exato de gols - primeiro tempo"  && Id.Best[i].Casa === 0){
                if((TimePriCasa+TimePriFora) === 0 ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
               //Inicio ---------
              if(Id.Best[i].Grupo === "Número exato de gols - primeiro tempo"  && Id.Best[i].Casa === 1){
                if((TimePriCasa+TimePriFora) === 1 ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                 //Inicio ---------
              if(Id.Best[i].Grupo === "Número exato de gols - primeiro tempo"  && Id.Best[i].Casa === 2){
                if((TimePriCasa+TimePriFora) === 2 ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Número exato de gols - primeiro tempo"  && Id.Best[i].Casa === 3){
                if((TimePriCasa+TimePriFora) === 3 ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Número exato de gols - primeiro tempo"  && Id.Best[i].Casa === 4){
                if((TimePriCasa+TimePriFora) === 4 ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Número exato de gols - primeiro tempo"  && Id.Best[i].Casa === 5){
                if((TimePriCasa+TimePriFora) === 5 ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                //Inicio ---------
              if(Id.Best[i].Grupo === "Número exato de gols - primeiro tempo"  && Id.Best[i].Casa === "Mais que 5"){
                if((TimePriCasa+TimePriFora)  > 5 ){
                  db.collection("CasaOlds")
                  .doc(Id.Best[i].idCasaOlds)
                  .update({
                   Resultado: "Aprovado"
                 })
                  
                } else {
                 db.collection("CasaOlds")
                 .doc(Id.Best[i].idCasaOlds)
                 .update({
                  Resultado: "Reprovado"
                })
                }
               }
               //Fim -------------
                //Inicio ---------
            if(Id.Best[i].Grupo === "Resultado do Segundo Tempo Impar/par"  && Id.Best[i].Casa === "Impar"){
              if((TimeSegCasa + TimeSegFora)%2 !== 0 ){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
               //Inicio ---------
            if(Id.Best[i].Grupo === "Resultado do Segundo Tempo Impar/par" && Id.Best[i].Casa === "Par"){
              if((TimeSegCasa + TimeSegFora)%2 === 0){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
               //Inicio ---------
            if(Id.Best[i].Grupo === "Time que Marca no 1° e 2° Tempo" && Id.Best[i].Casa === "Casa"){
              if(TimePriCasa !== 0 && TimeSegCasa !== 0){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
              //Inicio ---------
            if(Id.Best[i].Grupo === "Time que Marca no 1° e 2° Tempo" && Id.Best[i].Casa === "Fora"){
              if(TimePriFora !== 0 && TimeSegFora !== 0){
                db.collection("CasaOlds")
                .doc(Id.Best[i].idCasaOlds)
                .update({
                 Resultado: "Aprovado"
               })
                
              } else {
               db.collection("CasaOlds")
               .doc(Id.Best[i].idCasaOlds)
               .update({
                Resultado: "Reprovado"
              })
              }
             }
             //Fim -------------
             
              
               
               
               
               
               
               


               




        }
   
 
             } else {
               setAlert("Você está acessando essa conta de forma incorreta!");
               setAlertTipo("danger");
       
              }
             
             
             
             })
           
         
    
      
     
     
   },
  
  

};